/*!
 * @inspira-npm/pg-switch-js 0.1.76 (https://github.com/gautam_cs/pg-switch-js)
 * API https://github.com/gautam_cs/pg-switch-js/blob/master/doc/api.md
 * Copyright 2017-2026 gautam_cs. All Rights Reserved
 * Licensed under MIT (https://github.com/gautam_cs/pg-switch-js/blob/master/LICENSE)
 */

import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _sliceInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/slice';
import _Symbol from '@babel/runtime-corejs3/core-js-stable/symbol';
import _getIteratorMethod from '@babel/runtime-corejs3/core-js/get-iterator-method';
import _toConsumableArray from '@babel/runtime-corejs3/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _asyncToGenerator from '@babel/runtime-corejs3/helpers/asyncToGenerator';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _typeof from '@babel/runtime-corejs3/helpers/typeof';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _regeneratorRuntime from '@babel/runtime-corejs3/regenerator';
import _Array$isArray from '@babel/runtime-corejs3/core-js-stable/array/is-array';
import _indexOfInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/index-of';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _URL from '@babel/runtime-corejs3/core-js-stable/url';
import _WeakMap from '@babel/runtime-corejs3/core-js-stable/weak-map';
import _trimInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/trim';
import _Promise from '@babel/runtime-corejs3/core-js-stable/promise';
import _Object$fromEntries from '@babel/runtime-corejs3/core-js-stable/object/from-entries';
import _JSON$stringify from '@babel/runtime-corejs3/core-js-stable/json/stringify';
import _parseInt from '@babel/runtime-corejs3/core-js-stable/parse-int';
import _setTimeout from '@babel/runtime-corejs3/core-js-stable/set-timeout';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import _findInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find';
import _someInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/some';
import _reverseInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/reverse';
import _startsWithInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/starts-with';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _URLSearchParams from '@babel/runtime-corejs3/core-js-stable/url-search-params';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _Object$entries from '@babel/runtime-corejs3/core-js-stable/object/entries';
import _Array$from from '@babel/runtime-corejs3/core-js-stable/array/from';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/includes';
import { client, dataCollector, threeDSecure, hostedFields, paypalCheckout, googlePayment, applePay, venmo } from 'braintree-web';
import _Map from '@babel/runtime-corejs3/core-js-stable/map';
import _setInterval from '@babel/runtime-corejs3/core-js-stable/set-interval';
import { loadStripe } from '@stripe/stripe-js';
import cardValidator from 'card-validator';
import _Set from '@babel/runtime-corejs3/core-js-stable/set';
import _Number$isNaN from '@babel/runtime-corejs3/core-js-stable/number/is-nan';
import _padStartInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/pad-start';
import axios from 'axios';
import EventEmitter from 'events';
import IMask from 'imask';
import _everyInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/every';
import _Object$values from '@babel/runtime-corejs3/core-js-stable/object/values';

function ownKeys$4(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$4(e) { for (var r = 1; r < arguments.length; r++) { var _context0, _context1; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context0 = ownKeys$4(Object(t), true)).call(_context0, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context1 = ownKeys$4(Object(t))).call(_context1, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CARD_HOSTED_FIELD_NAMES = ["number", "expirationDate", "cvv", "cardholderName", "postalCode"];
function hostedFieldContainer(container) {
  var trimmed = _trimInstanceProperty(container).call(container);
  if (_startsWithInstanceProperty(trimmed).call(trimmed, "#") || _startsWithInstanceProperty(trimmed).call(trimmed, ".") || _startsWithInstanceProperty(trimmed).call(trimmed, "[")) {
    return trimmed;
  }
  return "#".concat(trimmed);
}
function cardHostedFieldsOptions(data) {
  var fields = {};
  for (var _i = 0, _CARD_HOSTED_FIELD_NA = CARD_HOSTED_FIELD_NAMES; _i < _CARD_HOSTED_FIELD_NA.length; _i++) {
    var _data$placeholders;
    var name = _CARD_HOSTED_FIELD_NA[_i];
    var container = data.fields[name];
    if (container == null || typeof container === "string" && _trimInstanceProperty(container).call(container) === "") {
      throw new Error("Hosted field container for ".concat(name, " is required."));
    }
    var placeholder = (_data$placeholders = data.placeholders) === null || _data$placeholders === void 0 ? void 0 : _data$placeholders[name];
    fields[name] = _objectSpread$4({
      container: typeof container === "string" ? hostedFieldContainer(container) : container
    }, placeholder ? {
      placeholder: placeholder
    } : {});
  }
  return fields;
}
var BraintreeGateway = /*#__PURE__*/function () {
  function BraintreeGateway() {
    _classCallCheck(this, BraintreeGateway);
    _defineProperty(this, "provider", "braintree");
    _defineProperty(this, "publishableKey", void 0);
    _defineProperty(this, "braintree", void 0);
    _defineProperty(this, "clientInstance", void 0);
    _defineProperty(this, "dataCollectorInstance", void 0);
    _defineProperty(this, "dataCollectorClient", void 0);
    _defineProperty(this, "dataCollectorPromise", void 0);
    _defineProperty(this, "dataCollectorGeneration", 0);
    _defineProperty(this, "hostedFields", hostedFields);
  }
  return _createClass(BraintreeGateway, [{
    key: "setElements",
    value: function setElements() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "getElements",
    value: function getElements() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "setCardElement",
    value: function setCardElement() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "getCardElement",
    value: function getCardElement() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "getNMIPayment",
    value: function getNMIPayment() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "getFlywirePayment",
    value: function getFlywirePayment() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "getNMIGateway",
    value: function getNMIGateway() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "confirmCardPaymentWithCVC",
    value: function confirmCardPaymentWithCVC() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "showLoader",
    value: function showLoader() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "hideLoader",
    value: function hideLoader() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "getProviderName",
    value: function getProviderName() {
      return this.provider;
    }
  }, {
    key: "getProviderClient",
    value: function getProviderClient() {
      return this.hostedFields;
    }
  }, {
    key: "getClientInstance",
    value: function getClientInstance() {
      return this.clientInstance;
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(publishableKey) {
        var clientInstance;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(this.clientInstance && this.publishableKey === publishableKey)) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return", this);
            case 1:
              _context.next = 2;
              return client.create({
                authorization: publishableKey
              });
            case 2:
              clientInstance = _context.sent;
              if (clientInstance) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return", this);
            case 3:
              _context.next = 4;
              return this.teardownDataCollector();
            case 4:
              this.publishableKey = publishableKey;
              this.clientInstance = clientInstance;
              return _context.abrupt("return", this);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init(_x) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "getCvvHostedFieldInstance",
    value: function () {
      var _getCvvHostedFieldInstance = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(selector) {
        var placeholder,
          _this$hostedFields,
          hostedFieldsInstance,
          _args2 = arguments,
          _t;
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              placeholder = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : "CVV";
              _context2.prev = 1;
              _context2.next = 2;
              return (_this$hostedFields = this.hostedFields) === null || _this$hostedFields === void 0 ? void 0 : _this$hostedFields.create({
                client: this.clientInstance,
                fields: {
                  cvv: {
                    selector: "#" + selector,
                    placeholder: placeholder
                  }
                }
              });
            case 2:
              hostedFieldsInstance = _context2.sent;
              return _context2.abrupt("return", hostedFieldsInstance);
            case 3:
              _context2.prev = 3;
              _t = _context2["catch"](1);
              console.log("Braintree CVV hostedFields Error", _t);
              throw new Error("Error: " + _t, {
                cause: _t
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function getCvvHostedFieldInstance(_x2) {
        return _getCvvHostedFieldInstance.apply(this, arguments);
      }
      return getCvvHostedFieldInstance;
    }()
  }, {
    key: "getHostedFieldsInstance",
    value: function () {
      var _getHostedFieldsInstance = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data) {
        var fields, hostedFieldsInstance, _t2;
        return _regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (this.clientInstance) {
                _context3.next = 1;
                break;
              }
              throw new Error("Braintree client is not initialized. Call init() before getHostedFieldsInstance().");
            case 1:
              fields = cardHostedFieldsOptions(data);
              _context3.prev = 2;
              _context3.next = 3;
              return this.hostedFields.create(_objectSpread$4({
                client: this.clientInstance,
                fields: fields
              }, data.styles ? {
                styles: data.styles
              } : {}));
            case 3:
              hostedFieldsInstance = _context3.sent;
              return _context3.abrupt("return", hostedFieldsInstance);
            case 4:
              _context3.prev = 4;
              _t2 = _context3["catch"](2);
              console.log("Braintree hostedFields Error", _t2);
              throw new Error("Error: " + _t2, {
                cause: _t2
              });
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[2, 4]]);
      }));
      function getHostedFieldsInstance(_x3) {
        return _getHostedFieldsInstance.apply(this, arguments);
      }
      return getHostedFieldsInstance;
    }()
  }, {
    key: "saveCard",
    value: function () {
      var _saveCard = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(data) {
        var body, response, pIntent, _t3;
        return _regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              body = _objectSpread$4({
                token: data.token,
                account_id: data.account_id,
                email: data.email,
                device_data: data.device_data
              }, data.payment_method ? {
                payment_method: data.payment_method
              } : {});
              _context4.prev = 1;
              _context4.next = 2;
              return fetch("".concat(data.apiBaseURL, "/v1/payment/card"), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": data.apiKey
                  // Authorization: `Basic ${btoa(`${this.apiKey}:${this.apiSecret}`)}`,
                },
                body: _JSON$stringify(body)
              });
            case 2:
              response = _context4.sent;
              _context4.next = 3;
              return response.json();
            case 3:
              pIntent = _context4.sent;
              return _context4.abrupt("return", pIntent);
            case 4:
              _context4.prev = 4;
              _t3 = _context4["catch"](1);
              throw new Error("Error: " + _t3, {
                cause: _t3
              });
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[1, 4]]);
      }));
      function saveCard(_x4) {
        return _saveCard.apply(this, arguments);
      }
      return saveCard;
    }()
  }, {
    key: "ensureDataCollector",
    value: function ensureDataCollector() {
      var _this = this;
      if (!this.clientInstance) {
        return _Promise.resolve();
      }
      if (this.dataCollectorInstance && this.dataCollectorClient === this.clientInstance) {
        return _Promise.resolve();
      }
      if (this.dataCollectorPromise) {
        return this.dataCollectorPromise;
      }
      var generation = ++this.dataCollectorGeneration;
      var client = this.clientInstance;
      var pending = this.startDataCollector(client, generation).finally(function () {
        if (_this.dataCollectorPromise === pending) {
          _this.dataCollectorPromise = undefined;
        }
      });
      this.dataCollectorPromise = pending;
      return pending;
    }
  }, {
    key: "startDataCollector",
    value: function () {
      var _startDataCollector = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(client, generation) {
        var existing, created, _t4, _t5;
        return _regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              existing = this.dataCollectorInstance;
              if (!existing) {
                _context5.next = 4;
                break;
              }
              this.dataCollectorInstance = undefined;
              this.dataCollectorClient = undefined;
              _context5.prev = 1;
              _context5.next = 2;
              return existing.teardown();
            case 2:
              _context5.next = 4;
              break;
            case 3:
              _context5.prev = 3;
              _t4 = _context5["catch"](1);
              console.log("Braintree data collector teardown", _t4);
            case 4:
              if (!(this.clientInstance !== client || generation !== this.dataCollectorGeneration)) {
                _context5.next = 5;
                break;
              }
              return _context5.abrupt("return");
            case 5:
              _context5.next = 6;
              return dataCollector.create({
                client: client
              });
            case 6:
              created = _context5.sent;
              if (!(this.clientInstance !== client || generation !== this.dataCollectorGeneration)) {
                _context5.next = 11;
                break;
              }
              _context5.prev = 7;
              _context5.next = 8;
              return created.teardown();
            case 8:
              _context5.next = 10;
              break;
            case 9:
              _context5.prev = 9;
              _t5 = _context5["catch"](7);
              console.log("Braintree data collector teardown", _t5);
            case 10:
              return _context5.abrupt("return");
            case 11:
              this.dataCollectorInstance = created;
              this.dataCollectorClient = client;
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[1, 3], [7, 9]]);
      }));
      function startDataCollector(_x5, _x6) {
        return _startDataCollector.apply(this, arguments);
      }
      return startDataCollector;
    }()
  }, {
    key: "getDeviceData",
    value: function getDeviceData() {
      var _this$dataCollectorIn;
      var deviceData = (_this$dataCollectorIn = this.dataCollectorInstance) === null || _this$dataCollectorIn === void 0 ? void 0 : _this$dataCollectorIn.deviceData;
      return typeof deviceData === "string" ? deviceData : undefined;
    }
  }, {
    key: "teardownDataCollector",
    value: function () {
      var _teardownDataCollector = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var collector, _t6;
        return _regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              this.dataCollectorGeneration += 1;
              this.dataCollectorPromise = undefined;
              collector = this.dataCollectorInstance;
              this.dataCollectorInstance = undefined;
              this.dataCollectorClient = undefined;
              if (collector) {
                _context6.next = 1;
                break;
              }
              return _context6.abrupt("return");
            case 1:
              _context6.prev = 1;
              _context6.next = 2;
              return collector.teardown();
            case 2:
              _context6.next = 4;
              break;
            case 3:
              _context6.prev = 3;
              _t6 = _context6["catch"](1);
              console.log("Braintree data collector teardown", _t6);
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[1, 3]]);
      }));
      function teardownDataCollector() {
        return _teardownDataCollector.apply(this, arguments);
      }
      return teardownDataCollector;
    }()
  }, {
    key: "verify3dSecure",
    value: function () {
      var _verify3dSecure = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(data) {
        var threeDs, result, _t7;
        return _regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 1;
              return threeDSecure.create({
                version: 2,
                // Will use 3DS2 whenever possible
                client: this.getClientInstance()
              });
            case 1:
              threeDs = _context7.sent;
              _context7.prev = 2;
              threeDs.on("lookup-complete", function (_lookup, next) {
                // use `data` here, then call `next()`
                if (typeof next !== "function") {
                  throw new TypeError("next is not a function");
                }
                next();
              });
              _context7.next = 3;
              return threeDs.verifyCard(_objectSpread$4(_objectSpread$4(_objectSpread$4({
                amount: data.amount,
                nonce: data.token,
                bin: data.bin
              }, typeof data.email === "string" ? {
                email: data.email
              } : {}), data.collectDeviceData ? {
                collectDeviceData: true
              } : {}), {}, {
                additionalInformation: {
                  acsWindowSize: "03"
                }
              }));
            case 3:
              result = _context7.sent;
              return _context7.abrupt("return", result);
            case 4:
              _context7.prev = 4;
              _context7.prev = 5;
              _context7.next = 6;
              return threeDs.teardown();
            case 6:
              _context7.next = 8;
              break;
            case 7:
              _context7.prev = 7;
              _t7 = _context7["catch"](5);
              console.log("Braintree 3DS teardown", _t7);
            case 8:
              return _context7.finish(4);
            case 9:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[2,, 4, 9], [5, 7]]);
      }));
      function verify3dSecure(_x7) {
        return _verify3dSecure.apply(this, arguments);
      }
      return verify3dSecure;
    }()
  }, {
    key: "generateNonce",
    value: function () {
      var _generateNonce = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(data) {
        var response, result, _t8;
        return _regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 1;
              return fetch("".concat(data.apiBaseURL, "/v1/payment/generateNonce"), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": data.apiKey
                },
                body: _JSON$stringify({
                  account_id: data.account_id,
                  payment_method: data.payment_method,
                  email: data.email,
                  device_data: data.device_data
                  // Include other relevant fields as needed by the backend
                })
              });
            case 1:
              response = _context8.sent;
              _context8.next = 2;
              return response.json();
            case 2:
              result = _context8.sent;
              return _context8.abrupt("return", result);
            case 3:
              _context8.prev = 3;
              _t8 = _context8["catch"](0);
              throw new Error("Error generating nonce: " + _t8, {
                cause: _t8
              });
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8, null, [[0, 3]]);
      }));
      function generateNonce(_x8) {
        return _generateNonce.apply(this, arguments);
      }
      return generateNonce;
    }()
  }, {
    key: "setToken",
    value: function () {
      var _setToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(token) {
        return _regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              console.log(token);
            case 1:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      function setToken(_x9) {
        return _setToken.apply(this, arguments);
      }
      return setToken;
    }()
  }]);
}();

function _createForOfIteratorHelper$2(r, e) { var t = "undefined" != typeof _Symbol && _getIteratorMethod(r) || r["@@iterator"]; if (!t) { if (_Array$isArray(r) || (t = _unsupportedIterableToArray$2(r)) || e) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: true } : { done: false, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = true, u = false; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = true, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$2(r, a) { if (r) { var _context48; if ("string" == typeof r) return _arrayLikeToArray$2(r, a); var t = _sliceInstanceProperty(_context48 = {}.toString.call(r)).call(_context48, 8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? _Array$from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$2(r, a) : void 0; } }
function _arrayLikeToArray$2(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys$3(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var _context46, _context47; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context46 = ownKeys$3(Object(t), true)).call(_context46, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context47 = ownKeys$3(Object(t))).call(_context47, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function checkoutIsDark() {
  var _context;
  if (typeof document === "undefined") {
    return false;
  }
  var background = _trimInstanceProperty(_context = getComputedStyle(document.documentElement).getPropertyValue("--bg-color")).call(_context).toLowerCase();
  return background === "#000" || background === "#000000" || background === "black" || background === "rgb(0, 0, 0)";
}
function watchCheckoutTheme() {
  var dark = checkoutIsDark();
  var listeners = [];
  var observer = typeof MutationObserver === "undefined" ? undefined : new MutationObserver(function () {
    var next = checkoutIsDark();
    if (next === dark) {
      return;
    }
    dark = next;
    _forEachInstanceProperty(listeners).call(listeners, function (listener) {
      return listener(dark);
    });
  });
  if (typeof document !== "undefined") {
    observer === null || observer === void 0 || observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["style", "class"]
    });
  }
  return {
    isDark: function isDark() {
      return dark;
    },
    subscribe: function subscribe(listener) {
      listeners.push(listener);
    },
    stop: function stop() {
      observer === null || observer === void 0 || observer.disconnect();
    }
  };
}
function nonceAuthorizationFailed(result) {
  return isRecord(result) && result.status === false;
}
function isRecord(value) {
  return _typeof(value) === "object" && value !== null && !_Array$isArray(value);
}
function methodEnabled(types, name) {
  var normalized = name.toLowerCase().replace("_", "");
  return _someInstanceProperty(types).call(types, function (type) {
    return type.toLowerCase().replace("_", "") === normalized;
  });
}
function optionRecord(options, key) {
  var value = options[key];
  return isRecord(value) ? value : {};
}
function optionString(options, key) {
  var value = options[key];
  return typeof value === "string" && _trimInstanceProperty(value).call(value) !== "" ? value : undefined;
}
function nestedMessage(value) {
  var _context2;
  if (typeof value === "string" && _trimInstanceProperty(value).call(value) !== "") {
    return value;
  }
  if (_typeof(value) !== "object" || value === null) {
    return undefined;
  }
  if ("message" in value && typeof value.message === "string" && _trimInstanceProperty(_context2 = value.message).call(_context2) !== "") {
    return value.message;
  }
  if ("error" in value) {
    return nestedMessage(value.error);
  }
  return undefined;
}
function errorMessage(error) {
  if (_typeof(error) === "object" && error !== null && "details" in error) {
    var details = error.details;
    if (_typeof(details) === "object" && details !== null && "originalError" in details) {
      var original = nestedMessage(details.originalError);
      if (original) {
        return original;
      }
    }
  }
  if (_typeof(error) === "object" && error !== null && "message" in error && typeof error.message === "string") {
    return error.message;
  }
  return "The wallet payment could not be started.";
}
function errorCode$1(error) {
  if (_typeof(error) === "object" && error !== null && "code" in error && typeof error.code === "string") {
    return error.code;
  }
  return undefined;
}
function isCancellation(error) {
  var code = errorCode$1(error);
  if (code === "VENMO_TOKENIZATION_CANCELED_BY_USER" || code === "VENMO_DESKTOP_CANCELED" || code === "VENMO_CANCELED" || code === "PAYPAL_POPUP_CLOSED" || code === "CANCELED") {
    return true;
  }
  return isRecord(error) && (error.statusCode === "CANCELED" || error.statusCode === "CANCELLED");
}
var scriptLoads = new _Map();
function externalScriptReady(src) {
  var _candidate$payments;
  var candidate = window.google;
  return (candidate === null || candidate === void 0 || (_candidate$payments = candidate.payments) === null || _candidate$payments === void 0 ? void 0 : _candidate$payments.api) != null;
}
function scriptSettled(script) {
  var state = script.readyState;
  return state === "complete" || state === "loaded";
}
function loadScript(src) {
  var pending = scriptLoads.get(src);
  if (pending) {
    return pending;
  }
  var existing = document.querySelector("script[src=\"".concat(src, "\"]"));
  if (existing instanceof HTMLScriptElement && (existing.dataset.pgLoaded === "true" || externalScriptReady())) {
    var ready = _Promise.resolve();
    scriptLoads.set(src, ready);
    return ready;
  }
  var promise = new _Promise(function (resolve, reject) {
    var reused = existing instanceof HTMLScriptElement;
    var script = reused ? existing : document.createElement("script");
    var done = false;
    var poll;
    var timeout;
    var cleanup = function cleanup() {
      script.removeEventListener("load", finish);
      script.removeEventListener("error", fail);
      if (poll !== undefined) {
        clearInterval(poll);
      }
      if (timeout !== undefined) {
        clearTimeout(timeout);
      }
    };
    var finish = function finish() {
      if (done) {
        return;
      }
      done = true;
      cleanup();
      script.dataset.pgLoaded = "true";
      resolve();
    };
    var fail = function fail() {
      if (done) {
        return;
      }
      done = true;
      cleanup();
      scriptLoads.delete(src);
      // Only remove tags this loader created, never one added elsewhere.
      if (!reused) {
        script.remove();
      }
      reject(new Error("".concat(src, " failed to load.")));
    };
    script.addEventListener("load", finish);
    script.addEventListener("error", fail);
    if (reused) {
      // A pre-existing tag may have already fired load/error before we attached
      // listeners (modern browsers don't set readyState), so those events may
      // never fire again. Poll for the script's global and fall back to a
      // timeout so the promise always settles instead of hanging forever.
      if (scriptSettled(script) || externalScriptReady()) {
        finish();
        return;
      }
      poll = _setInterval(function () {
        if (externalScriptReady()) {
          finish();
        }
      }, 100);
      timeout = _setTimeout(function () {
        if (externalScriptReady()) {
          finish();
        } else {
          fail();
        }
      }, 10000);
      return;
    }
    script.src = src;
    script.async = true;
    script.dataset.pgLoaded = "pending";
    document.head.appendChild(script);
  });
  scriptLoads.set(src, promise);
  return promise;
}
function walletError(parent, message) {
  var note = document.createElement("p");
  note.className = "pg-bt-wallet-error";
  note.textContent = message;
  parent.appendChild(note);
}
function paypalStatusMessage(error) {
  var message = errorMessage(error);
  if (_includesInstanceProperty(message).call(message, "linked PayPal Sandbox") || _includesInstanceProperty(message).call(message, "PAYPAL_SANDBOX_ACCOUNT_NOT_LINKED")) {
    return "PayPal is unavailable until the sandbox account is linked.";
  }
  return message;
}
function applePaySessionConstructor() {
  var candidate = window.ApplePaySession;
  if (!candidate || typeof candidate.canMakePayments !== "function") {
    return undefined;
  }
  return candidate;
}
function mountPayPal(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9, _x0) {
  return _mountPayPal.apply(this, arguments);
}
function _mountPayPal() {
  _mountPayPal = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(root, client, options, amount, currency, isProduction, theme, onNonce, _onError, teardowns) {
    var slot, grid, alive, checkout, paypalSdk, createButtons, flow, intent, activeButtons, closeActiveButtons, renderChain, renderButtons;
    return _regeneratorRuntime.wrap(function (_context0) {
      while (1) switch (_context0.prev = _context0.next) {
        case 0:
          //create the slot for the button
          slot = document.createElement("div");
          slot.id = "pg-bt-paypal-button";
          slot.className = "pg-bt-wallet pg-bt-wallet-paypal";
          //add the slot to the root
          grid = root.querySelector(".pg-bt-wallets-grid");
          if (grid) {
            root.insertBefore(slot, grid);
          } else {
            root.appendChild(slot);
          }
          alive = true; //initialise the component with the client
          _context0.next = 1;
          return paypalCheckout.create({
            client: client
          });
        case 1:
          checkout = _context0.sent;
          teardowns.push(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function (_context4) {
              while (1) switch (_context4.prev = _context4.next) {
                case 0:
                  alive = false;
                  _context4.next = 1;
                  return checkout.teardown();
                case 1:
                case "end":
                  return _context4.stop();
              }
            }, _callee);
          })));
          //load the PayPal SDK
          _context0.next = 2;
          return checkout.loadPayPalSDK(_objectSpread$3({
            currency: currency,
            // Authorize only (match the card flow); funds are captured later by the backend.
            // Braintree requires this intent to match the one passed to createPayment below.
            intent: "authorize",
            components: "buttons,messages",
            "enable-funding": "paylater"
          }, isProduction ? {} : {
            "buyer-country": "US"
          }));
        case 2:
          if (!(!alive || !slot.isConnected)) {
            _context0.next = 3;
            break;
          }
          return _context0.abrupt("return");
        case 3:
          //get the PayPal SDK
          paypalSdk = window.paypal;
          if (paypalSdk !== null && paypalSdk !== void 0 && paypalSdk.Buttons) {
            _context0.next = 4;
            break;
          }
          walletError(slot, "PayPal could not be loaded.");
          return _context0.abrupt("return");
        case 4:
          //create the buttons
          createButtons = paypalSdk.Buttons; // Authorize-first for both PayPal and Pay Later, consistent with the card flow.
          // "capture" would force immediate settlement (Braintree ignores the server-side
          // submitForSettlement when intent is capture); the backend captures later instead.
          flow = optionString(options, "flow") === "vault" ? "vault" : "checkout";
          intent = "authorize";
          activeButtons = [];
          closeActiveButtons = /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              var closing, _i, _closing, button, _button$close, _t;
              return _regeneratorRuntime.wrap(function (_context5) {
                while (1) switch (_context5.prev = _context5.next) {
                  case 0:
                    closing = activeButtons;
                    activeButtons = [];
                    _i = 0, _closing = closing;
                  case 1:
                    if (!(_i < _closing.length)) {
                      _context5.next = 6;
                      break;
                    }
                    button = _closing[_i];
                    _context5.prev = 2;
                    _context5.next = 3;
                    return (_button$close = button.close) === null || _button$close === void 0 ? void 0 : _button$close.call(button);
                  case 3:
                    _context5.next = 5;
                    break;
                  case 4:
                    _context5.prev = 4;
                    _t = _context5["catch"](2);
                    console.log("PayPal button close", _t);
                  case 5:
                    _i++;
                    _context5.next = 1;
                    break;
                  case 6:
                  case "end":
                    return _context5.stop();
                }
              }, _callee2, null, [[2, 4]]);
            }));
            return function closeActiveButtons() {
              return _ref2.apply(this, arguments);
            };
          }();
          teardowns.push(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
            return _regeneratorRuntime.wrap(function (_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  alive = false;
                  _context6.next = 1;
                  return closeActiveButtons();
                case 1:
                case "end":
                  return _context6.stop();
              }
            }, _callee3);
          })));
          renderChain = _Promise.resolve();
          renderButtons = function renderButtons(dark) {
            renderChain = renderChain.then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
              var _paypalSdk$FUNDING, _paypalSdk$FUNDING2;
              var paypalHost, messageHost, payLaterHost, buttons, renders, payLaterFunding, _payLaterButtons$isEl, payLaterButtons, eligible;
              return _regeneratorRuntime.wrap(function (_context9) {
                while (1) switch (_context9.prev = _context9.next) {
                  case 0:
                    if (!(!alive || !slot.isConnected || slot.querySelector(".pg-bt-wallet-error"))) {
                      _context9.next = 1;
                      break;
                    }
                    return _context9.abrupt("return");
                  case 1:
                    _context9.next = 2;
                    return closeActiveButtons();
                  case 2:
                    if (!(!alive || !slot.isConnected)) {
                      _context9.next = 3;
                      break;
                    }
                    return _context9.abrupt("return");
                  case 3:
                    slot.replaceChildren();
                    paypalHost = document.createElement("div");
                    paypalHost.id = "pg-bt-paypal-mark";
                    messageHost = document.createElement("div");
                    messageHost.id = "pg-bt-paylater-message";
                    payLaterHost = document.createElement("div");
                    payLaterHost.id = "pg-bt-paylater-button";
                    slot.append(paypalHost, messageHost, payLaterHost);
                    buttons = createButtons(_objectSpread$3(_objectSpread$3({}, (_paypalSdk$FUNDING = paypalSdk.FUNDING) !== null && _paypalSdk$FUNDING !== void 0 && _paypalSdk$FUNDING.PAYPAL ? {
                      fundingSource: paypalSdk.FUNDING.PAYPAL
                    } : {}), {}, {
                      style: {
                        height: 44,
                        shape: "rect",
                        color: dark ? "black" : "white",
                        label: "paypal"
                      },
                      createOrder: function createOrder() {
                        return checkout.createPayment({
                          flow: flow,
                          amount: amount,
                          currency: currency,
                          intent: intent
                        });
                      },
                      onApprove: function () {
                        var _onApprove = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(data) {
                          var payload;
                          return _regeneratorRuntime.wrap(function (_context7) {
                            while (1) switch (_context7.prev = _context7.next) {
                              case 0:
                                _context7.next = 1;
                                return checkout.tokenizePayment(_objectSpread$3(_objectSpread$3({}, data), {}, {
                                  vault: flow === "vault"
                                }));
                              case 1:
                                payload = _context7.sent;
                                if (payload.nonce) {
                                  _context7.next = 2;
                                  break;
                                }
                                _onError("PayPal did not return a payment method.");
                                return _context7.abrupt("return", payload);
                              case 2:
                                _context7.next = 3;
                                return onNonce(payload.nonce);
                              case 3:
                                return _context7.abrupt("return", payload);
                              case 4:
                              case "end":
                                return _context7.stop();
                            }
                          }, _callee4);
                        }));
                        function onApprove(_x38) {
                          return _onApprove.apply(this, arguments);
                        }
                        return onApprove;
                      }(),
                      onError: function onError(error) {
                        var message = paypalStatusMessage(error);
                        var showStatus = function showStatus() {
                          void closeActiveButtons();
                          slot.replaceChildren();
                          walletError(slot, message);
                        };
                        showStatus();
                        _setTimeout(showStatus, 0);
                      }
                    }));
                    activeButtons.push(buttons);
                    renders = [_Promise.resolve(buttons.render("#".concat(paypalHost.id)))];
                    payLaterFunding = (_paypalSdk$FUNDING2 = paypalSdk.FUNDING) === null || _paypalSdk$FUNDING2 === void 0 ? void 0 : _paypalSdk$FUNDING2.PAYLATER;
                    if (payLaterFunding) {
                      payLaterButtons = createButtons({
                        fundingSource: payLaterFunding,
                        style: {
                          height: 44,
                          shape: "rect",
                          color: dark ? "black" : "white"
                        },
                        createOrder: function createOrder() {
                          return checkout.createPayment({
                            flow: flow,
                            amount: amount,
                            currency: currency,
                            intent: intent,
                            offerPayLater: true
                          });
                        },
                        onApprove: function () {
                          var _onApprove2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(data) {
                            var payload;
                            return _regeneratorRuntime.wrap(function (_context8) {
                              while (1) switch (_context8.prev = _context8.next) {
                                case 0:
                                  _context8.next = 1;
                                  return checkout.tokenizePayment(_objectSpread$3(_objectSpread$3({}, data), {}, {
                                    vault: false
                                  }));
                                case 1:
                                  payload = _context8.sent;
                                  if (payload.nonce) {
                                    _context8.next = 2;
                                    break;
                                  }
                                  _onError("PayPal did not return a payment method.");
                                  return _context8.abrupt("return", payload);
                                case 2:
                                  _context8.next = 3;
                                  return onNonce(payload.nonce);
                                case 3:
                                  return _context8.abrupt("return", payload);
                                case 4:
                                case "end":
                                  return _context8.stop();
                              }
                            }, _callee5);
                          }));
                          function onApprove(_x39) {
                            return _onApprove2.apply(this, arguments);
                          }
                          return onApprove;
                        }(),
                        onError: function onError(error) {
                          _onError(paypalStatusMessage(error));
                        }
                      });
                      eligible = ((_payLaterButtons$isEl = payLaterButtons.isEligible) === null || _payLaterButtons$isEl === void 0 ? void 0 : _payLaterButtons$isEl.call(payLaterButtons)) !== false;
                      if (eligible) {
                        activeButtons.push(payLaterButtons);
                        renders.push(_Promise.resolve(payLaterButtons.render("#".concat(payLaterHost.id))));
                        if (paypalSdk.Messages) {
                          renders.push(_Promise.resolve(paypalSdk.Messages({
                            amount: amount,
                            placement: "payment",
                            style: {
                              layout: "text",
                              logo: {
                                type: "inline"
                              },
                              text: {
                                color: dark ? "white" : "black"
                              }
                            }
                          }).render("#".concat(messageHost.id))));
                        }
                      } else {
                        payLaterHost.remove();
                        messageHost.remove();
                      }
                    }
                    _context9.next = 4;
                    return _Promise.all(renders);
                  case 4:
                  case "end":
                    return _context9.stop();
                }
              }, _callee6);
            }))).catch(function (error) {
              if (!alive || !slot.isConnected) {
                return;
              }
              walletError(slot, paypalStatusMessage(error));
            });
          };
          renderButtons(theme.isDark());
          theme.subscribe(renderButtons);
        case 5:
        case "end":
          return _context0.stop();
      }
    }, _callee7);
  }));
  return _mountPayPal.apply(this, arguments);
}
function mountGooglePay(_x1, _x10, _x11, _x12, _x13, _x14, _x15, _x16, _x17, _x18) {
  return _mountGooglePay.apply(this, arguments);
}
function _mountGooglePay() {
  _mountGooglePay = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee0(root, client, options, amount, currency, isProduction, theme, onNonce, onError, teardowns) {
    var merchantId, googlePayVersion, instance, storedTransaction, paymentDataRequest, paymentsClient, ready, slot, paint;
    return _regeneratorRuntime.wrap(function (_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 1;
          return loadScript("https://pay.google.com/gp/p/js/pay.js");
        case 1:
          merchantId = optionString(options, "merchantId");
          googlePayVersion = options.googlePayVersion === 1 ? 1 : 2;
          _context11.next = 2;
          return googlePayment.create(_objectSpread$3({
            client: client,
            googlePayVersion: googlePayVersion
          }, merchantId ? {
            googleMerchantId: merchantId
          } : {}));
        case 2:
          instance = _context11.sent;
          teardowns.push(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
            var teardown;
            return _regeneratorRuntime.wrap(function (_context1) {
              while (1) switch (_context1.prev = _context1.next) {
                case 0:
                  teardown = instance.teardown;
                  _context1.next = 1;
                  return teardown === null || teardown === void 0 ? void 0 : teardown();
                case 1:
                case "end":
                  return _context1.stop();
              }
            }, _callee8);
          })));
          storedTransaction = isRecord(options.transactionInfo) ? options.transactionInfo : {};
          paymentDataRequest = instance.createPaymentDataRequest({
            transactionInfo: _objectSpread$3(_objectSpread$3({}, storedTransaction), {}, {
              currencyCode: currency,
              totalPriceStatus: "FINAL",
              totalPrice: amount
            })
          });
          paymentsClient = new google.payments.api.PaymentsClient({
            environment: isProduction ? "PRODUCTION" : "TEST"
          });
          _context11.next = 3;
          return paymentsClient.isReadyToPay({
            apiVersion: 2,
            apiVersionMinor: 0,
            allowedPaymentMethods: paymentDataRequest.allowedPaymentMethods
          });
        case 3:
          ready = _context11.sent;
          if (ready.result) {
            _context11.next = 4;
            break;
          }
          return _context11.abrupt("return");
        case 4:
          slot = document.createElement("div");
          slot.className = "pg-bt-wallet pg-bt-wallet-google";
          paint = function paint(dark) {
            var button = paymentsClient.createButton({
              buttonType: "plain",
              buttonColor: dark ? "black" : "white",
              buttonSizeMode: "fill",
              buttonRadius: 8,
              allowedPaymentMethods: paymentDataRequest.allowedPaymentMethods,
              onClick: function onClick() {
                void _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
                  var paymentData, payload, _t2;
                  return _regeneratorRuntime.wrap(function (_context10) {
                    while (1) switch (_context10.prev = _context10.next) {
                      case 0:
                        _context10.prev = 0;
                        _context10.next = 1;
                        return paymentsClient.loadPaymentData(paymentDataRequest);
                      case 1:
                        paymentData = _context10.sent;
                        _context10.next = 2;
                        return instance.parseResponse(paymentData);
                      case 2:
                        payload = _context10.sent;
                        if (payload.nonce) {
                          _context10.next = 3;
                          break;
                        }
                        onError("Google Pay did not return a payment method.");
                        return _context10.abrupt("return");
                      case 3:
                        _context10.next = 4;
                        return onNonce(payload.nonce, "googlePay");
                      case 4:
                        _context10.next = 6;
                        break;
                      case 5:
                        _context10.prev = 5;
                        _t2 = _context10["catch"](0);
                        if (!isCancellation(_t2)) {
                          onError(errorMessage(_t2));
                        }
                      case 6:
                      case "end":
                        return _context10.stop();
                    }
                  }, _callee9, null, [[0, 5]]);
                }))();
              }
            });
            slot.replaceChildren(button);
          };
          paint(theme.isDark());
          theme.subscribe(paint);
          root.appendChild(slot);
        case 5:
        case "end":
          return _context11.stop();
      }
    }, _callee0);
  }));
  return _mountGooglePay.apply(this, arguments);
}
function mountVenmo(_x19, _x20, _x21, _x22, _x23, _x24) {
  return _mountVenmo.apply(this, arguments);
}
function _mountVenmo() {
  _mountVenmo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(root, client, options, onNonce, onError, teardowns) {
    var profileId, paymentMethodUsage, instance, button, slot;
    return _regeneratorRuntime.wrap(function (_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          profileId = optionString(options, "profileId"); // multi_use allows vaulting for later on-demand charges (not Braintree Subscriptions).
          // https://developer.paypal.com/braintree/docs/guides/venmo/client-side/javascript/v3/
          paymentMethodUsage = optionString(options, "paymentMethodUsage") === "single_use" ? "single_use" : "multi_use";
          _context14.next = 1;
          return venmo.create(_objectSpread$3({
            client: client,
            allowDesktop: options.allowDesktop !== false,
            // Desktop shows the Venmo QR code. Web login only when explicitly requested.
            // https://developer.paypal.com/braintree/docs/guides/venmo/client-side/javascript/v3/
            allowDesktopWebLogin: options.allowDesktopWebLogin === true,
            allowNewBrowserTab: options.allowNewBrowserTab === true,
            paymentMethodUsage: paymentMethodUsage
          }, profileId ? {
            profileId: profileId
          } : {}));
        case 1:
          instance = _context14.sent;
          teardowns.push(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee1() {
            return _regeneratorRuntime.wrap(function (_context12) {
              while (1) switch (_context12.prev = _context12.next) {
                case 0:
                  _context12.next = 1;
                  return instance.teardown();
                case 1:
                case "end":
                  return _context12.stop();
              }
            }, _callee1);
          })));
          if (instance.isBrowserSupported()) {
            _context14.next = 2;
            break;
          }
          return _context14.abrupt("return", undefined);
        case 2:
          button = document.createElement("button");
          button.type = "button";
          button.className = "pg-bt-wallet-button pg-bt-venmo-button";
          button.textContent = "Venmo";
          button.addEventListener("click", function () {
            void _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
              var payload, _t3;
              return _regeneratorRuntime.wrap(function (_context13) {
                while (1) switch (_context13.prev = _context13.next) {
                  case 0:
                    _context13.prev = 0;
                    _context13.next = 1;
                    return instance.tokenize();
                  case 1:
                    payload = _context13.sent;
                    if (payload.nonce) {
                      _context13.next = 2;
                      break;
                    }
                    onError("Venmo did not return a payment method.");
                    return _context13.abrupt("return");
                  case 2:
                    _context13.next = 3;
                    return onNonce(payload.nonce, "venmo");
                  case 3:
                    _context13.next = 5;
                    break;
                  case 4:
                    _context13.prev = 4;
                    _t3 = _context13["catch"](0);
                    if (!isCancellation(_t3)) {
                      onError(errorMessage(_t3));
                    }
                  case 5:
                  case "end":
                    return _context13.stop();
                }
              }, _callee10, null, [[0, 4]]);
            }))();
          });
          slot = document.createElement("div");
          slot.className = "pg-bt-wallet pg-bt-wallet-venmo";
          slot.appendChild(button);
          root.appendChild(slot);
          return _context14.abrupt("return", slot);
        case 3:
        case "end":
          return _context14.stop();
      }
    }, _callee11);
  }));
  return _mountVenmo.apply(this, arguments);
}
function mountApplePay(_x25, _x26, _x27, _x28, _x29, _x30, _x31, _x32) {
  return _mountApplePay.apply(this, arguments);
}
function _mountApplePay() {
  _mountApplePay = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee14(root, client, options, amount, theme, onNonce, onError, teardowns) {
    var ApplePaySession, instance, displayName, storedRequest, storedTotal, label, button, paintApple, slot;
    return _regeneratorRuntime.wrap(function (_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          ApplePaySession = applePaySessionConstructor();
          if (!(!ApplePaySession || !ApplePaySession.supportsVersion(3) || !ApplePaySession.canMakePayments())) {
            _context17.next = 1;
            break;
          }
          return _context17.abrupt("return");
        case 1:
          _context17.next = 2;
          return applePay.create({
            client: client
          });
        case 2:
          instance = _context17.sent;
          teardowns.push(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
            return _regeneratorRuntime.wrap(function (_context15) {
              while (1) switch (_context15.prev = _context15.next) {
                case 0:
                  _context15.next = 1;
                  return instance.teardown();
                case 1:
                case "end":
                  return _context15.stop();
              }
            }, _callee12);
          })));
          displayName = optionString(options, "displayName") || "Store";
          storedRequest = isRecord(options.paymentRequest) ? options.paymentRequest : {};
          storedTotal = isRecord(storedRequest.total) ? storedRequest.total : {};
          label = typeof storedTotal.label === "string" ? storedTotal.label : displayName;
          button = document.createElement("button");
          button.type = "button";
          paintApple = function paintApple(dark) {
            button.classList.toggle("pg-bt-apple-pay-dark", dark);
          };
          button.className = "pg-bt-apple-pay-button";
          paintApple(theme.isDark());
          theme.subscribe(paintApple);
          button.setAttribute("aria-label", "Apple Pay");
          button.addEventListener("click", function () {
            var paymentRequest = instance.createPaymentRequest(_objectSpread$3(_objectSpread$3({}, storedRequest), {}, {
              total: {
                label: label,
                amount: amount
              }
            }));
            var session = new ApplePaySession(3, paymentRequest);
            session.onvalidatemerchant = function (event) {
              void instance.performValidation({
                validationURL: event.validationURL,
                displayName: displayName
              }).then(function (merchantSession) {
                session.completeMerchantValidation(merchantSession);
              }).catch(function (error) {
                session.abort();
                onError(errorMessage(error));
              });
            };
            session.onpaymentauthorized = function (event) {
              void instance.tokenize({
                token: event.payment.token
              }).then(/*#__PURE__*/function () {
                var _ref0 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13(payload) {
                  var authorized;
                  return _regeneratorRuntime.wrap(function (_context16) {
                    while (1) switch (_context16.prev = _context16.next) {
                      case 0:
                        if (payload.nonce) {
                          _context16.next = 1;
                          break;
                        }
                        session.completePayment(ApplePaySession.STATUS_FAILURE);
                        onError("Apple Pay did not return a payment method.");
                        return _context16.abrupt("return");
                      case 1:
                        _context16.next = 2;
                        return onNonce(payload.nonce, "applePay");
                      case 2:
                        authorized = _context16.sent;
                        if (!nonceAuthorizationFailed(authorized)) {
                          _context16.next = 3;
                          break;
                        }
                        session.completePayment(ApplePaySession.STATUS_FAILURE);
                        return _context16.abrupt("return");
                      case 3:
                        session.completePayment(ApplePaySession.STATUS_SUCCESS);
                      case 4:
                      case "end":
                        return _context16.stop();
                    }
                  }, _callee13);
                }));
                return function (_x40) {
                  return _ref0.apply(this, arguments);
                };
              }()).catch(function (error) {
                session.completePayment(ApplePaySession.STATUS_FAILURE);
                onError(errorMessage(error));
              });
            };
            session.begin();
          });
          slot = document.createElement("div");
          slot.className = "pg-bt-wallet pg-bt-wallet-apple";
          slot.appendChild(button);
          root.appendChild(slot);
        case 3:
        case "end":
          return _context17.stop();
      }
    }, _callee14);
  }));
  return _mountApplePay.apply(this, arguments);
}
function paypalInstrument(type) {
  var _context3;
  return typeof type === "string" && _includesInstanceProperty(_context3 = type.toLowerCase().replace(/[\s_]/g, "")).call(_context3, "paypal");
}
function saveCardWalletRoot(container) {
  var existing = container.querySelector(":scope > .pg-bt-wallets");
  if (existing instanceof HTMLElement) {
    return existing;
  }
  var root = document.createElement("div");
  root.className = "pg-bt-wallets";
  var divider = document.createElement("div");
  divider.className = "pg-bt-wallets-divider";
  divider.textContent = "or";
  root.appendChild(divider);
  container.appendChild(root);
  return root;
}
function removeWalletRootIfEmpty(root) {
  if (root.dataset.pgWalletMounting === "true") {
    return;
  }
  if (root.querySelector(".pg-bt-wallet, .pg-bt-wallet-error") == null) {
    root.remove();
  }
}
function appendWalletSkeletons(root) {
  var skeleton = document.createElement("div");
  skeleton.className = "pg-bt-wallet-skeletons";
  skeleton.setAttribute("aria-hidden", "true");
  var first = document.createElement("div");
  first.className = "pg-bt-wallet-skeleton";
  var second = document.createElement("div");
  second.className = "pg-bt-wallet-skeleton";
  skeleton.append(first, second);
  root.appendChild(skeleton);
  return skeleton;
}
function finishWalletLoading(root, skeleton) {
  skeleton.remove();
  root.classList.remove("pg-bt-wallets-loading");
  root.removeAttribute("aria-busy");
  delete root.dataset.pgWalletMounting;
}
function openWalletLoading(container) {
  var root = saveCardWalletRoot(container);
  root.classList.add("pg-bt-wallets-loading");
  root.dataset.pgWalletMounting = "true";
  root.setAttribute("aria-busy", "true");
  var skeleton = appendWalletSkeletons(root);
  return function () {
    finishWalletLoading(root, skeleton);
    removeWalletRootIfEmpty(root);
  };
}
function mountGooglePayVaultButton(_x33) {
  return _mountGooglePayVaultButton.apply(this, arguments);
}
function _mountGooglePayVaultButton() {
  _mountGooglePayVaultButton = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee20(input) {
    var teardowns, root, slot, theme, teardownMounted, alive, instance, merchantId, googlePayVersion, storedTransaction, _paymentDataRequest, transactionInfo, price, _paymentsClient, ready, paint, _t7, _t8;
    return _regeneratorRuntime.wrap(function (_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          teardowns = [];
          root = saveCardWalletRoot(input.container);
          slot = document.createElement("div");
          slot.id = "pg-bt-google-pay-vault-button";
          slot.className = "pg-bt-wallet pg-bt-wallet-google";
          root.appendChild(slot);
          theme = watchCheckoutTheme();
          teardowns.push(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
            return _regeneratorRuntime.wrap(function (_context18) {
              while (1) switch (_context18.prev = _context18.next) {
                case 0:
                  theme.stop();
                  slot.remove();
                  removeWalletRootIfEmpty(root);
                case 1:
                case "end":
                  return _context18.stop();
              }
            }, _callee15);
          })));
          teardownMounted = /*#__PURE__*/function () {
            var _ref10 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
              var _iterator, _step, teardown, _t4, _t5;
              return _regeneratorRuntime.wrap(function (_context19) {
                while (1) switch (_context19.prev = _context19.next) {
                  case 0:
                    _iterator = _createForOfIteratorHelper$2(_reverseInstanceProperty(teardowns).call(teardowns));
                    _context19.prev = 1;
                    _iterator.s();
                  case 2:
                    if ((_step = _iterator.n()).done) {
                      _context19.next = 7;
                      break;
                    }
                    teardown = _step.value;
                    _context19.prev = 3;
                    _context19.next = 4;
                    return teardown();
                  case 4:
                    _context19.next = 6;
                    break;
                  case 5:
                    _context19.prev = 5;
                    _t4 = _context19["catch"](3);
                    console.log("Google Pay vault teardown", _t4);
                  case 6:
                    _context19.next = 2;
                    break;
                  case 7:
                    _context19.next = 9;
                    break;
                  case 8:
                    _context19.prev = 8;
                    _t5 = _context19["catch"](1);
                    _iterator.e(_t5);
                  case 9:
                    _context19.prev = 9;
                    _iterator.f();
                    return _context19.finish(9);
                  case 10:
                  case "end":
                    return _context19.stop();
                }
              }, _callee16, null, [[1, 8, 9, 10], [3, 5]]);
            }));
            return function teardownMounted() {
              return _ref10.apply(this, arguments);
            };
          }();
          alive = true;
          _context23.prev = 1;
          _context23.next = 2;
          return loadScript("https://pay.google.com/gp/p/js/pay.js");
        case 2:
          merchantId = optionString(input.options, "merchantId");
          googlePayVersion = input.options.googlePayVersion === 1 ? 1 : 2;
          _context23.next = 3;
          return googlePayment.create(_objectSpread$3({
            client: input.client,
            googlePayVersion: googlePayVersion
          }, merchantId ? {
            googleMerchantId: merchantId
          } : {}));
        case 3:
          instance = _context23.sent;
          _context23.next = 6;
          break;
        case 4:
          _context23.prev = 4;
          _t7 = _context23["catch"](1);
          _context23.next = 5;
          return teardownMounted();
        case 5:
          throw _t7;
        case 6:
          teardowns.push(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
            var teardown;
            return _regeneratorRuntime.wrap(function (_context20) {
              while (1) switch (_context20.prev = _context20.next) {
                case 0:
                  alive = false;
                  teardown = instance.teardown;
                  _context20.next = 1;
                  return teardown === null || teardown === void 0 ? void 0 : teardown();
                case 1:
                case "end":
                  return _context20.stop();
              }
            }, _callee17);
          })));
          _context23.prev = 7;
          storedTransaction = isRecord(input.options.transactionInfo) ? input.options.transactionInfo : {};
          _paymentDataRequest = instance.createPaymentDataRequest({
            transactionInfo: _objectSpread$3(_objectSpread$3({}, storedTransaction), {}, {
              currencyCode: input.currency,
              totalPriceStatus: "NOT_CURRENTLY_KNOWN",
              totalPrice: "0.00"
            })
          });
          transactionInfo = _paymentDataRequest.transactionInfo;
          if (transactionInfo) {
            transactionInfo.totalPriceStatus = "NOT_CURRENTLY_KNOWN";
            transactionInfo.checkoutOption = "DEFAULT";
            price = transactionInfo;
            delete price.totalPrice;
          }
          _paymentsClient = new google.payments.api.PaymentsClient({
            environment: input.isProduction ? "PRODUCTION" : "TEST"
          });
          _context23.next = 8;
          return _paymentsClient.isReadyToPay({
            apiVersion: 2,
            apiVersionMinor: 0,
            allowedPaymentMethods: _paymentDataRequest.allowedPaymentMethods
          });
        case 8:
          ready = _context23.sent;
          if (!(!alive || !ready.result)) {
            _context23.next = 10;
            break;
          }
          _context23.next = 9;
          return teardownMounted();
        case 9:
          return _context23.abrupt("return", {
            teardown: function () {
              var _teardown = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
                return _regeneratorRuntime.wrap(function (_context21) {
                  while (1) switch (_context21.prev = _context21.next) {
                    case 0:
                      return _context21.abrupt("return", undefined);
                    case 1:
                    case "end":
                      return _context21.stop();
                  }
                }, _callee18);
              }));
              function teardown() {
                return _teardown.apply(this, arguments);
              }
              return teardown;
            }()
          });
        case 10:
          paint = function paint(dark) {
            if (!alive || !slot.isConnected) {
              return;
            }
            var button = _paymentsClient.createButton({
              buttonType: "plain",
              buttonColor: dark ? "black" : "white",
              buttonSizeMode: "fill",
              buttonRadius: 8,
              allowedPaymentMethods: _paymentDataRequest.allowedPaymentMethods,
              onClick: function onClick() {
                void _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
                  var paymentData, payload, _t6;
                  return _regeneratorRuntime.wrap(function (_context22) {
                    while (1) switch (_context22.prev = _context22.next) {
                      case 0:
                        _context22.prev = 0;
                        _context22.next = 1;
                        return _paymentsClient.loadPaymentData(_paymentDataRequest);
                      case 1:
                        paymentData = _context22.sent;
                        _context22.next = 2;
                        return instance.parseResponse(paymentData);
                      case 2:
                        payload = _context22.sent;
                        if (!paypalInstrument(payload.type)) {
                          _context22.next = 3;
                          break;
                        }
                        input.onError("A PayPal account chosen in Google Pay cannot be saved. Choose a card.");
                        return _context22.abrupt("return");
                      case 3:
                        if (payload.nonce) {
                          _context22.next = 4;
                          break;
                        }
                        input.onError("Google Pay did not return a payment method.");
                        return _context22.abrupt("return");
                      case 4:
                        _context22.next = 5;
                        return input.onNonce(payload.nonce);
                      case 5:
                        _context22.next = 7;
                        break;
                      case 6:
                        _context22.prev = 6;
                        _t6 = _context22["catch"](0);
                        if (!isCancellation(_t6)) {
                          input.onError(errorMessage(_t6));
                        }
                      case 7:
                      case "end":
                        return _context22.stop();
                    }
                  }, _callee19, null, [[0, 6]]);
                }))();
              }
            });
            slot.replaceChildren(button);
          };
          paint(theme.isDark());
          theme.subscribe(paint);
          _context23.next = 13;
          break;
        case 11:
          _context23.prev = 11;
          _t8 = _context23["catch"](7);
          _context23.next = 12;
          return teardownMounted();
        case 12:
          throw _t8;
        case 13:
          return _context23.abrupt("return", {
            teardown: teardownMounted
          });
        case 14:
        case "end":
          return _context23.stop();
      }
    }, _callee20, null, [[1, 4], [7, 11]]);
  }));
  return _mountGooglePayVaultButton.apply(this, arguments);
}
function mountApplePayVaultButton(_x34) {
  return _mountApplePayVaultButton.apply(this, arguments);
}
function _mountApplePayVaultButton() {
  _mountApplePayVaultButton = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee26(input) {
    var ApplePaySession, teardowns, root, slot, button, theme, paintApple, teardownMounted, instance, displayName, managementURL, paymentDescription, storedRequest, _t1;
    return _regeneratorRuntime.wrap(function (_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          ApplePaySession = applePaySessionConstructor();
          if (!(!ApplePaySession || !ApplePaySession.supportsVersion(3) || !ApplePaySession.canMakePayments())) {
            _context29.next = 1;
            break;
          }
          return _context29.abrupt("return", {
            teardown: function () {
              var _teardown2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
                return _regeneratorRuntime.wrap(function (_context24) {
                  while (1) switch (_context24.prev = _context24.next) {
                    case 0:
                      return _context24.abrupt("return", undefined);
                    case 1:
                    case "end":
                      return _context24.stop();
                  }
                }, _callee21);
              }));
              function teardown() {
                return _teardown2.apply(this, arguments);
              }
              return teardown;
            }()
          });
        case 1:
          teardowns = [];
          root = saveCardWalletRoot(input.container);
          slot = document.createElement("div");
          slot.className = "pg-bt-wallet pg-bt-wallet-apple";
          button = document.createElement("button");
          button.type = "button";
          button.className = "pg-bt-apple-pay-button";
          button.setAttribute("aria-label", "Apple Pay");
          slot.appendChild(button);
          root.appendChild(slot);
          theme = watchCheckoutTheme();
          paintApple = function paintApple(dark) {
            button.classList.toggle("pg-bt-apple-pay-dark", dark);
          };
          paintApple(theme.isDark());
          theme.subscribe(paintApple);
          teardowns.push(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
            return _regeneratorRuntime.wrap(function (_context25) {
              while (1) switch (_context25.prev = _context25.next) {
                case 0:
                  theme.stop();
                  slot.remove();
                  removeWalletRootIfEmpty(root);
                case 1:
                case "end":
                  return _context25.stop();
              }
            }, _callee22);
          })));
          teardownMounted = /*#__PURE__*/function () {
            var _ref14 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
              var _iterator2, _step2, teardown, _t9, _t0;
              return _regeneratorRuntime.wrap(function (_context26) {
                while (1) switch (_context26.prev = _context26.next) {
                  case 0:
                    _iterator2 = _createForOfIteratorHelper$2(_reverseInstanceProperty(teardowns).call(teardowns));
                    _context26.prev = 1;
                    _iterator2.s();
                  case 2:
                    if ((_step2 = _iterator2.n()).done) {
                      _context26.next = 7;
                      break;
                    }
                    teardown = _step2.value;
                    _context26.prev = 3;
                    _context26.next = 4;
                    return teardown();
                  case 4:
                    _context26.next = 6;
                    break;
                  case 5:
                    _context26.prev = 5;
                    _t9 = _context26["catch"](3);
                    console.log("Apple Pay vault teardown", _t9);
                  case 6:
                    _context26.next = 2;
                    break;
                  case 7:
                    _context26.next = 9;
                    break;
                  case 8:
                    _context26.prev = 8;
                    _t0 = _context26["catch"](1);
                    _iterator2.e(_t0);
                  case 9:
                    _context26.prev = 9;
                    _iterator2.f();
                    return _context26.finish(9);
                  case 10:
                  case "end":
                    return _context26.stop();
                }
              }, _callee23, null, [[1, 8, 9, 10], [3, 5]]);
            }));
            return function teardownMounted() {
              return _ref14.apply(this, arguments);
            };
          }();
          _context29.prev = 2;
          _context29.next = 3;
          return applePay.create({
            client: input.client
          });
        case 3:
          instance = _context29.sent;
          _context29.next = 6;
          break;
        case 4:
          _context29.prev = 4;
          _t1 = _context29["catch"](2);
          _context29.next = 5;
          return teardownMounted();
        case 5:
          throw _t1;
        case 6:
          teardowns.push(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
            return _regeneratorRuntime.wrap(function (_context27) {
              while (1) switch (_context27.prev = _context27.next) {
                case 0:
                  _context27.next = 1;
                  return instance.teardown();
                case 1:
                case "end":
                  return _context27.stop();
              }
            }, _callee24);
          })));
          displayName = optionString(input.options, "displayName") || "Store";
          managementURL = optionString(input.options, "managementURL") || window.location.origin;
          paymentDescription = optionString(input.options, "paymentDescription") || "Save Apple Pay for future payments";
          storedRequest = isRecord(input.options.paymentRequest) ? input.options.paymentRequest : {};
          button.addEventListener("click", function () {
            // Save does not sell. Braintree vaults the nonce with Payment Method: Create.
            // recurringPaymentRequest asks Apple for a merchant token that can be charged later.
            // The sheet total is 0 because this step does not authorize a purchase.
            var paymentRequest = instance.createPaymentRequest(_objectSpread$3(_objectSpread$3({}, storedRequest), {}, {
              total: {
                label: displayName,
                amount: "0.00"
              }
            }));
            var sessionRequest = _objectSpread$3(_objectSpread$3({}, paymentRequest), {}, {
              recurringPaymentRequest: {
                paymentDescription: paymentDescription,
                managementURL: managementURL,
                regularBilling: {
                  label: displayName,
                  amount: "0.00",
                  type: "pending",
                  paymentTiming: "recurring",
                  recurringPaymentStartDate: new Date().toISOString()
                }
              }
            });
            var session;
            try {
              session = new ApplePaySession(3, sessionRequest);
            } catch (error) {
              input.onError(errorMessage(error));
              return;
            }
            session.onvalidatemerchant = function (event) {
              void instance.performValidation({
                validationURL: event.validationURL,
                displayName: displayName
              }).then(function (merchantSession) {
                session.completeMerchantValidation(merchantSession);
              }).catch(function (error) {
                session.abort();
                input.onError(errorMessage(error));
              });
            };
            session.onpaymentauthorized = function (event) {
              void instance.tokenize({
                token: event.payment.token
              }).then(/*#__PURE__*/function () {
                var _ref16 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee25(payload) {
                  var saved;
                  return _regeneratorRuntime.wrap(function (_context28) {
                    while (1) switch (_context28.prev = _context28.next) {
                      case 0:
                        if (payload.nonce) {
                          _context28.next = 1;
                          break;
                        }
                        session.completePayment(ApplePaySession.STATUS_FAILURE);
                        input.onError("Apple Pay did not return a payment method.");
                        return _context28.abrupt("return");
                      case 1:
                        _context28.next = 2;
                        return input.onNonce(payload.nonce);
                      case 2:
                        saved = _context28.sent;
                        if (!(!isRecord(saved) || saved.success !== true)) {
                          _context28.next = 3;
                          break;
                        }
                        session.completePayment(ApplePaySession.STATUS_FAILURE);
                        return _context28.abrupt("return");
                      case 3:
                        session.completePayment(ApplePaySession.STATUS_SUCCESS);
                      case 4:
                      case "end":
                        return _context28.stop();
                    }
                  }, _callee25);
                }));
                return function (_x41) {
                  return _ref16.apply(this, arguments);
                };
              }()).catch(function (error) {
                session.completePayment(ApplePaySession.STATUS_FAILURE);
                input.onError(errorMessage(error));
              });
            };
            session.oncancel = function () {
              return undefined;
            };
            session.begin();
          });
          return _context29.abrupt("return", {
            teardown: teardownMounted
          });
        case 7:
        case "end":
          return _context29.stop();
      }
    }, _callee26, null, [[2, 4]]);
  }));
  return _mountApplePayVaultButton.apply(this, arguments);
}
function mountVenmoVaultButton(_x35) {
  return _mountVenmoVaultButton.apply(this, arguments);
}
function _mountVenmoVaultButton() {
  _mountVenmoVaultButton = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee31(input) {
    var teardowns, root, slot, teardownMounted, _t12;
    return _regeneratorRuntime.wrap(function (_context34) {
      while (1) switch (_context34.prev = _context34.next) {
        case 0:
          teardowns = [];
          root = saveCardWalletRoot(input.container);
          teardowns.push(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
            var _slot;
            return _regeneratorRuntime.wrap(function (_context30) {
              while (1) switch (_context30.prev = _context30.next) {
                case 0:
                  (_slot = slot) === null || _slot === void 0 || _slot.remove();
                  removeWalletRootIfEmpty(root);
                case 1:
                case "end":
                  return _context30.stop();
              }
            }, _callee27);
          })));
          teardownMounted = /*#__PURE__*/function () {
            var _ref18 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
              var _iterator3, _step3, teardown, _t10, _t11;
              return _regeneratorRuntime.wrap(function (_context31) {
                while (1) switch (_context31.prev = _context31.next) {
                  case 0:
                    _iterator3 = _createForOfIteratorHelper$2(_reverseInstanceProperty(teardowns).call(teardowns));
                    _context31.prev = 1;
                    _iterator3.s();
                  case 2:
                    if ((_step3 = _iterator3.n()).done) {
                      _context31.next = 7;
                      break;
                    }
                    teardown = _step3.value;
                    _context31.prev = 3;
                    _context31.next = 4;
                    return teardown();
                  case 4:
                    _context31.next = 6;
                    break;
                  case 5:
                    _context31.prev = 5;
                    _t10 = _context31["catch"](3);
                    console.log("Venmo vault teardown", _t10);
                  case 6:
                    _context31.next = 2;
                    break;
                  case 7:
                    _context31.next = 9;
                    break;
                  case 8:
                    _context31.prev = 8;
                    _t11 = _context31["catch"](1);
                    _iterator3.e(_t11);
                  case 9:
                    _context31.prev = 9;
                    _iterator3.f();
                    return _context31.finish(9);
                  case 10:
                  case "end":
                    return _context31.stop();
                }
              }, _callee28, null, [[1, 8, 9, 10], [3, 5]]);
            }));
            return function teardownMounted() {
              return _ref18.apply(this, arguments);
            };
          }();
          _context34.prev = 1;
          _context34.next = 2;
          return mountVenmo(root, input.client, input.options, /*#__PURE__*/function () {
            var _ref19 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee29(nonce) {
              return _regeneratorRuntime.wrap(function (_context32) {
                while (1) switch (_context32.prev = _context32.next) {
                  case 0:
                    _context32.next = 1;
                    return input.onNonce(nonce);
                  case 1:
                  case "end":
                    return _context32.stop();
                }
              }, _callee29);
            }));
            return function (_x42) {
              return _ref19.apply(this, arguments);
            };
          }(), input.onError, teardowns);
        case 2:
          slot = _context34.sent;
          _context34.next = 5;
          break;
        case 3:
          _context34.prev = 3;
          _t12 = _context34["catch"](1);
          _context34.next = 4;
          return teardownMounted();
        case 4:
          throw _t12;
        case 5:
          if (slot) {
            _context34.next = 7;
            break;
          }
          _context34.next = 6;
          return teardownMounted();
        case 6:
          return _context34.abrupt("return", {
            teardown: function () {
              var _teardown3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
                return _regeneratorRuntime.wrap(function (_context33) {
                  while (1) switch (_context33.prev = _context33.next) {
                    case 0:
                      return _context33.abrupt("return", undefined);
                    case 1:
                    case "end":
                      return _context33.stop();
                  }
                }, _callee30);
              }));
              function teardown() {
                return _teardown3.apply(this, arguments);
              }
              return teardown;
            }()
          });
        case 7:
          return _context34.abrupt("return", {
            teardown: teardownMounted
          });
        case 8:
        case "end":
          return _context34.stop();
      }
    }, _callee31, null, [[1, 3]]);
  }));
  return _mountVenmoVaultButton.apply(this, arguments);
}
function paypalVaultDescription(options) {
  var direct = optionString(options, "billingAgreementDescription");
  if (direct) {
    return direct;
  }
  var details = optionRecord(options, "billingAgreementDetails");
  return optionString(details, "description") || "Save PayPal for future payments";
}
function mountPayPalVaultButton(_x36) {
  return _mountPayPalVaultButton.apply(this, arguments);
}
function _mountPayPalVaultButton() {
  _mountPayPalVaultButton = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee38(input) {
    var teardowns, root, slot, theme, teardownMounted, alive, checkout, paypalSdk, createButtons, description, activeButtons, renderChain, renderButtons, _t16, _t17;
    return _regeneratorRuntime.wrap(function (_context41) {
      while (1) switch (_context41.prev = _context41.next) {
        case 0:
          teardowns = [];
          root = saveCardWalletRoot(input.container);
          slot = document.createElement("div");
          slot.id = "pg-bt-paypal-vault-button";
          slot.className = "pg-bt-wallet pg-bt-wallet-paypal";
          root.appendChild(slot);
          theme = watchCheckoutTheme();
          teardowns.push(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee32() {
            return _regeneratorRuntime.wrap(function (_context35) {
              while (1) switch (_context35.prev = _context35.next) {
                case 0:
                  theme.stop();
                  slot.remove();
                  removeWalletRootIfEmpty(root);
                case 1:
                case "end":
                  return _context35.stop();
              }
            }, _callee32);
          })));
          teardownMounted = /*#__PURE__*/function () {
            var _ref21 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee33() {
              var _iterator4, _step4, teardown, _t13, _t14;
              return _regeneratorRuntime.wrap(function (_context36) {
                while (1) switch (_context36.prev = _context36.next) {
                  case 0:
                    _iterator4 = _createForOfIteratorHelper$2(_reverseInstanceProperty(teardowns).call(teardowns));
                    _context36.prev = 1;
                    _iterator4.s();
                  case 2:
                    if ((_step4 = _iterator4.n()).done) {
                      _context36.next = 7;
                      break;
                    }
                    teardown = _step4.value;
                    _context36.prev = 3;
                    _context36.next = 4;
                    return teardown();
                  case 4:
                    _context36.next = 6;
                    break;
                  case 5:
                    _context36.prev = 5;
                    _t13 = _context36["catch"](3);
                    console.log("PayPal vault teardown", _t13);
                  case 6:
                    _context36.next = 2;
                    break;
                  case 7:
                    _context36.next = 9;
                    break;
                  case 8:
                    _context36.prev = 8;
                    _t14 = _context36["catch"](1);
                    _iterator4.e(_t14);
                  case 9:
                    _context36.prev = 9;
                    _iterator4.f();
                    return _context36.finish(9);
                  case 10:
                  case "end":
                    return _context36.stop();
                }
              }, _callee33, null, [[1, 8, 9, 10], [3, 5]]);
            }));
            return function teardownMounted() {
              return _ref21.apply(this, arguments);
            };
          }();
          alive = true;
          _context41.prev = 1;
          _context41.next = 2;
          return paypalCheckout.create({
            client: input.client
          });
        case 2:
          checkout = _context41.sent;
          _context41.next = 5;
          break;
        case 3:
          _context41.prev = 3;
          _t16 = _context41["catch"](1);
          _context41.next = 4;
          return teardownMounted();
        case 4:
          throw _t16;
        case 5:
          teardowns.push(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee34() {
            return _regeneratorRuntime.wrap(function (_context37) {
              while (1) switch (_context37.prev = _context37.next) {
                case 0:
                  alive = false;
                  _context37.next = 1;
                  return checkout.teardown();
                case 1:
                case "end":
                  return _context37.stop();
              }
            }, _callee34);
          })));
          _context41.prev = 6;
          _context41.next = 7;
          return checkout.loadPayPalSDK({
            currency: input.currency,
            intent: "capture",
            vault: true
          });
        case 7:
          _context41.next = 10;
          break;
        case 8:
          _context41.prev = 8;
          _t17 = _context41["catch"](6);
          _context41.next = 9;
          return teardownMounted();
        case 9:
          throw _t17;
        case 10:
          if (!(!alive || !slot.isConnected)) {
            _context41.next = 11;
            break;
          }
          return _context41.abrupt("return", {
            teardown: teardownMounted
          });
        case 11:
          paypalSdk = window.paypal;
          if (paypalSdk !== null && paypalSdk !== void 0 && paypalSdk.Buttons) {
            _context41.next = 12;
            break;
          }
          walletError(slot, "PayPal could not be loaded.");
          return _context41.abrupt("return", {
            teardown: teardownMounted
          });
        case 12:
          createButtons = paypalSdk.Buttons;
          description = paypalVaultDescription(input.options);
          teardowns.push(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee35() {
            var _activeButtons, _activeButtons$close, _t15;
            return _regeneratorRuntime.wrap(function (_context38) {
              while (1) switch (_context38.prev = _context38.next) {
                case 0:
                  alive = false;
                  _context38.prev = 1;
                  _context38.next = 2;
                  return (_activeButtons = activeButtons) === null || _activeButtons === void 0 || (_activeButtons$close = _activeButtons.close) === null || _activeButtons$close === void 0 ? void 0 : _activeButtons$close.call(_activeButtons);
                case 2:
                  _context38.next = 4;
                  break;
                case 3:
                  _context38.prev = 3;
                  _t15 = _context38["catch"](1);
                  console.log("PayPal vault button close", _t15);
                case 4:
                case "end":
                  return _context38.stop();
              }
            }, _callee35, null, [[1, 3]]);
          })));
          renderChain = _Promise.resolve();
          renderButtons = function renderButtons(dark) {
            renderChain = renderChain.then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee37() {
              var _activeButtons2, _activeButtons2$close, _paypalSdk$FUNDING3;
              var buttons;
              return _regeneratorRuntime.wrap(function (_context40) {
                while (1) switch (_context40.prev = _context40.next) {
                  case 0:
                    if (!(!alive || !slot.isConnected || slot.querySelector(".pg-bt-wallet-error"))) {
                      _context40.next = 1;
                      break;
                    }
                    return _context40.abrupt("return");
                  case 1:
                    _context40.next = 2;
                    return (_activeButtons2 = activeButtons) === null || _activeButtons2 === void 0 || (_activeButtons2$close = _activeButtons2.close) === null || _activeButtons2$close === void 0 ? void 0 : _activeButtons2$close.call(_activeButtons2);
                  case 2:
                    if (!(!alive || !slot.isConnected)) {
                      _context40.next = 3;
                      break;
                    }
                    return _context40.abrupt("return");
                  case 3:
                    slot.replaceChildren();
                    buttons = createButtons(_objectSpread$3(_objectSpread$3({}, (_paypalSdk$FUNDING3 = paypalSdk.FUNDING) !== null && _paypalSdk$FUNDING3 !== void 0 && _paypalSdk$FUNDING3.PAYPAL ? {
                      fundingSource: paypalSdk.FUNDING.PAYPAL
                    } : {}), {}, {
                      style: {
                        height: 44,
                        shape: "rect",
                        color: dark ? "black" : "white",
                        label: "paypal"
                      },
                      createBillingAgreement: function createBillingAgreement() {
                        return checkout.createPayment({
                          flow: "vault",
                          intent: "capture",
                          billingAgreementDescription: description
                        });
                      },
                      onApprove: function () {
                        var _onApprove3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee36(data) {
                          var tokenizeInput, payload;
                          return _regeneratorRuntime.wrap(function (_context39) {
                            while (1) switch (_context39.prev = _context39.next) {
                              case 0:
                                tokenizeInput = _objectSpread$3(_objectSpread$3({}, data), {}, {
                                  vault: true
                                });
                                _context39.next = 1;
                                return checkout.tokenizePayment(tokenizeInput);
                              case 1:
                                payload = _context39.sent;
                                if (payload.nonce) {
                                  _context39.next = 2;
                                  break;
                                }
                                input.onError("PayPal did not return a payment method.");
                                return _context39.abrupt("return", payload);
                              case 2:
                                _context39.next = 3;
                                return input.onNonce(payload.nonce);
                              case 3:
                                return _context39.abrupt("return", payload);
                              case 4:
                              case "end":
                                return _context39.stop();
                            }
                          }, _callee36);
                        }));
                        function onApprove(_x43) {
                          return _onApprove3.apply(this, arguments);
                        }
                        return onApprove;
                      }(),
                      onCancel: function onCancel() {
                        return undefined;
                      },
                      onError: function onError(error) {
                        var message = paypalStatusMessage(error);
                        var showStatus = function showStatus() {
                          slot.replaceChildren();
                          walletError(slot, message);
                        };
                        showStatus();
                        _setTimeout(showStatus, 0);
                      }
                    }));
                    activeButtons = buttons;
                    _context40.next = 4;
                    return _Promise.resolve(buttons.render("#".concat(slot.id)));
                  case 4:
                  case "end":
                    return _context40.stop();
                }
              }, _callee37);
            }))).catch(function (error) {
              if (!alive || !slot.isConnected) {
                return;
              }
              walletError(slot, paypalStatusMessage(error));
            });
          };
          renderButtons(theme.isDark());
          theme.subscribe(renderButtons);
          return _context41.abrupt("return", {
            teardown: teardownMounted
          });
        case 13:
        case "end":
          return _context41.stop();
      }
    }, _callee38, null, [[1, 3], [6, 8]]);
  }));
  return _mountPayPalVaultButton.apply(this, arguments);
}
function mountBraintreeWalletButtons(_x37) {
  return _mountBraintreeWalletButtons.apply(this, arguments);
}
function _mountBraintreeWalletButtons() {
  _mountBraintreeWalletButtons = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee42(input) {
    var teardowns, root, grid, divider, skeleton, types, options, theme, mounts;
    return _regeneratorRuntime.wrap(function (_context45) {
      while (1) switch (_context45.prev = _context45.next) {
        case 0:
          teardowns = [];
          root = document.createElement("div");
          root.className = "pg-bt-wallets pg-bt-wallets-loading";
          root.dataset.pgWalletMounting = "true";
          root.setAttribute("aria-busy", "true");
          grid = document.createElement("div");
          grid.className = "pg-bt-wallets-grid";
          if (input.divider !== false) {
            divider = document.createElement("div");
            divider.className = "pg-bt-wallets-divider";
            divider.textContent = "or";
            root.appendChild(divider);
          }
          skeleton = appendWalletSkeletons(root);
          root.appendChild(grid);
          input.container.appendChild(root);
          types = input.paymentMethodTypes;
          options = input.paymentMethodOptions;
          theme = watchCheckoutTheme();
          teardowns.push(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee39() {
            return _regeneratorRuntime.wrap(function (_context42) {
              while (1) switch (_context42.prev = _context42.next) {
                case 0:
                  theme.stop();
                case 1:
                case "end":
                  return _context42.stop();
              }
            }, _callee39);
          })));
          mounts = [];
          if (methodEnabled(types, "paypal")) {
            mounts.push(mountPayPal(root, input.client, optionRecord(options, "paypal"), input.amount, input.currency, input.isProduction, theme, /*#__PURE__*/function () {
              var _ref26 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee40(nonce) {
                return _regeneratorRuntime.wrap(function (_context43) {
                  while (1) switch (_context43.prev = _context43.next) {
                    case 0:
                      _context43.next = 1;
                      return input.onNonce(nonce, "paypal");
                    case 1:
                    case "end":
                      return _context43.stop();
                  }
                }, _callee40);
              }));
              return function (_x44) {
                return _ref26.apply(this, arguments);
              };
            }(), input.onError, teardowns).catch(function (error) {
              walletError(root, paypalStatusMessage(error));
            }));
          }
          if (methodEnabled(types, "googlePay")) {
            mounts.push(mountGooglePay(grid, input.client, optionRecord(options, "googlePay"), input.amount, input.currency, input.isProduction, theme, input.onNonce, input.onError, teardowns).catch(function (error) {
              walletError(grid, errorMessage(error));
            }));
          }
          if (methodEnabled(types, "venmo")) {
            mounts.push(mountVenmo(grid, input.client, optionRecord(options, "venmo"), input.onNonce, input.onError, teardowns).catch(function (error) {
              walletError(grid, errorMessage(error));
            }));
          }
          if (methodEnabled(types, "applePay")) {
            mounts.push(mountApplePay(grid, input.client, optionRecord(options, "applePay"), input.amount, theme, input.onNonce, input.onError, teardowns).catch(function (error) {
              walletError(grid, errorMessage(error));
            }));
          }
          _context45.prev = 1;
          _context45.next = 2;
          return _Promise.allSettled(mounts);
        case 2:
          _context45.prev = 2;
          finishWalletLoading(root, skeleton);
          return _context45.finish(2);
        case 3:
          if (grid.childElementCount === 0) {
            grid.remove();
          }
          if (root.querySelector(".pg-bt-wallet, .pg-bt-wallet-error") == null) {
            root.remove();
          }
          return _context45.abrupt("return", {
            teardown: function () {
              var _teardown4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee41() {
                var _iterator5, _step5, _teardown5, _t18, _t19;
                return _regeneratorRuntime.wrap(function (_context44) {
                  while (1) switch (_context44.prev = _context44.next) {
                    case 0:
                      root.remove();
                      _iterator5 = _createForOfIteratorHelper$2(_reverseInstanceProperty(teardowns).call(teardowns));
                      _context44.prev = 1;
                      _iterator5.s();
                    case 2:
                      if ((_step5 = _iterator5.n()).done) {
                        _context44.next = 7;
                        break;
                      }
                      _teardown5 = _step5.value;
                      _context44.prev = 3;
                      _context44.next = 4;
                      return _teardown5();
                    case 4:
                      _context44.next = 6;
                      break;
                    case 5:
                      _context44.prev = 5;
                      _t18 = _context44["catch"](3);
                      console.log("Braintree wallet teardown", _t18);
                    case 6:
                      _context44.next = 2;
                      break;
                    case 7:
                      _context44.next = 9;
                      break;
                    case 8:
                      _context44.prev = 8;
                      _t19 = _context44["catch"](1);
                      _iterator5.e(_t19);
                    case 9:
                      _context44.prev = 9;
                      _iterator5.f();
                      return _context44.finish(9);
                    case 10:
                    case "end":
                      return _context44.stop();
                  }
                }, _callee41, null, [[1, 8, 9, 10], [3, 5]]);
              }));
              function teardown() {
                return _teardown4.apply(this, arguments);
              }
              return teardown;
            }()
          });
        case 4:
        case "end":
          return _context45.stop();
      }
    }, _callee42, null, [[1,, 2, 3]]);
  }));
  return _mountBraintreeWalletButtons.apply(this, arguments);
}

function ownKeys$2(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var _context4, _context5; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context4 = ownKeys$2(Object(t), true)).call(_context4, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context5 = ownKeys$2(Object(t))).call(_context5, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function optionalClient(value) {
  return value;
}
var FlywireGateway = /*#__PURE__*/function () {
  function FlywireGateway() {
    _classCallCheck(this, FlywireGateway);
    _defineProperty(this, "provider", "flywire");
    _defineProperty(this, "publishableKey", void 0);
    _defineProperty(this, "company_code", void 0);
  }
  return _createClass(FlywireGateway, [{
    key: "setElements",
    value: function setElements() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "getElements",
    value: function getElements() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "setCardElement",
    value: function setCardElement() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "getCardElement",
    value: function getCardElement() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "getFlywirePayment",
    value: function getFlywirePayment() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "getNMIGateway",
    value: function getNMIGateway() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "confirmCardPaymentWithCVC",
    value: function confirmCardPaymentWithCVC() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "showLoader",
    value: function showLoader() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "hideLoader",
    value: function hideLoader() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "getNMIPayment",
    value: function getNMIPayment() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "getProviderClient",
    value: function getProviderClient() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "getClientInstance",
    value: function getClientInstance() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "saveCard",
    value: function () {
      var _saveCard = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(data) {
        var body, response, pIntent, _t;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              body = {
                token: data.token,
                account_id: data.account_id,
                email: data.email,
                card: data.card
              };
              _context.prev = 1;
              _context.next = 2;
              return fetch("".concat(data.apiBaseURL, "/v1/payment/card"), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": data.apiKey,
                  token: data.token
                  // Authorization: `Basic ${btoa(`${this.apiKey}:${this.apiSecret}`)}`,
                },
                body: _JSON$stringify(body)
              });
            case 2:
              response = _context.sent;
              _context.next = 3;
              return response.json();
            case 3:
              pIntent = _context.sent;
              console.log("pIntent ", pIntent);
              return _context.abrupt("return", pIntent);
            case 4:
              _context.prev = 4;
              _t = _context["catch"](1);
              throw new Error("Error: " + _t, {
                cause: _t
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 4]]);
      }));
      function saveCard(_x) {
        return _saveCard.apply(this, arguments);
      }
      return saveCard;
    }()
  }, {
    key: "verify3dSecure",
    value: function verify3dSecure() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "setToken",
    value: function setToken() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "getProviderName",
    value: function getProviderName() {
      return this.provider;
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(publishableKey, containerId, data) {
        var config, loadModel, scriptTag;
        return _regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.publishableKey = publishableKey;
              if (containerId) {
                config = {
                  env: (data === null || data === void 0 ? void 0 : data.is_prod_env) == true ? "prod" : "demo",
                  recipientCode: this.publishableKey || "IPQ",
                  amount: data === null || data === void 0 ? void 0 : data.amount,
                  recurringType: (data === null || data === void 0 ? void 0 : data.recurringType) || "",
                  onInvalidInput: function onInvalidInput(errors) {
                    _forEachInstanceProperty(errors).call(errors, function (error) {
                      console.log("errr " + error.msg);
                    });
                  },
                  embedTo: "#" + containerId.id,
                  // Display payer and custom field input boxes
                  requestPayerInfo: true,
                  requestRecipientInfo: false,
                  firstName: data === null || data === void 0 ? void 0 : data.first_name,
                  lastName: data === null || data === void 0 ? void 0 : data.last_name,
                  email: data === null || data === void 0 ? void 0 : data.email,
                  phone: data === null || data === void 0 ? void 0 : data.phone,
                  // address:null,
                  // city: null,
                  // state: null,
                  // zip: null,
                  country: data === null || data === void 0 ? void 0 : data.country_code,
                  //data?.billing?.address?.country,
                  // Pass in complete custom field information
                  recipientFields: data !== null && data !== void 0 && data.recurringType ? {} : {
                    booking_reference: data === null || data === void 0 ? void 0 : data.payment_id
                  },
                  paymentOptionsConfig: {
                    sort: [{
                      currency: ["foreign", "local"]
                    }, {
                      amount: "asc"
                    }, {
                      type: ["credit_card", "direct_debit"]
                    }],
                    filters: {
                      type: ["credit_card", "direct_debit"]
                    }
                  },
                  onCompleteCallback: function () {
                    var _onCompleteCallback = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args) {
                      return _regeneratorRuntime.wrap(function (_context2) {
                        while (1) switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!(data !== null && data !== void 0 && data.recurringType)) {
                              _context2.next = 2;
                              break;
                            }
                            _context2.next = 1;
                            return data === null || data === void 0 ? void 0 : data.processFlywirePayment(_objectSpread$2(_objectSpread$2({}, args), {}, {
                              card: {
                                brand: args.brand,
                                last4: args.digits,
                                exp_month: args.expirationMonth,
                                exp_year: args.expirationYear,
                                token: args.token,
                                paymentMethod: args.paymentMethod,
                                country: data === null || data === void 0 ? void 0 : data.country_code
                              },
                              account_id: data === null || data === void 0 ? void 0 : data.account_id,
                              token: args.token,
                              provider_name: "flywire",
                              email: data === null || data === void 0 ? void 0 : data.email
                            }));
                          case 1:
                            _context2.next = 3;
                            break;
                          case 2:
                            _context2.next = 3;
                            return data === null || data === void 0 ? void 0 : data.processFlywirePayment(_objectSpread$2({}, args));
                          case 3:
                          case "end":
                            return _context2.stop();
                        }
                      }, _callee2);
                    }));
                    function onCompleteCallback(_x5) {
                      return _onCompleteCallback.apply(this, arguments);
                    }
                    return onCompleteCallback;
                  }(),
                  // Supply a nonce to be included in the signature generation
                  nonce: data === null || data === void 0 ? void 0 : data.order_id,
                  // Set the return URL where payers are redirected to on completion
                  returnUrl: data === null || data === void 0 ? void 0 : data.return_url,
                  callbackId: data === null || data === void 0 ? void 0 : data.order_id,
                  callbackUrl: data === null || data === void 0 ? void 0 : data.webhook_url,
                  //  for webhook
                  callbackVersion: "2"
                };
                if (typeof window != "undefined") {
                  loadModel = function loadModel(flywireConfig) {
                    containerId.innerHTML = "";
                    var modal = window.FlywirePayment.initiate(flywireConfig);
                    modal.render();
                  };
                  if (optionalClient(window.FlywirePayment) === undefined) {
                    scriptTag = document.createElement("script");
                    scriptTag.src = "https://checkout.flywire.com/flywire-payment.js";
                    // Wrap the loading logic in a Promise
                    new _Promise(function (resolve, reject) {
                      scriptTag.onload = function () {
                        resolve();
                        // Add event listeners after the script has loaded
                        // const saveButton = document.querySelector('#save-card-tab');
                        // const paymentButton = document.querySelector('#payment-tab');
                        // saveButton?.removeEventListener('click', loadDivs);
                        // saveButton?.addEventListener('click', loadDivs);
                        // paymentButton?.removeEventListener('click', loadDivs);
                        // paymentButton?.addEventListener('click', loadDivs);
                        loadModel(config);
                      };
                      scriptTag.onerror = reject;
                    });
                    // Append the script to the document
                    document.head.appendChild(scriptTag);
                  } else {
                    loadModel(config);
                  }
                }
              } else {
                console.log("init container id not found: ", containerId);
              }
              return _context3.abrupt("return", this);
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function init(_x2, _x3, _x4) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }]);
}();

var img$d = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg id='Layer_2' data-name='Layer 2' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 36.07 24.72'%3e %3cdefs%3e %3cstyle%3e .cls-1 %7b fill: white%3b stroke: %23d4d4d4%3b stroke-miterlimit: 10%3b stroke-width: .81px%3b %7d .cls-2 %7b fill: %23ffab00%3b %7d .cls-2%2c .cls-3 %7b stroke-width: 0px%3b %7d .cls-3 %7b fill: %230023a0%3b %7d %3c/style%3e %3c/defs%3e %3cg id='icons2'%3e %3cg%3e %3crect class='cls-1' x='.41' y='.41' width='35.26' height='23.91' rx='2.07' ry='2.07'/%3e %3cg%3e %3cpath class='cls-3' d='m21.15%2c8.25c-2.22%2c0-3.78%2c1.18-3.8%2c2.87-.01%2c1.25%2c1.12%2c1.95%2c1.97%2c2.37.88.43%2c1.17.7%2c1.17%2c1.08%2c0%2c.58-.7.85-1.35.85-.9%2c0-1.38-.13-2.11-.45l-.29-.14-.31%2c1.95c.53.24%2c1.5.45%2c2.51.46%2c2.36%2c0%2c3.89-1.17%2c3.91-2.97%2c0-.99-.59-1.74-1.89-2.36-.78-.4-1.27-.67-1.26-1.08%2c0-.36.41-.75%2c1.29-.75.74-.01%2c1.27.16%2c1.68.33l.2.1.31-1.89c-.44-.18-1.14-.37-2.01-.37h0Zm-6.98.15l-1.41%2c8.7h2.25l1.41-8.7h-2.25Zm-3.29%2c0l-2.2%2c5.93-.23-1.21c-.55-1.48-1.73-3.03-3.11-3.66l2.01%2c7.62h2.38s3.54-8.69%2c3.54-8.69h-2.38Zm16.31%2c0c-.54%2c0-.94.15-1.18.72l-3.34%2c7.97h2.36s.39-1.07.47-1.31c.26%2c0%2c2.55%2c0%2c2.88%2c0%2c.07.3.27%2c1.3.27%2c1.3h2.09l-1.82-8.7h-1.74Zm.16%2c2.35l.15.75s.43%2c2.08.52%2c2.51h-1.87c.19-.5.9-2.43.9-2.43-.01.02.18-.5.3-.83h0Z'/%3e %3cpath class='cls-2' d='m6.64%2c8.41h-3.62l-.02.15c2.82.72%2c4.68%2c2.49%2c5.45%2c4.58l-.79-4c-.14-.55-.53-.71-1.02-.73'/%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$c = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg id='Layer_2' data-name='Layer 2' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 36.07 24.72'%3e %3cdefs%3e %3cstyle%3e .cls-1 %7b fill: white%3b stroke: %23d4d4d4%3b stroke-miterlimit: 10%3b stroke-width: .81px%3b %7d .cls-2 %7b fill: %231d1d1b%3b %7d .cls-2%2c .cls-3%2c .cls-4%2c .cls-5 %7b stroke-width: 0px%3b %7d .cls-3 %7b fill: %23e20d17%3b %7d .cls-4 %7b fill: %23ea610a%3b %7d .cls-5 %7b fill: %23f59e00%3b %7d %3c/style%3e %3c/defs%3e %3cg id='icons2'%3e %3cg%3e %3crect class='cls-1' x='.41' y='.41' width='35.26' height='23.91' rx='2.07' ry='2.07'/%3e %3cg%3e %3cg%3e %3cpath class='cls-2' d='m11.16%2c19.04c-.06-.06-.14-.11-.22-.14-.09-.03-.18-.05-.28-.05-.05%2c0-.11%2c0-.17.01-.06%2c0-.11.03-.17.05-.06.02-.11.06-.16.1-.05.04-.09.09-.13.16-.06-.1-.14-.18-.24-.23-.1-.06-.22-.08-.35-.08-.04%2c0-.09%2c0-.14.01-.05%2c0-.09.02-.14.04-.05.02-.09.05-.13.08-.04.03-.08.08-.12.13v-.22h-.37v1.77h.37v-.98c0-.07.01-.14.04-.2.02-.06.06-.11.1-.15.04-.04.09-.07.14-.09.05-.02.11-.03.17-.03.13%2c0%2c.22.04.29.12.07.08.1.19.1.34v.98h.37v-.98c0-.07.01-.14.04-.2.02-.06.06-.11.1-.15.04-.04.09-.07.14-.09.05-.02.11-.03.17-.03.13%2c0%2c.22.04.29.12.07.08.1.19.1.34v.98h.37v-1.11c0-.1-.02-.2-.05-.28-.03-.09-.08-.16-.14-.22Z'/%3e %3cpath class='cls-2' d='m13.13%2c19.1c-.06-.08-.14-.14-.23-.19-.09-.05-.2-.07-.33-.07s-.24.02-.35.07c-.11.05-.2.11-.28.19-.08.08-.14.18-.19.29-.05.11-.07.24-.07.37s.02.26.07.37c.05.11.11.21.19.29.08.08.17.15.28.19.11.05.22.07.35.07s.24-.02.33-.07c.09-.05.17-.11.23-.19v.21h.39v-1.77h-.39v.21Zm-.01.89c-.03.07-.06.13-.11.18-.05.05-.1.09-.17.12-.07.03-.14.04-.22.04s-.16-.02-.22-.05c-.07-.03-.12-.07-.17-.12-.05-.05-.08-.11-.11-.18-.02-.07-.04-.14-.04-.22s.01-.15.04-.22c.02-.07.06-.13.11-.18.05-.05.1-.09.17-.12.07-.03.14-.05.22-.05s.15.01.22.04c.07.03.12.07.17.12.05.05.08.11.11.18.03.07.04.14.04.22s-.01.16-.04.22Z'/%3e %3cpath class='cls-2' d='m15.29%2c19.77c-.11-.08-.26-.14-.45-.17l-.18-.03s-.08-.01-.11-.02c-.04%2c0-.07-.02-.09-.03-.03-.01-.05-.03-.06-.05-.02-.02-.02-.05-.02-.08%2c0-.06.03-.11.09-.15.06-.04.14-.06.25-.06.06%2c0%2c.11%2c0%2c.16.01.05%2c0%2c.1.02.15.04.05.01.09.03.13.05.04.02.07.03.1.05l.17-.3c-.09-.06-.2-.1-.32-.14-.12-.03-.25-.05-.39-.05-.11%2c0-.21.01-.3.04-.09.03-.17.06-.23.11-.06.05-.11.11-.15.18-.03.07-.05.15-.05.24%2c0%2c.14.05.26.15.35.1.09.25.15.45.17l.18.02c.11.01.18.04.23.07.05.03.07.07.07.12%2c0%2c.07-.03.12-.1.16-.07.04-.17.06-.3.06-.07%2c0-.14%2c0-.19-.01-.06%2c0-.11-.02-.16-.04-.05-.02-.09-.04-.13-.06-.04-.02-.07-.04-.1-.07l-.18.29c.06.05.13.09.2.12s.14.05.21.07c.07.02.13.03.19.03.06%2c0%2c.11%2c0%2c.16%2c0%2c.13%2c0%2c.24-.01.34-.04.1-.03.18-.07.25-.12.07-.05.12-.11.16-.18s.05-.15.05-.23c0-.15-.05-.27-.16-.35Z'/%3e %3cpath class='cls-2' d='m18.9%2c19.1c-.07-.08-.16-.15-.26-.19-.1-.04-.22-.07-.34-.07-.13%2c0-.25.02-.36.07-.11.04-.2.11-.28.19-.08.08-.14.18-.18.29-.04.11-.06.24-.06.38s.02.27.07.38c.04.11.11.21.19.29.08.08.18.14.29.19.11.04.23.07.37.07s.26-.02.38-.06c.12-.04.24-.1.34-.19l-.19-.27c-.07.06-.16.1-.24.14-.09.03-.18.05-.27.05-.06%2c0-.12%2c0-.18-.03-.06-.02-.11-.04-.16-.08-.05-.04-.09-.08-.12-.14-.03-.06-.06-.12-.07-.2h1.31s0-.05%2c0-.07c0-.02%2c0-.05%2c0-.07%2c0-.14-.02-.26-.06-.38-.04-.11-.1-.21-.17-.29Zm-1.08.52c0-.06.03-.12.05-.18.02-.05.06-.1.09-.14.04-.04.08-.07.14-.09.05-.02.11-.03.18-.03.12%2c0%2c.22.04.3.11.08.08.13.18.15.32h-.92Z'/%3e %3cpath class='cls-2' d='m24.02%2c19.1c-.06-.08-.14-.14-.23-.19-.09-.05-.2-.07-.33-.07s-.24.02-.35.07c-.11.05-.2.11-.28.19-.08.08-.14.18-.19.29-.05.11-.07.24-.07.37s.02.26.07.37c.05.11.11.21.19.29.08.08.17.15.28.19.11.05.22.07.35.07s.24-.02.33-.07.17-.11.23-.19v.21h.39v-1.77h-.39v.21Zm-.01.89c-.03.07-.06.13-.11.18-.05.05-.1.09-.17.12-.07.03-.14.04-.22.04s-.16-.02-.22-.05-.12-.07-.17-.12-.08-.11-.11-.18c-.02-.07-.04-.14-.04-.22s.01-.15.04-.22c.02-.07.06-.13.11-.18.05-.05.1-.09.17-.12.07-.03.14-.05.22-.05s.15.01.22.04c.07.03.12.07.17.12.05.05.08.11.11.18.03.07.04.14.04.22s-.01.16-.04.22Z'/%3e %3cpath class='cls-2' d='m16.94%2c20.3c-.06.02-.12.04-.18.04-.04%2c0-.08%2c0-.11-.02-.03-.01-.06-.03-.09-.06-.03-.03-.05-.06-.06-.1s-.02-.09-.02-.15v-.77h.62v-.35h-.62v-.53h-.39v.53h-.35v.35h.35v.78c0%2c.23.06.41.17.52.11.11.27.17.47.17.11%2c0%2c.21-.02.3-.05.06-.02.11-.05.16-.08l-.13-.32s-.08.04-.12.05Z'/%3e %3cpath class='cls-2' d='m20.42%2c18.84c-.11%2c0-.21.02-.29.06-.09.04-.16.13-.22.22v-.23h-.35v1.77h.35v-.97c0-.07.01-.14.03-.2.02-.06.05-.11.09-.15.04-.04.08-.07.13-.09.05-.02.11-.03.17-.03.05%2c0%2c.1%2c0%2c.15.02.03%2c0%2c.05.01.08.02l.11-.37s-.06-.02-.09-.02c-.05%2c0-.1-.01-.16-.01Z'/%3e %3cpath class='cls-2' d='m25.78%2c18.84c-.11%2c0-.21.02-.29.06-.09.04-.16.13-.22.22v-.23h-.35v1.77h.35v-.97c0-.07.01-.14.03-.2.02-.06.05-.11.09-.15.04-.04.08-.07.13-.09.05-.02.11-.03.17-.03.05%2c0%2c.1%2c0%2c.15.02.03%2c0%2c.05.01.08.02l.11-.37s-.06-.02-.09-.02c-.05%2c0-.1-.01-.16-.01Z'/%3e %3cpath class='cls-2' d='m27.58%2c18.17v.93c-.06-.08-.14-.14-.23-.19-.09-.05-.2-.07-.33-.07s-.24.02-.35.07c-.11.05-.2.11-.28.19-.08.08-.14.18-.19.29-.05.11-.07.24-.07.37s.02.26.07.37c.05.11.11.21.19.29.08.08.17.15.28.19.11.05.22.07.35.07s.24-.02.33-.07c.09-.05.17-.11.23-.19v.21h.39v-2.48h-.39Zm-.01%2c1.83c-.03.07-.06.13-.11.18-.05.05-.1.09-.17.12-.07.03-.14.04-.22.04s-.16-.02-.22-.05c-.07-.03-.12-.07-.17-.12-.05-.05-.08-.11-.11-.18-.02-.07-.04-.14-.04-.22s.01-.15.04-.22c.02-.07.06-.13.11-.18.05-.05.1-.09.17-.12.07-.03.14-.05.22-.05s.15.01.22.04c.07.03.12.07.17.12.05.05.08.11.11.18.03.07.04.14.04.22s-.01.16-.04.22Z'/%3e %3cpath class='cls-2' d='m21.35%2c19.36s.11-.09.18-.12c.07-.03.14-.04.22-.04h0c.09%2c0%2c.17.01.24.04.07.03.13.06.19.11l.19-.31c-.07-.06-.15-.1-.24-.14-.12-.05-.24-.07-.38-.07s-.26.02-.38.07c-.12.05-.22.11-.3.2-.08.08-.15.18-.2.29-.05.11-.07.24-.07.37s.02.26.07.37c.05.11.11.21.2.29.08.08.18.15.3.2s.24.07.38.07.26-.02.38-.07c.09-.04.17-.08.24-.14l-.19-.31c-.05.05-.12.08-.19.11-.07.03-.15.04-.24.04h0c-.08%2c0-.15-.01-.22-.04-.07-.03-.13-.07-.18-.12-.05-.05-.09-.11-.12-.18-.03-.07-.04-.15-.04-.23s.01-.16.04-.23c.03-.07.07-.13.12-.18Z'/%3e %3c/g%3e %3cpath class='cls-2' d='m28.78%2c20.39s.05%2c0%2c.07.01c.02%2c0%2c.04.02.06.04.02.02.03.04.04.06%2c0%2c.02.01.05.01.07s0%2c.05-.01.07c0%2c.02-.02.04-.04.06-.02.02-.04.03-.06.04-.02%2c0-.05.01-.07.01s-.05%2c0-.07-.01c-.02%2c0-.04-.02-.06-.04-.02-.02-.03-.04-.04-.06%2c0-.02-.01-.05-.01-.07s0-.05.01-.07c0-.02.02-.04.04-.06.02-.02.04-.03.06-.04.02%2c0%2c.05-.01.07-.01Zm0%2c.31s.03%2c0%2c.05-.01.03-.02.04-.03c.01-.01.02-.03.03-.04%2c0-.02.01-.03.01-.05s0-.03-.01-.05c0-.02-.02-.03-.03-.04-.01-.01-.03-.02-.04-.03-.02%2c0-.03-.01-.05-.01s-.04%2c0-.05.01c-.02%2c0-.03.02-.04.03-.01.01-.02.03-.03.04%2c0%2c.02-.01.03-.01.05s0%2c.04.01.05c0%2c.02.02.03.03.04.01.01.03.02.04.03.02%2c0%2c.03.01.05.01Zm.01-.21s.04%2c0%2c.05.01c.01%2c0%2c.02.02.02.04%2c0%2c.01%2c0%2c.02-.01.03%2c0%2c0-.02.01-.04.02l.05.06h-.05l-.04-.06h0v.06h-.04v-.16h.08Zm-.03.04v.03h.03s.01%2c0%2c.02%2c0c0%2c0%2c0%2c0%2c0-.01%2c0%2c0%2c0%2c0%2c0-.01%2c0%2c0%2c0%2c0-.02%2c0h-.03Z'/%3e %3cg%3e %3cpath class='cls-3' d='m15.72%2c10.63c0-2.12.99-4%2c2.53-5.22-1.14-.9-2.57-1.44-4.13-1.44-3.68%2c0-6.66%2c2.98-6.66%2c6.66s2.98%2c6.66%2c6.66%2c6.66c1.56%2c0%2c2.99-.54%2c4.13-1.44-1.54-1.22-2.53-3.1-2.53-5.22Z'/%3e %3cpath class='cls-4' d='m15.72%2c10.63c0%2c2.12.99%2c4%2c2.53%2c5.22%2c1.54-1.22%2c2.53-3.1%2c2.53-5.22s-.99-4-2.53-5.22c-1.54%2c1.22-2.53%2c3.1-2.53%2c5.22Z'/%3e %3cpath class='cls-5' d='m28.58%2c14.23v-.19h-.08v-.05h.22v.05h-.08v.19h-.06Zm.42%2c0v-.17l-.06.15h-.06l-.06-.15v.17h-.06v-.25h.08l.06.16.06-.16h.08v.25h-.06Z'/%3e %3cpath class='cls-5' d='m22.37%2c3.97c-1.56%2c0-2.99.54-4.13%2c1.44%2c1.54%2c1.22%2c2.53%2c3.1%2c2.53%2c5.22s-.99%2c4-2.53%2c5.22c1.14.9%2c2.57%2c1.44%2c4.13%2c1.44%2c3.68%2c0%2c6.66-2.98%2c6.66-6.66s-2.98-6.66-6.66-6.66Z'/%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$b = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg id='Layer_2' data-name='Layer 2' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 36.07 24.72'%3e %3cdefs%3e %3cstyle%3e .cls-1 %7b fill: white%3b stroke: %23d4d4d4%3b stroke-miterlimit: 10%3b stroke-width: .81px%3b %7d .cls-2 %7b fill: %230078a9%3b fill-rule: evenodd%3b stroke-width: 0px%3b %7d %3c/style%3e %3c/defs%3e %3cg id='icons2'%3e %3cg%3e %3crect class='cls-1' x='.41' y='.41' width='35.26' height='23.91' rx='2.07' ry='2.07'/%3e %3cg%3e %3cpath class='cls-2' d='m8.29%2c21.38h-.06s0-.08%2c0-.09c0-.02%2c0-.05-.05-.05h-.1v.14h-.04v-.32h.14c.06%2c0%2c.1.02.1.07%2c0%2c.05-.02.06-.03.08.02.02.03.03.03.06v.06s0%2c.02.02.02v.03Zm-.06-.23s-.02-.04-.04-.04h-.11v.09h.1s.06-.02.06-.05m.26.06c0-.18-.15-.34-.35-.34-.18%2c0-.34.15-.34.34%2c0%2c.2.15.35.34.35.2%2c0%2c.35-.15.35-.35m-.05%2c0c0%2c.17-.14.29-.3.29s-.29-.12-.29-.29c0-.15.12-.29.29-.29s.3.14.3.29'/%3e %3cpath class='cls-2' d='m27.31%2c15.01c0%2c.46-.3.67-.82.67h-.99v-.46h.99c.1%2c0%2c.17-.02.2-.05s.06-.08.06-.14c0-.06-.03-.13-.06-.15-.03-.03-.09-.05-.18-.05-.47-.02-1.07.02-1.07-.66%2c0-.3.2-.64.74-.64h1.02v.46h-.94c-.1%2c0-.16%2c0-.2.03-.05.05-.08.1-.08.17%2c0%2c.08.05.13.1.15.06.02.13.03.2.03h.28c.29%2c0%2c.47.06.6.17.09.11.15.25.15.46m-2.16-.46c-.13-.1-.31-.17-.6-.17h-.28c-.07%2c0-.14-.02-.2-.03-.06-.02-.1-.07-.1-.15%2c0-.07.02-.12.08-.17.04-.03.1-.03.2-.03h.94v-.46h-1.02c-.55%2c0-.74.34-.74.64%2c0%2c.68.6.65%2c1.07.66.1%2c0%2c.15.02.18.05.03.02.06.09.06.15%2c0%2c.06-.03.1-.06.14-.05.03-.1.05-.2.05h-.99v.46h.99c.52%2c0%2c.82-.22.82-.67%2c0-.22-.06-.35-.15-.46m-1.97.7h-1.21v-.43h1.18v-.43h-1.18v-.39h1.21v-.45h-1.71v2.15h1.71v-.44Zm-2.26-1.6c-.17-.09-.37-.1-.63-.1h-1.17v2.15h.52v-.78h.55c.18%2c0%2c.29.02.37.1.09.1.09.29.09.43v.26h.51v-.42c0-.19-.02-.29-.08-.39-.05-.06-.14-.14-.26-.18.14-.05.37-.23.37-.57%2c0-.25-.09-.38-.26-.48m-2.91-.1h-1.64l-.66.7-.62-.7h-2.07v2.15h2.04l.66-.7.63.7h.99v-.72h.65c.44%2c0%2c.89-.12.89-.72s-.46-.7-.86-.7m2.49.89c-.08.03-.15.03-.25.03l-.62.02v-.49h.62c.1%2c0%2c.18%2c0%2c.25.04.06.03.1.1.1.18%2c0%2c.1-.04.17-.1.22m-2.49.1h-.68v-.54h.68c.18%2c0%2c.3.07.3.26s-.12.29-.3.29m-1.97.08l.79-.84v1.73l-.79-.89Zm-1.25.63h-1.27v-.43h1.13v-.43h-1.13v-.39h1.29l.57.62-.58.63Zm11.09-3.26h-.74l-.97-1.61v1.61h-1.04l-.2-.47h-1.07l-.2.47h-.6c-.25%2c0-.57-.06-.75-.24-.17-.18-.26-.43-.26-.82%2c0-.32.05-.61.28-.84.15-.17.43-.25.78-.25h.49v.46h-.49c-.18%2c0-.3.03-.4.12-.1.1-.14.26-.14.49s.04.4.14.51c.07.07.22.1.35.1h.23l.74-1.69h.76l.86%2c2.03v-2.03h.79l.9%2c1.49v-1.49h.53v2.15Zm-6.08-2.15h-.52v2.15h.52v-2.15Zm-1.09.1c-.17-.1-.35-.1-.62-.1h-1.17v2.15h.5v-.78h.55c.18%2c0%2c.3.02.38.09.09.11.07.3.07.42v.27h.53v-.42c0-.18-.02-.28-.1-.38-.05-.06-.14-.14-.25-.18.14-.06.37-.23.37-.57%2c0-.25-.1-.38-.27-.49m-2.16%2c1.61h-1.2v-.43h1.18v-.44h-1.18v-.38h1.2v-.45h-1.72v2.15h1.72v-.44Zm-2.1-1.71h-.84l-.63%2c1.46-.67-1.46h-.82v2.03l-.88-2.03h-.76l-.92%2c2.15h.55l.19-.47h1.08l.19.47h1.05v-1.68l.75%2c1.68h.44l.75-1.68v1.68h.52v-2.15Zm8.3%2c1.22l-.35-.85-.35.85h.7Zm-4.44-.34c-.08.05-.15.05-.26.05h-.63v-.47h.63c.09%2c0%2c.19%2c0%2c.26.03.06.04.1.1.1.2%2c0%2c.09-.03.17-.1.19m-8.46.34l.36-.85.35.85h-.71ZM27.18%2c3.1H8.92v7.74l.62-1.43h1.33l.18.35v-.35h1.56l.35.76.34-.76h4.97c.23%2c0%2c.43.04.58.17v-.17h1.37v.17c.22-.13.52-.17.86-.17h1.97l.18.35v-.35h1.45l.22.35v-.35h1.42v3h-1.44l-.28-.46v.46h-1.79l-.2-.49h-.44l-.2.49h-.94c-.37%2c0-.64-.09-.82-.18v.18h-2.22v-.69c0-.1-.02-.11-.08-.11h-.07v.8h-4.29v-.38l-.15.38h-.9l-.15-.37v.37h-1.73l-.18-.49h-.44l-.2.49h-.89v9.07h18.26v-5.5c-.19.09-.47.14-.74.14h-1.33v-.18c-.15.12-.43.18-.69.18h-4.2v-.69c0-.1-.02-.1-.1-.1h-.07v.78h-1.38v-.82c-.23.11-.49.11-.72.11h-.15v.7h-1.69l-.4-.46-.44.46h-2.71v-3.01h2.76l.39.46.43-.46h1.85c.22%2c0%2c.57.03.72.18v-.18h1.65c.17%2c0%2c.49.03.7.18v-.18h2.49v.18c.14-.12.4-.18.63-.18h1.39v.18c.15-.1.37-.18.65-.18h.94V3.1Z'/%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$a = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg id='Layer_2' data-name='Layer 2' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 36.07 24.72'%3e %3cdefs%3e %3cstyle%3e .cls-1 %7b stroke: %23d4d4d4%3b stroke-miterlimit: 10%3b stroke-width: .81px%3b %7d .cls-1%2c .cls-2 %7b fill: white%3b %7d .cls-2%2c .cls-3 %7b stroke-width: 0px%3b %7d .cls-3 %7b fill: %23004a98%3b %7d %3c/style%3e %3c/defs%3e %3cg id='icons2'%3e %3cg%3e %3crect class='cls-1' x='.41' y='.41' width='35.26' height='23.91' rx='2.07' ry='2.07'/%3e %3cg%3e %3cpath class='cls-3' d='m19.05%2c13.08c2.24.01%2c4.29-1.83%2c4.29-4.07%2c0-2.45-2.05-4.14-4.29-4.14h-1.93c-2.27%2c0-4.14%2c1.69-4.14%2c4.14%2c0%2c2.24%2c1.87%2c4.08%2c4.14%2c4.07h1.93Z'/%3e %3cpath class='cls-2' d='m17.98%2c11.19v-4.44c.89.34%2c1.53%2c1.21%2c1.53%2c2.22%2c0%2c1.01-.64%2c1.88-1.53%2c2.22m-3.23-2.22c0-1.01.63-1.88%2c1.53-2.22v4.44c-.89-.34-1.53-1.21-1.53-2.22m2.38-3.75c-2.07%2c0-3.75%2c1.68-3.75%2c3.75%2c0%2c2.07%2c1.68%2c3.75%2c3.75%2c3.75%2c2.07%2c0%2c3.75-1.68%2c3.75-3.75%2c0-2.07-1.68-3.75-3.75-3.75'/%3e %3cpath class='cls-3' d='m8.79%2c15.88c0%2c.33.24.37.45.37.94%2c0%2c1.24-.71%2c1.24-1.35%2c0-.81-.52-1.4-1.36-1.4-.18%2c0-.26.01-.34.02v2.36Zm-.42-2.03c0-.39-.2-.36-.4-.37v-.11c.17%2c0%2c.34%2c0%2c.51%2c0%2c.18%2c0%2c.43%2c0%2c.75%2c0%2c1.12%2c0%2c1.73.75%2c1.73%2c1.52%2c0%2c.43-.25%2c1.51-1.79%2c1.51-.22%2c0-.43%2c0-.63%2c0s-.39%2c0-.58%2c0v-.11c.26-.03.39-.03.4-.33v-2.1Z'/%3e %3cpath class='cls-3' d='m11.57%2c13.74c-.11%2c0-.21-.1-.21-.22s.1-.21.21-.21.21.09.21.21-.1.22-.21.22m-.46%2c2.54h.08c.12%2c0%2c.21%2c0%2c.21-.14v-1.18c0-.19-.06-.22-.23-.3v-.07c.2-.06.45-.14.46-.16.03-.02.06-.02.08-.02s.03.03.03.06v1.66c0%2c.14.1.14.22.14h.07v.11c-.15%2c0-.3%2c0-.46%2c0s-.31%2c0-.47%2c0v-.11Z'/%3e %3cpath class='cls-3' d='m12.45%2c14.98c0-.16-.05-.2-.25-.29v-.08c.19-.06.36-.12.57-.21.01%2c0%2c.03%2c0%2c.03.04v.28c.25-.18.46-.33.75-.33.37%2c0%2c.5.27.5.61v1.12c0%2c.14.1.14.22.14h.08v.11c-.15%2c0-.3%2c0-.46%2c0s-.31%2c0-.47%2c0v-.11h.08c.12%2c0%2c.21%2c0%2c.21-.14v-1.12c0-.25-.15-.37-.4-.37-.14%2c0-.36.11-.5.21v1.28c0%2c.14.1.14.22.14h.08v.11c-.15%2c0-.3%2c0-.46%2c0s-.31%2c0-.47%2c0v-.11h.08c.12%2c0%2c.21%2c0%2c.21-.14v-1.15Z'/%3e %3cpath class='cls-3' d='m15.44%2c15.05c.11%2c0%2c.12-.06.12-.11%2c0-.22-.13-.4-.38-.4-.26%2c0-.45.2-.5.51h.75Zm-.77.14s0%2c.1%2c0%2c.25c.03.41.29.75.64.75.24%2c0%2c.43-.13.59-.29l.06.06c-.2.26-.45.49-.8.49-.69%2c0-.83-.67-.83-.94%2c0-.85.57-1.1.88-1.1.35%2c0%2c.73.22.73.68%2c0%2c.03%2c0%2c.05%2c0%2c.08l-.04.03h-1.22Z'/%3e %3cpath class='cls-3' d='m16.03%2c16.28h.12c.12%2c0%2c.21%2c0%2c.21-.14v-1.22c0-.13-.16-.16-.23-.2v-.06c.32-.13.49-.25.53-.25.03%2c0%2c.04.01.04.06v.39h0c.11-.17.29-.45.55-.45.11%2c0%2c.25.07.25.23%2c0%2c.12-.08.22-.2.22-.13%2c0-.13-.1-.29-.1-.07%2c0-.32.1-.32.36v1.02c0%2c.14.09.14.21.14h.24v.11c-.24%2c0-.42%2c0-.61%2c0s-.36%2c0-.52%2c0v-.11Z'/%3e %3cpath class='cls-3' d='m17.7%2c15.79c.06.29.23.53.55.53.26%2c0%2c.35-.16.35-.31%2c0-.51-.94-.35-.94-1.05%2c0-.24.2-.56.67-.56.14%2c0%2c.32.04.49.13l.03.44h-.1c-.04-.27-.2-.43-.47-.43-.17%2c0-.34.1-.34.29%2c0%2c.51%2c1.01.35%2c1.01%2c1.03%2c0%2c.29-.23.59-.75.59-.17%2c0-.38-.06-.53-.15l-.05-.5.08-.02Z'/%3e %3cpath class='cls-3' d='m22.86%2c14.15h-.11c-.08-.51-.44-.71-.93-.71s-1.22.33-1.22%2c1.37c0%2c.88.62%2c1.5%2c1.29%2c1.5.43%2c0%2c.79-.29.87-.75l.1.03-.1.63c-.18.11-.67.23-.96.23-1.01%2c0-1.66-.65-1.66-1.63%2c0-.89.79-1.53%2c1.64-1.53.35%2c0%2c.69.11%2c1.02.23l.04.62Z'/%3e %3cpath class='cls-3' d='m23.02%2c16.28h.08c.12%2c0%2c.21%2c0%2c.21-.14v-2.41c0-.28-.06-.29-.23-.34v-.07c.17-.06.36-.13.45-.19.05-.03.08-.05.1-.05.03%2c0%2c.04.03.04.06v3c0%2c.14.1.14.22.14h.07v.11c-.15%2c0-.3%2c0-.45%2c0s-.31%2c0-.47%2c0v-.11Z'/%3e %3cpath class='cls-3' d='m25.8%2c16.15c0%2c.08.05.08.12.08.05%2c0%2c.12%2c0%2c.17%2c0v.09c-.19.02-.54.11-.62.13h-.02v-.36c-.26.21-.46.36-.77.36-.23%2c0-.48-.15-.48-.52v-1.11c0-.11-.02-.22-.26-.24v-.08c.16%2c0%2c.5-.03.56-.03.05%2c0%2c.05.03.05.13v1.12c0%2c.13%2c0%2c.5.38.5.15%2c0%2c.34-.11.52-.26v-1.17c0-.09-.21-.13-.36-.18v-.08c.39-.03.63-.06.68-.06.04%2c0%2c.04.03.04.08v1.6Z'/%3e %3cpath class='cls-3' d='m26.66%2c15.9c0%2c.16.16.44.45.44.46%2c0%2c.66-.46.66-.84%2c0-.47-.35-.86-.69-.86-.16%2c0-.29.1-.41.2v1.05Zm0-1.18c.17-.15.41-.31.65-.31.5%2c0%2c.81.44.81.91%2c0%2c.57-.42%2c1.14-1.04%2c1.14-.32%2c0-.49-.1-.6-.15l-.13.1-.09-.05c.04-.26.06-.51.06-.77v-1.86c0-.28-.07-.29-.23-.34v-.07c.17-.06.36-.13.45-.19.05-.03.08-.05.1-.05.03%2c0%2c.03.03.03.06v1.58Z'/%3e %3cpath class='cls-3' d='m7.96%2c18.91h.03c.08%2c0%2c.17-.01.17-.14v-1.24c0-.12-.09-.14-.17-.14h-.03v-.07c.09%2c0%2c.23%2c0%2c.35%2c0s.26%2c0%2c.37%2c0v.07h-.03c-.08%2c0-.17.01-.17.14v1.24c0%2c.12.09.14.17.14h.03v.07c-.11%2c0-.25%2c0-.37%2c0s-.26%2c0-.35%2c0v-.07Z'/%3e %3cpath class='cls-3' d='m8.67%2c18.97v-.05h-.02c-.08%2c0-.18-.01-.18-.15v-1.24c0-.13.1-.15.18-.15h.02v-.05c-.11%2c0-.25%2c0-.36%2c0s-.25%2c0-.34%2c0v.05h.02c.08%2c0%2c.18.01.18.15v1.24c0%2c.13-.1.15-.18.15h-.02v.05c.09%2c0%2c.22%2c0%2c.34%2c0s.25%2c0%2c.36%2c0m.01.02c-.11%2c0-.25%2c0-.37%2c0s-.25%2c0-.35%2c0h0v-.08h0s0-.01%2c0-.01h.03c.09%2c0%2c.16%2c0%2c.16-.12v-1.24c0-.12-.08-.12-.16-.12h-.04v-.09h0c.09%2c0%2c.23%2c0%2c.35%2c0s.26%2c0%2c.37%2c0h.01v.09h-.04c-.09%2c0-.16%2c0-.16.12v1.24c0%2c.12.08.12.16.12h.04v.09h-.01Z'/%3e %3cpath class='cls-3' d='m10.3%2c18.52h0v-.89c0-.19-.13-.22-.21-.22h-.05v-.07c.11%2c0%2c.22%2c0%2c.33%2c0%2c.1%2c0%2c.19%2c0%2c.29%2c0v.07h-.03c-.1%2c0-.21.02-.21.3v1.07c0%2c.08%2c0%2c.16.01.24h-.09l-1.22-1.35v.97c0%2c.21.04.28.22.28h.04v.07c-.1%2c0-.2%2c0-.3%2c0s-.21%2c0-.32%2c0v-.07h.03c.16%2c0%2c.21-.11.21-.3v-.99c0-.13-.11-.21-.21-.21h-.03v-.07c.09%2c0%2c.18%2c0%2c.27%2c0%2c.07%2c0%2c.14%2c0%2c.21%2c0l1.05%2c1.18Z'/%3e %3cpath class='cls-3' d='m10.29%2c18.51h0s0%2c0%2c0%2c0h0Zm0%2c0h0s0%2c0%2c0%2c0Zm.05.49h.08c-.01-.07-.01-.15-.01-.23v-1.07c0-.28.12-.31.22-.31h.02v-.05c-.09%2c0-.19%2c0-.28%2c0-.11%2c0-.21%2c0-.32%2c0v.05h.04c.07%2c0%2c.22.03.22.23v.89s0%2c0%2c0%2c0h0s-1.05-1.18-1.05-1.18c-.07%2c0-.14%2c0-.21%2c0-.09%2c0-.18%2c0-.26%2c0v.05h.02c.11%2c0%2c.22.08.22.22v.99c0%2c.19-.05.31-.22.31h-.02s0%2c.05%2c0%2c.05c.1%2c0%2c.21%2c0%2c.31%2c0s.2%2c0%2c.29%2c0v-.05h-.03c-.19%2c0-.23-.08-.23-.29v-1l1.23%2c1.37Zm.09.02h-.1s-1.2-1.34-1.2-1.34v.95c0%2c.21.03.26.21.27h.05v.09h-.01c-.1%2c0-.2%2c0-.3%2c0-.11%2c0-.21%2c0-.32%2c0h-.01v-.09h.04c.16%2c0%2c.2-.1.2-.29v-.99c0-.13-.1-.2-.2-.2h-.04v-.09h.01c.09%2c0%2c.18%2c0%2c.27%2c0%2c.07%2c0%2c.14%2c0%2c.22%2c0l1.04%2c1.17v-.87c0-.19-.13-.21-.2-.21h-.06v-.09h.01c.11%2c0%2c.22%2c0%2c.33%2c0%2c.1%2c0%2c.19%2c0%2c.29%2c0h.01v.09h-.05c-.1%2c0-.2.01-.2.29v1.07c0%2c.08%2c0%2c.16.01.24h0s-.01.01-.01.01Z'/%3e %3cpath class='cls-3' d='m11.02%2c17.45c-.18%2c0-.18.04-.22.21h-.07c0-.07.02-.13.03-.2%2c0-.07.01-.13.01-.2h.06c.02.07.08.07.14.07h1.22c.06%2c0%2c.12%2c0%2c.13-.07h.06c0%2c.07-.02.14-.03.2%2c0%2c.06%2c0%2c.13%2c0%2c.19l-.07.03c0-.09-.02-.23-.17-.23h-.39v1.26c0%2c.18.08.2.2.2h.05v.07c-.09%2c0-.26%2c0-.38%2c0-.14%2c0-.31%2c0-.4%2c0v-.07h.04c.13%2c0%2c.2-.01.2-.2v-1.26h-.39Z'/%3e %3cpath class='cls-3' d='m11.95%2c18.99c-.09%2c0-.26%2c0-.38%2c0-.14%2c0-.31%2c0-.4%2c0h0v-.09h.05c.13%2c0%2c.18%2c0%2c.19-.19v-1.25h-.38v-.02h.4v1.27c0%2c.19-.08.21-.21.21h-.03v.05c.09%2c0%2c.25%2c0%2c.39%2c0%2c.12%2c0%2c.28%2c0%2c.37%2c0v-.05h-.03c-.11%2c0-.21-.03-.21-.21v-1.27h.4c.16%2c0%2c.18.14.18.22l.05-.02c0-.06%2c0-.12%2c0-.19%2c0-.06.02-.12.02-.18h-.04c-.01.06-.08.07-.14.07h-1.23c-.06%2c0-.12%2c0-.14-.07h-.04c0%2c.07%2c0%2c.13-.01.19%2c0%2c.06-.02.13-.03.19h.05c.03-.16.05-.22.23-.22h0v.02c-.17%2c0-.17.03-.21.21h0s0%2c0%2c0%2c0h-.08%2c0c0-.08.02-.14.03-.21%2c0-.07.01-.13.01-.2h0s.01-.01.01-.01h.07c.02.07.06.07.12.07h1.23c.07%2c0%2c.11%2c0%2c.12-.06h0s.01%2c0%2c.01%2c0h.07s0%2c.02%2c0%2c.02c0%2c.06-.02.13-.03.19%2c0%2c.06%2c0%2c.13%2c0%2c.19h0s0%2c.01%2c0%2c.01l-.08.03h0c0-.1-.02-.23-.16-.23h-.38v1.25c0%2c.18.07.19.19.19h.06v.09h0Z'/%3e %3cpath class='cls-3' d='m12.45%2c18.91h.03c.08%2c0%2c.17-.01.17-.14v-1.24c0-.12-.09-.14-.17-.14h-.03v-.07c.14%2c0%2c.39%2c0%2c.59%2c0s.44%2c0%2c.6%2c0c0%2c.1%2c0%2c.26%2c0%2c.36l-.07.02c-.01-.15-.04-.28-.29-.28h-.33v.62h.28c.14%2c0%2c.17-.08.19-.21h.07c0%2c.09%2c0%2c.18%2c0%2c.28s0%2c.18%2c0%2c.27h-.07c-.01-.13-.02-.22-.18-.22h-.28v.55c0%2c.15.14.15.29.15.28%2c0%2c.41-.02.48-.29l.07.02c-.03.13-.06.25-.08.38-.15%2c0-.42%2c0-.64%2c0s-.49%2c0-.63%2c0v-.07Z'/%3e %3cpath class='cls-3' d='m13.7%2c18.97c.02-.12.05-.24.08-.36h-.05c-.07.25-.21.28-.49.27-.15%2c0-.3%2c0-.3-.16v-.56h.29c.16%2c0%2c.18.1.19.23h.05c0-.1%2c0-.18%2c0-.27s0-.18%2c0-.27h-.05c-.01.12-.05.21-.2.21h-.29v-.64h.34c.25%2c0%2c.29.12.3.27h.05c0-.08%2c0-.17%2c0-.24%2c0-.04%2c0-.08%2c0-.11-.16%2c0-.4%2c0-.59%2c0s-.43%2c0-.58%2c0v.05h.02c.08%2c0%2c.18.01.18.15v1.24c0%2c.13-.1.14-.18.15h-.02v.05c.14%2c0%2c.41%2c0%2c.62%2c0s.47%2c0%2c.63%2c0m0%2c.02c-.15%2c0-.42%2c0-.63%2c0s-.49%2c0-.63%2c0h-.01v-.08h0s.01-.01.01-.01h.03c.09%2c0%2c.16%2c0%2c.16-.12v-1.24c0-.12-.08-.12-.16-.12h-.04v-.09h.01c.14%2c0%2c.39%2c0%2c.59%2c0s.44%2c0%2c.6%2c0h.01%2c0s0%2c.09%2c0%2c.13c0%2c.08%2c0%2c.17%2c0%2c.24h0s0%2c.01%2c0%2c.01l-.08.02h0c-.01-.16-.03-.28-.28-.28h-.32v.6h.27c.14%2c0%2c.16-.07.18-.2h0s0%2c0%2c0%2c0h.08%2c0c0%2c.1%2c0%2c.19%2c0%2c.29s0%2c.18%2c0%2c.27h0s0%2c.01%2c0%2c.01l-.08.02h0c-.02-.16-.02-.23-.17-.24h-.27v.54c0%2c.14.12.14.28.14.28%2c0%2c.4-.02.47-.28h0s0%2c0%2c0%2c0l.08.02h0c-.03.13-.06.26-.08.39h0s0%2c0%2c0%2c0Z'/%3e %3cpath class='cls-3' d='m14.41%2c18.13h.12c.24%2c0%2c.36-.09.36-.37%2c0-.21-.13-.34-.34-.34-.07%2c0-.1%2c0-.13%2c0v.7Zm-.3-.55c0-.17-.09-.18-.17-.18h-.04v-.07c.08%2c0%2c.22%2c0%2c.37%2c0s.25%2c0%2c.38%2c0c.3%2c0%2c.56.08.56.42%2c0%2c.21-.14.34-.33.42l.4.6c.07.1.11.13.23.14v.07c-.08%2c0-.15%2c0-.23%2c0-.07%2c0-.15%2c0-.22%2c0-.18-.24-.34-.49-.49-.77h-.16v.51c0%2c.18.08.19.19.19h.04v.07c-.13%2c0-.27%2c0-.41%2c0-.11%2c0-.22%2c0-.34%2c0v-.07h.04c.09%2c0%2c.17-.04.17-.13v-1.2Z'/%3e %3cpath class='cls-3' d='m14.52%2c18.12c.23%2c0%2c.35-.08.35-.36%2c0-.21-.13-.33-.33-.33-.06%2c0-.09%2c0-.12%2c0v.68h.11Zm-.12.02h-.01v-.72h0s.06-.01.14-.01c.22%2c0%2c.35.14.35.35%2c0%2c.28-.14.38-.37.38h-.12Zm0%2c.06h.16c.15.28.31.53.48.76.07%2c0%2c.15%2c0%2c.22%2c0s.15%2c0%2c.22%2c0v-.05c-.11-.01-.16-.05-.23-.14l-.41-.61h.01c.18-.08.32-.2.32-.41%2c0-.33-.25-.4-.55-.41-.12%2c0-.24%2c0-.38%2c0s-.28%2c0-.36%2c0v.05h.03c.07%2c0%2c.18.01.18.19v1.2c0%2c.09-.09.14-.18.14h-.03v.05c.11%2c0%2c.22%2c0%2c.33%2c0%2c.13%2c0%2c.27%2c0%2c.4%2c0v-.05h-.03c-.11%2c0-.2-.01-.2-.2v-.52h.01Zm1.1.78c-.08%2c0-.15%2c0-.23%2c0-.07%2c0-.15%2c0-.23%2c0-.18-.24-.34-.49-.49-.76h-.14v.49c0%2c.18.07.18.18.18h.05v.09h-.01c-.13%2c0-.27%2c0-.41%2c0-.11%2c0-.22%2c0-.34%2c0h-.01v-.09h.05c.09%2c0%2c.16-.04.16-.12v-1.2c0-.17-.08-.17-.16-.17h-.05v-.09h.01c.08%2c0%2c.22%2c0%2c.37%2c0s.25%2c0%2c.38%2c0c.3%2c0%2c.57.08.57.43%2c0%2c.21-.14.35-.32.42l.4.59c.07.1.11.12.22.14h0v.09h0Z'/%3e %3cpath class='cls-3' d='m17.11%2c18.52h0v-.89c0-.19-.13-.22-.21-.22h-.05v-.07c.11%2c0%2c.22%2c0%2c.33%2c0%2c.1%2c0%2c.19%2c0%2c.29%2c0v.07h-.04c-.1%2c0-.21.02-.21.3v1.07c0%2c.08%2c0%2c.16.01.24h-.09l-1.21-1.35v.97c0%2c.21.04.28.22.28h.04v.07c-.1%2c0-.2%2c0-.3%2c0-.11%2c0-.22%2c0-.32%2c0v-.07h.03c.16%2c0%2c.21-.11.21-.3v-.99c0-.13-.11-.21-.21-.21h-.03v-.07c.09%2c0%2c.18%2c0%2c.27%2c0%2c.07%2c0%2c.14%2c0%2c.21%2c0l1.05%2c1.18Z'/%3e %3cpath class='cls-3' d='m17.1%2c18.51h0s0%2c0%2c0%2c0h0Zm0%2c0h0s0%2c0%2c0%2c0Zm.05.49h.08c-.01-.07-.01-.15-.01-.23v-1.07c0-.28.12-.31.22-.31h.02v-.05c-.09%2c0-.19%2c0-.28%2c0-.11%2c0-.21%2c0-.32%2c0v.05h.04c.07%2c0%2c.22.03.22.23v.89s0%2c0%2c0%2c0h0s-1.05-1.18-1.05-1.18c-.07%2c0-.14%2c0-.21%2c0-.09%2c0-.18%2c0-.26%2c0v.05h.02c.11%2c0%2c.22.08.22.22v.99c0%2c.19-.05.31-.22.31h-.02s0%2c.05%2c0%2c.05c.1%2c0%2c.21%2c0%2c.31%2c0s.2%2c0%2c.29%2c0v-.05h-.03c-.19%2c0-.23-.08-.23-.29v-1l1.23%2c1.37Zm.09.02h-.1s-1.2-1.34-1.2-1.34v.95c0%2c.21.03.26.21.27h.05v.09h-.01c-.1%2c0-.2%2c0-.3%2c0s-.21%2c0-.32%2c0h-.01v-.09h.04c.16%2c0%2c.2-.1.2-.29v-.99c0-.13-.1-.2-.2-.2h-.04v-.09h.01c.09%2c0%2c.18%2c0%2c.27%2c0%2c.07%2c0%2c.14%2c0%2c.22%2c0l1.04%2c1.17v-.87c0-.19-.13-.21-.19-.21h-.06v-.09h.01c.11%2c0%2c.22%2c0%2c.33%2c0%2c.1%2c0%2c.19%2c0%2c.29%2c0h.01v.09h-.05c-.1%2c0-.2.01-.2.29v1.07c0%2c.08%2c0%2c.16.01.24h0s-.01.01-.01.01Z'/%3e %3cpath class='cls-3' d='m18.2%2c17.6h0l-.22.67h.44l-.22-.67Zm-.34%2c1.05c-.02.08-.05.14-.05.18%2c0%2c.07.1.08.18.08h.03v.07c-.09%2c0-.19%2c0-.29%2c0-.08%2c0-.17%2c0-.25%2c0v-.07h.01c.09%2c0%2c.17-.05.2-.15l.38-1.08c.03-.09.07-.21.09-.29.08-.03.17-.07.21-.1%2c0%2c0%2c.01%2c0%2c.02%2c0s.01%2c0%2c.02%2c0c0%2c.02.01.04.02.06l.43%2c1.23c.03.08.06.17.09.24.03.07.08.09.16.09h.01v.07c-.11%2c0-.21%2c0-.32%2c0s-.23%2c0-.35%2c0v-.07h.03c.05%2c0%2c.15%2c0%2c.15-.07%2c0-.03-.02-.09-.05-.17l-.09-.27h-.54l-.07.25Z'/%3e %3cpath class='cls-3' d='m18.19%2c17.6h0s0%2c0%2c0%2c0Zm-.2.65h.41l-.21-.63-.21.63Zm-.03.02l.23-.69h.01s0%2c.01%2c0%2c.01h0s0-.01%2c0-.01l.22.69h-.47Zm.48.69c.12%2c0%2c.23%2c0%2c.34%2c0s.21%2c0%2c.31%2c0v-.05h0c-.08%2c0-.14-.03-.17-.1-.03-.07-.06-.16-.09-.24l-.43-1.23s-.01-.04-.02-.06c0%2c0%2c0%2c0%2c0%2c0h0s0%2c0-.01%2c0c-.05.03-.14.08-.21.09-.01.09-.06.21-.09.29l-.38%2c1.08c-.04.1-.12.16-.21.16h0v.05c.08%2c0%2c.16%2c0%2c.24%2c0%2c.09%2c0%2c.18%2c0%2c.27%2c0v-.05h-.02c-.08%2c0-.18%2c0-.19-.09%2c0-.05.03-.11.05-.19h.01s-.01%2c0-.01%2c0l.08-.25h.55l.09.28c.03.08.05.14.05.17%2c0%2c.07-.1.08-.16.08h-.02v.05Zm.67.02c-.11%2c0-.21%2c0-.32%2c0s-.23%2c0-.35%2c0h-.01s0%2c0%2c0%2c0v-.08h.04c.05%2c0%2c.14-.01.14-.06%2c0-.03-.02-.09-.05-.17l-.09-.27h-.52l-.07.24c-.02.08-.05.14-.05.18%2c0%2c.06.09.07.17.07h.04v.09h-.01c-.09%2c0-.19-.01-.28-.01-.08%2c0-.17%2c0-.25%2c0h-.01s0%2c0%2c0%2c0v-.08h.02c.09%2c0%2c.16-.05.19-.15l.38-1.08c.03-.09.07-.2.09-.3.07-.03.17-.07.21-.1%2c0%2c0%2c.01%2c0%2c.02%2c0%2c0%2c0%2c.02%2c0%2c.03.01%2c0%2c.02.01.04.02.06l.43%2c1.23c.03.08.06.17.09.24.03.06.07.09.15.09h.02v.09h-.01Z'/%3e %3cpath class='cls-3' d='m19.22%2c17.45c-.18%2c0-.18.04-.22.21h-.07c0-.07.02-.13.03-.2%2c0-.07.01-.13.01-.2h.06c.02.07.08.07.14.07h1.22c.06%2c0%2c.12%2c0%2c.13-.07h.06c0%2c.07-.02.14-.03.2%2c0%2c.06%2c0%2c.13%2c0%2c.19l-.07.03c0-.09-.02-.23-.17-.23h-.39v1.26c0%2c.18.08.2.2.2h.04v.07c-.09%2c0-.26%2c0-.38%2c0-.14%2c0-.31%2c0-.4%2c0v-.07h.04c.13%2c0%2c.2-.01.2-.2v-1.26h-.39Z'/%3e %3cpath class='cls-3' d='m20.15%2c18.99c-.09%2c0-.26%2c0-.38%2c0-.14%2c0-.31%2c0-.4%2c0h-.01v-.09h.06c.13%2c0%2c.18%2c0%2c.19-.19v-1.25h-.38v-.02h.4v1.27c0%2c.19-.08.21-.21.21h-.03v.05c.09%2c0%2c.25%2c0%2c.39%2c0%2c.12%2c0%2c.28%2c0%2c.37%2c0v-.05h-.03c-.11%2c0-.21-.03-.21-.21v-1.27h.4c.16%2c0%2c.18.14.18.22l.05-.02c0-.06%2c0-.12%2c0-.19%2c0-.06.02-.12.02-.18h-.04c-.01.06-.08.07-.14.07h-1.23c-.06%2c0-.12%2c0-.14-.07h-.04c0%2c.07%2c0%2c.13-.01.19%2c0%2c.07-.02.13-.03.19h.05c.03-.16.05-.22.23-.22h0v.02c-.17%2c0-.17.03-.21.21h0s0%2c0%2c0%2c0h-.08%2c0c0-.08.02-.14.03-.21%2c0-.07.01-.13.01-.2h0s.01-.01.01-.01h.07c.02.07.06.07.12.07%2c0%2c0%2c0%2c0%2c.01%2c0h1.22c.07%2c0%2c.11%2c0%2c.12-.06h0s.01%2c0%2c.01%2c0h.07s0%2c.02%2c0%2c.02c0%2c.06-.02.13-.03.19%2c0%2c.06%2c0%2c.13%2c0%2c.19h0s0%2c.01%2c0%2c.01l-.08.03h0c0-.1-.02-.23-.16-.23h-.38v1.25c0%2c.18.07.19.19.19h.06v.09h-.01Z'/%3e %3cpath class='cls-3' d='m20.66%2c18.91h.03c.09%2c0%2c.17-.01.17-.14v-1.24c0-.12-.09-.14-.17-.14h-.03v-.07c.09%2c0%2c.23%2c0%2c.35%2c0s.26%2c0%2c.37%2c0v.07h-.03c-.09%2c0-.18.01-.18.14v1.24c0%2c.12.09.14.18.14h.03v.07c-.11%2c0-.25%2c0-.37%2c0s-.25%2c0-.35%2c0v-.07Z'/%3e %3cpath class='cls-3' d='m21.37%2c18.97v-.05h-.02c-.08%2c0-.19-.01-.19-.15v-1.24c0-.13.1-.15.19-.15h.02v-.05c-.11%2c0-.25%2c0-.36%2c0s-.25%2c0-.34%2c0v.05h.02c.08%2c0%2c.19.01.19.15v1.24c0%2c.13-.1.15-.19.15h-.02v.05c.09%2c0%2c.22%2c0%2c.34%2c0s.25%2c0%2c.36%2c0m.01.02c-.11%2c0-.26%2c0-.37%2c0s-.25%2c0-.35%2c0h-.01v-.08h0s.01-.01.01-.01h.03c.09%2c0%2c.16%2c0%2c.16-.12v-1.24c0-.12-.08-.12-.16-.12h-.04v-.09h.01c.09%2c0%2c.23%2c0%2c.35%2c0s.26%2c0%2c.37%2c0h0v.09h-.04c-.09%2c0-.16%2c0-.17.12v1.24c0%2c.12.08.12.17.12h.04v.09h0Z'/%3e %3cpath class='cls-3' d='m22.35%2c18.91c.46%2c0%2c.54-.4.54-.75s-.19-.76-.58-.76c-.41%2c0-.54.37-.54.68%2c0%2c.42.19.83.58.83m-.04-1.61c.5%2c0%2c.9.31.9.81%2c0%2c.54-.39.9-.89.9s-.88-.34-.88-.85.38-.87.87-.87'/%3e %3cpath class='cls-3' d='m21.77%2c18.09c0-.32.12-.69.55-.69.4%2c0%2c.59.43.59.77%2c0%2c.34-.08.76-.55.76h0v-.02c.45%2c0%2c.53-.39.53-.74%2c0-.34-.18-.75-.57-.75-.4%2c0-.52.36-.53.67%2c0%2c.42.19.81.57.82h0v.02c-.39%2c0-.59-.41-.59-.84m-.33.08c0-.5.38-.88.88-.88h0v.02c-.48%2c0-.86.37-.86.86%2c0%2c.5.38.84.87.84.5%2c0%2c.88-.36.88-.89%2c0-.5-.39-.8-.89-.8h0v-.02c.51%2c0%2c.91.32.91.82%2c0%2c.55-.39.91-.9.91-.5%2c0-.89-.34-.89-.86'/%3e %3cpath class='cls-3' d='m24.81%2c18.52h0v-.89c0-.19-.13-.22-.21-.22h-.05v-.07c.11%2c0%2c.22%2c0%2c.33%2c0%2c.1%2c0%2c.19%2c0%2c.29%2c0v.07h-.04c-.1%2c0-.21.02-.21.3v1.07c0%2c.08%2c0%2c.16.01.24h-.09l-1.22-1.35v.97c0%2c.21.04.28.22.28h.04v.07c-.1%2c0-.2%2c0-.3%2c0-.11%2c0-.22%2c0-.32%2c0v-.07h.03c.16%2c0%2c.21-.11.21-.3v-.99c0-.13-.11-.21-.21-.21h-.03v-.07c.09%2c0%2c.18%2c0%2c.27%2c0%2c.07%2c0%2c.14%2c0%2c.21%2c0l1.05%2c1.18Z'/%3e %3cpath class='cls-3' d='m24.81%2c18.51h0s0%2c0%2c0%2c0h0Zm0%2c0h0s0%2c0%2c0%2c0Zm.05.49h.08c0-.07-.01-.15-.01-.23v-1.07c0-.28.12-.31.22-.31h.03v-.05c-.09%2c0-.19%2c0-.28%2c0-.11%2c0-.21%2c0-.32%2c0v.05h.04c.07%2c0%2c.22.03.22.23v.89s0%2c0%2c0%2c0h0s-1.05-1.18-1.05-1.18c-.07%2c0-.14%2c0-.21%2c0-.09%2c0-.18%2c0-.26%2c0v.05h.02c.11%2c0%2c.22.08.22.22v.99c0%2c.19-.05.31-.22.31h-.02s0%2c.05%2c0%2c.05c.1%2c0%2c.21%2c0%2c.31%2c0s.2%2c0%2c.29%2c0v-.05h-.03c-.19%2c0-.23-.08-.23-.29v-1l1.23%2c1.37Zm.09.02h-.1s-1.2-1.34-1.2-1.34v.95c0%2c.21.03.26.21.27h.05v.09h-.01c-.1%2c0-.2%2c0-.3%2c0s-.21%2c0-.32%2c0h0v-.09h.04c.16%2c0%2c.2-.1.2-.29v-.99c0-.13-.1-.2-.2-.2h-.04v-.09h0c.09%2c0%2c.18%2c0%2c.27%2c0%2c.07%2c0%2c.14%2c0%2c.22%2c0l1.04%2c1.17v-.87c0-.19-.13-.21-.2-.21h-.06v-.09h.01c.11%2c0%2c.22%2c0%2c.33%2c0%2c.1%2c0%2c.19%2c0%2c.29%2c0h.01v.09h-.05c-.1%2c0-.2.01-.2.29v1.07c0%2c.08%2c0%2c.16.01.24h0s-.01.01-.01.01Z'/%3e %3cpath class='cls-3' d='m25.9%2c17.6h0l-.22.67h.44l-.22-.67Zm-.34%2c1.05c-.02.08-.05.14-.05.18%2c0%2c.07.1.08.18.08h.03v.07c-.09%2c0-.19%2c0-.29%2c0-.09%2c0-.17%2c0-.25%2c0v-.07h.01c.09%2c0%2c.17-.05.21-.15l.38-1.08c.03-.09.07-.21.09-.29.08-.03.17-.07.22-.1%2c0%2c0%2c.01%2c0%2c.02%2c0%2c0%2c0%2c.01%2c0%2c.02%2c0%2c0%2c.02.01.04.02.06l.43%2c1.23c.03.08.06.17.09.24.03.07.08.09.16.09h.01v.07c-.11%2c0-.21%2c0-.33%2c0s-.23%2c0-.35%2c0v-.07h.03c.05%2c0%2c.15%2c0%2c.15-.07%2c0-.03-.02-.09-.05-.17l-.09-.27h-.54l-.08.25Z'/%3e %3cpath class='cls-3' d='m25.9%2c17.6h0s0%2c0%2c0%2c0Zm-.2.65h.41l-.21-.63-.21.63Zm-.03.02l.23-.69h.01s0%2c.01%2c0%2c.01h0s0-.01%2c0-.01l.22.69h-.47Zm.48.69c.12%2c0%2c.23%2c0%2c.34%2c0s.21%2c0%2c.32%2c0v-.05h0c-.08%2c0-.14-.03-.16-.1-.03-.07-.06-.16-.09-.24l-.43-1.23s-.01-.04-.02-.06c0%2c0%2c0%2c0%2c0%2c0h0s0%2c0-.01%2c0c-.05.03-.14.08-.21.09-.01.09-.06.21-.09.29l-.38%2c1.08c-.04.1-.12.16-.22.16h0v.05c.08%2c0%2c.16%2c0%2c.24%2c0%2c.09%2c0%2c.18%2c0%2c.27%2c0v-.05h-.02c-.08%2c0-.18%2c0-.19-.09%2c0-.05.03-.11.05-.19h0s0%2c0%2c0%2c0l.08-.25h.55l.09.28c.03.08.05.14.05.17%2c0%2c.07-.1.08-.16.08h-.02v.05Zm.67.02c-.11%2c0-.21%2c0-.33%2c0s-.23%2c0-.35%2c0h-.01s0%2c0%2c0%2c0v-.08h.04c.05%2c0%2c.14-.01.14-.06%2c0-.03-.02-.09-.05-.17l-.09-.27h-.52l-.07.24c-.02.08-.05.14-.05.18%2c0%2c.06.09.07.17.07h.04v.09h-.01c-.09%2c0-.19%2c0-.28%2c0-.08%2c0-.17%2c0-.25%2c0h-.01s0%2c0%2c0%2c0v-.08h.02c.09%2c0%2c.16-.05.2-.15l.38-1.08c.03-.09.07-.2.09-.3.07-.03.17-.07.22-.1%2c0%2c0%2c.01%2c0%2c.02%2c0%2c0%2c0%2c.02%2c0%2c.03.01%2c0%2c.02.01.04.02.06l.43%2c1.23c.03.08.06.17.09.24.03.06.07.09.15.09h.02v.09h-.01Z'/%3e %3cpath class='cls-3' d='m27.41%2c18.75c0%2c.09.07.12.14.13.1%2c0%2c.2%2c0%2c.31%2c0%2c.1-.01.18-.07.23-.13.04-.05.06-.12.07-.17h.07c-.03.13-.06.27-.09.4-.21%2c0-.41%2c0-.62%2c0s-.42%2c0-.62%2c0v-.07h.03c.09%2c0%2c.18-.01.18-.16v-1.21c0-.12-.09-.14-.18-.14h-.03v-.07c.12%2c0%2c.25%2c0%2c.37%2c0s.24%2c0%2c.36%2c0v.07h-.06c-.09%2c0-.16%2c0-.16.13v1.22Z'/%3e %3cpath class='cls-3' d='m28.14%2c18.97c.03-.13.06-.25.08-.38h-.05c-.01.05-.04.11-.07.17-.04.06-.13.12-.23.13-.06%2c0-.12.01-.18.01-.05%2c0-.09%2c0-.13%2c0-.08%2c0-.15-.04-.15-.14v-1.22c0-.13.08-.14.17-.14h.05v-.05c-.12%2c0-.23%2c0-.35%2c0s-.24%2c0-.36%2c0v.05h.02c.08%2c0%2c.19.01.19.15v1.21c0%2c.15-.1.17-.19.17h-.02v.05c.2%2c0%2c.41%2c0%2c.61%2c0s.41%2c0%2c.61%2c0m0%2c.02c-.21%2c0-.42%2c0-.62%2c0s-.42%2c0-.62%2c0h0v-.09h.04c.09%2c0%2c.17%2c0%2c.17-.15v-1.21c0-.11-.08-.12-.17-.12h-.04v-.09h0c.13%2c0%2c.25%2c0%2c.37%2c0s.24%2c0%2c.36%2c0h0v.09h-.07c-.09%2c0-.15%2c0-.15.12v1.22c0%2c.09.06.11.13.12.04%2c0%2c.09%2c0%2c.13%2c0%2c.06%2c0%2c.12%2c0%2c.18%2c0%2c.1-.01.18-.07.22-.12.04-.05.06-.11.07-.17h0s0%2c0%2c0%2c0h.08%2c0c-.03.15-.06.28-.09.41h0s0%2c0%2c0%2c0Z'/%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$9 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 36.07 24.72'%3e %3cdefs%3e %3cstyle%3e .cls-1 %7b clip-path: url(%23clippath)%3b %7d .cls-2%2c .cls-3%2c .cls-4%2c .cls-5%2c .cls-6%2c .cls-7%2c .cls-8 %7b stroke-width: 0px%3b %7d .cls-2%2c .cls-4 %7b fill: none%3b %7d .cls-9 %7b mask: url(%23mask)%3b %7d .cls-3 %7b fill: url(%23linear-gradient)%3b %7d .cls-10 %7b filter: url(%23luminosity-invert)%3b %7d .cls-11 %7b fill: white%3b stroke: %23d4d4d4%3b stroke-miterlimit: 10%3b stroke-width: .81px%3b %7d .cls-4%2c .cls-5%2c .cls-6%2c .cls-7%2c .cls-8 %7b fill-rule: evenodd%3b %7d .cls-5 %7b fill: url(%23linear-gradient-2)%3b %7d .cls-6 %7b fill: %23252122%3b %7d .cls-7 %7b fill: %23231f20%3b %7d .cls-8 %7b fill: %238a371e%3b %7d .cls-12 %7b isolation: isolate%3b %7d .cls-13 %7b mix-blend-mode: multiply%3b opacity: .75%3b %7d %3c/style%3e %3clinearGradient id='linear-gradient' x1='18.42' y1='9.54' x2='20.41' y2='13.81' gradientUnits='userSpaceOnUse'%3e %3cstop offset='.38' stop-color='%23e45e26'/%3e %3cstop offset='1' stop-color='%23f8a020'/%3e %3c/linearGradient%3e %3cclipPath id='clippath'%3e %3cellipse class='cls-2' cx='19.41' cy='11.67' rx='2.35' ry='2.36'/%3e %3c/clipPath%3e %3clinearGradient id='linear-gradient-2' x1='-967.75' y1='-235.77' x2='-965.07' y2='-230.03' gradientTransform='translate(863.6 -422.57) rotate(-41.47) scale(.95 1)' gradientUnits='userSpaceOnUse'%3e %3cstop offset='.32' stop-color='%23e45e26' stop-opacity='0'/%3e %3cstop offset='1' stop-color='%23f8a020' stop-opacity='0'/%3e %3c/linearGradient%3e %3cfilter id='luminosity-invert' x='14.61' y='6.34' width='11' height='11' color-interpolation-filters='sRGB' filterUnits='userSpaceOnUse'%3e %3cfeColorMatrix result='cm' values='-1 0 0 0 1 0 -1 0 0 1 0 0 -1 0 1 0 0 0 1 0'/%3e %3c/filter%3e %3cmask id='mask' x='14.61' y='6.34' width='11' height='11' maskUnits='userSpaceOnUse'%3e %3cg class='cls-10'%3e %3cimage width='11' height='11' transform='translate(14.61 6.34)' xlink:href='data:image/png%3bbase64%2ciVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAACXBIWXMAAAsSAAALEgHS3X78AAAAO0lEQVQYlWNkYGD4z0AkYCJWIVbF////Z/j/H7tljDBn4FTAyEglZ2BzFm1MxqoY2SPIAFkcHhpUdwYAkn4PDvpsAdgAAAAASUVORK5CYII='/%3e %3c/g%3e %3c/mask%3e %3c/defs%3e %3cg class='cls-12'%3e %3cg id='Layer_2' data-name='Layer 2'%3e %3cg id='icons2'%3e %3cg%3e %3crect class='cls-11' x='.41' y='.41' width='35.26' height='23.91' rx='2.07' ry='2.07'/%3e %3cg%3e %3cpath class='cls-7' d='m4.78%2c9.55c0-.07.01-.1.09-.1.42%2c0%2c.85%2c0%2c1.27%2c0%2c.62.02%2c1.19.2%2c1.65.64.32.3.52.67.6%2c1.1.16.86-.08%2c1.58-.74%2c2.16-.36.32-.78.48-1.25.51-.52.04-1.04%2c0-1.56.02-.06%2c0-.06-.03-.06-.07%2c0-.44%2c0-3.57%2c0-4.28Zm.87%2c3.51c0%2c.06.01.08.08.08.17%2c0%2c.35%2c0%2c.52-.02.31-.04.61-.13.84-.36.39-.39.53-.86.42-1.39-.11-.54-.42-.92-.95-1.08-.26-.08-.53-.08-.8-.08-.08%2c0-.1.01-.1.1%2c0%2c.46%2c0%2c2.29%2c0%2c2.75Z'/%3e %3cpath class='cls-7' d='m31.06%2c12.03c.47.62.92%2c1.24%2c1.39%2c1.86h-.19c-.26%2c0-.52%2c0-.79%2c0-.08%2c0-.12-.03-.16-.09-.36-.54-.73-1.09-1.09-1.63%2c0%2c0-.01-.01-.01-.02-.02-.05-.07-.05-.11-.04-.05%2c0-.02.05-.02.08%2c0%2c.53%2c0%2c1.07%2c0%2c1.6%2c0%2c.09-.03.11-.11.1-.23%2c0-.46%2c0-.69%2c0-.06%2c0-.08%2c0-.08-.08%2c0-1.43%2c0-2.87%2c0-4.3%2c0-.05%2c0-.07.07-.07.49.01.99-.02%2c1.48.02.34.03.66.12.93.35.32.28.4.65.38%2c1.05-.03.6-.36.99-.93%2c1.14-.02%2c0-.04.01-.06.02Zm-.99-1.2c0%2c.2%2c0%2c.39%2c0%2c.59%2c0%2c.07.02.08.08.08.13%2c0%2c.26%2c0%2c.39-.02.38-.04.59-.26.62-.64.02-.3-.13-.53-.42-.63-.19-.06-.39-.06-.58-.06-.06%2c0-.09.01-.08.08%2c0%2c.2%2c0%2c.39%2c0%2c.59Z'/%3e %3cpath class='cls-7' d='m26.17%2c9.54c0-.07.01-.09.09-.09.76%2c0%2c1.53%2c0%2c2.29%2c0%2c.06%2c0%2c.08.01.08.08%2c0%2c.21%2c0%2c.41%2c0%2c.62%2c0%2c.06-.02.07-.08.07-.47%2c0-.95%2c0-1.42%2c0-.08%2c0-.1.02-.1.1%2c0%2c.27%2c0%2c.54%2c0%2c.8%2c0%2c.07.02.08.08.08.46%2c0%2c.91%2c0%2c1.37%2c0%2c.07%2c0%2c.09.02.08.09%2c0%2c.2%2c0%2c.39%2c0%2c.59%2c0%2c.06-.02.08-.08.08-.45%2c0-.91%2c0-1.36%2c0-.08%2c0-.1.03-.1.1%2c0%2c.34%2c0%2c.67%2c0%2c1.01%2c0%2c.07.01.09.09.09.47%2c0%2c.95%2c0%2c1.42%2c0%2c.07%2c0%2c.09.02.09.09%2c0%2c.2%2c0%2c.41%2c0%2c.61%2c0%2c.05-.01.07-.06.06-.78%2c0-1.55%2c0-2.33%2c0-.07%2c0-.07-.03-.07-.08%2c0-.72%2c0-3.57%2c0-4.28Z'/%3e %3cpath class='cls-7' d='m10.58%2c12.61c.12.22.27.4.5.5.24.11.5.14.75.03.23-.1.35-.29.36-.54%2c0-.25-.12-.41-.34-.52-.25-.12-.51-.2-.77-.31-.25-.11-.48-.23-.65-.45-.1-.13-.16-.29-.18-.45-.09-.73.31-1.25.92-1.42.63-.18%2c1.2-.02%2c1.71.38.04.03.05.05.01.1-.13.16-.26.33-.38.5-.04.05-.05.04-.09%2c0-.14-.15-.3-.27-.51-.3-.26-.04-.51%2c0-.69.21-.16.19-.13.44.08.58.18.13.4.2.6.28.19.08.38.16.57.26.37.21.57.52.6.95.04.73-.34%2c1.34-1.05%2c1.53-.76.2-1.51-.02-1.99-.74-.02-.03-.02-.05%2c0-.07.18-.17.35-.34.53-.51Z'/%3e %3cpath class='cls-7' d='m21.52%2c9.45c.3%2c0%2c.59%2c0%2c.88%2c0%2c.06%2c0%2c.08.02.1.07.27.67%2c1.03%2c2.59%2c1.15%2c2.89.05-.06.82-2%2c1.18-2.89.01-.04.02-.07.08-.07.29%2c0%2c.59%2c0%2c.89%2c0-.07.17-1.33%2c3.16-1.89%2c4.49-.02.05-.05.07-.1.07-.11%2c0-.22%2c0-.34%2c0-.05%2c0-.07-.02-.09-.06-.35-.84-1.56-3.77-1.82-4.39-.01-.03-.02-.06-.04-.1Z'/%3e %3cpath class='cls-7' d='m16.79%2c10.65c-.16-.16-.32-.29-.51-.38-.74-.34-1.63.03-1.91.81-.22.6-.15%2c1.18.29%2c1.67.29.33.68.45%2c1.12.44.34%2c0%2c.63-.14.88-.37.04-.03.07-.07.11-.1.03.02.02.04.02.06%2c0%2c.29%2c0%2c.58%2c0%2c.87%2c0%2c.04%2c0%2c.07-.05.09-.89.43-2.02.26-2.72-.45-.43-.44-.64-.98-.66-1.59-.02-1.05.67-1.96%2c1.64-2.25.59-.18%2c1.17-.15%2c1.73.14.03.02.05.03.05.07%2c0%2c.32%2c0%2c.64%2c0%2c.98Z'/%3e %3cpath class='cls-7' d='m9.7%2c13.8c0%2c.07-.01.1-.09.1-.24%2c0-.47%2c0-.71%2c0-.06%2c0-.07-.01-.07-.07%2c0-1.43%2c0-2.87%2c0-4.3%2c0-.06.02-.08.08-.08.23%2c0%2c.46%2c0%2c.7%2c0%2c.08%2c0%2c.1.02.1.1%2c0%2c.71%2c0%2c3.55%2c0%2c4.25Z'/%3e %3cpath class='cls-4' d='m32.46%2c9.55s0%2c.02%2c0%2c.03c0%2c.12%2c0%2c.24%2c0%2c.36%2c0%2c.01%2c0%2c.03%2c0%2c.04-.15-.12-.15-.32%2c0-.44Z'/%3e %3cpath class='cls-4' d='m5.64%2c10.31c0-.08.03-.1.1-.1.27%2c0%2c.54%2c0%2c.8.08.54.17.85.54.95%2c1.08.11.53-.03%2c1-.42%2c1.39-.23.23-.53.32-.84.36-.17.02-.35.02-.52.02-.06%2c0-.08-.02-.08-.08%2c0-.46%2c0-2.3%2c0-2.75Z'/%3e %3cpath class='cls-4' d='m30.07%2c10.83c0-.2%2c0-.39%2c0-.59%2c0-.07.02-.08.08-.08.2%2c0%2c.39%2c0%2c.58.06.29.09.45.33.42.63-.03.38-.24.6-.62.64-.13.01-.26.01-.39.02-.06%2c0-.09-.01-.08-.08%2c0-.2%2c0-.39%2c0-.59Z'/%3e %3cpath class='cls-6' d='m32.61%2c9.42c-.19%2c0-.34.15-.34.34s.15.34.34.34.34-.15.34-.34-.15-.34-.34-.34Zm0%2c.62c-.15%2c0-.27-.13-.27-.28s.12-.28.27-.28.27.13.27.28-.12.28-.27.28Z'/%3e %3cpath class='cls-7' d='m32.64%2c9.8c.04.06.08.11.13.17h-.02s-.05%2c0-.07%2c0c0%2c0-.01%2c0-.01%2c0-.03-.05-.07-.1-.1-.15%2c0%2c0%2c0%2c0%2c0%2c0%2c0%2c0%2c0%2c0-.01%2c0%2c0%2c0%2c0%2c0%2c0%2c0%2c0%2c.05%2c0%2c.1%2c0%2c.14%2c0%2c0%2c0%2c0%2c0%2c0-.02%2c0-.04%2c0-.06%2c0%2c0%2c0%2c0%2c0%2c0%2c0%2c0-.13%2c0-.26%2c0-.39%2c0%2c0%2c0%2c0%2c0%2c0%2c.04%2c0%2c.09%2c0%2c.13%2c0%2c.03%2c0%2c.06.01.08.03.03.03.04.06.03.1%2c0%2c.05-.03.09-.08.1%2c0%2c0%2c0%2c0%2c0%2c0Zm-.09-.11s0%2c.04%2c0%2c.05c0%2c0%2c0%2c0%2c0%2c0%2c.01%2c0%2c.02%2c0%2c.03%2c0%2c.03%2c0%2c.05-.02.06-.06%2c0-.03-.01-.05-.04-.06-.02%2c0-.03%2c0-.05%2c0%2c0%2c0%2c0%2c0%2c0%2c0%2c0%2c.02%2c0%2c.04%2c0%2c.05Z'/%3e %3cg%3e %3cellipse class='cls-3' cx='19.41' cy='11.67' rx='2.35' ry='2.36'/%3e %3cg class='cls-1'%3e %3cg%3e %3cpath class='cls-5' d='m22.03%2c10.39c1.18%2c1.33%2c1.19%2c3.24.04%2c4.25-1.15%2c1.02-3.04.77-4.22-.56-1.18-1.33-1.19-3.24-.04-4.25%2c1.15-1.02%2c3.04-.77%2c4.22.56Z'/%3e %3cg class='cls-9'%3e %3cg class='cls-13'%3e %3cpath class='cls-8' d='m22.03%2c10.39c1.18%2c1.33%2c1.19%2c3.24.04%2c4.25-1.15%2c1.02-3.04.77-4.22-.56-1.18-1.33-1.19-3.24-.04-4.25%2c1.15-1.02%2c3.04-.77%2c4.22.56Z'/%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var img$8 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg id='Layer_2' data-name='Layer 2' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 36.07 24.72'%3e %3cdefs%3e %3cstyle%3e .cls-1 %7b fill: url(%23linear-gradient)%3b %7d .cls-1%2c .cls-2%2c .cls-3%2c .cls-4%2c .cls-5%2c .cls-6 %7b stroke-width: 0px%3b %7d .cls-7 %7b fill: white%3b stroke: %23d4d4d4%3b stroke-miterlimit: 10%3b stroke-width: .81px%3b %7d .cls-2 %7b fill: url(%23linear-gradient-4)%3b %7d .cls-3 %7b fill: url(%23linear-gradient-2)%3b %7d .cls-4 %7b fill: url(%23linear-gradient-3)%3b %7d .cls-5 %7b fill: url(%23linear-gradient-5)%3b %7d .cls-6 %7b fill: url(%23linear-gradient-6)%3b %7d %3c/style%3e %3clinearGradient id='linear-gradient' x1='7.99' y1='12.47' x2='14.11' y2='12.47' gradientUnits='userSpaceOnUse'%3e %3cstop offset='0' stop-color='%23313578'/%3e %3cstop offset='1' stop-color='%230077bd'/%3e %3c/linearGradient%3e %3clinearGradient id='linear-gradient-2' x1='7.99' y1='14.17' x2='7.99' y2='14.17' xlink:href='%23linear-gradient'/%3e %3clinearGradient id='linear-gradient-3' x1='14.89' y1='12.47' x2='21.01' y2='12.47' gradientUnits='userSpaceOnUse'%3e %3cstop offset='0' stop-color='%23763137'/%3e %3cstop offset='1' stop-color='%23ee1846'/%3e %3c/linearGradient%3e %3clinearGradient id='linear-gradient-4' x1='22.96' y1='13.43' x2='25.08' y2='13.43' gradientUnits='userSpaceOnUse'%3e %3cstop offset='0' stop-color='%23008149'/%3e %3cstop offset='1' stop-color='%2362bb45'/%3e %3c/linearGradient%3e %3clinearGradient id='linear-gradient-5' x1='22.95' y1='11.43' x2='24.9' y2='11.43' xlink:href='%23linear-gradient-4'/%3e %3clinearGradient id='linear-gradient-6' x1='21.76' y1='12.47' x2='27.88' y2='12.47' xlink:href='%23linear-gradient-4'/%3e %3c/defs%3e %3cg id='icons2'%3e %3cg%3e %3crect class='cls-7' x='.41' y='.41' width='35.26' height='23.91' rx='2.07' ry='2.07'/%3e %3cg%3e %3cg%3e %3cpath class='cls-1' d='m10.4%2c5.02c-1.26%2c0-2.41%2c1.13-2.41%2c2.41%2c0%2c.7%2c0%2c3.47%2c0%2c6.23.23.14%2c1.34.5%2c1.79.53.98.07%2c1.58-.25%2c1.68-1.07v-3.02s2.16%2c0%2c2.16%2c0v2.95c-.11%2c1.69-1.6%2c2.04-3.86%2c1.92-.58-.03-1.38-.18-1.76-.28%2c0%2c2.76%2c0%2c5.23%2c0%2c5.23h3.76c1.03%2c0%2c2.36-.96%2c2.36-2.42V5.02h-3.71Z'/%3e %3cpath class='cls-3' d='m7.99%2c13.65v1.04s0%2c0%2c0%2c0c0-.34%2c0-.69%2c0-1.04%2c0%2c0%2c0%2c0%2c0%2c0Z'/%3e %3c/g%3e %3cpath class='cls-4' d='m17.3%2c5.02c-1.26%2c0-2.41%2c1.13-2.41%2c2.41%2c0%2c.44%2c0%2c1.72%2c0%2c3.29.75-.59%2c1.97-.88%2c3.52-.76.88.07%2c1.53.19%2c1.89.3v1.05c-.39-.2-1.16-.49-1.81-.53-1.46-.11-2.23.58-2.23%2c1.68%2c0%2c1%2c.59%2c1.85%2c2.22%2c1.73.54-.04%2c1.43-.35%2c1.81-.53v1.01c-.32.1-1.34.32-2.3.33-1.44.01-2.46-.29-3.1-.79%2c0%2c2.94%2c0%2c5.71%2c0%2c5.71h3.76c1.03%2c0%2c2.36-.96%2c2.36-2.42V5.02h-3.71Z'/%3e %3cpath class='cls-2' d='m24.43%2c12.77c-.41%2c0-1.31%2c0-1.47%2c0v1.32s1.47%2c0%2c1.47%2c0c.29%2c0%2c.65-.25.65-.67%2c0-.38-.31-.65-.64-.65Z'/%3e %3cpath class='cls-5' d='m24.9%2c11.45c0-.38-.28-.63-.59-.63-.42%2c0-1.19-.01-1.36%2c0v1.2s1.39%2c0%2c1.39%2c0c.23%2c0%2c.56-.22.56-.59Z'/%3e %3cpath class='cls-6' d='m24.17%2c5.02c-1.26%2c0-2.41%2c1.13-2.41%2c2.41%2c0%2c.38%2c0%2c1.38%2c0%2c2.65h3.57c.71%2c0%2c1.55.3%2c1.55%2c1.17%2c0%2c.46-.25.99-1.14%2c1.16v.02c.52%2c0%2c1.42.3%2c1.42%2c1.22s-.97%2c1.21-1.49%2c1.21h-3.91c0%2c2.69%2c0%2c5.07%2c0%2c5.07h3.76c1.03%2c0%2c2.36-.96%2c2.36-2.42V5.02h-3.71Z'/%3e %3c/g%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var NMIGateway = /*#__PURE__*/function () {
  function NMIGateway() {
    var _this = this;
    _classCallCheck(this, NMIGateway);
    _defineProperty(this, "provider", "nmi");
    _defineProperty(this, "publishableKey", void 0);
    _defineProperty(this, "old_publishableKey", void 0);
    _defineProperty(this, "gateway", void 0);
    _defineProperty(this, "containerId", void 0);
    _defineProperty(this, "isLoading", false);
    _defineProperty(this, "fieldErrors", {});
    _defineProperty(this, "buttonId", "");
    _defineProperty(this, "loadNmi", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(tokenizationKey, containerId) {
        var loadDivs, scriptTag, gatewayScriptTag, loadScriptPromise;
        return _regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this.fieldErrors = {};
              // load div
              loadDivs = function loadDivs() {
                var _context, _context2, _context3, _context4, _context5, _context6;
                var paymentFieldsHTML = _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = _concatInstanceProperty(_context5 = _concatInstanceProperty(_context6 = "\n          <style>\n        svg#nmiSVG {\n            width: 3.25em;\n            transform-origin: center;\n            animation: rotate4 2s linear infinite;\n        }\n\n        circle {\n            fill: none;\n            stroke: hsl(214, 97%, 59%);\n            stroke-width: 2;\n            stroke-dasharray: 1, 200;\n            stroke-dashoffset: 0;\n            stroke-linecap: round;\n            animation: dash4 1.5s ease-in-out infinite;\n        }\n\n        @keyframes rotate4 {\n            100% {\n                transform: rotate(360deg);\n            }\n        }\n\n        @keyframes dash4 {\n            0% {\n                stroke-dasharray: 1, 200;\n                stroke-dashoffset: 0;\n            }\n\n            50% {\n                stroke-dasharray: 90, 200;\n                stroke-dashoffset: -35px;\n            }\n\n            100% {\n                stroke-dashoffset: -125px;\n            }\n        }\n\n        .nmi-formInner {\n            width: 100%;\n            max-width: 100%;\n            display: flex;\n            flex-wrap: wrap;\n            justify-content: space-between;\n            margin: 20px auto;\n        }\n\n        #nmi-payButton {\n            width: 290px;\n            display: block;\n            margin: 20px auto;\n            height: 50px !important;\n            font-size: 20px;\n            background-color: #1CC48B;\n            border-color: #1CC48B;\n            box-shadow: 0 3px 10px #bbbbbb;\n        }\n\n        #nmi-payButton:hover {\n            background-color: #19C687;\n            border-color: #19C687;\n            box-shadow: 0 3px 4px #bbbbbb;\n        }\n\n        #nmi-payButton:active {\n            opacity: 0.7;\n        }\n\n        .nmi-error {\n            position: absolute;\n            bottom: -20px;\n            color: #B40E3E;\n            font-size: 14px;\n        }\n\n        .nmi-checkboxLabel {\n            margin: 0 0 0 7px;\n        }\n\n        .payment-field {\n            position: relative;\n            border-radius: 2px;\n            width: 32%;\n            margin-bottom: 14px;\n            box-shadow: 0 2px 8px #dddddd;\n            font-size: 16px;\n            transition: 200ms;\n        }\n\n        .payment-field input:focus {\n            border: 3px solid #1CC48B;\n            outline: none !important;\n        }\n\n        .payment-field:hover {\n            box-shadow: 0 2px 4px #dddddd;\n        }\n\n        .payment-field input {\n            border: 3px solid #FFFFFF;\n            width: 100%;\n            border-radius: 2px;\n            padding: 4px 8px;\n        }\n\n        #payment-fields {\n            display: flex;\n            flex-wrap: wrap;\n            justify-content: space-between;\n        }\n\n        #ccnumber {\n            width: 100%;\n            font-size: 20px;\n            font-family: inherit;\n            font-size: inherit;\n            line-height: inherit;\n        }\n\n        #ccexp,\n        #cvv {\n            font-size: 20px;\n            font-family: inherit;\n            font-size: inherit;\n            line-height: inherit;\n        }\n\n        .nmi-separator {\n            margin-top: 30px;\n            width: 100%;\n        }\n\n        @media only screen and (max-width: 600px) {\n            .nmi-theForm {\n                width: 300px;\n                max-width: 90%;\n                margin: auto;\n            }\n        }\n    </style>\n    <style>\n        #overlay.show {\n            display: block;\n        }\n\n        #overlay-container {\n            align-items: center;\n            justify-content: center;\n            display: flex;\n            flex-direction: column;\n            height: 100%;\n        }\n\n        #overlay {\n            background-color: rgba(255, 255, 255, 1);\n            display: none;\n            position: absolute;\n            bottom: 0;\n            top: 0;\n            left: 0;\n            right: 0;\n            z-index: 1;\n        }\n\n        .nmi3ds-modal {\n          visibility: hidden;\n          opacity: 0;\n          position: absolute;\n          top: 0;\n          right: 0;\n          bottom: 0;\n          left: 0;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          background: rgba(77, 77, 77, .7);\n          transition: all .4s;\n          position: fixed;\n          width: 100%;\n          height: 100%;\n        }\n          \n        .nmi3ds-modal:target {\n          visibility: visible;\n          opacity: 1;\n        }\n\n        .nmi3ds-modal__content {\n          border-radius: 4px;\n          position: relative;\n          width: 500px;\n          max-width: 90%;\n          background: #fff;\n          padding: 1em 2em;\n        }\n\n        .nmi3ds-modal__close {\n          position: absolute;\n          top: 10px;\n          right: 10px;\n          color: #585858;\n          text-decoration: none;\n        }\n        .nmi-card{\n          box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n          transition: 0.3s;\n          width:  100%;\n        }\n        .nmi-card-container {\n          padding: 14px 16px 0;\n        }\n    </style>\n     <div style=\"position:relative;z-index:0\">\n        <div id=\"overlay\" class=\"show\">\n            <div id=\"overlay-container\">\n                <svg id=\"nmiSVG\" viewBox=\"25 25 50 50\">\n                    <circle r=\"20\" cy=\"50\" cx=\"50\"></circle>\n                </svg>\n            </div>\n        </div>\n        <div class=\"nmi-formInner\">\n          <div class=\"nmi-card\">\n            <div class=\"nmi-card-container\">\n              <div style=\"margin-bottom:10px; text-align:right\">\n                <img src=\"".concat(img$d, "\" style=\"width: 40px; margin-right:5px;display:inline-block\"/>\n                <img src=\"")).call(_context6, img$c, "\" style=\"width: 40px; margin-right:5px;display:inline-block\"/>\n                <img src=\"")).call(_context5, img$b, "\" style=\"width: 40px; margin-right:5px;display:inline-block\"/>\n                <img src=\"")).call(_context4, img$a, "\" style=\"width: 40px; margin-right:5px;display:inline-block\"/>\n                <img src=\"")).call(_context3, img$9, "\" style=\"width: 40px; margin-right:5px;display:inline-block\"/>\n                <img src=\"")).call(_context2, img$8, "\" style=\"width: 40px; margin-right:5px;display:inline-block\"/>\n              </div>\n              <div id=\"payment-fields\">\n                  <div class=\"payment-field\" id=\"ccnumber\"></div>\n                  <div class=\"payment-field\" id=\"ccexp\"></div>\n                  <div class=\"payment-field\" id=\"cvv\"></div>\n                  <div class=\"payment-field\" id=\"zip\">\n                      <input type=\"text\" inputmode=\"numeric\" pattern=\"[0-9]{5,6}\" \n                      name=\"zip\" <input type=\"text\" onkeypress=\"return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))\" \n                      maxLength='6' minLength='5' placeholder=\"Postal Code\">\n                  </div>\n              </div>\n            </div>\n          </div>\n        </div>\n    </div>\n     <div id=\"nmi3ds-modal\" class=\"nmi3ds-modal\">\n          <div class=\"nmi3ds-modal__content\" id='nmi3ds_modal_content'>\n              <a href=\"#")).call(_context, containerId.id, "\" id=\"nmi3ds_modal_close\" class=\"nmi3ds-modal__close\">&times;</a>\n          </div>\n      </div>\n      ");
                // let targetSaveCardContainer = document.getElementById(containerId);
                // if (targetSaveCardContainer) {
                if (document.getElementById("payment-fields")) {
                  var _document$getElementB;
                  (_document$getElementB = document.getElementById("payment-fields")) === null || _document$getElementB === void 0 || _document$getElementB.remove();
                }
                containerId.innerHTML = paymentFieldsHTML;
                // }
              };
              if (_this.isLoading) {
                _context7.next = 4;
                break;
              }
              _this.isLoading = true;
              if (!(_this.old_publishableKey != _this.publishableKey)) {
                _context7.next = 2;
                break;
              }
              // Create script tag
              scriptTag = document.createElement("script");
              scriptTag.src = "https://secure.networkmerchants.com/token/Collect.js";
              scriptTag.setAttribute("data-tokenization-key", tokenizationKey);
              gatewayScriptTag = document.createElement("script");
              gatewayScriptTag.src = "https://secure.nmi.com/js/v1/Gateway.js";
              // Wrap the loading logic in a Promise
              loadScriptPromise = new _Promise(function (resolve, reject) {
                var collectJsLoaded = 0;
                var gatewayLoaded = 0;
                scriptTag.onload = function () {
                  collectJsLoaded = 1;
                  // Add event listeners after the script has loaded
                  // const saveButton = document.querySelector('#save-card-tab');
                  // const paymentButton = document.querySelector('#payment-tab');
                  // saveButton?.removeEventListener('click', loadDivs);
                  // saveButton?.addEventListener('click', loadDivs);
                  // paymentButton?.removeEventListener('click', loadDivs);
                  // paymentButton?.addEventListener('click', loadDivs);
                  if (gatewayLoaded === 1) {
                    loadDivs();
                    console.log(" nmi script loaded successfully...");
                    resolve();
                  }
                };
                scriptTag.onerror = reject;
                gatewayScriptTag.onload = function () {
                  gatewayLoaded = 1;
                  _this.gateway = window.Gateway.create(tokenizationKey);
                  if (collectJsLoaded === 1) {
                    loadDivs();
                    console.log(" nmi script loaded successfully...");
                    resolve();
                  }
                };
                gatewayScriptTag.onerror = reject;
              }); // Append the script to the document
              document.head.appendChild(scriptTag);
              document.head.appendChild(gatewayScriptTag);
              _context7.next = 1;
              return loadScriptPromise;
            case 1:
              _context7.next = 3;
              break;
            case 2:
              loadDivs();
            case 3:
              _context7.next = 5;
              break;
            case 4:
              loadDivs();
            case 5:
            case "end":
              return _context7.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(this, "getNMIPayment", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(callbackFn) {
        var collectJS, nmiConfiguration;
        return _regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              collectJS = window.CollectJS;
              if (collectJS !== null && collectJS !== void 0 && collectJS.configure) {
                nmiConfiguration = {
                  callback: callbackFn,
                  variant: "inline",
                  // googleFont: 'Abel',
                  invalidCss: {
                    color: "#B40E3E"
                  },
                  validCss: {
                    color: "#14855F"
                  },
                  customCss: {
                    "border-color": "#FFFFFF",
                    "border-style": "solid"
                  },
                  focusCss: {
                    "border-color": "#1CC48B",
                    "border-style": "solid",
                    "border-width": "3px"
                  },
                  validationCallback: function validationCallback(field, status, message) {
                    if (status) {
                      delete _this.fieldErrors[field];
                      message = "";
                    } else {
                      _this.fieldErrors[field] = message;
                    }
                    var errorElement = document.getElementById(field + "-error");
                    if (errorElement) {
                      errorElement.innerHTML = message;
                    }
                    var btnElement = document.getElementById(_this.buttonId);
                    if (btnElement) {
                      if (_Object$keys(_this.fieldErrors).length > 0) {
                        btnElement.disabled = true;
                        _this.hideLoader();
                        _this.isLoading = false;
                      } else {
                        btnElement.disabled = false;
                      }
                    }
                  },
                  fieldsAvailableCallback: function fieldsAvailableCallback() {
                    _this.hideLoader();
                    _this.isLoading = false;
                  },
                  fields: {
                    cvv: {
                      placeholder: "CVV",
                      display: "hide",
                      selector: "#cvv",
                      title: "CVV Code"
                    },
                    ccnumber: {
                      placeholder: "Credit Card"
                    },
                    ccexp: {
                      placeholder: "MM / YY"
                    }
                  }
                };
                if (_this.buttonId) {
                  nmiConfiguration.paymentSelector = "#" + _this.buttonId;
                }
                collectJS.configure(nmiConfiguration);
              }
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee2);
      }));
      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }());
  }
  return _createClass(NMIGateway, [{
    key: "setElements",
    value: function setElements() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "getElements",
    value: function getElements() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "setCardElement",
    value: function setCardElement() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "getCardElement",
    value: function getCardElement() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "getFlywirePayment",
    value: function getFlywirePayment() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "confirmCardPaymentWithCVC",
    value: function confirmCardPaymentWithCVC() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "getProviderClient",
    value: function getProviderClient() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "getClientInstance",
    value: function getClientInstance() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "getNMIGateway",
    value: function getNMIGateway() {
      if (this.gateway === undefined) {
        throw new TypeError("Cannot read properties of undefined (reading 'get3DSecure')");
      }
      return this.gateway;
    }
  }, {
    key: "saveCard",
    value: function () {
      var _saveCard = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data) {
        var body, response, pIntent, _t;
        return _regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              body = {
                token: data.token,
                account_id: data.account_id,
                email: data.email,
                card: data.card,
                cvv: data.cvv
              };
              _context9.prev = 1;
              _context9.next = 2;
              return fetch("".concat(data.apiBaseURL, "/v1/payment/card"), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": data.apiKey,
                  token: data.token
                  // Authorization: `Basic ${btoa(`${this.apiKey}:${this.apiSecret}`)}`,
                },
                body: _JSON$stringify(body)
              });
            case 2:
              response = _context9.sent;
              _context9.next = 3;
              return response.json();
            case 3:
              pIntent = _context9.sent;
              this.hideLoader();
              if (this.containerId) {
                if (pIntent.success) ;
              }
              return _context9.abrupt("return", pIntent);
            case 4:
              _context9.prev = 4;
              _t = _context9["catch"](1);
              throw new Error("Error: " + _t, {
                cause: _t
              });
            case 5:
            case "end":
              return _context9.stop();
          }
        }, _callee3, this, [[1, 4]]);
      }));
      function saveCard(_x4) {
        return _saveCard.apply(this, arguments);
      }
      return saveCard;
    }()
  }, {
    key: "verify3dSecure",
    value: function verify3dSecure() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "setToken",
    value: function setToken() {
      throw new Error("Method not implemented.");
    }
  }, {
    key: "getProviderName",
    value: function getProviderName() {
      return this.provider;
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(publishableKey, containerId, data) {
        return _regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              this.old_publishableKey = this.publishableKey;
              this.publishableKey = publishableKey;
              this.containerId = containerId;
              if (data.button_id) {
                this.buttonId = data.button_id;
              }
              if (!containerId) {
                _context0.next = 2;
                break;
              }
              _context0.next = 1;
              return this.loadNmi(this.publishableKey, containerId);
            case 1:
              _context0.next = 3;
              break;
            case 2:
              console.log("init container id not found: ", containerId);
            case 3:
              return _context0.abrupt("return", this);
            case 4:
            case "end":
              return _context0.stop();
          }
        }, _callee4, this);
      }));
      function init(_x5, _x6, _x7) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
  }, {
    key: "showLoader",
    value: function showLoader() {
      var errorElement = document.getElementById("overlay");
      if (errorElement) {
        errorElement.classList.add("show");
      }
    }
  }, {
    key: "hideLoader",
    value: function hideLoader() {
      _setTimeout(function () {
        // const errorElement = document.getElementById('');
        var errorElement = document.querySelectorAll("[id=overlay]");
        for (var i = 0; i < errorElement.length; i++) {
          if (errorElement[i]) {
            errorElement[i].classList.remove("show");
          }
        }
      }, 1000);
    }
  }]);
}();

var StripeGateway = /*#__PURE__*/function () {
  function StripeGateway() {
    _classCallCheck(this, StripeGateway);
    _defineProperty(this, "provider", "stripe");
    _defineProperty(this, "publishableKey", void 0);
    _defineProperty(this, "stripe", void 0);
    _defineProperty(this, "elements", void 0);
    _defineProperty(this, "cardElement", void 0);
    _defineProperty(this, "clientSecret", "");
  }
  return _createClass(StripeGateway, [{
    key: "setElements",
    value: function setElements(elements) {
      this.elements = elements;
    }
  }, {
    key: "setCardElement",
    value: function setCardElement(cardElement) {
      this.cardElement = cardElement;
    }
  }, {
    key: "getCardElement",
    value: function getCardElement() {
      return this.cardElement;
    }
  }, {
    key: "getElements",
    value: function getElements() {
      return this.elements;
    }
  }, {
    key: "getProviderName",
    value: function getProviderName() {
      return this.provider;
    }
  }, {
    key: "getProviderClient",
    value: function getProviderClient() {
      return this.stripe;
    }
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(publishableKey, _containerId, data) {
        var _data$metadata;
        var loadStripeIns;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.publishableKey = publishableKey;
              _context.next = 1;
              return loadStripe(this.publishableKey, {
                locale: (data === null || data === void 0 || (_data$metadata = data.metadata) === null || _data$metadata === void 0 ? void 0 : _data$metadata.language_code) || "auto"
              });
            case 1:
              loadStripeIns = _context.sent;
              this.stripe = loadStripeIns;
              return _context.abrupt("return", this);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init(_x, _x2, _x3) {
        return _init.apply(this, arguments);
      }
      return init;
    }() // async confirmPaymentIntent(clientSecret: string): Promise<any> {
    //   const elements = this.stripe?.elements({
    //     clientSecret: clientSecret,
    //     loader: 'auto',
    //   });
    //   const payEl = elements?.create('payment', {
    //     layout: 'tabs',
    //   });
    //   payEl?.mount(this.mountPaymentElementContainer!);
    //   return this.stripe?.confirmPayment({
    //     elements,
    //     redirect: 'if_required',
    //     confirmParams: {
    //       return_url: 'http://localhost:3000',
    //     },
    //   } as any);
    // }
  }, {
    key: "saveCard",
    value: function () {
      var _saveCard = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(data) {
        var _this$elements, submitResult, _this$stripe, paymentMethodResult, result, body, _data$apiKey, response, pIntent, _t, _t2;
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              if (!this.cardElement) {
                _context2.next = 10;
                break;
              }
              _context2.next = 1;
              return (_this$elements = this.elements) === null || _this$elements === void 0 ? void 0 : _this$elements.submit();
            case 1:
              submitResult = _context2.sent;
              if (!(submitResult !== null && submitResult !== void 0 && submitResult.error)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", {
                error: submitResult.error
              });
            case 2:
              if (!(this.cardElement && this.clientSecret)) {
                _context2.next = 10;
                break;
              }
              _context2.next = 3;
              return (_this$stripe = this.stripe) === null || _this$stripe === void 0 ? void 0 : _this$stripe.confirmSetup({
                // payment_method: {
                elements: this.elements,
                clientSecret: this.clientSecret,
                // billing_details: {
                //   name: data.name,
                //   email: data.email,
                //   phone: data.phone
                // },
                confirmParams: {
                  return_url: "https://example.com/order/123/complete"
                },
                redirect: "if_required"
                // }
              });
            case 3:
              paymentMethodResult = _context2.sent;
              if (paymentMethodResult) {
                _context2.next = 4;
                break;
              }
              throw new TypeError("Cannot read properties of undefined (reading 'error')");
            case 4:
              if (!paymentMethodResult.error) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return", {
                error: paymentMethodResult.error
              });
            case 5:
              result = paymentMethodResult.setupIntent;
              body = {
                token: result.payment_method,
                account_id: data.account_id,
                email: data.email
              };
              _context2.prev = 6;
              _context2.next = 7;
              return fetch("".concat(data.apiBaseURL, "/v1/payment/card"), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": (_data$apiKey = data.apiKey) !== null && _data$apiKey !== void 0 ? _data$apiKey : ""
                  // Authorization: `Basic ${btoa(`${this.apiKey}:${this.apiSecret}`)}`,
                },
                body: _JSON$stringify(body)
              });
            case 7:
              response = _context2.sent;
              _context2.next = 8;
              return response.json();
            case 8:
              pIntent = _context2.sent;
              return _context2.abrupt("return", pIntent);
            case 9:
              _context2.prev = 9;
              _t = _context2["catch"](6);
              throw new Error("Error: " + _t, {
                cause: _t
              });
            case 10:
              _context2.next = 12;
              break;
            case 11:
              _context2.prev = 11;
              _t2 = _context2["catch"](0);
              return _context2.abrupt("return", {
                error: _t2
              });
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 11], [6, 9]]);
      }));
      function saveCard(_x4) {
        return _saveCard.apply(this, arguments);
      }
      return saveCard;
    }()
  }, {
    key: "confirmCardPaymentWithCVC",
    value: function () {
      var _confirmCardPaymentWithCVC = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data) {
        var clientSecret, selectedCardId, cvcElement, result, paymentIntent, error, _t3;
        return _regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              clientSecret = data.clientSecret, selectedCardId = data.selectedCardId, cvcElement = data.cvcElement;
              if (!(!this.stripe || !clientSecret || !selectedCardId || !cvcElement)) {
                _context3.next = 1;
                break;
              }
              throw new Error("Missing required parameters for confirmCardPaymentWithCVC.");
            case 1:
              _context3.next = 2;
              return this.stripe.confirmCardPayment(clientSecret, {
                payment_method: selectedCardId,
                payment_method_options: {
                  card: {
                    cvc: cvcElement
                  }
                }
              });
            case 2:
              result = _context3.sent;
              paymentIntent = result.paymentIntent, error = result.error;
              return _context3.abrupt("return", {
                paymentIntent: paymentIntent,
                error: error
              });
            case 3:
              _context3.prev = 3;
              _t3 = _context3["catch"](0);
              return _context3.abrupt("return", {
                error: _t3
              });
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 3]]);
      }));
      function confirmCardPaymentWithCVC(_x5) {
        return _confirmCardPaymentWithCVC.apply(this, arguments);
      }
      return confirmCardPaymentWithCVC;
    }()
  }, {
    key: "setToken",
    value: function () {
      var _setToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(token) {
        return _regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.clientSecret = token;
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function setToken(_x6) {
        return _setToken.apply(this, arguments);
      }
      return setToken;
    }()
  }, {
    key: "verify3dSecure",
    value: function verify3dSecure() {
      return {};
    }
  }]);
}();

function _createForOfIteratorHelper$1(r, e) { var t = "undefined" != typeof _Symbol && _getIteratorMethod(r) || r["@@iterator"]; if (!t) { if (_Array$isArray(r) || (t = _unsupportedIterableToArray$1(r)) || e) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: true } : { done: false, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = true, u = false; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = true, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray$1(r, a) { if (r) { var _context4; if ("string" == typeof r) return _arrayLikeToArray$1(r, a); var t = _sliceInstanceProperty(_context4 = {}.toString.call(r)).call(_context4, 8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? _Array$from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$1(r, a) : void 0; } }
function _arrayLikeToArray$1(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/** User-facing card field messages. Empty and invalid are separate, and a past date is not a format error. */
var CARD_FIELD_MESSAGES = {
  emptyNumber: "Please enter card number",
  invalidNumber: "Invalid card number",
  emptyCvv: "Please enter CVV",
  invalidCvv: "Invalid CVV",
  emptyExpiry: "Please enter expiry date",
  invalidExpiry: "Invalid expiry date",
  expired: "Card has expired"
};
var CARD_VALIDATOR_MAX_FUTURE_YEARS = 19;
var STRIPE_CODE_MESSAGES = {
  incomplete_number: CARD_FIELD_MESSAGES.emptyNumber,
  invalid_number: CARD_FIELD_MESSAGES.invalidNumber,
  incorrect_number: CARD_FIELD_MESSAGES.invalidNumber,
  incomplete_cvc: CARD_FIELD_MESSAGES.emptyCvv,
  invalid_cvc: CARD_FIELD_MESSAGES.invalidCvv,
  incorrect_cvc: CARD_FIELD_MESSAGES.invalidCvv,
  incomplete_expiry: CARD_FIELD_MESSAGES.emptyExpiry,
  invalid_expiry_month: CARD_FIELD_MESSAGES.invalidExpiry,
  invalid_expiry_year: CARD_FIELD_MESSAGES.invalidExpiry,
  invalid_expiry_month_past: CARD_FIELD_MESSAGES.expired,
  invalid_expiry_year_past: CARD_FIELD_MESSAGES.expired,
  expired_card: CARD_FIELD_MESSAGES.expired
};
var STRIPE_MESSAGE_MESSAGES = {
  "your card number is incomplete.": CARD_FIELD_MESSAGES.emptyNumber,
  "your card number is invalid.": CARD_FIELD_MESSAGES.invalidNumber,
  "your card number is incorrect.": CARD_FIELD_MESSAGES.invalidNumber,
  "your card's security code is incomplete.": CARD_FIELD_MESSAGES.emptyCvv,
  "your card's security code is invalid.": CARD_FIELD_MESSAGES.invalidCvv,
  "your card's security code is incorrect.": CARD_FIELD_MESSAGES.invalidCvv,
  "your card's expiration date is incomplete.": CARD_FIELD_MESSAGES.emptyExpiry,
  "your card's expiration month is invalid.": CARD_FIELD_MESSAGES.invalidExpiry,
  "your card's expiration year is invalid.": CARD_FIELD_MESSAGES.invalidExpiry,
  "your card's expiration month is in the past.": CARD_FIELD_MESSAGES.expired,
  "your card's expiration year is in the past.": CARD_FIELD_MESSAGES.expired,
  "your card has expired.": CARD_FIELD_MESSAGES.expired,
  "expired card": CARD_FIELD_MESSAGES.expired,
  "invalid expiration date": CARD_FIELD_MESSAGES.invalidExpiry,
  "invalid credit card number": CARD_FIELD_MESSAGES.invalidNumber
};
/** Drop blank copies. The same text is shown once; different field errors stay in order. */
function dedupeValidationMessages(messages) {
  var unique = [];
  var seen = new _Set();
  var _iterator = _createForOfIteratorHelper$1(messages),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var message = _step.value;
      var text = typeof message === "string" ? _trimInstanceProperty(message).call(message) : "";
      if (!text || seen.has(text)) {
        continue;
      }
      seen.add(text);
      unique.push(text);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return unique;
}
function errorText(error) {
  if (typeof error === "string") {
    return error;
  }
  if (_typeof(error) === "object" && error !== null && "message" in error && typeof error.message === "string") {
    return error.message;
  }
  return undefined;
}
function errorCode(error) {
  if (_typeof(error) === "object" && error !== null && "code" in error && typeof error.code === "string") {
    return error.code;
  }
  return undefined;
}
function splitExpiry(value) {
  var compact = _trimInstanceProperty(value).call(value).replace(/\s+/g, "");
  if (!compact) {
    return undefined;
  }
  var slashed = compact.match(/^(\d{1,2})\/(\d{0,4})$/);
  if (slashed) {
    return {
      month: slashed[1],
      year: slashed[2]
    };
  }
  if (compact.replace(/[/\d]/g, "") !== "") {
    return undefined;
  }
  var digits = compact.replace(/\D/g, "");
  if (!digits) {
    return undefined;
  }
  if (digits.length <= 2) {
    return {
      month: digits,
      year: ""
    };
  }
  if (digits[0] === "0" || digits[0] === "1") {
    return {
      month: _sliceInstanceProperty(digits).call(digits, 0, 2),
      year: _sliceInstanceProperty(digits).call(digits, 2)
    };
  }
  return {
    month: _sliceInstanceProperty(digits).call(digits, 0, 1),
    year: _sliceInstanceProperty(digits).call(digits, 1)
  };
}
/**
 * Distinguishes an empty expiry, a malformed expiry, and a past expiry.
 * card-validator confirms a complete future date. A finished month/year in the past is expired
 * even when card-validator only reports the field as not potentially valid.
 */
function classifyExpiry(value) {
  var _context, _context2;
  if (value == null || _trimInstanceProperty(value).call(value) === "") {
    return "empty";
  }
  var parts = splitExpiry(value);
  if (!parts) {
    return "invalid";
  }
  var monthNumber = Number(parts.month);
  if (!parts.month || _Number$isNaN(monthNumber) || monthNumber < 1 || monthNumber > 12) {
    return "invalid";
  }
  if (parts.year.length !== 2 && parts.year.length !== 4) {
    return "invalid";
  }
  var now = new Date();
  var currentYear = now.getFullYear();
  var fullYear = parts.year.length === 2 ? Math.floor(currentYear / 100) * 100 + Number(parts.year) : Number(parts.year);
  if (fullYear > currentYear + CARD_VALIDATOR_MAX_FUTURE_YEARS) {
    return "invalid";
  }
  if (fullYear < currentYear || fullYear === currentYear && monthNumber < now.getMonth() + 1) {
    return "expired";
  }
  var month = _padStartInstanceProperty(_context = String(monthNumber)).call(_context, 2, "0");
  var year = parts.year.length === 2 ? parts.year : String(fullYear);
  var checked = cardValidator.expirationDate(_concatInstanceProperty(_context2 = "".concat(month, "/")).call(_context2, year));
  if (checked.isValid) {
    return "valid";
  }
  if (checked.month && checked.year) {
    return "expired";
  }
  return "invalid";
}
function messageForCardExpiry(month, year) {
  var _context3;
  if (!month || !year) {
    return undefined;
  }
  var kind = classifyExpiry(_concatInstanceProperty(_context3 = "".concat(month, "/")).call(_context3, year));
  if (kind === "expired") {
    return CARD_FIELD_MESSAGES.expired;
  }
  if (kind === "invalid" || kind === "empty") {
    return CARD_FIELD_MESSAGES.invalidExpiry;
  }
  return undefined;
}
function snapshotMessage(field, emptyMessage, invalidMessage) {
  if (!field || field.isEmpty !== false) {
    return emptyMessage;
  }
  if (field.isValid !== true) {
    return invalidMessage;
  }
  return undefined;
}
/**
 * Failing card fields in number, expiry, CVV order.
 * Braintree does not expose the expiry text, so a non-empty invalid expiry stays "Invalid expiry date"
 * until tokenize returns a month and year that can be classified.
 */
function messagesForBraintreeCardFields(fields) {
  if (!fields) {
    return [];
  }
  return dedupeValidationMessages([snapshotMessage(fields.number, CARD_FIELD_MESSAGES.emptyNumber, CARD_FIELD_MESSAGES.invalidNumber), snapshotMessage(fields.expirationDate, CARD_FIELD_MESSAGES.emptyExpiry, CARD_FIELD_MESSAGES.invalidExpiry), snapshotMessage(fields.cvv, CARD_FIELD_MESSAGES.emptyCvv, CARD_FIELD_MESSAGES.invalidCvv)]);
}
function messageForBraintreeCardFields(fields) {
  return messagesForBraintreeCardFields(fields)[0];
}
/**
 * Card fields win while any of them fail. The cardholder name is reported only once the card fields are valid.
 */
function messagesForCardEntry(cardFieldMessages, cardholderNameMessage) {
  var fields = dedupeValidationMessages(cardFieldMessages);
  if (fields.length > 0) {
    return fields;
  }
  return dedupeValidationMessages([cardholderNameMessage]);
}
function messageForBraintreeTokenizeError(error, fields) {
  var code = errorCode(error);
  var fieldMessage = messageForBraintreeCardFields(fields);
  if (fieldMessage && (code === "HOSTED_FIELDS_FIELDS_EMPTY" || code === "HOSTED_FIELDS_FIELDS_INVALID")) {
    return fieldMessage;
  }
  var known = friendlyCardFailureMessage(error);
  if (known) {
    return known;
  }
  if (code === "HOSTED_FIELDS_FIELDS_EMPTY") {
    return CARD_FIELD_MESSAGES.emptyNumber;
  }
  return errorText(error) || "Please enter card details first!";
}
function stripeError(error) {
  if (_typeof(error) === "object" && error !== null) {
    return error;
  }
  return undefined;
}
/**
 * Maps Stripe.js validation and card errors onto the field messages.
 * Non-card payment methods keep Stripe's own message.
 */
function messageForStripeError(error, options) {
  var paymentMethodType = options === null || options === void 0 ? void 0 : options.paymentMethodType;
  if (paymentMethodType && paymentMethodType !== "card") {
    return undefined;
  }
  var details = stripeError(error);
  var code = typeof (details === null || details === void 0 ? void 0 : details.code) === "string" ? details.code : undefined;
  if (code && STRIPE_CODE_MESSAGES[code]) {
    return STRIPE_CODE_MESSAGES[code];
  }
  return friendlyCardFailureMessage(error);
}
function friendlyCardFailureMessage(error) {
  var _errorText;
  var code = errorCode(error);
  if (code && STRIPE_CODE_MESSAGES[code]) {
    return STRIPE_CODE_MESSAGES[code];
  }
  var message = (_errorText = errorText(error)) === null || _errorText === void 0 ? void 0 : _trimInstanceProperty(_errorText).call(_errorText).toLowerCase();
  if (!message) {
    return undefined;
  }
  return STRIPE_MESSAGE_MESSAGES[message];
}

var version = "0.1.76";
var packageJson = {
	version: version};

var img$7 = "data:image/svg+xml,%3csvg width='780' height='500' viewBox='0 0 780 500' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M654.223 279.812L637.598 202.107L609.685 279.812H654.223Z' fill='%23393939'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M41.458 0H736.038C758.935 0 777.497 18.99 777.497 42.426V457.076C777.497 480.508 758.926 499.502 736.038 499.502H41.458C18.562 499.502 0 480.513 0 457.076V42.426C0 18.994 18.571 0 41.458 0ZM399.884 212.007C399.884 167.144 441.738 142.862 488.573 142.862C518.568 142.862 539.837 152.04 539.837 152.04L530.378 195.765C530.378 195.765 510.831 185.865 486.872 185.865C465.637 185.865 455.402 195.206 455.402 203.732C455.402 213.307 467.277 219.61 481.547 227.184C503.029 238.586 529.94 252.869 529.94 285.535C529.94 331.166 489.648 356.64 438.442 356.64C403.895 356.64 377.873 345.141 377.873 345.141L387.539 299.87C387.539 299.87 410.127 313.482 440.35 313.482C461.645 313.482 474.114 303.74 474.114 292.857C474.114 282.136 461.343 275.251 446.395 267.192C425.306 255.822 399.884 242.116 399.884 212.007ZM58.9453 152.762L60.0794 146.162H149.49C162.401 146.162 172.949 153.954 175.032 167.612L197.739 286.953L253.385 146.162H309.469L222.868 353.237H166.655L124.721 191.537C120.872 176.619 119.245 171.815 96.395 163.565C78.6488 156.369 58.9453 152.762 58.9453 152.762ZM288.025 353.237L332.021 146.162H385.348L341.506 353.237H288.025ZM605.561 165.137C610.575 153.069 617.408 146.162 630.304 146.162H675.383L718.555 353.237H669.068L662.47 321.887H594.143L583.292 353.237H527.208L605.561 165.137Z' fill='%23393939'/%3e%3c/svg%3e";

var img$6 = "data:image/svg+xml,%3csvg width='780' height='500' enable-background='new 0 0 780 500' version='1.1' viewBox='0 0 780 500' xml:space='preserve' xmlns='http://www.w3.org/2000/svg'%3e%3cpolygon points='486.1 347.13 500.13 347.13 504.13 333.22 490.2 333.22' fill='%23393939'/%3e%3cpath d='m497.32 308.85l-4.858 16.469s5.291-2.782 8.206-3.673c2.915-0.667 7.232-1.225 7.232-1.225l3.348-11.46h-14.034l0.106-0.111z' fill='%23393939'/%3e%3cpath d='m504.18 285.26l-4.481 13.907s5.003-2.153 7.816-2.838c2.813-0.687 6.983-0.882 6.983-0.882l3.23-10.09h-13.445l-0.103-0.097z' fill='%23393939'/%3e%3cpath d='m418.18 299.17s5.29-5.005 14.36-6.562c2.051-0.445 15.007-0.225 15.007-0.225l1.944-6.676h-27.316l-3.996 13.575 1e-3 -0.112z' fill='%23393939'/%3e%3cpath d='m443.87 304.29h-27.1l-1.619 5.675h23.537c2.807-0.334 3.347 0.111 3.562-0.111l1.728-5.563h-0.108v-1e-3z' fill='%23393939'/%3e%3cpath d='m367.78 221.44c-0.324 2.002-2.052 9.458-4.319 12.574-1.62 2.336-3.456 3.783-5.615 3.783-0.647 0-4.319 0-4.426-5.675 0-2.781 0.539-5.675 1.187-8.79 1.944-9.013 4.319-16.467 10.257-16.467 4.643-1e-3 4.966 5.562 2.916 14.575z' fill='%23393939'/%3e%3cpath d='m556.26 222.93c-0.432 1.891-2.16 9.457-4.427 12.573-1.513 2.225-5.183 3.672-7.233 3.672-0.647 0-4.211 0-4.427-5.562 0-2.783 0.539-5.675 1.187-8.791 1.944-8.79 4.32-16.245 10.258-16.245 4.643 0 6.693 5.452 4.643 14.465v-0.112h-1e-3z' fill='%23393939'/%3e%3cpath d='m511.29 185.45c-1.295 6.12-5.182 11.35-10.147 13.797-4.104 2.113-9.07 2.336-14.252 2.336h-3.348l0.216-1.335s6.155-27.594 6.155-27.483l0.215-1.447 0.108-1.112 2.482 0.223s12.74 1.112 12.957 1.112c4.967 2.004 7.127 7.122 5.614 13.909z' fill='%23393939'/%3e%3cpath d='m740.77 0h-699.05c-23.035 0-41.725 19.07-41.725 42.596v416.31c0 23.53 18.681 42.596 41.725 42.596h699.05c23.035 0 41.726-19.07 41.726-42.596v-416.31c0-23.53-18.682-42.596-41.726-42.596zm-187.64 196.45c2.846 1.131 4.789 2.873 6.162 4.934 0.062-0.48 0.125-0.967 0.188-1.464l0.648-0.556c8.961-1.337 11.443-1.67 20.837-3.45l0.216 0.778c-1.729 7.344-3.347 14.577-5.075 21.808-3.454 15.243-4.641 23.033-5.937 31.044l-0.864 0.667v-0.112c-9.07-0.111-11.66-0.111-19.976 0.334l-0.539-0.667 0.721-2.798c-2.86 2.338-5.933 3.923-9.23 4.112-3.347 0.223-6.692-0.223-10.364-1.891-11.553-4.562-9.718-17.692-8.097-24.813 1.51-7.121 4.318-14.575 9.933-19.916 7.988-7.565 17.382-9.68 21.377-8.01zm-87.945-8.889c0-0.111 5.83-27.705 5.83-27.705s0.432-2.113 0.647-3.338c2.59 0.333 9.068 0.445 25.265 0.223l6.262-0.112c12.632 0.112 23.537 0.223 29.043 8.123 2.16 3.004 2.915 6.787 2.915 10.682 0 3.003-0.432 5.896-0.971 8.344-2.268 10.014-7.234 18.359-14.575 23.923-10.798 8.123-24.509 8.123-36.71 8.123h-1.297c-0.863 0.555-1.726 1.78-1.726 1.78-0.108 0.445-2.916 12.462-2.916 12.462-0.108 0-3.346 16.355-3.887 19.137-2.483-0.334-8.206-0.334-22.35-0.112 0.65-2.781 14.47-61.53 14.47-61.53zm-71.706 41.939c3.671-16.801 4.535-23.254 5.613-31.822l0.647-0.445c8.64-1.224 10.798-1.558 20.082-3.449l0.757 0.89-1.296 5.341c1.513-1.001 3.132-2.003 4.644-2.782 4.427-2.226 9.285-2.893 11.982-2.893 4.104 0 8.531 1.225 10.474 6.12 1.728 4.339 0.541 9.68-1.835 20.251l-1.188 5.341c-2.482 11.794-2.807 13.908-4.104 21.919l-0.862 0.667 0.107 0.112c-7.449-0.112-10.041-0.112-18.786 0.333l-0.324-0.668c0.756-3.45 1.62-6.787 2.375-10.237l0.971-4.673c1.621-7.231 3.24-15.8 3.348-18.358 0.216-1.558 0.647-5.452-3.563-5.452-1.835 0-3.777 0.889-5.613 1.779-0.972 3.895-3.132 14.799-4.212 19.694-2.051 10.459-2.267 11.683-3.238 16.802l-0.647 0.667c-7.665-0.111-10.364-0.111-19.218 0.334l-0.432-0.779c1.512-6.229 2.914-12.461 4.318-18.692zm7.5 49.641l-3.563 12.127h-26.56l-2.915 2.561c-1.296 1.225-1.619 0.779-3.24 1.67-1.51 0.777-4.642 2.335-8.745 2.335h-8.529l3.454-11.682h2.592c2.16 0 3.672-0.224 4.427-0.668 0.864-0.557 1.836-1.78 2.807-3.783l4.858-9.124h19.327l-3.291 6.564h19.378zm-166.35-64.096c-2.592 9.68-5.614 20.695-17.167 27.705-6.586 4.116-16.411 6.454-26.884 6.454-8.098 0-22.458-1.335-27.532-10.459-1.62-2.783-2.375-6.231-2.375-10.348l1.834-14.021 0.973-4.227 11.014-50.406s0.539-2.781 0.648-3.226c0.216 0.333 3.993 0.557 25.048 0.333 0 0.111 0 0.334-0.107 0.667-1.943 5.897-12.741 50.627-12.741 50.627 0 0.11-2.051 13.352-2.051 13.352l0.109 2.226c0.647 6.564 4.534 10.013 11.336 10.013 4.21 0 7.882-1.223 11.013-3.894 5.398-4.562 7.018-11.684 9.286-21.586 0 0 10.365-49.068 10.904-51.738v0.112c1.511 0.334 5.938 0.445 21.27 0.334-0.109 0.111-0.109 0.333-0.216 0.667-1.943 6.008-13.064 52.406-13.064 52.406l-1.298 5.009zm60.939 5.666l-1.187 5.341c-2.376 11.794-2.807 13.908-4.104 21.919l-0.863 0.667 0.107 0.112h1e-3 -1e-3c-7.45-0.112-10.149-0.112-18.894 0.333l-0.325-0.668c0.756-3.45 1.619-6.787 2.267-10.237l1.08-4.673c1.619-7.231 3.131-15.8 3.347-18.358 0.216-1.558 0.647-5.452-3.672-5.452-1.835 0-3.67 0.889-5.613 1.779-1.081 3.895-3.132 14.799-4.212 19.694-2.16 10.459-2.267 11.683-3.239 16.802l-0.648 0.667c-7.666-0.111-10.364-0.111-19.218 0.334l-0.432-0.779c1.512-6.231 2.915-12.462 4.319-18.693 3.67-16.801 4.643-23.254 5.613-31.822l0.756-0.445c8.638-1.224 10.689-1.558 20.082-3.449l0.755 0.89-1.403 5.341c1.619-1.001 3.131-2.003 4.75-2.782 4.427-2.226 9.286-2.893 11.985-2.893 4.102 0 8.637 1.225 10.473 6.12 1.731 4.341 0.65 9.681-1.724 20.252zm31.723-3.309c-0.864 3.672-1.728 7.343-2.483 11.016-1.621 7.789-2.376 10.682-2.699 12.795-0.432 2.003-0.541 3.005-1.189 7.01l-0.432 0.333-0.432 0.334-0.216-0.112c-4.534 0-7.449-0.111-10.255 0-2.808 0-5.507 0.223-9.718 0.334l-0.216-0.334-0.216-0.445c1.188-4.451 1.728-6.008 2.375-7.566 0.54-1.558 1.079-3.115 2.16-7.677 1.294-5.898 2.159-10.015 2.698-13.687 0.648-3.45 0.972-6.453 1.404-9.903l0.323-0.222 0.324-0.334c4.536-0.668 7.343-1.113 10.258-1.558 2.916-0.445 5.938-1.001 10.581-1.891l0.216 0.445 0.107 0.445-2.59 11.017zm0.88-15.357c-4.966 3.561-12.416 4.229-16.518 1.78-4.211-2.67-3.672-7.565 1.295-11.015 4.967-3.56 12.417-4.34 16.627-1.78 4.211 2.558 3.562 7.454-1.404 11.015zm6.887 20.844c1.512-7.121 4.211-14.577 9.933-20.028 7.99-7.566 18.138-8.011 22.458-8.011 7.125 0 14.035 1.668 17.922 6.787 2.483 3.337 4.534 8.901 1.944 20.696h0.106c-0.864 3.672-3.131 12.351-8.205 18.137-6.586 7.121-15.332 9.568-23.861 9.568-3.347 0-8.53-0.444-12.092-2.001-11.661-4.898-9.825-17.916-8.205-25.148zm39.977 141.13h-21.81c-1.726 0-3.022-0.223-4.966-0.668-1.836-0.444-2.699-1.335-3.454-2.559-0.757-1.335-2.053-2.338-1.189-5.23l6.262-21.362h-10.796l3.563-12.239h10.796l2.915-9.902h-10.795l3.456-11.685-0.216-0.11h47.396l-3.456 11.684h-18.894l-2.914 9.901h19.434l-3.563 12.018h-19.327l-4.75 16.134c-0.539 1.78 4.643 2.003 6.478 2.003l9.717-1.336-3.887 13.351zm80.264-33.83c-0.646 2.337-1.187 4.118-2.915 5.675-1.835 1.559-3.886 3.227-8.852 3.227l-9.178 0.445-0.108 8.457c-0.107 2.335 0.541 2.112 0.863 2.558 0.433 0.445 0.756 0.558 1.188 0.78l2.915-0.224 8.747-0.444-3.672 12.462h-10.041c-7.018 0-12.309-0.224-13.929-1.558-1.727-1.113-1.942-2.448-1.942-4.896l0.646-33.157h16.088l-0.216 6.787h3.886c1.297 0 2.27-0.111 2.809-0.445 0.539-0.333 0.864-0.89 1.08-1.669l1.619-5.34h12.479l0.045-0.223 0.109 0.223h-0.154l-1.467 7.342zm1.42-15.773c-0.97 1.558-2.159 3.004-4.533 4.339-2.268 1.225-4.32 2.003-6.263 2.115-1.728 0.11-4.535 0.223-8.206 0.223h-25.804l-7.234 24.812c-0.646 2.447-0.971 3.67-0.539 4.338 0.323 0.558 1.295 1.225 2.483 1.225l11.336-1.112-3.887 13.574h-12.739c-4.104 0-7.019-0.111-9.07-0.224-1.943-0.221-3.996 0-5.399-1.111-1.187-1.112-3.022-2.559-2.915-4.006 0.109-1.335 0.648-3.561 1.513-6.676l23.212-79.223h16.52l-2.375 8.568s5.182-4.339 8.853-5.898c3.671-1.335 11.876-2.67 11.876-2.67l26.776-0.11-9.177 31.377c-1.512 5.34-3.348 8.79-4.428 10.459zm132.61-5.441h-18.894l-2.915 9.681h18.894l-3.132 10.569h-20.405l-3.67 4.45h8.313l2.051 13.353c0.216 1.335 0.216 2.225 0.646 2.782 0.434 0.445 2.917 0.668 4.319 0.668h2.483l-3.886 13.018h-6.371c-0.971 0-2.483-0.111-4.534-0.111-1.944-0.224-3.238-1.336-4.534-2.003-1.188-0.557-2.915-2.003-3.347-4.562l-1.944-13.353-9.285 13.13c-2.916 4.116-6.909 7.344-13.712 7.344h-12.955l1.231-4.129h-4.271l-1.188 3.895h-17.276l1.189-3.895h-34.982l3.454-11.792h3.562l18.356-62.756 3.67-12.685h17.6l-1.836 6.342s4.642-3.448 9.178-4.674c3.581-0.989 20.946-1.468 27.444-1.618l-0.049-0.05h18.786l0.216 7.232c-0.106 1.224 0.864 1.78 3.131 1.78h3.779l-3.454 11.906h-10.149c-8.745 0.668-12.093-3.227-11.877-7.566l-0.146-5.95-1.553 5.171h-6.046l0.107 0.111-18.139 61.753h4.859l-1.581 5.351h4.405c1.403 0 2.699-0.555 3.67-1.112 0.972-0.445 1.836-0.89 2.699-2.335l13.604-19.695h-17.924l3.023-10.569h20.514l2.915-9.681h-20.188l3.453-11.906h56.145l-3.453 11.906zm12.79-37.747l-1.404 1.67h-0.148l-7.115 12.589c-2.269 4.339-6.587 7.677-13.281 7.677l-11.553-0.223 3.348-11.571h2.267c1.188 0 2.051-0.111 2.699-0.445 0.648-0.223 0.973-0.668 1.512-1.335l4.319-7.01h0.549l-0.086-0.239c5.83-9.011 7.232-12.904 13.28-23.142-1.079-11.461-1.62-15.132-2.483-22.698-0.54-4.451-1.188-9.013-1.728-13.576-1.08-9.235-0.863-7.9-1.943-13.796l-0.109-0.112c0-0.333 0-0.667 0.109-1.001l0.646-0.668c8.855-1.224 9.069-1.558 18.787-3.449l0.755 0.89 1.297 25.592c0.108 0.557 0.108 0.89 0.108 1.447 5.073-11.794 4.966-8.568 11.229-23.588v0.111c0-0.223 0.107-0.333 0.107-0.445l0.647-0.668c8.422-1.224 10.149-1.558 19.327-3.449l0.755 0.89 0.109 0.11c0-1e-3 -37.142 65.647-42 76.439z' fill='%23393939'/%3e%3c/svg%3e";

var img$5 = "data:image/svg+xml,%3csvg width='780' height='500' viewBox='0 0 780 500' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M513.444 443.897C513.444 435.693 518.725 428.951 527.434 428.951C535.637 428.951 541.424 435.244 541.424 443.897C541.424 452.1 535.637 458.842 527.434 458.842C518.781 458.336 513.444 452.043 513.444 443.897Z' fill='%23393939'/%3e%3cpath d='M392.42 428.446C398.713 428.446 403.039 432.322 403.994 439.514H379.891C380.846 433.278 385.172 428.446 392.42 428.446Z' fill='%23393939'/%3e%3cpath d='M606.543 443.897C606.543 435.693 611.825 428.951 620.533 428.951C628.737 428.951 634.524 435.244 634.524 443.897C634.524 452.1 628.737 458.842 620.533 458.842C611.825 458.336 606.543 452.043 606.543 443.897Z' fill='%23393939'/%3e%3cpath d='M230.381 443.897C230.381 435.693 235.662 428.951 244.371 428.951C252.574 428.951 258.361 435.244 258.361 443.897C258.361 452.1 252.574 458.842 244.371 458.842C235.662 458.336 230.381 452.043 230.381 443.897Z' fill='%23393939'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M736.038 0H41.458C18.571 0 0 18.975 0 42.383V456.613C0 480.026 18.562 498.997 41.458 498.997H736.038C758.927 498.997 777.497 480.021 777.497 456.613V42.383C777.497 18.971 758.935 0 736.038 0ZM211.053 467.045V438.109C211.053 427.041 204.311 419.793 192.736 419.793C186.949 419.793 180.657 421.703 176.33 427.996C172.959 422.715 168.127 419.793 160.879 419.793C156.047 419.793 151.215 421.254 147.395 426.535V420.748H137.281V467.045H147.395V441.481C147.395 433.278 151.721 429.401 158.463 429.401C165.205 429.401 168.577 433.727 168.577 441.481V467.045H178.69V441.481C178.69 433.278 183.522 429.401 189.759 429.401C196.501 429.401 199.872 433.727 199.872 441.481V467.045H211.053ZM361.012 420.748H344.662V406.758H334.549V420.748H325.391V429.906H334.549V451.145C334.549 461.764 338.875 468 350.449 468C354.776 468 359.608 466.539 362.979 464.629L360.057 455.92C357.135 457.831 353.764 458.336 351.348 458.336C346.516 458.336 344.606 455.415 344.606 450.639V429.906H361.012V420.748ZM446.92 419.737C441.133 419.737 437.256 422.658 434.84 426.479V420.692H424.727V466.989H434.84V440.919C434.84 433.221 438.211 428.839 444.504 428.839C446.414 428.839 448.83 429.345 450.797 429.794L453.718 420.13C451.696 419.737 448.83 419.737 446.92 419.737ZM317.187 424.569C312.355 421.198 305.613 419.737 298.365 419.737C286.791 419.737 279.094 425.524 279.094 434.682C279.094 442.38 284.881 446.762 294.994 448.167L299.826 448.672C305.108 449.628 308.029 451.088 308.029 453.504C308.029 456.875 304.152 459.291 297.41 459.291C290.668 459.291 285.33 456.875 281.959 454.46L277.127 462.157C282.409 466.034 289.657 467.944 296.904 467.944C310.389 467.944 318.143 461.651 318.143 452.999C318.143 444.796 311.85 440.469 302.242 439.008L297.41 438.503C293.084 437.997 289.713 437.042 289.713 434.176C289.713 430.805 293.084 428.895 298.421 428.895C304.209 428.895 309.996 431.311 312.917 432.772L317.187 424.569ZM586.26 419.737C580.473 419.737 576.596 422.658 574.18 426.479V420.692H564.067V466.989H574.18V440.919C574.18 433.221 577.551 428.839 583.844 428.839C585.755 428.839 588.17 429.345 590.137 429.794L593.059 420.242C591.092 419.737 588.227 419.737 586.26 419.737ZM457.033 443.897C457.033 457.887 466.697 468 481.643 468C488.385 468 493.217 466.539 498.049 462.719L493.217 454.516C489.34 457.437 485.519 458.842 481.137 458.842C472.934 458.842 467.147 453.055 467.147 443.897C467.147 435.188 472.934 429.401 481.137 428.951C485.463 428.951 489.34 430.412 493.217 433.278L498.049 425.074C493.217 421.198 488.385 419.793 481.643 419.793C466.697 419.737 457.033 429.906 457.033 443.897ZM550.582 420.748H540.469V426.535C537.098 422.209 532.266 419.793 525.973 419.793C512.938 419.793 502.825 429.906 502.825 443.897C502.825 457.887 512.938 468 525.973 468C532.715 468 537.547 465.584 540.469 461.258V467.045H550.582V420.748ZM392.42 419.737C378.935 419.737 369.271 429.401 369.271 443.84C369.271 458.336 378.935 467.944 392.926 467.944C399.668 467.944 406.41 466.034 411.748 461.651L406.916 454.403C403.039 457.325 398.207 459.235 393.431 459.235C387.139 459.235 380.902 456.314 379.441 448.167H413.658V444.29C414.108 429.401 405.399 419.737 392.42 419.737ZM643.682 402.432H633.568V426.535C630.197 422.209 625.365 419.793 619.073 419.793C606.037 419.793 595.924 429.906 595.924 443.897C595.924 457.887 606.037 468 619.073 468C625.815 468 630.647 465.584 633.568 461.258V467.045H643.682V402.432ZM267.969 420.748H257.855V426.535C254.484 422.209 249.652 419.793 243.36 419.793C230.325 419.793 220.211 429.906 220.211 443.897C220.211 457.887 230.325 468 243.36 468C250.102 468 254.934 465.584 257.855 461.258V467.045H267.969V420.748ZM282.987 378.458C187.36 378.458 109.633 300.855 109.633 205.104C109.633 109.728 187.36 32 282.987 32.1252C317.032 32.1252 350.451 42.2635 378.738 61.0383C288.119 135.261 287.493 275.321 378.738 349.544C350.451 368.194 317.032 378.458 282.987 378.458ZM390.003 341.283C478.245 272.443 477.869 138.265 390.003 69.0489C302.137 138.265 301.762 272.568 390.003 341.283ZM497.019 32C592.646 32 670.373 109.728 670.373 205.104C670.373 300.855 592.646 378.458 497.019 378.332C463.225 378.332 429.555 368.194 401.268 349.419C492.889 275.572 491.512 135.136 401.268 60.9132C429.555 42.2636 462.974 32 497.019 32Z' fill='%23393939'/%3e%3c/svg%3e";

var img$4 = "data:image/svg+xml,%3csvg width='780' height='500' enable-background='new 0 0 780 500' version='1.1' viewBox='0 0 780 500' xml:space='preserve' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='m199.87 124.06l-26.311 63.322-28.644-63.323h-35.722v88.379l-37.224-88.378h-32.517l-39.193 93.344h23.77l8.496-20.82h45.57l8.41 20.82h44.515v-73.171l31.819 73.171h19.218l31.735-73.106 0.083 73.106h22.435v-93.344h-36.44zm-129.68 53.068h-29.875l14.896-37.213 14.979 37.211v2e-3z' fill='%23393939'/%3e%3cpolygon points='325.74 217.41 252.62 217.41 252.62 124.06 325.74 124.06 325.74 143.5 274.51 143.5 274.51 160.33 324.51 160.33 324.51 179.46 274.51 179.46 274.51 198.1 325.74 198.1 325.74 217.41' fill='%23393939'/%3e%3cpath d='m428.82 149.2c0-10.412-4.152-16.5-11.076-20.669-7.076-4.17-15.316-4.471-26.502-4.471h-50.34v93.344h21.884v-33.952h23.495c7.88 0 12.755 0.713 15.952 3.996 3.982 4.491 3.455 12.569 3.455 18.186l0.084 11.771h22.075v-18.338c0-8.336-0.534-12.484-3.624-17.126-1.947-2.72-6.037-6.002-10.827-7.861 5.679-2.31 15.424-9.998 15.424-24.88zm-28.622 13.109c-3.007 1.861-6.564 1.923-10.826 1.923h-26.588v-20.734h26.95c3.813 0 7.795 0.176 10.378 1.685 2.84 1.36 4.597 4.253 4.597 8.251 0 4.08-1.672 7.363-4.511 8.875z' fill='%23393939'/%3e%3crect x='441.52' y='124.06' width='22.334' height='93.344' fill='%23393939'/%3e%3cpath d='m700.52 124.07v65.009l-38.474-65.009h-33.323v88.29l-37.056-88.29h-32.794l-30.847 73.407h-9.83c-5.761 0-11.884-1.121-15.253-4.813-4.068-4.711-6.02-11.922-6.02-21.922 0-9.785 2.562-17.213 6.293-21.144 4.344-4.318 8.854-5.53 16.842-5.53h20.743v-20h-21.189c-15.083 0-26.163 3.436-33.238 10.885-9.407 10-11.798 22.656-11.798 36.499 0 16.975 4 27.71 11.692 35.637 7.629 7.925 21.098 10.323 31.737 10.323h25.61l8.263-20.82h45.465l8.518 20.82h44.573v-70.059l41.485 70.059h31.016l1e-3 1e-3v-93.342h-22.416zm-110.64 53.064h-30.209l15.062-37.213 15.147 37.213z' fill='%23393939'/%3e%3cpath d='m387.16 284.61h-69.936l-27.839 30.603-26.928-30.603h-88.027v93.366h86.693l28.007-30.909 26.951 30.908h42.54v-31.315h27.31c19.132 0 38.113-5.355 38.113-31.292-1e-3 -25.857-19.516-30.758-36.884-30.758zm-137.12 73.909h-53.811v-18.577h48.049v-19.05h-48.049v-16.974h54.872l23.939 27.208-25 27.393zm86.78 10.966l-33.603-38.032 33.603-36.823v74.855zm50.082-41.789h-28.285v-23.776h28.539c7.902 0 13.386 3.284 13.386 11.448 1e-3 8.075-5.23 12.328-13.64 12.328z' fill='%23393939'/%3e%3cpolygon points='534.57 284.61 607.62 284.61 607.62 303.92 556.37 303.92 556.37 320.89 606.37 320.89 606.37 339.94 556.37 339.94 556.37 358.52 607.62 358.6 607.62 377.98 534.57 377.98' fill='%23393939'/%3e%3cpath d='m506.92 334.59c5.761-2.331 15.511-9.936 15.513-24.838 0-10.652-4.344-16.479-11.252-20.734-7.183-3.906-15.253-4.404-26.334-4.404h-50.53v93.365h21.993v-34.1h23.389c7.985 0 12.861 0.799 16.059 4.144 4.067 4.342 3.537 12.658 3.537 18.276v11.681h21.973v-18.509c-0.088-8.229-0.535-12.484-3.625-17.043-1.87-2.719-5.852-6.006-10.723-7.838zm-13.218-11.619c-2.928 1.771-6.549 1.923-10.809 1.923h-26.588v-20.971h26.951c3.896 0 7.796 0.085 10.445 1.688 2.836 1.512 4.532 4.403 4.532 8.399 1e-3 3.995-1.695 7.212-4.531 8.961z' fill='%23393939'/%3e%3cpath d='m691.2 328.73c4.262 4.496 6.547 10.173 6.547 19.782 0 20.086-12.312 29.461-34.383 29.461h-42.629v-20.021h42.457c4.152 0 7.096-0.559 8.939-2.311 1.506-1.445 2.585-3.543 2.585-6.09 0-2.721-1.167-4.88-2.67-6.174-1.674-1.426-3.982-2.072-7.794-2.072-20.468-0.713-46.101 0.646-46.101-28.9 0-13.542 8.347-27.796 31.292-27.796h43.877v19.872h-40.148c-3.98 0-6.568 0.151-8.77 1.686-2.396 1.513-3.286 3.757-3.286 6.718 0 3.522 2.035 5.92 4.789 6.954 2.309 0.818 4.79 1.059 8.519 1.059l11.78 0.324c11.884 0.295 20.039 2.391 24.996 7.508z' fill='%23393939'/%3e%3cpath d='m729.75 307.08c2.228-1.54 4.874-1.692 8.857-1.692h39.889v-261.75c0-23.553-18.586-42.638-41.512-42.638h-695.48c-22.917 0-41.512 19.089-41.512 42.638v124.31l26.505-62.085h57.077l7.351 15.422v-15.421h66.925l14.641 33.726 14.256-33.726h212.48c9.657 0 18.345 1.84 24.718 7.624v-7.624h58.159v7.624c10.018-5.611 22.417-7.625 36.524-7.625h84.278l7.819 15.422v-15.422h62.392l8.515 15.422v-15.421h60.804v130.58h-61.438l-11.611-19.753v19.753h-76.672l-8.327-20.795h-18.877l-8.515 20.795h-39.787c-15.612 0-27.478-3.767-35.106-7.947v7.947h-94.573v-29.631c0-4.182-0.723-4.417-3.201-4.504h-3.537l0.084 34.136h-182.86v-16.137l-6.568 16.202h-38.196l-6.568-15.965v15.898h-73.577l-8.41-20.795h-18.877l-8.432 20.795h-37.395v1e-3h-3e-3v223.92c0 23.553 18.585 42.637 41.512 42.637h695.48c22.917 0 41.512-19.089 41.512-42.638v-93.235l-1e-3 1e-3v24.343c-8.77 4.331-20.294 6.022-32.095 6.022h-56.712v-8.361c-6.569 5.39-18.436 8.361-29.787 8.361h-178.79v-30.198c0-3.703-0.357-3.854-3.979-3.854h-2.84v34.055h-58.854v-35.264c-9.852 4.354-21.019 4.744-30.486 4.594h-7.016v30.738l-71.355-0.065-17.542-20.313-18.624 20.313h-115.76v-130.67h117.98l16.928 20 18.071-20h78.981c9.13 0 24.11 0.978 30.846 7.648v-7.648h70.57c6.632 0 21 1.368 29.515 7.648v-7.648h106.99v7.648c5.319-5.219 16.564-7.648 26.146-7.648h59.913v7.648c6.288-4.652 15.168-7.648 27.391-7.648h40.507v18.633h-43.596c-22.968 0-31.403 14.297-31.403 27.88 0 29.635 25.64 28.271 46.189 28.986 3.812 0 6.122 0.648 7.711 2.079 1.609 1.298 2.674 3.463 2.674 6.192 0.017 2.319-0.924 4.538-2.588 6.107-1.76 1.758-4.681 2.317-8.857 2.317h-42.096v20.082h42.269c14.023 0 24.383-4.03 29.699-11.979v-1e-3h1e-3v-35.092c-0.61-0.803-1.145-1.604-2.03-2.318-4.872-5.131-12.861-7.235-24.831-7.537l-11.862-0.324c-3.646 0-6.126-0.242-8.435-1.062-2.836-1.039-4.785-3.443-4.785-6.975 0-2.971 0.888-5.221 3.197-6.737z' fill='%23393939'/%3e%3c/svg%3e";

var img$3 = "data:image/svg+xml,%3csvg width='780' height='500' enable-background='new 0 0 780 500' version='1.1' viewBox='0 0 780 500' xml:space='preserve' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='m0 42.426c0-23.432 18.571-42.426 41.458-42.426h694.58c22.897 0 41.459 18.99 41.459 42.426v414.65c0 23.432-18.571 42.426-41.459 42.426h-694.58c-22.896 0-41.458-18.989-41.458-42.426v-414.65zm606.38 208.86c0-105.43-86.022-178.31-180.27-178.27h-81.11c-95.376-0.035-173.88 72.862-173.88 178.27 0 96.432 78.504 175.66 173.88 175.2h81.111c94.247 0.462 180.27-78.789 180.27-175.2zm-261-163.66c-87.153 0.028-157.77 72.441-157.8 161.81 0.021 89.356 70.642 161.76 157.8 161.79 87.173-0.027 157.81-72.434 157.82-161.79-0.014-89.371-70.648-161.78-157.82-161.81zm-100.02 161.81c0.082-43.672 26.69-80.913 64.211-95.711v191.4c-37.52-14.791-64.13-52.01-64.211-95.689zm135.82 95.733v-191.45c37.534 14.763 64.185 52.024 64.252 95.718-0.067 43.707-26.718 80.941-64.252 95.732v2e-3z' fill='%23393939'/%3e%3c/svg%3e";

var img$2 = "data:image/svg+xml,%3csvg width='780' height='500' enable-background='new 0 0 780 500' version='1.1' viewBox='0 0 780 500' xml:space='preserve' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='m90.682 228.13c-6.922 6.002-15.916 8.622-30.154 8.622h-5.911v-71.747h5.912c14.237 0 22.875 2.449 30.154 8.774 7.619 6.519 12.204 16.616 12.204 27.011 0 10.414-4.584 20.821-12.205 27.34z' fill='%23393939'/%3e%3cpath d='m682.92 196.57h-6.438v-32.86h6.787c13.721 0 21.18 5.525 21.18 16.083 0 10.908-7.459 16.777-21.529 16.777z' fill='%23393939'/%3e%3cpath d='m736.99 0h-695.48c-22.927 0-41.512 18.99-41.512 42.426v414.65c0 23.432 18.595 42.426 41.512 42.426h695.48c22.926 0 41.512-18.989 41.512-42.426v-414.65c-1e-3 -23.432-18.596-42.426-41.513-42.426zm-82.518 146.62h32.671c25.413 0 39.977 11.721 39.977 32.034 0 16.612-9.135 27.515-25.731 30.759l35.559 45.708h-27.097l-30.496-43.587h-2.873v43.587h-22.01v-108.5zm-77.079 0h62.486v18.385h-40.47v24.082h38.977v18.377h-38.977v29.289h40.47v18.368h-62.486v-108.5zm-94.49-0.167l30.126 72.878 30.515-72.878h23.885l-48.8 111.28h-11.857l-47.936-111.28h24.067zm-137.4 54.362c0-31.879 26.906-57.684 60.096-57.684 33.188 0 60.094 25.806 60.094 57.684v0.038c0 31.879-26.905 57.72-60.094 57.72-33.191 0-60.096-25.842-60.096-57.72v-0.038zm-94.427-0.163c0-31.548 26.764-56.778 60.146-56.778 9.479 0 17.431 1.953 27.106 6.665v24.899c-9.165-8.605-17.117-12.206-27.63-12.206-20.664 0-36.916 16.432-36.916 37.265 0 21.969 15.75 37.425 37.942 37.425 9.989 0 17.792-3.417 26.604-11.884v24.913c-10.021 4.53-18.143 6.32-27.63 6.32-33.551 0-59.622-24.728-59.622-56.619zm-36.235 10.933c-2.216-1.309-6.606-3.258-15.232-6.18-20.693-7.155-27.793-14.805-27.793-29.752 0-17.757 15.246-31.091 35.232-31.091 12.385 0 23.717 4.07 33.193 12.03l-11.53 14.5c-5.739-6.179-11.165-8.786-17.766-8.786-9.497 0-16.416 5.193-16.416 12.026 0 5.86 3.884 8.963 17.106 13.661 25.064 8.803 32.492 16.607 32.492 33.845 0 21.004-16.064 35.625-38.961 35.625-16.766 0-28.956-6.342-39.107-20.653l14.232-13.166c5.076 9.424 13.54 14.469 24.05 14.469 9.829 0 17.106-6.514 17.106-15.303 0-4.556-2.205-8.463-6.606-11.225zm-109.76 31.011c-10.843 8.647-23.198 12.524-40.306 12.524h-32.172v-108.5h32.342c35.734 0 60.642 22.305 60.642 54.326 0 15.967-7.62 31.405-20.506 41.65zm30.645-95.976h22.035v108.5h-22.034l-1e-3 -108.5zm633.29 307.8c0 19.908-15.802 36.049-35.294 36.049h-578.61c397.1-69.975 613.91-226.32 613.91-226.32v190.27z' fill='%23393939'/%3e%3c/svg%3e";

var img$1 = "data:image/svg+xml,%3csvg width='780' height='500' enable-background='new 0 0 780 500' version='1.1' viewBox='0 0 780 500' xml:space='preserve' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='m739.83 0h-698.16c-23.005 0-41.672 19.108-41.672 42.68v417.14c0 23.577 18.657 42.681 41.672 42.681h698.16c23.006 0 41.672-19.108 41.672-42.681v-417.14c0-23.576-18.657-42.68-41.672-42.68zm-428.08 358.49c-0.778 25.866-22.803 48.51-48.12 49.156-25.628 0.077-51.262 0.011-76.893 0.033v-109.21c19.032 3.572 38.165 7.418 57.637 6.255 18.675-0.995 41.199-3.921 51.894-21.81 7.916-13.214 4.368-28.979 5.025-43.593l-0.243-37.373-43.302 0.249c-0.208 21.741 0.428 43.529-0.34 65.239-1.664 14.438-16.754 21.854-29.713 20.52-14.988-0.142-28.329-5.87-40.987-9.689h-1e-3s-0.283-95.488 0.032-139.46c4.225-25.701 29.919-44.937 55.085-42.589h70.137c-0.081 87.422-0.071 174.85-0.211 262.26zm141.54 1.078c-1.638 27.289-27.35 50.2-53.998 47.607h-71.22v-119.53c18.569 15.018 43.654 17.273 66.539 16.972 15.047-0.404 29.988-2.681 44.497-6.781l-0.314-21.668c-20.466 10.086-45.831 17.212-67.179 5.734-16.96-9.938-18.952-34.961-9.886-51.063 11.197-16.703 33.816-17.2 51.426-13.668 8.64 0.788 20.247 8.703 25.953 8.525v-19.839c-29.536-7.646-61.183-10.121-90.774-1.463-7.356 2.575-14.56 6.22-20.262 11.716l-1e-3 -2e-3c0.161-24.581-0.329-49.188 0.264-73.755 1.755-23.411 20.969-43.115 43.559-45.974 22.715-0.766 45.506-0.121 68.251-0.334h13.235c-0.059 87.841 0.117 175.69-0.09 263.53zm93.906 45.895c-26.467 0.226-52.956 0.032-79.434 0.096v-105.57h78.867c14.679 0.577 32.55-9.041 32.195-25.976 0.268-15.705-15.538-24.658-29.084-25.765 10.841-1.292 21.872-9.082 22.921-20.954 2.504-15.516-12.225-26.589-26.033-26.937-26.275-0.43-52.58-0.064-78.866-0.186v-52.033c-1.781-27.039 20.542-52.148 46.802-53.771 26.112-0.347 52.241-0.052 78.359-0.15v259.15c1.304 26.251-20.556 49.791-45.727 52.104zm-25.418-148.33c1e-3 0 14.272-0.846 14.272 13.632s-14.188 13.632-14.272 13.632h-28.947v-27.264h28.947zm-28.947-14.904v-25.376h27.065s12.681 0 12.681 12.669-12.681 12.707-12.681 12.707h-27.065z' fill='%23393939'/%3e%3c/svg%3e";

var img = "data:image/svg+xml,%3csvg width='780' height='500' viewBox='0 0 780 500' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M298.417 442.641C298.577 439.933 299.525 437.332 301.144 435.156C302.764 432.98 304.985 431.325 307.533 430.396C310.081 429.466 312.846 429.302 315.486 429.923C318.126 430.545 320.527 431.925 322.393 433.894C324.259 435.862 325.508 438.334 325.987 441.004C326.466 443.674 326.154 446.425 325.089 448.92C324.024 451.415 322.252 453.543 319.993 455.044C317.733 456.545 315.084 457.351 312.372 457.366C310.456 457.41 308.553 457.055 306.783 456.322C305.013 455.589 303.415 454.494 302.093 453.108C300.77 451.722 299.751 450.075 299.102 448.273C298.452 446.47 298.186 444.552 298.321 442.641H298.417Z' fill='%23393939'/%3e%3cpath d='M549.453 428.206C547.493 428.179 545.547 428.539 543.727 429.264C542.012 429.952 540.456 430.984 539.155 432.296C537.828 433.677 536.797 435.314 536.124 437.108C534.654 440.95 534.654 445.199 536.124 449.041C536.796 450.835 537.827 452.472 539.155 453.853C540.455 455.166 542.011 456.198 543.727 456.884C547.393 458.32 551.465 458.32 555.131 456.884C556.928 456.22 558.567 455.187 559.943 453.853C561.273 452.474 562.305 450.836 562.974 449.041C564.444 445.199 564.444 440.95 562.974 437.108C562.305 435.313 561.273 433.675 559.943 432.296C558.567 430.961 556.928 429.929 555.131 429.264C553.316 428.433 551.352 427.975 549.357 427.917L549.453 428.206Z' fill='%23393939'/%3e%3cpath d='M355.775 438.599C355.961 435.545 357.322 432.681 359.574 430.608C361.826 428.536 364.793 427.416 367.852 427.484C369.35 427.452 370.84 427.715 372.235 428.259C373.631 428.803 374.906 429.616 375.988 430.653C377.069 431.69 377.936 432.929 378.538 434.301C379.14 435.673 379.466 437.15 379.497 438.647L355.775 438.599Z' fill='%23393939'/%3e%3cpath d='M583.232 462.129V463.284H584.291C584.479 463.34 584.68 463.34 584.868 463.284C584.902 463.217 584.92 463.143 584.92 463.068C584.92 462.992 584.902 462.918 584.868 462.851C584.902 462.784 584.92 462.71 584.92 462.635C584.92 462.559 584.902 462.485 584.868 462.418C584.68 462.362 584.479 462.362 584.291 462.418L583.232 462.129Z' fill='%23393939'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M584.002 467.037C584.482 467.04 584.958 466.942 585.397 466.749C585.811 466.564 586.187 466.303 586.504 465.979C586.912 465.568 587.214 465.064 587.383 464.509C587.552 463.956 587.584 463.368 587.475 462.8C587.366 462.231 587.119 461.697 586.757 461.245C586.395 460.793 585.929 460.436 585.397 460.205C584.957 460.013 584.482 459.914 584.002 459.916C583.522 459.918 583.048 460.017 582.607 460.205C582.174 460.382 581.782 460.644 581.452 460.974C580.85 461.631 580.516 462.49 580.516 463.38C580.516 464.271 580.85 465.13 581.452 465.786C581.785 466.124 582.182 466.391 582.62 466.573C583.058 466.755 583.528 466.847 584.002 466.845V467.037ZM584.291 461.311C584.74 461.29 585.183 461.426 585.542 461.696C585.689 461.818 585.805 461.973 585.881 462.149C585.956 462.325 585.988 462.516 585.975 462.707C585.982 462.867 585.955 463.026 585.897 463.175C585.839 463.324 585.751 463.46 585.638 463.573C585.359 463.826 585.003 463.979 584.628 464.006L586.023 465.594H584.916L583.617 464.006H583.184V465.594H582.27V461.167L584.291 461.311Z' fill='%23393939'/%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M736.992 0H41.512C18.595 0 0 18.994 0 42.426V457.076C0 480.513 18.585 499.502 41.512 499.502H736.992C759.909 499.502 778.504 480.508 778.504 457.076V42.426C778.503 18.99 759.918 0 736.992 0ZM279.314 465.594V436.723C279.482 434.301 279.132 431.871 278.288 429.595C277.443 427.319 276.123 425.249 274.416 423.524C272.708 421.798 270.653 420.456 268.386 419.587C266.119 418.719 263.693 418.343 261.269 418.486C258.089 418.277 254.911 418.926 252.067 420.365C249.223 421.804 246.818 423.98 245.102 426.666C243.537 424.06 241.299 421.926 238.623 420.486C235.947 419.046 232.932 418.355 229.896 418.486C227.25 418.352 224.614 418.912 222.251 420.111C219.887 421.309 217.878 423.104 216.423 425.318V419.64H206.414V465.594H216.519V440.139C216.295 438.564 216.424 436.96 216.896 435.441C217.369 433.922 218.173 432.528 219.251 431.358C220.328 430.188 221.653 429.273 223.127 428.678C224.602 428.082 226.191 427.823 227.779 427.917C234.419 427.917 237.787 432.248 237.787 440.043V465.594H247.892V440.139C247.686 438.568 247.828 436.97 248.307 435.459C248.786 433.948 249.591 432.561 250.664 431.395C251.738 430.229 253.055 429.314 254.522 428.713C255.988 428.112 257.569 427.84 259.152 427.917C265.985 427.917 269.257 432.248 269.257 440.043V465.594H279.314ZM335.613 442.641V419.689H325.508V425.27C323.811 423.08 321.616 421.327 319.105 420.155C316.595 418.984 313.841 418.428 311.072 418.534C304.691 418.534 298.572 421.069 294.06 425.581C289.548 430.093 287.013 436.212 287.013 442.593C287.013 448.974 289.548 455.094 294.06 459.606C298.572 464.118 304.691 466.653 311.072 466.653C313.841 466.759 316.595 466.203 319.105 465.031C321.616 463.859 323.811 462.106 325.508 459.916V465.498H335.517L335.613 442.641ZM549.453 418.582C552.748 418.573 556.014 419.194 559.077 420.41C562 421.581 564.664 423.314 566.92 425.511C569.146 427.688 570.913 430.29 572.117 433.162C574.631 439.331 574.631 446.24 572.117 452.409C570.915 455.282 569.147 457.884 566.92 460.06C564.664 462.257 562 463.99 559.077 465.161C552.731 467.626 545.693 467.626 539.348 465.161C536.438 463.991 533.789 462.258 531.553 460.06C529.348 457.875 527.598 455.275 526.404 452.409C523.895 446.239 523.895 439.332 526.404 433.162C527.598 430.296 529.348 427.696 531.553 425.511C533.789 423.313 536.438 421.58 539.348 420.41C542.52 419.095 545.922 418.425 549.357 418.437L549.453 418.582ZM389.987 442.641C389.987 428.206 381.037 418.582 368.189 418.582C361.808 418.671 355.724 421.292 351.275 425.867C346.827 430.442 344.378 436.597 344.467 442.978C344.556 449.359 347.177 455.443 351.752 459.892C356.327 464.341 362.482 466.79 368.863 466.701C375.713 466.935 382.411 464.64 387.677 460.253L382.866 452.842C379.066 455.89 374.359 457.583 369.488 457.654C366.18 457.939 362.891 456.922 360.321 454.819C357.751 452.716 356.103 449.694 355.727 446.394H389.843C389.987 445.191 389.987 443.989 389.987 442.641ZM432.091 431.381C427.697 428.851 422.726 427.492 417.655 427.436C412.17 427.436 408.898 429.457 408.898 432.825C408.898 436.193 412.362 436.771 416.693 437.348L421.505 438.022C431.514 439.465 437.577 443.7 437.577 451.784C437.577 459.868 429.878 466.797 416.645 466.797C409.553 466.986 402.587 464.894 396.772 460.83L401.584 453.035C406 456.311 411.389 458.006 416.886 457.847C423.718 457.847 427.375 455.826 427.375 452.265C427.375 449.667 424.777 448.223 419.291 447.453L414.48 446.78C404.182 445.336 398.6 440.716 398.6 433.21C398.6 424.067 406.107 418.486 417.848 418.486C424.419 418.265 430.916 419.936 436.566 423.298L432.091 431.381ZM480.21 428.783H463.898V449.522C463.898 454.334 465.534 457.221 470.538 457.221C473.661 457.118 476.708 456.224 479.392 454.623L482.279 463.188C478.527 465.529 474.19 466.764 469.768 466.749C457.931 466.749 453.793 460.397 453.793 449.715V428.783H444.458V419.64H453.793V405.686H463.898V419.64H480.21V428.783ZM514.807 418.486C517.235 418.495 519.643 418.918 521.929 419.737L518.849 429.361C516.86 428.568 514.735 428.175 512.594 428.206C506.05 428.206 502.97 432.44 502.97 440.043V465.786H492.961V419.833H502.874V425.415C504.102 423.305 505.877 421.565 508.011 420.38C510.145 419.194 512.56 418.606 515 418.678L514.807 418.486ZM584.002 458.905C584.628 458.898 585.249 459.012 585.831 459.242C586.383 459.468 586.889 459.794 587.322 460.205C587.745 460.619 588.088 461.109 588.333 461.648C588.576 462.21 588.702 462.816 588.702 463.429C588.702 464.041 588.576 464.647 588.333 465.209C588.088 465.748 587.745 466.238 587.322 466.653C586.889 467.063 586.383 467.389 585.831 467.615C585.255 467.869 584.632 468 584.002 468C583.09 467.993 582.198 467.727 581.432 467.233C580.665 466.739 580.055 466.037 579.671 465.209C579.43 464.646 579.306 464.041 579.306 463.429C579.306 462.816 579.43 462.211 579.671 461.648C579.917 461.109 580.259 460.619 580.682 460.205C581.115 459.794 581.621 459.468 582.174 459.242C582.68 459.041 583.217 458.927 583.761 458.905H584.002ZM282.987 378.458C187.36 378.458 109.633 300.855 109.633 205.104C109.633 109.728 187.36 32 282.987 32.1252C317.032 32.1252 350.451 42.2635 378.738 61.0383C288.119 135.261 287.493 275.321 378.738 349.544C350.451 368.194 317.032 378.458 282.987 378.458ZM390.003 341.283C478.245 272.443 477.869 138.265 390.003 69.0489C302.137 138.265 301.762 272.568 390.003 341.283ZM497.019 32C592.646 32 670.373 109.728 670.373 205.104C670.373 300.855 592.646 378.458 497.019 378.332C463.225 378.332 429.555 368.194 401.268 349.419C492.889 275.572 491.512 135.136 401.268 60.9132C429.555 42.2636 462.974 32 497.019 32Z' fill='%23393939'/%3e%3c/svg%3e";

var CardValidation = /*#__PURE__*/function () {
  function CardValidation() {
    _classCallCheck(this, CardValidation);
    _defineProperty(this, "style", "\n        #overlay.show {\n            display: block;\n        }\n\n        #overlay-container {\n            align-items: center;\n            justify-content: center;\n            display: flex;\n            flex-direction: column;\n            height: 100%;\n        }\n\n        #overlay {\n            background-color: rgba(255, 255, 255, 1);\n            display: none;\n            position: absolute;\n            bottom: 0;\n            top: 0;\n            left: 0;\n            right: 0;\n            z-index: 2;\n        }\n\n        svg#nmiSVG {\n            width: 3.25em;\n            transform-origin: center;\n            animation: rotate4 2s linear infinite;\n        }\n\n        circle {\n            fill: none;\n            stroke: hsl(214, 97%, 59%);\n            stroke-width: 2;\n            stroke-dasharray: 1, 200;\n            stroke-dashoffset: 0;\n            stroke-linecap: round;\n            animation: dash4 1.5s ease-in-out infinite;\n        }\n\n        @keyframes rotate4 {\n            100% {\n                transform: rotate(360deg);\n            }\n        }\n\n        @keyframes dash4 {\n            0% {\n                stroke-dasharray: 1, 200;\n                stroke-dashoffset: 0;\n            }\n\n            50% {\n                stroke-dasharray: 90, 200;\n                stroke-dashoffset: -35px;\n            }\n\n            100% {\n                stroke-dashoffset: -125px;\n            }\n        }\n\n        .card-validation-credit-card-last4:before {\n            content: \"**** **** **** \";\n            color: #4f4d4d;\n            font-size: 20px;\n        }\n\n        .card-validation-credit-card {\n            margin: auto;\n            margin-top: 20px;\n            margin-bottom: 20px;\n            border-radius: 7px;\n            width: 250px;\n            max-width: 250px;\n            position: relative;\n            transition: all 0.4s ease;\n            box-shadow: 0 2px 4px 0 #cfd7df;\n            min-height: 60px;\n            padding: 13px;\n            background: #1a1b1c;\n            color: #efefef;\n            display: inline-block;\n            margin-right: 10px;\n            height: 150px\n        }    \n\n        .card-validation-credit-card-last4 {\n            font-size: 24px;\n            padding-bottom: 1rem !important;\n        }\n\n        .card-validation-credit-card-expiry {\n            font-size: 18px;\n            position: absolute;\n            bottom: 8px;\n            left: 15px;\n        }\n\n        /* BRAND CUSTOMIZATION */\n\n        .card-validation-credit-card.visa {\n        background: #4862e2;\n        color: #eaeef2;\n        }\n\n        .card-validation-credit-card.visa .card-validation-credit-card-last4:before {\n        color: #8999e5;\n        }\n\n        .card-validation-credit-card.mastercard {\n        background: #4f0cd6;\n        color: #e3e8ef;\n        }\n\n        .card-validation-credit-card.mastercard .card-validation-credit-card-last4:before {\n        color: #8a82dd;\n        }\n\n        .card-validation-credit-card.american-express,\n        .card-validation-credit-card.amex {\n        background: #1cd8b3;\n        color: #f2fcfa;\n        }\n\n        .card-validation-credit-card.american-express .card-validation-credit-card-last4:before,\n        .card-validation-credit-card.amex .card-validation-credit-card-last4:before {\n        color: #99efe0;\n        }\n\n        .card-validation-credit-card.diners,\n        .card-validation-credit-card.diners-club {\n        background: #8a38ff;\n        color: #f5efff;\n        }\n\n        .card-validation-credit-card.diners .card-validation-credit-card-last4:before,\n        .card-validation-credit-card.diners-club .card-validation-credit-card-last4:before {\n        color: #b284f4;\n        }\n\n        .card-validation-credit-card.discover {\n        background: #f16821;\n        color: #fff4ef;\n        }\n\n        .card-validation-credit-card.discover .card-validation-credit-card-last4:before {\n        color: #ffae84;\n        }\n\n        .card-validation-credit-card.jcb {\n        background: #cc3737;\n        color: #f7e8e8;\n        }\n\n        .card-validation-credit-card.jcb .card-validation-credit-card-last4:before {\n        color: #f28a8a;\n        }\n\n        .card-validation-credit-card.unionpay {\n        background: #47bfff;\n        color: #fafdff;\n        }\n\n        .card-validation-credit-card.unionpay .card-validation-credit-card-last4:before {\n        color: #99dcff;\n        }\n\n\n        /*   LOGOS  */\n\n        .card-validation-credit-card::after {\n        content: \" \";\n        position: absolute;\n        bottom: 10px;\n        right: 15px;\n        }\n\n        .card-validation-credit-card.visa::after {\n        height: 16px;\n        width: 50px;\n        background-image: url('data:image/png;base64,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');\n        }\n\n        .card-validation-credit-card.mastercard::after {\n        width: 40px;\n        height: 25px;\n        background-image: url('data:image/png;base64,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');\n        }\n\n        .card-validation-credit-card.amex::after,\n        .card-validation-credit-card.american-express::after {\n        width: 50px;\n        height: 14px;\n        background-image: url('data:image/png;base64,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');\n        }\n\n        .card-validation-credit-card.diners::after,\n        .card-validation-credit-card.diners-club::after {\n        width: 30px;\n        height: 24px;\n        background-image: url('data:image/png;base64,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');\n        }\n\n        .card-validation-credit-card.discover::after {\n        width: 50px;\n        height: 14px;\n        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAOCAYAAABth09nAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAAA/tJREFUSA19ll2IVVUUx73jmEYgiUpYiIREkFqQD0FhKiVIoPaSRaEPQlATZmk9JERBQVCSldjHk9iDqE8KQaTQB0lFoljDSGKiFI3VWJZZfo6n32+fta5nrrcW/O/6r8+999n77HNbVVWNHnVZqlardSlNYj1yffAWVFt9qSNPX/axxzB2kehhfERdjNs5njmO4RyyBlok52W80pNziLmVpPaPA8fgnT4btyWL0bmAdixJt1inr9FnRP/s8X+aWuda6lqQmZHsUxxklX9qR8J0Ob7vwzcDPQHsx/cPOb3oixG7A309OIjvELEetDt5Nb5ZwAV/h++kdXB7/Yp9HBvlVKqx+G4Bx4H8WnAejAH6zoCJwB05Rc0faOd6lT8X7BByHv0OuCYSDsA/D64/ZQgyO/yz4P0ZCH1fxJZiH2nEfoGvjNg+eH9wF+ZcHo/ce9EfBE+1FvJkGL+jz4G3wFTQZ7GyHcwFG4CyOxoPwHeB2TqRl8EU8CKYDCaCU+Bv8DBwUW+AuWAeSHFnRMqDkAfCmONYCvZBcDS4D/EwuAvcDyaBV4GyGDxXWFU9gx6fC3m+dKqbZcIcEvaAj4Bc2ZB5Mdibtbu6vemP2LcRO4POhZwN3zH0DeA02B75Tlh5KuxD8E/lKdivm9CwNd8ttgx5pRG8sXZVK9Efg6+Mod8Pv5NaD3zR9oIjEdf2XJtrD3dJGa5V+zd35mY87YnB346MSdHj67B/Cv0Q2uOlrAFbCquqheaXsylpyLjgvkiuvuTwYi2ncD32KuBTGwJeDNcBxdxyXaPz+tTfFHOEN42Lfg88Td8X0EvBVsY5gVYcdxC8BBxjL/AiUNbVatQ88j+jvieP1toIaG8CimfyC2DiOOCNVATuEfHlfxYod2ZMjT0aeMaVbkfLm8rbz1z7p9ytT8ExAD6srfoXeyOwtg8oSyK31wLlS+CknLjSFwlH4Z8Aj5LX7QrgApRHI+fn2iz1C+Bu+T1gfvi7qcfqqZUJPxIJe9IXfV2It9Nq8Bq4DawD7qjz3iZHbi11kH5wGHgWXciiEqiTd2BvAtPBNyBlM8Tvgw2nAS+EFHdrfsSWwX/IANpFPxExvyvWjwe/gXx46d+Jz8vgBFBWBdyRMWACGAQ77dOCWNj5VyE/Zp55eX70bsI+i/0j2kk0P4hTcHlcjhF397JHfhDtNUDsL7S10FY+3am4hrB9CMWP9lvm3IaB79Q5YA/frdMkeWn4oXTMk+Cy2ARccQHgK08pMyOvvNjGtDPW1Pi79ept5v8Xb/bpxqkr42fMiafDR1GeUAZzEP3BSy62T6ktzRjOK3YXX44x4s9mNqDeB2WsPT6+rGmnBSGt/mObOdr/Ap6tK4eqKaaFAAAAAElFTkSuQmCC');\n        }\n\n        .card-validation-credit-card.jcb::after {\n        width: 30px;\n        height: 15px;\n        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAPCAYAAADzun+cAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACXBIWXMAAAsTAAALEwEAmpwYAAABWWlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyI+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgpMwidZAAACsklEQVQ4EX2U32uOYRjH32c2zIjyKyc7IDkRZw4cMEcjxIHSyoH4C6yNNJRJOZKWAyeEQqI4wQnlhE0phCHmR1NsI43ttdnm8fk8nktPWu+3Prvu676v57qv+3rve0kJpWk6FbMdVkICRemfS5LkiZPEbsSsgRpdUNpauEbc7WwiTVdjjXW+GDcd/4GJauAiVJJFGXusUhBrh/O4XYzHKsReryZwEzTBOFiZJ9ROgLIbgyRZgm11Ao1AsTPGzoAfxBl/CMxdzi3mX07jhl00YSjaZ1LHod8M6qEKxsB2TSbjFsG8fNFNJlPixkXFiT8y2Q1usAqmwC9QFvQUXoNdshhPth5cc3PVBf2gH9/OZtwIVX4UctP46AqXxIDN8BZMGK0/ztoK/Gb4Brb9IbyHOIixu4nbgu2BpXAH3+LaoM5AN1QmHwVPJ8obadstyPFnOADqLDSA2vHXlC5j4zDT8rlZ2DqYmftztG7sZbCtc2EhqPjIFsVls5gvVP2TC7SA8WJQFhWbZRP88TBx+nuM++A+qPkw4QdWdBc2wDN4BadBNcAy8ELZjeVsupbN/e3a4SvYbn/zIbC4uCfOq21wEHaC6oDUqgzYD1beAgOO2WAfdi/Es/F3U+dZO4J9B0fBFr6EPWCn3NgDbSXuObYTXsAbfA/n3fjuP4UWCA0z6IVyTOS2Ebvuvzld361vfEgHNUM9hO/cCBg3rpPrQvwOFJG10ncXby+eitVLyHm7IHFhohu2OjrEMHtudiE64Z3xTlWb0NYox7bbxCYqJvA2x+YRrzUuYFj6AM6bJxTrzsW3PSazAuVz0rcLVi76Z7hMj7BxOuNiPaw5bsFVKHatmMtYT/4YOlzoBRMPQpyKYVb1TewJHfQJboD/MIqyM51wigK9lGXGl6AWPG3IjbvhpK/iD/ZAl+AbzJMOAAAAAElFTkSuQmCC');\n        }\n\n        .card-validation-credit-card.unionpay::after {\n        width: 50px;\n        height: 30px;\n        background-image: url('data:image/png;base64,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');\n        }\n\n        #save_card_cvv{\n            width: 60px;\n            text-align: center;\n            display: inline-block;\n        }\n        \n        .save_card_cvv_confirm_button{\n            display: inline-block;\n            background-color: #f8f9fa;\n            color: black;\n            margin-left: 10px\n            border: none;\n            border-radius: 3px;\n        }\n        .save_card_cvv_confirm_button:disabled,\n        .save_card_cvv_confirm_button[disabled]{\n            display: inline-block;\n            background-color: #cccccc;\n            color: #666666;\n            margin-left: 10px\n            border: none;\n            border-radius: 3px;\n        }\n    ");
  }
  return _createClass(CardValidation, [{
    key: "loadDiv",
    value: function loadDiv(containerId, card, nmiEventEmitter) {
      var _context, _context2, _context3, _context4;
      var html = _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = _concatInstanceProperty(_context4 = "\n            <div style=\"position:relative\">\n                <style>".concat(this.style, "</style>\n                Please confirm security code <br/>\n                <div id=\"overlay\" >\n                    <div id=\"overlay-container\">\n                        <svg id=\"nmiSVG\" viewBox=\"25 25 50 50\">\n                            <circle r=\"20\" cy=\"50\" cx=\"50\"></circle>\n                        </svg>\n                    </div>\n                </div>\n                <div class=\"card-validation-credit-card ")).call(_context4, card === null || card === void 0 ? void 0 : card.type, "\">\n                    <div>\n                        <div class=\"card-validation-credit-card-last4\">\n                            ")).call(_context3, card === null || card === void 0 ? void 0 : card.last4, "\n                        </div>\n                        <div>\n                            <div class=\"inline-block\">\n                                <input type=\"text\" placeholder=\"CVV\" name=\"save_card_cvv\" id=\"save_card_cvv\" minLength=\"3\" maxLength=\"30\" />\n                                <button type=\"button\" class=\"save_card_cvv_confirm_button\" disabled id=\"save_card_cvv_confirm_button\">Confirm</button>\n                            </div>\n                            <div class=\"error\" id=\"save_card_cvv_error\"></div>\n                        </div>\n                        <div class=\"card-validation-credit-card-expiry\">\n                            ")).call(_context2, card === null || card === void 0 ? void 0 : card.exp_month, "/")).call(_context, card === null || card === void 0 ? void 0 : card.exp_year, "\n                        </div>\n                    </div>\n                <div>\n            </div>");
      containerId.innerHTML = html;
      var cvvProcessButton = document.getElementById("save_card_cvv_confirm_button");
      var save_card_cvv = document.getElementById("save_card_cvv");
      var save_card_cvvFunction = function save_card_cvvFunction(e) {
        if (!(e.target instanceof HTMLInputElement)) {
          return;
        }
        if (e.target.value.length > 2) {
          cvvProcessButton.disabled = false;
        } else {
          cvvProcessButton.disabled = true;
        }
      };
      if (save_card_cvv) {
        save_card_cvv.oninput = save_card_cvvFunction;
        IMask(save_card_cvv, {
          mask: IMask.MaskedRange,
          from: 0,
          to: 9999,
          minLength: 3,
          maxLength: 4
        });
      }
      if (cvvProcessButton) {
        cvvProcessButton.onclick = function () {
          nmiEventEmitter.emit("cvv-validation-response", {
            cvv: save_card_cvv.value,
            status: true
          });
        };
      }
    }
  }, {
    key: "failed",
    value: function failed(containerId, errorMessge) {
      var _context5;
      var style = "._failed{ border-bottom: solid 4px red !important; }\n                        ._failed i{  color:red !important;  }\n\n                        ._success {\n                            box-shadow: 0 15px 25px #00000019;\n                            padding: 45px;\n                            width: 100%;\n                            text-align: center;\n                            margin: 40px auto;\n                            border-bottom: solid 4px #28a745;\n                        }\n\n                        ._success i {\n                            font-size: 55px;\n                            color: #28a745;\n                        }\n\n                        ._success h2 {\n                            margin-bottom: 12px;\n                            font-size: 40px;\n                            font-weight: 500;\n                            line-height: 1.2;\n                            margin-top: 10px;\n                        }\n\n                        ._success p {\n                            margin-bottom: 0px;\n                            font-size: 18px;\n                            color: #495057;\n                            font-weight: 500;\n                        }";
      var html = _concatInstanceProperty(_context5 = "\n            <style>".concat(style, "</style>\n            \n            <div class=\"message-box _success _failed\">\n                <i class=\"fa fa-times-circle\" aria-hidden=\"true\"></i>\n                <h2> Card save failed! </h2>\n                <p> ")).call(_context5, errorMessge, "</p>\n            </div>");
      containerId.innerHTML = html;
    }
  }, {
    key: "success",
    value: function success(containerId) {
      var style = "\n        ._success {\n            box-shadow: 0 15px 25px #00000019;\n            padding: 45px;\n            width: 100%;\n            text-align: center;\n            margin: 40px auto;\n            border-bottom: solid 4px #28a745;\n        }\n\n        ._success i {\n            font-size: 55px;\n            color: #28a745;\n        }\n\n        ._success h2 {\n            margin-bottom: 12px;\n            font-size: 40px;\n            font-weight: 500;\n            line-height: 1.2;\n            margin-top: 10px;\n        }\n\n        ._success p {\n            margin-bottom: 0px;\n            font-size: 18px;\n            color: #495057;\n            font-weight: 500;\n        }";
      var html = "\n            <style>".concat(style, "</style>\n            <div class=\"message-box _success\">\n                <i class=\"fa fa-check-circle\" aria-hidden=\"true\"></i>\n                <h2> Card saved successfully!</h2>\n                <p> You can now use this card<br/> for future payments.</p>\n            </div>");
      containerId.innerHTML = html;
    }
  }]);
}();

/**
 * Translation dictionary for all Stripe-supported languages (35+ locales)
 * Covers cardholder name field translations for payment forms
 */
var TRANSLATIONS = {
  en: {
    cardHolderName: "Card Holder Name",
    enterCardHolderName: "Enter Card Holder Name",
    cardHolderNameRequired: "Card holder name is required"
  },
  ar: {
    cardHolderName: "اسم حامل البطاقة",
    enterCardHolderName: "أدخل اسم حامل البطاقة",
    cardHolderNameRequired: "اسم حامل البطاقة مطلوب"
  },
  bg: {
    cardHolderName: "Име на картодържател",
    enterCardHolderName: "Въведете име на картодържател",
    cardHolderNameRequired: "Изисква се име на картодържател"
  },
  cs: {
    cardHolderName: "Jméno držitele karty",
    enterCardHolderName: "Zadejte jméno držitele karty",
    cardHolderNameRequired: "Je vyžadováno jméno držitele karty"
  },
  da: {
    cardHolderName: "Kortholders navn",
    enterCardHolderName: "Indtast kortholders navn",
    cardHolderNameRequired: "Kortholders navn er påkrævet"
  },
  de: {
    cardHolderName: "Name des Karteninhabers",
    enterCardHolderName: "Name des Karteninhabers eingeben",
    cardHolderNameRequired: "Name des Karteninhabers ist erforderlich"
  },
  "de-DE": {
    cardHolderName: "Name des Karteninhabers",
    enterCardHolderName: "Name des Karteninhabers eingeben",
    cardHolderNameRequired: "Name des Karteninhabers ist erforderlich"
  },
  el: {
    cardHolderName: "Όνομα κατόχου κάρτας",
    enterCardHolderName: "Εισαγάγετε το όνομα του κατόχου της κάρτας",
    cardHolderNameRequired: "Απαιτείται όνομα κατόχου κάρτας"
  },
  es: {
    cardHolderName: "Nombre del Titular",
    enterCardHolderName: "Ingrese el Nombre del Titular",
    cardHolderNameRequired: "Se requiere el nombre del titular"
  },
  "es-ES": {
    cardHolderName: "Nombre del Titular",
    enterCardHolderName: "Ingrese el Nombre del Titular",
    cardHolderNameRequired: "Se requiere el nombre del titular"
  },
  "es-419": {
    cardHolderName: "Nombre del Titular",
    enterCardHolderName: "Ingrese el Nombre del Titular",
    cardHolderNameRequired: "Se requiere el nombre del titular"
  },
  et: {
    cardHolderName: "Kaardi omaniku nimi",
    enterCardHolderName: "Sisestage kaardi omaniku nimi",
    cardHolderNameRequired: "Kaardi omaniku nimi on nõutud"
  },
  fi: {
    cardHolderName: "Kortinhaltijan nimi",
    enterCardHolderName: "Anna kortinhaltijan nimi",
    cardHolderNameRequired: "Kortinhaltijan nimi vaaditaan"
  },
  fr: {
    cardHolderName: "Nom du Titulaire",
    enterCardHolderName: "Entrez le Nom du Titulaire",
    cardHolderNameRequired: "Le nom du titulaire est requis"
  },
  "fr-FR": {
    cardHolderName: "Nom du Titulaire",
    enterCardHolderName: "Entrez le Nom du Titulaire",
    cardHolderNameRequired: "Le nom du titulaire est requis"
  },
  "fr-CA": {
    cardHolderName: "Nom du Titulaire",
    enterCardHolderName: "Entrez le Nom du Titulaire",
    cardHolderNameRequired: "Le nom du titulaire est requis"
  },
  he: {
    cardHolderName: "שם בעל הכרטיס",
    enterCardHolderName: "הזן את שם בעל הכרטיס",
    cardHolderNameRequired: "שם בעל הכרטיס נדרש"
  },
  hi: {
    cardHolderName: "कार्डधारक का नाम",
    enterCardHolderName: "कार्डधारक का नाम दर्ज करें",
    cardHolderNameRequired: "कार्डधारक का नाम आवश्यक है"
  },
  hr: {
    cardHolderName: "Ime vlasnika kartice",
    enterCardHolderName: "Unesite ime vlasnika kartice",
    cardHolderNameRequired: "Ime vlasnika kartice je obavezno"
  },
  hu: {
    cardHolderName: "Kártyabirtokos neve",
    enterCardHolderName: "Adja meg a kártyabirtokos nevét",
    cardHolderNameRequired: "A kártyabirtokos neve kötelező"
  },
  id: {
    cardHolderName: "Nama Pemegang Kartu",
    enterCardHolderName: "Masukkan Nama Pemegang Kartu",
    cardHolderNameRequired: "Nama pemegang kartu wajib diisi"
  },
  it: {
    cardHolderName: "Nome del Titolare",
    enterCardHolderName: "Inserisci il Nome del Titolare",
    cardHolderNameRequired: "Il nome del titolare è richiesto"
  },
  "it-IT": {
    cardHolderName: "Nome del Titolare",
    enterCardHolderName: "Inserisci il Nome del Titolare",
    cardHolderNameRequired: "Il nome del titolare è richiesto"
  },
  ja: {
    cardHolderName: "カード名義人",
    enterCardHolderName: "カード名義人を入力してください",
    cardHolderNameRequired: "カード名義人は必須です"
  },
  ko: {
    cardHolderName: "카드 소유자 이름",
    enterCardHolderName: "카드 소유자 이름을 입력하세요",
    cardHolderNameRequired: "카드 소유자 이름은 필수입니다"
  },
  lt: {
    cardHolderName: "Kortelės turėtojo vardas",
    enterCardHolderName: "Įveskite kortelės turėtojo vardą",
    cardHolderNameRequired: "Kortelės turėtojo vardas yra privalomas"
  },
  lv: {
    cardHolderName: "Kartes īpašnieka vārds",
    enterCardHolderName: "Ievadiet kartes īpašnieka vārdu",
    cardHolderNameRequired: "Kartes īpašnieka vārds ir obligāts"
  },
  ms: {
    cardHolderName: "Nama Pemegang Kad",
    enterCardHolderName: "Masukkan Nama Pemegang Kad",
    cardHolderNameRequired: "Nama pemegang kad diperlukan"
  },
  mt: {
    cardHolderName: "Isem id-Detentur tal-Kard",
    enterCardHolderName: "Daħħal l-Isem tad-Detentur tal-Kard",
    cardHolderNameRequired: "L-isem tad-detentur tal-kard huwa meħtieġ"
  },
  nb: {
    cardHolderName: "Kortholders navn",
    enterCardHolderName: "Skriv inn kortholders navn",
    cardHolderNameRequired: "Kortholders navn er påkrevd"
  },
  no: {
    cardHolderName: "Kortholders navn",
    enterCardHolderName: "Skriv inn kortholders navn",
    cardHolderNameRequired: "Kortholders navn er påkrevd"
  },
  nl: {
    cardHolderName: "Naam Kaarthouder",
    enterCardHolderName: "Voer de Naam van de Kaarthouder in",
    cardHolderNameRequired: "Naam van de kaarthouder is vereist"
  },
  "nl-NL": {
    cardHolderName: "Naam Kaarthouder",
    enterCardHolderName: "Voer de Naam van de Kaarthouder in",
    cardHolderNameRequired: "Naam van de kaarthouder is vereist"
  },
  pl: {
    cardHolderName: "Imię i nazwisko posiadacza karty",
    enterCardHolderName: "Wprowadź imię i nazwisko posiadacza karty",
    cardHolderNameRequired: "Imię i nazwisko posiadacza karty jest wymagane"
  },
  pt: {
    cardHolderName: "Nome do Titular",
    enterCardHolderName: "Digite o Nome do Titular",
    cardHolderNameRequired: "O nome do titular é obrigatório"
  },
  "pt-PT": {
    cardHolderName: "Nome do Titular",
    enterCardHolderName: "Digite o Nome do Titular",
    cardHolderNameRequired: "O nome do titular é obrigatório"
  },
  "pt-BR": {
    cardHolderName: "Nome do Titular",
    enterCardHolderName: "Digite o Nome do Titular",
    cardHolderNameRequired: "O nome do titular é obrigatório"
  },
  ro: {
    cardHolderName: "Numele Titularului",
    enterCardHolderName: "Introduceți Numele Titularului",
    cardHolderNameRequired: "Numele titularului este obligatoriu"
  },
  ru: {
    cardHolderName: "Имя держателя карты",
    enterCardHolderName: "Введите имя держателя карты",
    cardHolderNameRequired: "Имя держателя карты обязательно"
  },
  sk: {
    cardHolderName: "Meno držiteľa karty",
    enterCardHolderName: "Zadajte meno držiteľa karty",
    cardHolderNameRequired: "Meno držiteľa karty je povinné"
  },
  sl: {
    cardHolderName: "Ime imetnika kartice",
    enterCardHolderName: "Vnesite ime imetnika kartice",
    cardHolderNameRequired: "Ime imetnika kartice je obvezno"
  },
  sv: {
    cardHolderName: "Kortinnehavarens namn",
    enterCardHolderName: "Ange kortinnehavarens namn",
    cardHolderNameRequired: "Kortinnehavarens namn krävs"
  },
  th: {
    cardHolderName: "ชื่อผู้ถือบัตร",
    enterCardHolderName: "ป้อนชื่อผู้ถือบัตร",
    cardHolderNameRequired: "จำเป็นต้องระบุชื่อผู้ถือบัตร"
  },
  tr: {
    cardHolderName: "Kart Sahibinin Adı",
    enterCardHolderName: "Kart Sahibinin Adını Girin",
    cardHolderNameRequired: "Kart sahibinin adı gereklidir"
  },
  uk: {
    cardHolderName: "Ім'я власника картки",
    enterCardHolderName: "Введіть ім'я власника картки",
    cardHolderNameRequired: "Ім'я власника картки обов'язкове"
  },
  vi: {
    cardHolderName: "Tên Chủ Thẻ",
    enterCardHolderName: "Nhập Tên Chủ Thẻ",
    cardHolderNameRequired: "Tên chủ thẻ là bắt buộc"
  },
  zh: {
    cardHolderName: "持卡人姓名",
    enterCardHolderName: "输入持卡人姓名",
    cardHolderNameRequired: "持卡人姓名为必填项"
  },
  "zh-CN": {
    cardHolderName: "持卡人姓名",
    enterCardHolderName: "输入持卡人姓名",
    cardHolderNameRequired: "持卡人姓名为必填项"
  },
  "zh-TW": {
    cardHolderName: "持卡人姓名",
    enterCardHolderName: "輸入持卡人姓名",
    cardHolderNameRequired: "持卡人姓名為必填項"
  },
  "zh-HK": {
    cardHolderName: "持卡人姓名",
    enterCardHolderName: "輸入持卡人姓名",
    cardHolderNameRequired: "持卡人姓名為必填項"
  }
};

function getTranslation(languageCode, key) {
  var _TRANSLATIONS$languag, _TRANSLATIONS$baseLan;
  // If no language code provided, use browser language like Stripe does
  if (!languageCode) {
    var _navigator;
    var browserLang = ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.language) || "en";
    languageCode = browserLang;
  }
  // Try exact match
  if ((_TRANSLATIONS$languag = TRANSLATIONS[languageCode]) !== null && _TRANSLATIONS$languag !== void 0 && _TRANSLATIONS$languag[key]) {
    return TRANSLATIONS[languageCode][key];
  }
  // Try base language (e.g., 'de' from 'de-DE')
  var baseLanguage = languageCode.split("-")[0];
  if ((_TRANSLATIONS$baseLan = TRANSLATIONS[baseLanguage]) !== null && _TRANSLATIONS$baseLan !== void 0 && _TRANSLATIONS$baseLan[key]) {
    return TRANSLATIONS[baseLanguage][key];
  }
  // Fallback to English
  return TRANSLATIONS["en"][key];
}

var _context;
// Multilingual labels and error messages for CVVModal
var cvvModalTranslationEntries = {
  en: {
    modalTitle: "Security Check",
    inputLabel: "Please enter your card CVV",
    submitButton: "Submit",
    closeButton: "Close",
    loaderMessage: "Processing...",
    defaultError: "An error occurred. Please try again.",
    cvvRequired: "CVV required",
    cvvInvalidFormat: "CVV must be 3 or 4 digits",
    invalidCvv: "Invalid CVV",
    // new
    processingError: "Failed to process request, please try again.",
    cvvInputEmpty: "CVV input is empty.",
    cvvInputIncomplete: "CVV input is incomplete or empty.",
    modalClosedByCustomer: "Modal canceled by customer.",
    modalClosedBySystem: "Modal closed by system."
  },
  ar: {
    modalTitle: "التحقق الأمني",
    inputLabel: "يرجى إدخال رمز CVV الخاص ببطاقتك",
    submitButton: "إرسال",
    closeButton: "إغلاق",
    loaderMessage: "جارٍ المعالجة...",
    defaultError: "حدث خطأ. يرجى المحاولة مرة أخرى.",
    cvvRequired: "مطلوب رمز CVV",
    cvvInvalidFormat: "يجب أن يتكون رمز CVV من 3 أو 4 أرقام",
    invalidCvv: "رمز CVV غير صالح",
    // new
    processingError: "فشل في معالجة الطلب، يرجى المحاولة مرة أخرى.",
    cvvInputEmpty: "حقل CVV فارغ.",
    cvvInputIncomplete: "حقل CVV غير مكتمل أو فارغ.",
    modalClosedByCustomer: "تم إلغاء النافذة من قبل العميل.",
    modalClosedBySystem: "تم إغلاق النافذة بواسطة النظام."
  },
  bg: {
    modalTitle: "Сигурна проверка",
    inputLabel: "Моля, въведете CVV на картата си",
    submitButton: "Изпрати",
    closeButton: "Затвори",
    loaderMessage: "Обработка...",
    defaultError: "Възникна грешка. Моля, опитайте отново.",
    cvvRequired: "Изисква се CVV",
    cvvInvalidFormat: "CVV трябва да е 3 или 4 цифри",
    invalidCvv: "Невалиден CVV",
    // new
    processingError: "Неуспешна обработка на заявката. Моля, опитайте отново.",
    cvvInputEmpty: "Полето за CVV е празно.",
    cvvInputIncomplete: "Полето за CVV е непълно или празно.",
    modalClosedByCustomer: "Прозорецът е отменен от клиента.",
    modalClosedBySystem: "Прозорецът е затворен от системата."
  },
  cs: {
    modalTitle: "Bezpečnostní kontrola",
    inputLabel: "Zadejte prosím CVV své karty",
    submitButton: "Odeslat",
    closeButton: "Zavřít",
    loaderMessage: "Zpracovává se...",
    defaultError: "Došlo k chybě. Zkuste to prosím znovu.",
    cvvRequired: "CVV je vyžadováno",
    cvvInvalidFormat: "CVV musí mít 3 nebo 4 číslice",
    invalidCvv: "Neplatné CVV",
    // new
    processingError: "Nepodařilo se zpracovat požadavek, zkuste to znovu.",
    cvvInputEmpty: "Pole CVV je prázdné.",
    cvvInputIncomplete: "Pole CVV je neúplné nebo prázdné.",
    modalClosedByCustomer: "Okno zrušeno zákazníkem.",
    modalClosedBySystem: "Okno zavřeno systémem."
  },
  da: {
    modalTitle: "Sikkerhedskontrol",
    inputLabel: "Indtast venligst dit korts CVV",
    submitButton: "Indsend",
    closeButton: "Luk",
    loaderMessage: "Behandler...",
    defaultError: "Der opstod en fejl. Prøv venligst igen.",
    cvvRequired: "CVV påkrævet",
    cvvInvalidFormat: "CVV skal være 3 eller 4 cifre",
    invalidCvv: "Ugyldigt CVV",
    // new
    processingError: "Kunne ikke behandle anmodning, prøv igen.",
    cvvInputEmpty: "CVV-feltet er tomt.",
    cvvInputIncomplete: "CVV-feltet er ufuldstændigt eller tomt.",
    modalClosedByCustomer: "Vinduet annulleret af kunden.",
    modalClosedBySystem: "Vinduet lukket af systemet."
  },
  de: {
    modalTitle: "Sicherheitsüberprüfung",
    inputLabel: "Bitte geben Sie den CVV Ihrer Karte ein",
    submitButton: "Absenden",
    closeButton: "Schließen",
    loaderMessage: "Verarbeitung...",
    defaultError: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    cvvRequired: "CVV erforderlich",
    cvvInvalidFormat: "CVV muss 3 oder 4 Ziffern haben",
    invalidCvv: "Ungültiger CVV",
    // new
    processingError: "Anfrage konnte nicht verarbeitet werden, bitte erneut versuchen.",
    cvvInputEmpty: "CVV-Feld ist leer.",
    cvvInputIncomplete: "CVV-Feld ist unvollständig oder leer.",
    modalClosedByCustomer: "Modal vom Kunden abgebrochen.",
    modalClosedBySystem: "Modal vom System geschlossen."
  },
  "de-DE": null,
  el: {
    modalTitle: "Έλεγχος ασφάλειας",
    inputLabel: "Παρακαλώ εισάγετε το CVV της κάρτας σας",
    submitButton: "Υποβολή",
    closeButton: "Κλείσιμο",
    loaderMessage: "Επεξεργασία...",
    defaultError: "Παρουσιάστηκε σφάλμα. Παρακαλώ δοκιμάστε ξανά.",
    cvvRequired: "Απαιτείται CVV",
    cvvInvalidFormat: "Το CVV πρέπει να είναι 3 ή 4 ψηφία",
    invalidCvv: "Μη έγκυρο CVV",
    // new
    processingError: "Η επεξεργασία του αιτήματος απέτυχε, δοκιμάστε ξανά.",
    cvvInputEmpty: "Το πεδίο CVV είναι κενό.",
    cvvInputIncomplete: "Το πεδίο CVV είναι ελλιπές ή κενό.",
    modalClosedByCustomer: "Το παράθυρο ακυρώθηκε από τον πελάτη.",
    modalClosedBySystem: "Το παράθυρο έκλεισε από το σύστημα."
  },
  es: {
    modalTitle: "Verificación de seguridad",
    inputLabel: "Por favor, introduzca el CVV de su tarjeta",
    submitButton: "Enviar",
    closeButton: "Cerrar",
    loaderMessage: "Procesando...",
    defaultError: "Ocurrió un error. Por favor, inténtelo de nuevo.",
    cvvRequired: "CVV requerido",
    cvvInvalidFormat: "El CVV debe tener 3 o 4 dígitos",
    invalidCvv: "CVV no válido",
    // new
    processingError: "Error al procesar la solicitud, intente nuevamente.",
    cvvInputEmpty: "El campo CVV está vacío.",
    cvvInputIncomplete: "El campo CVV está incompleto o vacío.",
    modalClosedByCustomer: "Ventana cancelada por el cliente.",
    modalClosedBySystem: "Ventana cerrada por el sistema."
  },
  "es-ES": null,
  "es-419": null,
  et: {
    modalTitle: "Turvakontroll",
    inputLabel: "Palun sisestage oma kaardi CVV",
    submitButton: "Esita",
    closeButton: "Sulge",
    loaderMessage: "Töötlemine...",
    defaultError: "Tekkis viga. Palun proovige uuesti.",
    cvvRequired: "CVV on vajalik",
    cvvInvalidFormat: "CVV peab olema 3 või 4 numbrit",
    invalidCvv: "Vigane CVV",
    // new
    processingError: "Päringu töötlemine ebaõnnestus, proovige uuesti.",
    cvvInputEmpty: "CVV väli on tühi.",
    cvvInputIncomplete: "CVV väli on puudulik või tühi.",
    modalClosedByCustomer: "Aken tühistati kliendi poolt.",
    modalClosedBySystem: "Aken suleti süsteemi poolt."
  },
  fi: {
    modalTitle: "Turvatarkastus",
    inputLabel: "Syötä korttisi CVV",
    submitButton: "Lähetä",
    closeButton: "Sulje",
    loaderMessage: "Käsitellään...",
    defaultError: "Tapahtui virhe. Yritä uudelleen.",
    cvvRequired: "CVV vaaditaan",
    cvvInvalidFormat: "CVV:n täytyy olla 3–4 numeroa",
    invalidCvv: "Virheellinen CVV",
    // new
    processingError: "Pyynnön käsittely epäonnistui, yritä uudelleen.",
    cvvInputEmpty: "CVV-kenttä on tyhjä.",
    cvvInputIncomplete: "CVV-kenttä on puutteellinen tai tyhjä.",
    modalClosedByCustomer: "Ikkuna peruutettu asiakkaan toimesta.",
    modalClosedBySystem: "Ikkuna suljettu järjestelmän toimesta."
  },
  fr: {
    modalTitle: "Vérification de sécurité",
    inputLabel: "Veuillez saisir le CVV de votre carte",
    submitButton: "Valider",
    closeButton: "Fermer",
    loaderMessage: "Traitement...",
    defaultError: "Une erreur s'est produite. Veuillez réessayer.",
    cvvRequired: "CVV requis",
    cvvInvalidFormat: "Le CVV doit comporter 3 ou 4 chiffres",
    invalidCvv: "CVV invalide",
    // new
    processingError: "Échec du traitement, veuillez réessayer.",
    cvvInputEmpty: "Le champ CVV est vide.",
    cvvInputIncomplete: "Le champ CVV est incomplet ou vide.",
    modalClosedByCustomer: "Fenêtre annulée par le client.",
    modalClosedBySystem: "Fenêtre fermée par le système."
  },
  "fr-FR": null,
  "fr-CA": null,
  he: {
    modalTitle: "בדיקת אבטחה",
    inputLabel: "אנא הזן את קוד ה-CVV של הכרטיס שלך",
    submitButton: "שלח",
    closeButton: "סגור",
    loaderMessage: "מעבד...",
    defaultError: "אירעה שגיאה. נסה שוב.",
    cvvRequired: "נדרש CVV",
    cvvInvalidFormat: "CVV חייב להכיל 3 או 4 ספרות",
    invalidCvv: "CVV שגוי",
    // new
    processingError: "פעולה נכשלה, נסה שוב.",
    cvvInputEmpty: "שדה CVV ריק.",
    cvvInputIncomplete: "שדה CVV אינו מלא או ריק.",
    modalClosedByCustomer: "החלון בוטל על ידי הלקוח.",
    modalClosedBySystem: "החלון נסגר על ידי המערכת."
  },
  hi: {
    modalTitle: "सुरक्षा जांच",
    inputLabel: "कृपया अपने कार्ड का CVV दर्ज करें",
    submitButton: "प्रस्तुत करें",
    closeButton: "बंद करें",
    loaderMessage: "प्रसंस्करण...",
    defaultError: "एक त्रुटि हुई है। कृपया पुनः प्रयास करें।",
    cvvRequired: "CVV आवश्यक है",
    cvvInvalidFormat: "CVV 3 या 4 अंक का होना चाहिए",
    invalidCvv: "अमान्य CVV",
    // new
    processingError: "अनुरोध संसाधित करने में विफल, कृपया पुनः प्रयास करें।",
    cvvInputEmpty: "CVV फ़ील्ड खाली है।",
    cvvInputIncomplete: "CVV फ़ील्ड अधूरी या खाली है।",
    modalClosedByCustomer: "ग्राहक द्वारा मोडल रद्द किया गया।",
    modalClosedBySystem: "प्रणाली द्वारा मोडल बंद किया गया।"
  },
  hr: {
    modalTitle: "Sigurnosna provjera",
    inputLabel: "Unesite CVV vaše kartice",
    submitButton: "Pošalji",
    closeButton: "Zatvori",
    loaderMessage: "Obrada...",
    defaultError: "Došlo je do pogreške. Pokušajte ponovo.",
    cvvRequired: "CVV je obavezan",
    cvvInvalidFormat: "CVV mora imati 3 ili 4 znamenke",
    invalidCvv: "Nevažeći CVV",
    // new
    processingError: "Zahtjev nije uspio, pokušajte ponovo.",
    cvvInputEmpty: "CVV polje je prazno.",
    cvvInputIncomplete: "CVV polje je nepotpuno ili prazno.",
    modalClosedByCustomer: "Prozor otkazan od strane korisnika.",
    modalClosedBySystem: "Prozor je zatvorio sistem."
  },
  hu: {
    modalTitle: "Biztonsági ellenőrzés",
    inputLabel: "Kérjük, adja meg kártyájának CVV kódját",
    submitButton: "Küldés",
    closeButton: "Bezárás",
    loaderMessage: "Feldolgozás...",
    defaultError: "Hiba történt. Kérjük, próbálja újra.",
    cvvRequired: "CVV szükséges",
    cvvInvalidFormat: "A CVV-nek 3 vagy 4 számjegyűnek kell lennie",
    invalidCvv: "Érvénytelen CVV",
    // new
    processingError: "A kérés feldolgozása nem sikerült, próbálja újra.",
    cvvInputEmpty: "A CVV mező üres.",
    cvvInputIncomplete: "A CVV mező hiányos vagy üres.",
    modalClosedByCustomer: "Az ablakot a felhasználó megszakította.",
    modalClosedBySystem: "Az ablakot a rendszer zárta be."
  },
  id: {
    modalTitle: "Pemeriksaan Keamanan",
    inputLabel: "Silakan masukkan CVV kartu Anda",
    submitButton: "Kirim",
    closeButton: "Tutup",
    loaderMessage: "Memproses...",
    defaultError: "Terjadi kesalahan. Silakan coba lagi.",
    cvvRequired: "CVV diperlukan",
    cvvInvalidFormat: "CVV harus 3 atau 4 digit",
    invalidCvv: "CVV tidak valid",
    // new
    processingError: "Gagal memproses permintaan, silakan coba lagi.",
    cvvInputEmpty: "Kolom CVV kosong.",
    cvvInputIncomplete: "Kolom CVV tidak lengkap atau kosong.",
    modalClosedByCustomer: "Jendela dibatalkan oleh pelanggan.",
    modalClosedBySystem: "Jendela ditutup oleh sistem."
  },
  it: {
    modalTitle: "Verifica di sicurezza",
    inputLabel: "Per favore inserisci il CVV della tua carta",
    submitButton: "Invia",
    closeButton: "Chiudi",
    loaderMessage: "Elaborazione...",
    defaultError: "Si è verificato un errore. Riprova.",
    cvvRequired: "CVV richiesto",
    cvvInvalidFormat: "Il CVV deve essere di 3 o 4 cifre",
    invalidCvv: "CVV non valido",
    // new
    processingError: "Elaborazione non riuscita, riprova.",
    cvvInputEmpty: "Il campo CVV è vuoto.",
    cvvInputIncomplete: "Il campo CVV è incompleto o vuoto.",
    modalClosedByCustomer: "Finestra annullata dal cliente.",
    modalClosedBySystem: "Finestra chiusa dal sistema."
  },
  "it-IT": null,
  ja: {
    modalTitle: "セキュリティチェック",
    inputLabel: "カードのCVVを入力してください",
    submitButton: "送信",
    closeButton: "閉じる",
    loaderMessage: "処理中...",
    defaultError: "エラーが発生しました。もう一度お試しください。",
    cvvRequired: "CVVは必須です",
    cvvInvalidFormat: "CVVは3桁または4桁である必要があります",
    invalidCvv: "無効なCVV",
    // new
    processingError: "リクエストの処理に失敗しました。再度お試しください。",
    cvvInputEmpty: "CVVフィールドが空です。",
    cvvInputIncomplete: "CVVフィールドが不完全または空です。",
    modalClosedByCustomer: "モーダルはお客様によりキャンセルされました。",
    modalClosedBySystem: "モーダルはシステムによって閉じられました。"
  },
  ko: {
    modalTitle: "보안 확인",
    inputLabel: "카드 CVV를 입력해주세요",
    submitButton: "제출",
    closeButton: "닫기",
    loaderMessage: "처리 중...",
    defaultError: "오류가 발생했습니다. 다시 시도해주세요.",
    cvvRequired: "CVV 필요",
    cvvInvalidFormat: "CVV는 3자리 또는 4자리 숫자여야 합니다",
    invalidCvv: "잘못된 CVV",
    // new
    processingError: "요청 처리 실패, 다시 시도해주세요.",
    cvvInputEmpty: "CVV 입력란이 비어 있습니다.",
    cvvInputIncomplete: "CVV 입력란이 비어 있거나 불완전합니다.",
    modalClosedByCustomer: "창이 고객에 의해 취소되었습니다.",
    modalClosedBySystem: "창이 시스템에 의해 닫혔습니다."
  },
  lt: {
    modalTitle: "Saugumo patikra",
    inputLabel: "Įveskite savo kortelės CVV",
    submitButton: "Pateikti",
    closeButton: "Uždaryti",
    loaderMessage: "Apdorojama...",
    defaultError: "Įvyko klaida. Bandykite dar kartą.",
    cvvRequired: "Būtinas CVV kodas",
    cvvInvalidFormat: "CVV turi būti 3 arba 4 skaitmenys",
    invalidCvv: "Neteisingas CVV",
    // new
    processingError: "Užklausos apdorojimas nepavyko, bandykite dar kartą.",
    cvvInputEmpty: "CVV laukas tuščias.",
    cvvInputIncomplete: "CVV laukas neužpildytas arba tuščias.",
    modalClosedByCustomer: "Langą atšaukė klientas.",
    modalClosedBySystem: "Langą uždarė sistema."
  },
  lv: {
    modalTitle: "Drošības pārbaude",
    inputLabel: "Lūdzu, ievadiet savas kartes CVV kodu",
    submitButton: "Iesniegt",
    closeButton: "Aizvērt",
    loaderMessage: "Apstrāde...",
    defaultError: "Radās kļūda. Lūdzu, mēģiniet vēlreiz.",
    cvvRequired: "Nepieciešams CVV",
    cvvInvalidFormat: "CVV jābūt 3 vai 4 cipariem",
    invalidCvv: "Nederīgs CVV",
    // new
    processingError: "Pieprasījumu neizdevās apstrādāt, mēģiniet vēlreiz.",
    cvvInputEmpty: "CVV lauks ir tukšs.",
    cvvInputIncomplete: "CVV lauks nav aizpildīts vai ir tukšs.",
    modalClosedByCustomer: "Logs atcelts klienta dēļ.",
    modalClosedBySystem: "Logs aizvērts sistēmas dēļ."
  },
  ms: {
    modalTitle: "Pemeriksaan Keselamatan",
    inputLabel: "Sila masukkan CVV kad anda",
    submitButton: "Hantar",
    closeButton: "Tutup",
    loaderMessage: "Memproses...",
    defaultError: "Berlaku ralat. Sila cuba lagi.",
    cvvRequired: "CVV diperlukan",
    cvvInvalidFormat: "CVV mesti 3 atau 4 digit",
    invalidCvv: "CVV tidak sah",
    // new
    processingError: "Permintaan gagal diproses, sila cuba lagi.",
    cvvInputEmpty: "Medan CVV kosong.",
    cvvInputIncomplete: "Medan CVV tidak lengkap atau kosong.",
    modalClosedByCustomer: "Tetingkap dibatalkan oleh pelanggan.",
    modalClosedBySystem: "Tetingkap ditutup oleh sistem."
  },
  mt: {
    modalTitle: "Verifika tas-Sigurtà",
    inputLabel: "Jekk jogħġbok daħħal il-CVV tal-kard tiegħek",
    submitButton: "Ibgħat",
    closeButton: "Agħlaq",
    loaderMessage: "Qiegħed jipproċessa...",
    defaultError: "Seħħ żball. Jekk jogħġbok ipprova mill-ġdid.",
    cvvRequired: "CVV meħtieġ",
    cvvInvalidFormat: "CVV għandu jkun ta' 3 jew 4 ċifri",
    invalidCvv: "CVV mhux validu",
    // new
    processingError: "It-talba falliet, erġa' pprova.",
    cvvInputEmpty: "Il-qasam CVV huwa vojt.",
    cvvInputIncomplete: "Il-qasam CVV mhux komplut jew vojt.",
    modalClosedByCustomer: "Tieqa kkanċellata mill-klijent.",
    modalClosedBySystem: "Tieqa magħluqa mis-sistema."
  },
  nb: {
    modalTitle: "Sikkerhetskontroll",
    inputLabel: "Vennligst tast inn CVV for kortet ditt",
    submitButton: "Send inn",
    closeButton: "Lukk",
    loaderMessage: "Behandler...",
    defaultError: "En feil har oppstått. Vennligst prøv igjen.",
    cvvRequired: "CVV kreves",
    cvvInvalidFormat: "CVV må være 3 eller 4 sifre",
    invalidCvv: "Ugyldig CVV",
    // new
    processingError: "Kunne ikke behandle forespørselen, prøv igjen.",
    cvvInputEmpty: "CVV-feltet er tomt.",
    cvvInputIncomplete: "CVV-feltet er ufullstendig eller tomt.",
    modalClosedByCustomer: "Vinduet avbrutt av kunden.",
    modalClosedBySystem: "Vinduet lukket av systemet."
  },
  no: null,
  nl: {
    modalTitle: "Beveiligingscontrole",
    inputLabel: "Voer uw kaart-CVV in",
    submitButton: "Verzenden",
    closeButton: "Sluiten",
    loaderMessage: "Bezig met verwerken...",
    defaultError: "Er is een fout opgetreden. Probeer het opnieuw.",
    cvvRequired: "CVV vereist",
    cvvInvalidFormat: "CVV moet uit 3 of 4 cijfers bestaan",
    invalidCvv: "Ongeldige CVV",
    // new
    processingError: "Verzoek verwerken mislukt, probeer opnieuw.",
    cvvInputEmpty: "CVV-veld is leeg.",
    cvvInputIncomplete: "CVV-veld is onvolledig of leeg.",
    modalClosedByCustomer: "Venster geannuleerd door klant.",
    modalClosedBySystem: "Venster gesloten door systeem."
  },
  "nl-NL": null,
  pl: {
    modalTitle: "Sprawdzenie bezpieczeństwa",
    inputLabel: "Wprowadź CVV swojej karty",
    submitButton: "Wyślij",
    closeButton: "Zamknij",
    loaderMessage: "Przetwarzanie...",
    defaultError: "Wystąpił błąd. Spróbuj ponownie.",
    cvvRequired: "CVV jest wymagany",
    cvvInvalidFormat: "CVV musi składać się z 3 lub 4 cyfr",
    invalidCvv: "Nieprawidłowy CVV",
    // new
    processingError: "Nie udało się przetworzyć żądania, spróbuj ponownie.",
    cvvInputEmpty: "Pole CVV jest puste.",
    cvvInputIncomplete: "Pole CVV jest niepełne lub puste.",
    modalClosedByCustomer: "Okno anulowane przez klienta.",
    modalClosedBySystem: "Okno zamknięte przez system."
  },
  pt: {
    modalTitle: "Verificação de segurança",
    inputLabel: "Por favor, insira o CVV do seu cartão",
    submitButton: "Enviar",
    closeButton: "Fechar",
    loaderMessage: "Processando...",
    defaultError: "Ocorreu um erro. Por favor, tente novamente.",
    cvvRequired: "CVV obrigatório",
    cvvInvalidFormat: "O CVV deve ter 3 ou 4 dígitos",
    invalidCvv: "CVV inválido",
    // new
    processingError: "Falha ao processar o pedido, tente novamente.",
    cvvInputEmpty: "O campo CVV está vazio.",
    cvvInputIncomplete: "O campo CVV está incompleto ou vazio.",
    modalClosedByCustomer: "Modal cancelado pelo cliente.",
    modalClosedBySystem: "Modal fechado pelo sistema."
  },
  "pt-PT": null,
  "pt-BR": null,
  ro: {
    modalTitle: "Verificare de siguranță",
    inputLabel: "Introduceți CVV-ul cardului",
    submitButton: "Trimiteți",
    closeButton: "Închideți",
    loaderMessage: "Se prelucrează...",
    defaultError: "A apărut o eroare. Încercați din nou.",
    cvvRequired: "Este necesar CVV",
    cvvInvalidFormat: "CVV trebuie să aibă 3 sau 4 cifre",
    invalidCvv: "CVV invalid",
    // new
    processingError: "Solicitarea a eșuat, încercați din nou.",
    cvvInputEmpty: "Câmpul CVV este gol.",
    cvvInputIncomplete: "Câmpul CVV este incomplet sau gol.",
    modalClosedByCustomer: "Fereastra a fost anulată de client.",
    modalClosedBySystem: "Fereastra a fost închisă de sistem."
  },
  ru: {
    modalTitle: "Проверка безопасности",
    inputLabel: "Пожалуйста, введите CVV вашей карты",
    submitButton: "Отправить",
    closeButton: "Закрыть",
    loaderMessage: "Обработка...",
    defaultError: "Произошла ошибка. Пожалуйста, попробуйте еще раз.",
    cvvRequired: "Требуется CVV",
    cvvInvalidFormat: "CVV должен содержать 3 или 4 цифры",
    invalidCvv: "Неверный CVV",
    // new
    processingError: "Ошибка обработки запроса, попробуйте еще раз.",
    cvvInputEmpty: "Поле CVV пустое.",
    cvvInputIncomplete: "Поле CVV не заполнено или пустое.",
    modalClosedByCustomer: "Окно отменено пользователем.",
    modalClosedBySystem: "Окно закрыто системой."
  },
  sk: {
    modalTitle: "Bezpečnostná kontrola",
    inputLabel: "Zadajte CVV vašej karty",
    submitButton: "Odoslať",
    closeButton: "Zavrieť",
    loaderMessage: "Spracováva sa...",
    defaultError: "Vyskytla sa chyba. Skúste to znova.",
    cvvRequired: "Vyžaduje sa CVV",
    cvvInvalidFormat: "CVV musí mať 3 alebo 4 číslice",
    invalidCvv: "Neplatné CVV",
    // new
    processingError: "Spracovanie požiadavky zlyhalo, skúste to znova.",
    cvvInputEmpty: "Pole CVV je prázdne.",
    cvvInputIncomplete: "Pole CVV je neúplné alebo prázdne.",
    modalClosedByCustomer: "Okno bolo zrušené zákazníkom.",
    modalClosedBySystem: "Okno bolo zatvorené systémom."
  },
  sl: {
    modalTitle: "Varnostni pregled",
    inputLabel: "Prosim, vnesite CVV vaše kartice",
    submitButton: "Pošlji",
    closeButton: "Zapri",
    loaderMessage: "Obdelava...",
    defaultError: "Prišlo je do napake. Poskusite znova.",
    cvvRequired: "Zahtevan CVV",
    cvvInvalidFormat: "CVV mora biti 3 ali 4 števke",
    invalidCvv: "Neveljaven CVV",
    // new
    processingError: "Zahteva ni bila obdelana, poskusite znova.",
    cvvInputEmpty: "Polje CVV je prazno.",
    cvvInputIncomplete: "Polje CVV ni popolno ali je prazno.",
    modalClosedByCustomer: "Okno preklicano s strani stranke.",
    modalClosedBySystem: "Okno zaprto s strani sistema."
  },
  sv: {
    modalTitle: "Säkerhetskontroll",
    inputLabel: "Ange kortets CVV",
    submitButton: "Skicka",
    closeButton: "Stäng",
    loaderMessage: "Bearbetar...",
    defaultError: "Ett fel har inträffat. Försök igen.",
    cvvRequired: "CVV krävs",
    cvvInvalidFormat: "CVV måste vara 3 eller 4 siffror",
    invalidCvv: "Ogiltig CVV",
    // new
    processingError: "Misslyckades att behandla begäran, försök igen.",
    cvvInputEmpty: "CVV-fältet är tomt.",
    cvvInputIncomplete: "CVV-fältet är ofullständigt eller tomt.",
    modalClosedByCustomer: "Fönster avbrutet av kunden.",
    modalClosedBySystem: "Fönster stängt av systemet."
  },
  th: {
    modalTitle: "การตรวจสอบความปลอดภัย",
    inputLabel: "กรุณาใส่ CVV ของบัตรของคุณ",
    submitButton: "ส่ง",
    closeButton: "ปิด",
    loaderMessage: "กำลังดำเนินการ...",
    defaultError: "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง",
    cvvRequired: "ต้องระบุ CVV",
    cvvInvalidFormat: "CVV ต้องมี 3 หรือ 4 หลัก",
    invalidCvv: "CVV ไม่ถูกต้อง",
    // new
    processingError: "ไม่สามารถดำเนินการตามคำขอ กรุณาลองใหม่อีกครั้ง",
    cvvInputEmpty: "ช่อง CVV ว่างเปล่า",
    cvvInputIncomplete: "ช่อง CVV ไม่สมบูรณ์หรือว่างเปล่า",
    modalClosedByCustomer: "หน้าต่างถูกยกเลิกโดยลูกค้า",
    modalClosedBySystem: "หน้าต่างถูกปิดโดยระบบ"
  },
  tr: {
    modalTitle: "Güvenlik Kontrolü",
    inputLabel: "Lütfen kartınızın CVV'sini girin",
    submitButton: "Gönder",
    closeButton: "Kapat",
    loaderMessage: "İşleniyor...",
    defaultError: "Bir hata oluştu. Lütfen tekrar deneyin.",
    cvvRequired: "CVV gerekli",
    cvvInvalidFormat: "CVV 3 veya 4 haneli olmalıdır",
    invalidCvv: "Geçersiz CVV",
    // new
    processingError: "İşlem başarısız oldu, lütfen tekrar deneyin.",
    cvvInputEmpty: "CVV alanı boş.",
    cvvInputIncomplete: "CVV alanı eksik veya boş.",
    modalClosedByCustomer: "Modal müşteri tarafından iptal edildi.",
    modalClosedBySystem: "Modal sistem tarafından kapatıldı."
  },
  uk: {
    modalTitle: "Перевірка безпеки",
    inputLabel: "Будь ласка, введіть CVV вашої картки",
    submitButton: "Відправити",
    closeButton: "Закрити",
    loaderMessage: "Обробка...",
    defaultError: "Виникла помилка. Спробуйте ще раз.",
    cvvRequired: "Потрібен CVV",
    cvvInvalidFormat: "CVV має містити 3 або 4 цифри",
    invalidCvv: "Недійсний CVV",
    // new
    processingError: "Не вдалося обробити запит, спробуйте ще раз.",
    cvvInputEmpty: "Поле CVV порожнє.",
    cvvInputIncomplete: "Поле CVV неповне або порожнє.",
    modalClosedByCustomer: "Вікно скасовано клієнтом.",
    modalClosedBySystem: "Вікно закрито системою."
  },
  vi: {
    modalTitle: "Kiểm tra bảo mật",
    inputLabel: "Vui lòng nhập CVV của thẻ",
    submitButton: "Gửi",
    closeButton: "Đóng",
    loaderMessage: "Đang xử lý...",
    defaultError: "Đã xảy ra lỗi. Vui lòng thử lại.",
    cvvRequired: "Cần nhập CVV",
    cvvInvalidFormat: "CVV phải có 3 hoặc 4 chữ số",
    invalidCvv: "CVV không hợp lệ",
    // new
    processingError: "Xử lý yêu cầu thất bại, hãy thử lại.",
    cvvInputEmpty: "Trường CVV đang trống.",
    cvvInputIncomplete: "Trường CVV không đầy đủ hoặc trống.",
    modalClosedByCustomer: "Cửa sổ bị hủy bởi khách hàng.",
    modalClosedBySystem: "Cửa sổ bị hệ thống đóng."
  },
  zh: {
    modalTitle: "安全检查",
    inputLabel: "请输入您的卡片CVV",
    submitButton: "提交",
    closeButton: "关闭",
    loaderMessage: "处理中...",
    defaultError: "发生错误，请重试。",
    cvvRequired: "需要CVV",
    cvvInvalidFormat: "CVV必须为3或4位数字",
    invalidCvv: "无效的CVV",
    // new
    processingError: "处理请求失败，请重试。",
    cvvInputEmpty: "CVV字段为空。",
    cvvInputIncomplete: "CVV字段不完整或为空。",
    modalClosedByCustomer: "用户取消了窗口。",
    modalClosedBySystem: "窗口已被系统关闭。"
  },
  "zh-CN": null,
  "zh-TW": null,
  "zh-HK": null
};
// Aliases: for languages which are region-specific variants, point them to their base translations
cvvModalTranslationEntries["de-DE"] = cvvModalTranslationEntries["de"];
cvvModalTranslationEntries["fr-FR"] = cvvModalTranslationEntries["fr"];
cvvModalTranslationEntries["fr-CA"] = cvvModalTranslationEntries["fr"];
cvvModalTranslationEntries["es-ES"] = cvvModalTranslationEntries["es"];
cvvModalTranslationEntries["es-419"] = cvvModalTranslationEntries["es"];
cvvModalTranslationEntries["pt-PT"] = cvvModalTranslationEntries["pt"];
cvvModalTranslationEntries["pt-BR"] = cvvModalTranslationEntries["pt"];
cvvModalTranslationEntries["nl-NL"] = cvvModalTranslationEntries["nl"];
cvvModalTranslationEntries["it-IT"] = cvvModalTranslationEntries["it"];
cvvModalTranslationEntries["zh-CN"] = cvvModalTranslationEntries["zh"];
cvvModalTranslationEntries["zh-TW"] = cvvModalTranslationEntries["zh"];
cvvModalTranslationEntries["zh-HK"] = cvvModalTranslationEntries["zh"];
cvvModalTranslationEntries["no"] = cvvModalTranslationEntries["nb"];
// Ensure possible undefined variants fallback to "en"
_forEachInstanceProperty(_context = _Object$keys(cvvModalTranslationEntries)).call(_context, function (lang) {
  if (!cvvModalTranslationEntries[lang]) {
    cvvModalTranslationEntries[lang] = cvvModalTranslationEntries["en"];
  }
});
function translationsAreDefined(translations) {
  var _context2;
  return _everyInstanceProperty(_context2 = _Object$values(translations)).call(_context2, function (entry) {
    return entry !== null;
  });
}
if (!translationsAreDefined(cvvModalTranslationEntries)) {
  throw new TypeError("Missing CVV modal translation");
}
var cvvModalTranslations = cvvModalTranslationEntries;
/**
 * Get a translation for the provided key and language.
 * Falls back to English if not found.
 */
function getCVVModalTranslation(key, lang) {
  var translation = cvvModalTranslations[lang] && cvvModalTranslations[lang][key] || cvvModalTranslations.en && cvvModalTranslations.en[key] || "";
  return translation;
}

function ownKeys$1(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var _context11, _context12; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context11 = ownKeys$1(Object(t), true)).call(_context11, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context12 = ownKeys$1(Object(t))).call(_context12, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function isHttpErrorStatus(code) {
  if (code == null || code === "") {
    return false;
  }
  var statusCode = Number(code);
  return !_Number$isNaN(statusCode) && statusCode >= 400;
}
function thrownMessage(err) {
  if (_typeof(err) === "object" && err !== null && "message" in err) {
    var message = err.message;
    return typeof message === "string" ? message : undefined;
  }
  return undefined;
}
// Utility function to filter updateLog payload to only allowed keys
function filterUpdateLogData(data) {
  var allowedKeys = ["type", "event_name", "provider", "payment_id", "message"];
  var result = {};
  for (var _i = 0, _allowedKeys = allowedKeys; _i < _allowedKeys.length; _i++) {
    var key = _allowedKeys[_i];
    result[key] = data[key] || "-";
  }
  return result;
}
var CVVModal = /*#__PURE__*/function () {
  function CVVModal() {
    var modalId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "cvv-modal";
    var inputId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "cvv-input";
    _classCallCheck(this, CVVModal);
    _defineProperty(this, "modalId", void 0);
    _defineProperty(this, "inputId", void 0);
    _defineProperty(this, "resolveFn", void 0);
    _defineProperty(this, "rejectFn", void 0);
    _defineProperty(this, "backdrop", void 0);
    _defineProperty(this, "modal", void 0);
    _defineProperty(this, "stripeCardCvcElement", void 0);
    _defineProperty(this, "stripeUnmountedCvc", void 0);
    _defineProperty(this, "paymentGateway", void 0);
    _defineProperty(this, "stripeClientSecret", void 0);
    _defineProperty(this, "selectedCardId", void 0);
    _defineProperty(this, "_paymentId", void 0);
    _defineProperty(this, "_onResult", void 0);
    // Track who closed the modal (customer/system)
    _defineProperty(this, "_modalCloseSource", void 0);
    // The language code to use for this modal instance
    _defineProperty(this, "_language", "en");
    this.modalId = modalId;
    this.inputId = inputId;
  }
  return _createClass(CVVModal, [{
    key: "getBaseModalHtml",
    value: function getBaseModalHtml() {
      var _context4, _context5, _context6;
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Please enter your card CVV";
      var showInput = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var useStripe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var useBraintree = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var lang = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "en";
      var inputAndSubmit = "";
      var submitButtonLabel = getCVVModalTranslation("submitButton", lang);
      var placeholder = "CVV";
      var inputLabel = getCVVModalTranslation("inputLabel", lang);
      if (showInput && !useStripe && !useBraintree) {
        placeholder = "CVV";
      }
      if (showInput) {
        if (useStripe) {
          inputAndSubmit = "\n                    <div class=\"pg-cvv-modal-stripe-cvc-container\" id=\"stripe-cvc-container\" style=\"margin-top:15px;margin-bottom:18px\" tabindex=\"0\"></div>\n                    <button class=\"pg-cvv-modal-submit\">".concat(submitButtonLabel, "</button>\n                ");
        } else if (useBraintree) {
          inputAndSubmit = "\n                    <div class=\"pg-cvv-modal-braintree-cvc-container\" id=\"braintree-cvc-container\" style=\"margin-top:15px;margin-bottom:18px\" tabindex=\"1\"></div>\n                    <button class=\"pg-cvv-modal-submit\" tabindex=\"2\">".concat(submitButtonLabel, "</button>\n                ");
        } else {
          var _context, _context2, _context3;
          inputAndSubmit = _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = "\n                    <input class=\"pg-cvv-modal-input\" id=\"".concat(this.inputId, "\" type=\"password\" maxlength=\"4\" autocomplete=\"off\" inputmode=\"numeric\" pattern=\"[0-9]*\" placeholder=\"")).call(_context3, placeholder, "\" tabindex=\"1\" aria-label=\"")).call(_context2, inputLabel, "\" />\n                    <button class=\"pg-cvv-modal-submit\" tabindex=\"2\">")).call(_context, submitButtonLabel, "</button>\n                ");
        }
      }
      // Use the translated label for the close button and loader
      var closeButtonLabel = getCVVModalTranslation("closeButton", lang);
      return _concatInstanceProperty(_context4 = _concatInstanceProperty(_context5 = _concatInstanceProperty(_context6 = "\n            <style>\n            .pg-cvv-modal-backdrop {\n                position: fixed; top: 0; left: 0; width: 100vw; height: 100vh;\n                background: rgba(0,0,0,0.5); z-index: 9999; display: flex; align-items: center; justify-content: center;\n            }\n            .pg-cvv-modal {\n                background: #fff; padding: 32px 24px; border-radius: 8px; max-width: 380px; box-shadow: 0 10px 24px #090f2c1e;\n                position: relative; min-width: 320px;\n            }\n            .pg-cvv-modal-close {\n                position: absolute; top: 10px; right: 10px; cursor: pointer; font-size: 20px; color: #999;\n                background: none; border: none;\n            }\n            .pg-cvv-modal-input {\n                width: 100%; padding: 12px 10px; font-size: 18px; border-radius: 4px; border: 1px solid #d7dce3;\n                margin-top: 15px; margin-bottom: 18px;\n            }\n            .pg-cvv-modal-submit {\n                background: #0546a0; border: none; color: #fff; font-weight: 500; padding: 10px 25px;\n                border-radius: 5px; font-size: 17px; cursor: pointer; width: 100%;\n            }\n            .pg-cvv-modal-label {\n                font-size: 16px;\n            }\n            .pg-cvv-modal-error {\n                color: #B40E3E;\n                margin-bottom: 7px;\n                font-size: 14px;\n                min-height: 18px;\n                display: none;\n            }\n            .pg-cvv-modal-loading-spinner {\n                border: 4px solid #f3f3f3;\n                border-top: 4px solid #0546a0;\n                border-radius: 50%;\n                width: 48px;\n                height: 48px;\n                animation: pg-cvv-spin 1s linear infinite;\n                margin: 24px auto 18px auto;\n                display:none;\n            }\n            @keyframes pg-cvv-spin {\n                0% { transform: rotate(0deg);}\n                100% { transform: rotate(360deg);}\n            }\n            .pg-cvv-modal-stripe-cvc-container {\n                width: 100%;\n                height: 40px;\n                background: transparent;\n                border-radius: 4px;\n                border: 1px solid #d7dce3;\n                padding: 0 10px;\n                display: grid; align-items: center;\n            }\n            .pg-cvv-modal-braintree-cvc-container {\n                width: 100%;\n                height: 40px;\n                background: transparent;\n                border-radius: 4px;\n                border: 1px solid #d7dce3;\n                padding: 0 10px;\n                align-items: center;\n            }\n            </style>\n            <div class=\"pg-cvv-modal\" role=\"dialog\" aria-modal=\"true\" id=\"".concat(this.modalId, "\">\n                <button class=\"pg-cvv-modal-close\" aria-label=\"")).call(_context6, closeButtonLabel, "\">&times;</button>\n                <div class=\"pg-cvv-modal-label\">")).call(_context5, message, "</div>\n                <div class=\"pg-cvv-modal-error\" id=\"pg-cvv-modal-error\"></div>\n                <div class=\"pg-cvv-modal-loading-spinner\" id=\"pg-cvv-modal-loader\"></div>\n                ")).call(_context4, inputAndSubmit, "\n            </div>\n        ");
    }
  }, {
    key: "setError",
    value: function setError(errorMsg) {
      var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en";
      if (this.modal) {
        var errDiv = this.modal.querySelector("#pg-cvv-modal-error");
        if (errDiv) {
          var _context7;
          if (errorMsg && _trimInstanceProperty(_context7 = String(errorMsg)).call(_context7).length > 0) {
            errDiv.style.display = "block";
            errDiv.textContent = errorMsg;
          } else {
            errDiv.textContent = "";
            errDiv.style.display = "none";
          }
        }
      }
      // Now update the modal title/label in error state to reflect the passed lang always
      if (this.modal) {
        var labelDiv = this.modal.querySelector(".pg-cvv-modal-label");
        if (labelDiv) {
          labelDiv.textContent = getCVVModalTranslation("modalTitle", lang);
        }
      }
      // Enable the submit button and re-enable stripe input on error for retry (Stripe fix)
      if (this.modal) {
        var submitBtn = this.modal.querySelector(".pg-cvv-modal-submit");
        if (submitBtn) {
          submitBtn.style.display = "";
          submitBtn.removeAttribute("disabled");
        }
        // For Stripe input, there is no input element to enable, but the button is all that's needed
      }
    }
  }, {
    key: "showLoader",
    value: function showLoader(show, loaderMsg) {
      var lang = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "en";
      if (!loaderMsg) loaderMsg = getCVVModalTranslation("loaderMessage", lang);
      if (this.modal) {
        var loader = this.modal.querySelector("#pg-cvv-modal-loader");
        var label = this.modal.querySelector(".pg-cvv-modal-label");
        if (loader) {
          loader.style.display = show ? "block" : "none";
        }
        if (label) {
          label.textContent = show ? loaderMsg : getCVVModalTranslation("modalTitle", lang);
        }
      }
      if (this.modal) {
        var submitBtn = this.modal.querySelector(".pg-cvv-modal-submit");
        if (submitBtn) submitBtn.style.display = show ? "none" : "";
        // For Stripe input, no input to disable but button is still core
        var input = this.modal.querySelector("#".concat(this.inputId));
        if (input) input.disabled = show;
      }
    }
  }, {
    key: "show",
    value: function show(params) {
      var _params$data,
        _this = this;
      // Get language_code from params.data.metadata.language_code, fallback "en"
      var lang = "en";
      var metadata = params === null || params === void 0 || (_params$data = params.data) === null || _params$data === void 0 ? void 0 : _params$data.metadata;
      if (metadata && _typeof(metadata) === "object" && "language_code" in metadata) {
        var code = metadata.language_code;
        if (typeof code === "string" && code) {
          lang = code;
        }
      }
      this._language = lang;
      return new _Promise(function (resolve, reject) {
        var _this$backdrop$queryS;
        _this.resolveFn = resolve;
        _this.rejectFn = reject;
        _this.close();
        _this._onResult = params.onResult;
        _this._modalCloseSource = undefined;
        _this.backdrop = document.createElement("div");
        _this.backdrop.className = "pg-cvv-modal-backdrop";
        _this.backdrop.innerHTML = _this.getBaseModalHtml(getCVVModalTranslation("loaderMessage", lang), false, false, false, lang);
        document.body.appendChild(_this.backdrop);
        _this.modal = (_this$backdrop$queryS = _this.backdrop.querySelector("#".concat(_this.modalId))) !== null && _this$backdrop$queryS !== void 0 ? _this$backdrop$queryS : undefined;
        var loadingModal = _this.modal;
        if (loadingModal) {
          var closeBtnLoading = loadingModal.querySelector(".pg-cvv-modal-close");
          if (closeBtnLoading) {
            closeBtnLoading.onclick = function () {
              _this._modalCloseSource = "customer";
              _this.handleClose({
                closedBy: "user-close-initial",
                params: params
              });
            };
          }
        }
        _this.showLoader(true, getCVVModalTranslation("loaderMessage", lang), lang);
        _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          var _response;
          var errorMsg, showInput, useStripe, useBraintree, providerName, response, paymentGateway, braintreeHostedFieldsInstance, stripeSetupPromise, braintreeSetupPromise, initializationError, reportInitializationFailure, _this$backdrop$queryS2, modal, closeBtn, submitBtn, cvcElementMounted, cred, publishableKey, _cred, _publishableKey, escListener, trapFocus, handleSubmit, el, _el, input;
          return _regeneratorRuntime.wrap(function (_context1) {
            while (1) switch (_context1.prev = _context1.next) {
              case 0:
                errorMsg = "";
                showInput = true;
                useStripe = false;
                useBraintree = false;
                providerName = "";
                response = null;
                _this.stripeClientSecret = "";
                _this.selectedCardId = undefined;
                braintreeHostedFieldsInstance = null;
                reportInitializationFailure = function reportInitializationFailure(err) {
                  initializationError = thrownMessage(err) || getCVVModalTranslation("defaultError", lang);
                  _this.showLoader(false, undefined, lang);
                  _this.setError(initializationError, lang);
                };
                _context1.prev = 1;
                _context1.next = 2;
                return params.createSavedCardIntent(params.data);
              case 2:
                response = _context1.sent;
                providerName = response && _typeof(response) === "object" && "provider_name" in response ? response.provider_name : "";
                _this._paymentId = response.payment_id;
                if (Object.prototype.hasOwnProperty.call(response, "message") && response.message === null) {
                  errorMsg = null;
                  showInput = false;
                } else if (isHttpErrorStatus(response.code)) {
                  errorMsg = response.message || getCVVModalTranslation("defaultError", lang);
                  showInput = false;
                }
                _context1.next = 3;
                return params.getGateway(providerName);
              case 3:
                paymentGateway = _context1.sent;
                _this.paymentGateway = paymentGateway;
                if (showInput && providerName === "stripe") {
                  useStripe = true;
                }
                if (showInput && providerName === "braintree" && paymentGateway && typeof paymentGateway.getCvvHostedFieldInstance === "function") {
                  useBraintree = true;
                }
                _context1.next = 5;
                break;
              case 4:
                _context1.prev = 4;
                _context1["catch"](1);
                errorMsg = getCVVModalTranslation("processingError", lang);
                showInput = false;
              case 5:
                if (_this.backdrop) {
                  _this.backdrop.innerHTML = _this.getBaseModalHtml(getCVVModalTranslation("modalTitle", lang), showInput, useStripe, useBraintree, lang);
                  _this.modal = (_this$backdrop$queryS2 = _this.backdrop.querySelector("#".concat(_this.modalId))) !== null && _this$backdrop$queryS2 !== void 0 ? _this$backdrop$queryS2 : undefined;
                }
                if (!(!_this.modal || !_this.backdrop)) {
                  _context1.next = 6;
                  break;
                }
                resolve(null);
                if (typeof _this._onResult === "function") {
                  _this._modalCloseSource = "system";
                  _this._onResult({
                    status: "failed",
                    data: null,
                    error: "Failed to mount CVV modal",
                    message: getCVVModalTranslation("defaultError", lang),
                    closed_by: "system"
                  });
                }
                return _context1.abrupt("return");
              case 6:
                modal = _this.modal;
                closeBtn = modal.querySelector(".pg-cvv-modal-close");
                submitBtn = modal.querySelector(".pg-cvv-modal-submit");
                _this.showLoader(false, undefined, lang);
                _this.setError(errorMsg, lang);
                if (showInput) {
                  _context1.next = 7;
                  break;
                }
                if (closeBtn) closeBtn.onclick = function () {
                  _this._modalCloseSource = "customer";
                  _this.handleClose({
                    closedBy: "user-close-showInput-false",
                    params: params
                  });
                };
                resolve(null);
                if (typeof _this._onResult === "function") {
                  _this._modalCloseSource = errorMsg ? "system" : "customer";
                  _this._onResult({
                    status: errorMsg ? "failed" : "success",
                    data: null,
                    error: errorMsg,
                    message: errorMsg ? errorMsg : getCVVModalTranslation("modalClosedByCustomer", lang),
                    closed_by: _this._modalCloseSource
                  });
                }
                return _context1.abrupt("return");
              case 7:
                _this.selectedCardId = (_response = response) === null || _response === void 0 ? void 0 : _response.payment_method;
                // Stripe setup: initialize/mount only ONCE and immediately before submit resolves
                cvcElementMounted = false; // track mount state in closure
                if (useStripe && paymentGateway && response) {
                  cred = response.provider_credential;
                  publishableKey = (cred === null || cred === void 0 ? void 0 : cred.publishable_key) || (cred === null || cred === void 0 ? void 0 : cred.client_token) || (cred === null || cred === void 0 ? void 0 : cred.tokenization_key);
                  stripeSetupPromise = paymentGateway.init(publishableKey, undefined, params.data).then(function () {
                    if (paymentGateway) {
                      var _response2, _paymentGateway$getPr, _response3, _this$backdrop, _context8;
                      _this.stripeClientSecret = (_response2 = response) === null || _response2 === void 0 ? void 0 : _response2.provider_client_secret;
                      var elements = (_paymentGateway$getPr = paymentGateway.getProviderClient()) === null || _paymentGateway$getPr === void 0 ? void 0 : _paymentGateway$getPr.elements({
                        clientSecret: (_response3 = response) === null || _response3 === void 0 ? void 0 : _response3.provider_client_secret,
                        paymentMethodCreation: "manual",
                        locale: lang
                      });
                      var cvc = elements.create("cardCvc", {
                        style: {
                          base: {
                            fontSize: "18px",
                            color: "#242424",
                            letterSpacing: "0.3px",
                            "::placeholder": {
                              color: "#aab7c4"
                            },
                            fontFamily: "inherit"
                          }
                        }
                      });
                      _this.stripeCardCvcElement = cvc;
                      _this.stripeUnmountedCvc = false;
                      var mountEl = (_this$backdrop = _this.backdrop) === null || _this$backdrop === void 0 ? void 0 : _this$backdrop.querySelector("#stripe-cvc-container");
                      if (mountEl) {
                        cvc.mount(mountEl);
                        cvcElementMounted = true;
                      }
                      // patch handleClose to unmount ONLY on close
                      var originalHandleClose = _bindInstanceProperty(_context8 = _this.handleClose).call(_context8, _this);
                      _this.handleClose = function (args) {
                        if (_this.stripeCardCvcElement && !_this.stripeUnmountedCvc) {
                          try {
                            _this.stripeCardCvcElement.unmount();
                            _this.stripeUnmountedCvc = true;
                            cvcElementMounted = false;
                          } catch (_unused2) {
                            // Stripe unmount throws if the element is already gone. Payment can still close.
                          }
                        }
                        _this.stripeCardCvcElement = undefined;
                        originalHandleClose(args);
                      };
                    }
                  }).catch(reportInitializationFailure);
                }
                // Braintree setup
                if (useBraintree && paymentGateway && response && typeof paymentGateway.getCvvHostedFieldInstance === "function") {
                  _cred = response.provider_credential;
                  _publishableKey = (_cred === null || _cred === void 0 ? void 0 : _cred.publishable_key) || (_cred === null || _cred === void 0 ? void 0 : _cred.client_token) || (_cred === null || _cred === void 0 ? void 0 : _cred.tokenization_key);
                  braintreeSetupPromise = paymentGateway.init(_publishableKey, undefined, params.data).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                    return _regeneratorRuntime.wrap(function (_context9) {
                      while (1) switch (_context9.prev = _context9.next) {
                        case 0:
                          if (!(paymentGateway && typeof paymentGateway.getCvvHostedFieldInstance === "function")) {
                            _context9.next = 2;
                            break;
                          }
                          _context9.next = 1;
                          return paymentGateway.getCvvHostedFieldInstance("braintree-cvc-container", "CVV");
                        case 1:
                          braintreeHostedFieldsInstance = _context9.sent;
                        case 2:
                        case "end":
                          return _context9.stop();
                      }
                    }, _callee);
                  }))).catch(reportInitializationFailure);
                }
                escListener = function escListener(e) {
                  if (e.key === "Escape") {
                    _this._modalCloseSource = "customer";
                    _this.handleClose({
                      closedBy: "escape-key",
                      params: params
                    });
                  }
                };
                trapFocus = function trapFocus(e) {
                  if (!_this.modal) return;
                  var focusables = _this.modal.querySelectorAll('input,button,[tabindex]:not([tabindex="-1"])');
                  if (!focusables.length) return;
                  var first = focusables[0];
                  var last = focusables[focusables.length - 1];
                  if (e.key === "Tab") {
                    if (e.shiftKey) {
                      if (document.activeElement === first) {
                        last.focus();
                        e.preventDefault();
                      }
                    } else {
                      if (document.activeElement === last) {
                        first.focus();
                        e.preventDefault();
                      }
                    }
                  }
                };
                handleSubmit = /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(event) {
                    var _this$backdrop3, _input$value;
                    var _this$backdrop2, mountEl, _submitBtn, logPayload, state, _logPayload, payload, result, _logPayload2, _logPayload3, input, _logPayload4, value, _logPayload5, _t, _t2;
                    return _regeneratorRuntime.wrap(function (_context0) {
                      while (1) switch (_context0.prev = _context0.next) {
                        case 0:
                          event.preventDefault();
                          if (!initializationError) {
                            _context0.next = 1;
                            break;
                          }
                          _this.showLoader(false, undefined, lang);
                          _this.setError(initializationError, lang);
                          return _context0.abrupt("return");
                        case 1:
                          _this.setError("", lang);
                          _this.showLoader(true, undefined, lang);
                          if (!useStripe) {
                            _context0.next = 8;
                            break;
                          }
                          if (!stripeSetupPromise) {
                            _context0.next = 2;
                            break;
                          }
                          _context0.next = 2;
                          return stripeSetupPromise;
                        case 2:
                          if (!initializationError) {
                            _context0.next = 3;
                            break;
                          }
                          _this.showLoader(false, undefined, lang);
                          _this.setError(initializationError, lang);
                          return _context0.abrupt("return");
                        case 3:
                          // Defensive: retry to mount if not yet mounted
                          if (_this.stripeCardCvcElement && !cvcElementMounted) {
                            mountEl = (_this$backdrop2 = _this.backdrop) === null || _this$backdrop2 === void 0 ? void 0 : _this$backdrop2.querySelector("#stripe-cvc-container");
                            if (mountEl) {
                              _this.stripeCardCvcElement.mount(mountEl);
                              cvcElementMounted = true;
                            }
                          }
                          _context0.prev = 4;
                          _context0.next = 5;
                          return _this.handleResolve("stripe", _this.stripeClientSecret, _this.selectedCardId, params);
                        case 5:
                          _context0.next = 7;
                          break;
                        case 6:
                          _context0.prev = 6;
                          _t = _context0["catch"](4);
                          _this.showLoader(false, undefined, lang);
                          _this.setError(thrownMessage(_t) || getCVVModalTranslation("cvvInvalidFormat", lang), lang);
                          // Enable retry for Stripe: re-enable button in addition to setError logic
                          if (_this.modal) {
                            _submitBtn = _this.modal.querySelector(".pg-cvv-modal-submit");
                            if (_submitBtn) {
                              _submitBtn.style.display = "";
                              _submitBtn.removeAttribute("disabled");
                            }
                          }
                          if (params && typeof params.updateLog === "function") {
                            logPayload = {
                              type: "error",
                              event_name: "cvv_submit_error_stripe",
                              provider: "stripe",
                              error: thrownMessage(_t) || String(_t),
                              step: "handleSubmit-stripe",
                              message: thrownMessage(_t) || String(_t),
                              payment_id: _this._paymentId || ""
                            };
                            params.updateLog(filterUpdateLogData(logPayload));
                          }
                        case 7:
                          return _context0.abrupt("return");
                        case 8:
                          if (!(useBraintree && braintreeSetupPromise)) {
                            _context0.next = 10;
                            break;
                          }
                          _context0.next = 9;
                          return braintreeSetupPromise;
                        case 9:
                          if (!initializationError) {
                            _context0.next = 10;
                            break;
                          }
                          _this.showLoader(false, undefined, lang);
                          _this.setError(initializationError, lang);
                          return _context0.abrupt("return");
                        case 10:
                          if (!(providerName === "braintree" && braintreeHostedFieldsInstance)) {
                            _context0.next = 19;
                            break;
                          }
                          _context0.prev = 11;
                          state = braintreeHostedFieldsInstance.getState();
                          if (state.fields.cvv.isValid) {
                            _context0.next = 12;
                            break;
                          }
                          _this.showLoader(false, undefined, lang);
                          _this.setError(getCVVModalTranslation("cvvInputIncomplete", lang), lang);
                          if (params && typeof params.updateLog === "function") {
                            _logPayload = {
                              type: "error",
                              event_name: "cvv_submit_error_braintree",
                              provider: "braintree",
                              error: getCVVModalTranslation("cvvInputIncomplete", lang),
                              step: "handleSubmit-braintree-validation",
                              message: getCVVModalTranslation("cvvInputIncomplete", lang),
                              payment_id: _this._paymentId || ""
                            };
                            params.updateLog(filterUpdateLogData(_logPayload));
                          }
                          return _context0.abrupt("return");
                        case 12:
                          _context0.next = 13;
                          return braintreeHostedFieldsInstance.focus("cvv");
                        case 13:
                          _context0.next = 14;
                          return braintreeHostedFieldsInstance.tokenize({
                            fieldsToTokenize: ["cvv"]
                          });
                        case 14:
                          payload = _context0.sent;
                          _this.setError("", lang);
                          _context0.next = 15;
                          return params.chargeCardAuthorize(_objectSpread$1(_objectSpread$1({
                            payment_method_token: payload.nonce
                          }, params.data), {}, {
                            payment_id: _this._paymentId || ""
                          }));
                        case 15:
                          result = _context0.sent;
                          if (!(result && typeof result.code === "number" && result.code >= 400)) {
                            _context0.next = 16;
                            break;
                          }
                          if (params && typeof params.updateLog === "function") {
                            _logPayload2 = {
                              type: "error",
                              event_name: "cvv_submit_error_braintree_authorize",
                              provider: "braintree",
                              error: result.message || "Payment failed with error code " + result.code,
                              code: result.code,
                              step: "handleSubmit-braintree-charge",
                              message: result.message || "Payment failed with error code " + result.code,
                              payment_id: _this._paymentId || ""
                            };
                            params.updateLog(filterUpdateLogData(_logPayload2));
                          }
                          throw new Error(result.message || "Payment failed with error code " + result.code);
                        case 16:
                          _this.close();
                          if (_this._onResult) {
                            _this._onResult(_objectSpread$1(_objectSpread$1({}, result), {}, {
                              status: "success",
                              closed_by: "system"
                            }));
                          }
                          if (_this.resolveFn) _this.resolveFn("braintree");
                          _this.resolveFn = undefined;
                          _this.rejectFn = undefined;
                          _context0.next = 18;
                          break;
                        case 17:
                          _context0.prev = 17;
                          _t2 = _context0["catch"](11);
                          _this.showLoader(false, undefined, lang);
                          // Show localized Invalid CVV (invalidCvv) on modal, but log real error from Braintree
                          _this.setError(getCVVModalTranslation("invalidCvv", lang), lang);
                          if (params && typeof params.updateLog === "function") {
                            _logPayload3 = {
                              type: "error",
                              event_name: "cvv_submit_error_braintree",
                              provider: "braintree",
                              // For log, use the actual error message from Braintree (rather than localized)
                              error: thrownMessage(_t2) || String(_t2),
                              step: "handleSubmit-braintree-catch",
                              // For message in log, also use actual error from Braintree
                              message: thrownMessage(_t2) || String(_t2),
                              payment_id: _this._paymentId || ""
                            };
                            params.updateLog(filterUpdateLogData(_logPayload3));
                          }
                          console.log(_t2);
                          return _context0.abrupt("return");
                        case 18:
                          return _context0.abrupt("return");
                        case 19:
                          input = (_this$backdrop3 = _this.backdrop) === null || _this$backdrop3 === void 0 ? void 0 : _this$backdrop3.querySelector("#".concat(_this.inputId));
                          if (input) {
                            _context0.next = 20;
                            break;
                          }
                          _this.showLoader(false, undefined, lang);
                          _this.setError(getCVVModalTranslation("cvvRequired", lang), lang);
                          if (params && typeof params.updateLog === "function") {
                            _logPayload4 = {
                              type: "error",
                              event_name: "cvv_submit_error",
                              provider: providerName || "unknown",
                              error: getCVVModalTranslation("cvvRequired", lang),
                              step: "handleSubmit-no-input",
                              message: getCVVModalTranslation("cvvRequired", lang),
                              payment_id: _this._paymentId || ""
                            };
                            params.updateLog(filterUpdateLogData(_logPayload4));
                          }
                          return _context0.abrupt("return");
                        case 20:
                          value = (_input$value = input.value) === null || _input$value === void 0 ? void 0 : _trimInstanceProperty(_input$value).call(_input$value);
                          if (!(!value || !/^\d{3,4}$/.test(value))) {
                            _context0.next = 21;
                            break;
                          }
                          _this.showLoader(false, undefined, lang);
                          _this.setError(getCVVModalTranslation("cvvInvalidFormat", lang), lang);
                          input.focus();
                          if (params && typeof params.updateLog === "function") {
                            _logPayload5 = {
                              type: "error",
                              event_name: "cvv_submit_error",
                              provider: providerName || "unknown",
                              error: getCVVModalTranslation("cvvInvalidFormat", lang),
                              step: "handleSubmit-invalid-cvv-format",
                              message: getCVVModalTranslation("cvvInvalidFormat", lang),
                              payment_id: _this._paymentId || ""
                            };
                            params.updateLog(filterUpdateLogData(_logPayload5));
                          }
                          return _context0.abrupt("return");
                        case 21:
                          _this.setError("", lang);
                          _context0.next = 22;
                          return _this.handleResolve(value, undefined, undefined, params);
                        case 22:
                        case "end":
                          return _context0.stop();
                      }
                    }, _callee2, null, [[4, 6], [11, 17]]);
                  }));
                  return function handleSubmit(_x) {
                    return _ref3.apply(this, arguments);
                  };
                }();
                if (closeBtn) closeBtn.onclick = function () {
                  _this._modalCloseSource = "customer";
                  _this.handleClose({
                    closedBy: "user-close-main",
                    params: params
                  });
                };
                if (submitBtn) submitBtn.onclick = function (e) {
                  return handleSubmit(e);
                };
                _this.backdrop.onclick = function (e) {
                  if (e.target === _this.backdrop) {
                    _this._modalCloseSource = "customer";
                    _this.handleClose({
                      closedBy: "backdrop-click",
                      params: params
                    });
                  }
                };
                modal.addEventListener("keydown", trapFocus);
                document.addEventListener("keydown", escListener);
                modal._escListener = escListener;
                modal._trapFocus = trapFocus;
                if (useStripe) {
                  el = modal.querySelector("#stripe-cvc-container");
                  if (el) _setTimeout(function () {
                    if (el) el.focus();
                  }, 30);
                } else if (useBraintree) {
                  _el = _this.backdrop.querySelector("#braintree-cvc-container");
                  if (_el) _setTimeout(function () {
                    return _el.focus();
                  }, 30);
                } else {
                  input = _this.backdrop.querySelector("#".concat(_this.inputId));
                  if (input) _setTimeout(function () {
                    return input.focus();
                  }, 30);
                }
              case 8:
              case "end":
                return _context1.stop();
            }
          }, _callee3, null, [[1, 4]]);
        }))();
      });
    }
  }, {
    key: "handleResolve",
    value: function () {
      var _handleResolve = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(value, clientSecret, selectedCardId, params) {
        var _this2 = this;
        var lang, _ref4, _ref5, result, _this$modal, _this$modal2, _submitBtn2, closeBtn, submitBtn, paymentIntent, intent, _this$modal3, _this$modal4, _submitBtn3, _closeBtn, _submitBtn4, _t4;
        return _regeneratorRuntime.wrap(function (_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              lang = this._language || "en"; // DO NOT unmount first, instead, only after the resolve operation
              if (!(value === "stripe" && this.stripeCardCvcElement && this.paymentGateway)) {
                _context10.next = 6;
                break;
              }
              _context10.prev = 1;
              _context10.next = 2;
              return this.paymentGateway.confirmCardPaymentWithCVC({
                clientSecret: (_ref4 = clientSecret !== null && clientSecret !== void 0 ? clientSecret : this.stripeClientSecret) !== null && _ref4 !== void 0 ? _ref4 : "",
                selectedCardId: (_ref5 = selectedCardId !== null && selectedCardId !== void 0 ? selectedCardId : this.selectedCardId) !== null && _ref5 !== void 0 ? _ref5 : "",
                cvcElement: this.stripeCardCvcElement
              });
            case 2:
              result = _context10.sent;
              if (!(result !== null && result !== void 0 && result.error)) {
                _context10.next = 3;
                break;
              }
              this.showLoader(false, undefined, lang);
              this.setError(thrownMessage(result.error) || getCVVModalTranslation("cvvInvalidFormat", lang), lang);
              // Do not unmount, keep the input so the user can retry without losing the element
              // FIX: Enable submit button for retry
              if (this.modal) {
                _submitBtn2 = this.modal.querySelector(".pg-cvv-modal-submit");
                if (_submitBtn2) {
                  _submitBtn2.style.display = "";
                  _submitBtn2.removeAttribute("disabled");
                }
              }
              closeBtn = (_this$modal = this.modal) === null || _this$modal === void 0 ? void 0 : _this$modal.querySelector(".pg-cvv-modal-close");
              submitBtn = (_this$modal2 = this.modal) === null || _this$modal2 === void 0 ? void 0 : _this$modal2.querySelector(".pg-cvv-modal-submit");
              if (closeBtn) closeBtn.onclick = function () {
                _this2._modalCloseSource = "customer";
                _this2.handleClose({
                  closedBy: "stripe-submit-fail",
                  params: params
                });
              };
              if (submitBtn) submitBtn.onclick = function () {
                return _this2.handleResolve("stripe", clientSecret, selectedCardId, params);
              };
              return _context10.abrupt("return");
            case 3:
              if (this._onResult) {
                paymentIntent = result.paymentIntent;
                intent = paymentIntent && _typeof(paymentIntent) === "object" ? paymentIntent : {};
                this._onResult(_objectSpread$1(_objectSpread$1({}, intent), {}, {
                  status: "success",
                  closed_by: "system"
                }));
              }
              _context10.next = 5;
              break;
            case 4:
              _context10.prev = 4;
              _t4 = _context10["catch"](1);
              this.showLoader(false, undefined, lang);
              this.setError(thrownMessage(_t4) || getCVVModalTranslation("cvvInvalidFormat", lang), lang);
              // Do not unmount, keep input for retry
              // FIX: Enable submit button for retry
              if (this.modal) {
                _submitBtn3 = this.modal.querySelector(".pg-cvv-modal-submit");
                if (_submitBtn3) {
                  _submitBtn3.style.display = "";
                  _submitBtn3.removeAttribute("disabled");
                }
              }
              _closeBtn = (_this$modal3 = this.modal) === null || _this$modal3 === void 0 ? void 0 : _this$modal3.querySelector(".pg-cvv-modal-close");
              _submitBtn4 = (_this$modal4 = this.modal) === null || _this$modal4 === void 0 ? void 0 : _this$modal4.querySelector(".pg-cvv-modal-submit");
              if (_closeBtn) _closeBtn.onclick = function () {
                _this2._modalCloseSource = "customer";
                _this2.handleClose({
                  closedBy: "stripe-submit-catch",
                  params: params
                });
              };
              if (_submitBtn4) _submitBtn4.onclick = function () {
                return _this2.handleResolve("stripe", clientSecret, selectedCardId, params);
              };
              return _context10.abrupt("return");
            case 5:
              // Safe to unmount only after successful payment or explicit close
              if (this.stripeCardCvcElement && !this.stripeUnmountedCvc) {
                try {
                  this.stripeCardCvcElement.unmount();
                } catch (_unused3) {
                  // The CVC element may already be unmounted. Closing the modal still continues.
                }
                this.stripeUnmountedCvc = true;
              }
              this.stripeCardCvcElement = undefined;
              _context10.next = 7;
              break;
            case 6:
              if (this.stripeCardCvcElement && !this.stripeUnmountedCvc) {
                // Unmount if for some reason we're closing and element is still there, but not a Stripe payment.
                try {
                  this.stripeCardCvcElement.unmount();
                } catch (_unused4) {
                  // The CVC element may already be unmounted. Closing the modal still continues.
                }
                this.stripeUnmountedCvc = true;
                this.stripeCardCvcElement = undefined;
              }
            case 7:
              this.close();
              if (value !== "stripe" && this._onResult) {
                this._onResult(_objectSpread$1(_objectSpread$1({}, _typeof(value) === "object" && value !== null ? value : {}), {}, {
                  status: "success",
                  closed_by: "system"
                }));
              }
              if (this.resolveFn) this.resolveFn(value === "stripe" ? "stripe" : value);
              this.resolveFn = undefined;
              this.rejectFn = undefined;
            case 8:
            case "end":
              return _context10.stop();
          }
        }, _callee4, this, [[1, 4]]);
      }));
      function handleResolve(_x2, _x3, _x4, _x5) {
        return _handleResolve.apply(this, arguments);
      }
      return handleResolve;
    }()
  }, {
    key: "handleClose",
    value: function handleClose(args) {
      if (this.stripeCardCvcElement && !this.stripeUnmountedCvc) {
        try {
          this.stripeCardCvcElement.unmount();
        } catch (_unused5) {
          // The CVC element may already be unmounted. Closing the modal still continues.
        }
        this.stripeUnmountedCvc = true;
        this.stripeCardCvcElement = undefined;
      }
      // Determine source if not already set
      var closedByUser = false;
      if (args && args.closedBy) {
        // Consider these as customer actions
        if (args.closedBy === "user-close-initial" || args.closedBy === "user-close-main" || args.closedBy === "user-close-showInput-false" || args.closedBy === "escape-key" || args.closedBy === "backdrop-click") {
          this._modalCloseSource = "customer";
          closedByUser = true;
        } else {
          // Other internal/system closes
          this._modalCloseSource = "system";
        }
      } else {
        this._modalCloseSource = "unknown";
      }
      this.close();
      if (this._onResult) {
        var lang = this._language || "en";
        var customMessage = args && args.message ? args.message : args && args.closedBy === "escape-key" ? getCVVModalTranslation("modalClosedByCustomer", lang) : args && args.closedBy === "backdrop-click" ? getCVVModalTranslation("modalClosedByCustomer", lang) : closedByUser ? getCVVModalTranslation("modalClosedByCustomer", lang) : getCVVModalTranslation("modalClosedBySystem", lang);
        var statusString = this._modalCloseSource === "customer" ? "canceled" : "failed";
        this._onResult({
          status: statusString,
          data: null,
          error: args && args.error ? args.error : null,
          message: customMessage,
          closed_by: this._modalCloseSource
        });
      }
      if (this.resolveFn) this.resolveFn(null);
      this.resolveFn = undefined;
      this.rejectFn = undefined;
    }
  }, {
    key: "close",
    value: function close() {
      if (this.modal) {
        var modalWithHandlers = this.modal;
        var escListener = modalWithHandlers._escListener;
        var trapFocus = modalWithHandlers._trapFocus;
        if (escListener) document.removeEventListener("keydown", escListener);
        if (trapFocus) this.modal.removeEventListener("keydown", trapFocus);
      }
      if (this.backdrop && this.backdrop.parentNode) {
        this.backdrop.parentNode.removeChild(this.backdrop);
      }
      this.backdrop = undefined;
      this.modal = undefined;
      this.stripeCardCvcElement = undefined;
      this.stripeUnmountedCvc = undefined;
      this.paymentGateway = undefined;
      this.stripeClientSecret = undefined;
      this.selectedCardId = undefined;
      this._paymentId = undefined;
      this._modalCloseSource = undefined;
      this._language = "en";
    }
  }]);
}();

var _excluded = ["appearance", "fonts"];
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof _Symbol && _getIteratorMethod(r) || r["@@iterator"]; if (!t) { if (_Array$isArray(r) || (t = _unsupportedIterableToArray(r)) || e) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: true } : { done: false, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = true, u = false; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = true, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { var _context118; if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = _sliceInstanceProperty(_context118 = {}.toString.call(r)).call(_context118, 8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? _Array$from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context116, _context117; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context116 = ownKeys(Object(t), true)).call(_context116, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context117 = ownKeys(Object(t))).call(_context117, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var nmiEventEmitter = new EventEmitter();
var flywireEventEmitter = new EventEmitter();
var walletEventEmitter = new EventEmitter();
var mc = "Mastercard";
var visa = "Visa";
var amex = "American Express";
var diners = "Diners Club / Carte Blanche";
var dinersint = "Diners Club / International";
var dinersClub = "Diners Club";
var discover = "Discover";
var jcb = "JCB";
var unionpay = "UnionPay";
var maestro = "Maestro";
var CCTypeCodes = {
  Visa: "VI",
  Mastercard: "mc",
  Discover: "DS",
  "American Express": "AX"
};
var cardImages = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, mc, img$5), visa, img$7), amex, img$4), diners, img$3), dinersint, img$3), discover, img$2), jcb, img$1), unionpay, img$6), maestro, img), dinersClub, img$3);
function debug(message) {
  console.log("DEBUG: ", message);
}
var paymentMessageClass = "pg-payment-message";
var saveCardMessageClass = "pg-save-card-message";
/**
 * User-facing message shown when the payment is flagged as fraud suspected (Stripe/Braintree).
 * Used when: processor declines for fraud, riskData flags review/escalate/decline,
 * gateway rejects for fraud, post-auth rules decline, or Stripe charge outcome indicates blocked/manual_review.
 * Replaces the success message so the customer knows the transaction was not approved.
 */
var FRAUD_SUSPECTED_MESSAGE = "Credit card issuer declined the transaction.";
/** Event name logged when fraud is suspected, for analytics/auditing. */
var AUTHORIZATION_FRAUD_SUSPECTED_EVENT = "authorization_fraud_suspected";
var CARD_HOLDER_INPUT_ID = "ip_pg_card_holder";
var CARD_HOLDER_STYLE_ID = "pg-stripe-name-field-styles";
var BRAINTREE_HOSTED_FIELDS_STYLE_ID = "pg-braintree-checkout-styles";
var BRAINTREE_HOSTED_FIELD_CLASS = "pg-bt-hosted-field";
function getBrowserStripeTheme() {
  var _window$matchMedia, _window;
  if (typeof window !== "undefined" && (_window$matchMedia = (_window = window).matchMedia) !== null && _window$matchMedia !== void 0 && _window$matchMedia.call(_window, "(prefers-color-scheme: dark)").matches) {
    return "night";
  }
  return "stripe";
}
function translationFor(languageCode) {
  if (typeof languageCode === "string" || typeof languageCode === "number" || typeof languageCode === "boolean" || typeof languageCode === "bigint" || _typeof(languageCode) === "symbol" || typeof languageCode === "function" || _typeof(languageCode) === "object" && languageCode !== null) {
    return TRANSLATIONS[String(languageCode)];
  }
  return undefined;
}
function baseLanguageOf(languageCode) {
  if (_typeof(languageCode) === "object" && languageCode !== null && "split" in languageCode && typeof languageCode.split === "function") {
    var parts = languageCode.split("-");
    if (_Array$isArray(parts)) {
      return String(parts[0]);
    }
  }
  throw new TypeError("languageCode.split is not a function");
}
function languageCodeOf(body) {
  var metadata = body.metadata;
  if (_typeof(metadata) === "object" && metadata !== null || typeof metadata === "function") {
    if ("language_code" in metadata) {
      return metadata.language_code;
    }
  }
  return undefined;
}
function elementContains(parent, node) {
  var current = node;
  while (current) {
    if (current === parent) {
      return true;
    }
    current = current.parentElement || current.parentNode;
  }
  return false;
}
function messageClassName(container) {
  var names = (container.className || "").split(/\s+/);
  if (_indexOfInstanceProperty(names).call(names, paymentMessageClass) >= 0) {
    return paymentMessageClass;
  }
  if (_indexOfInstanceProperty(names).call(names, saveCardMessageClass) >= 0) {
    return saveCardMessageClass;
  }
  return undefined;
}
function messageForLanguage(languageCode, key) {
  var _translationFor, _translationFor2;
  if (typeof languageCode === "string" || languageCode == null || !languageCode) {
    return getTranslation(typeof languageCode === "string" ? languageCode : undefined, key);
  }
  var exact = (_translationFor = translationFor(languageCode)) === null || _translationFor === void 0 ? void 0 : _translationFor[key];
  if (exact) {
    return exact;
  }
  var base = (_translationFor2 = translationFor(baseLanguageOf(languageCode))) === null || _translationFor2 === void 0 ? void 0 : _translationFor2[key];
  if (base) {
    return base;
  }
  return getTranslation("en", key);
}
function isBraintreePaymentError(value) {
  return "error" in value;
}
function hostedFieldsErrorCode(error) {
  if (_typeof(error) === "object" && error !== null && "code" in error && typeof error.code === "string") {
    return error.code;
  }
  return undefined;
}
function hostedFieldsFailureMessage(error, fields) {
  return messageForBraintreeTokenizeError(error, fields);
}
function messageFromCaught(error) {
  if (_typeof(error) === "object" && error !== null && "message" in error && typeof error.message === "string") {
    return error.message;
  }
  return undefined;
}
function caughtMessage(error) {
  if (_typeof(error) === "object" && error !== null || typeof error === "function") {
    if ("message" in error) {
      return error.message;
    }
  }
  return undefined;
}
function ensureCardHolderNameStyles() {
  var _context, _context2;
  if (typeof document === "undefined" || document.getElementById(CARD_HOLDER_STYLE_ID)) {
    return;
  }
  var style = document.createElement("style");
  style.id = CARD_HOLDER_STYLE_ID;
  style.textContent = _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "\n#".concat(CARD_HOLDER_INPUT_ID, ".pg-stripe-name-input {\n  background-color: var(--pg-name-bg) !important;\n  color: var(--pg-name-text) !important;\n  border: 1px solid var(--pg-name-border) !important;\n  border-radius: var(--pg-name-radius, 6px) !important;\n  box-shadow: none !important;\n}\n#")).call(_context2, CARD_HOLDER_INPUT_ID, ".pg-stripe-name-input::placeholder {\n  color: var(--pg-name-placeholder) !important;\n}\n#")).call(_context, CARD_HOLDER_INPUT_ID, ".pg-stripe-name-input:focus {\n  border-color: var(--pg-name-primary) !important;\n  box-shadow: 0 0 0 1px var(--pg-name-primary) !important;\n  outline: none !important;\n}\nlabel.pg-stripe-name-label {\n  color: var(--pg-name-label) !important;\n}\n");
  document.head.appendChild(style);
}
function ensureBraintreeHostedFieldStyles() {
  if (typeof document === "undefined" || document.getElementById(BRAINTREE_HOSTED_FIELDS_STYLE_ID)) {
    return;
  }
  var style = document.createElement("style");
  style.id = BRAINTREE_HOSTED_FIELDS_STYLE_ID;
  style.textContent = "\n.pg-bt-hosted-fields {\n  text-align: left;\n}\n.pg-bt-section-label {\n  margin: 0 0 0.75rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--pg-bt-label, #667085);\n}\n.pg-bt-hosted-fields .form-label {\n  margin-bottom: 0.35rem;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--pg-bt-label, #344054);\n}\n.pg-bt-hosted-field.form-control {\n  height: 42px;\n  padding: 0 12px;\n  overflow: hidden;\n  border: 1px solid var(--pg-bt-border, #d0d5dd);\n  border-radius: var(--pg-bt-radius, 8px);\n  background: var(--pg-bt-bg, #fff);\n  box-shadow: none;\n}\n.pg-bt-hosted-field.form-control.braintree-hosted-fields-focused {\n  border-color: var(--pg-bt-primary, #0570de);\n  box-shadow: 0 0 0 1px var(--pg-bt-primary, #0570de);\n}\n.pg-bt-hosted-fields-row {\n  display: flex;\n  gap: 0.75rem;\n}\n.pg-bt-hosted-fields-row > div {\n  flex: 1;\n  min-width: 0;\n}\n.pg-bt-hosted-fields .mb-3 {\n  margin-bottom: 0.85rem !important;\n}\n.pg-bt-wallets {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-top: 0.35rem;\n  text-align: left;\n}\n.pg-bt-wallets-divider {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  color: var(--pg-bt-label, #667085);\n  font-size: 0.75rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n.pg-bt-wallets-divider::before,\n.pg-bt-wallets-divider::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  background: var(--pg-bt-line, #e4e7ec);\n}\n.pg-bt-wallets-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.75rem;\n}\n.pg-bt-wallet-google,\n.pg-bt-wallet-venmo,\n.pg-bt-wallet-apple {\n  min-width: 0;\n}\n.pg-bt-wallet-google,\n.pg-bt-wallet-apple {\n  border-radius: var(--pg-bt-radius, 8px);\n  box-shadow: 0 0 0 1px var(--pg-bt-border, #212529);\n}\n.pg-bt-wallet-google {\n  height: 44px;\n}\n.pg-bt-wallet-google button,\n.pg-bt-wallet-google > div {\n  width: 100% !important;\n  height: 44px !important;\n}\n.pg-bt-wallet-button {\n  height: 44px;\n  width: 100%;\n  border-radius: 8px;\n}\nbutton.pg-bt-venmo-button {\n  appearance: none;\n  -webkit-appearance: none;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  border-radius: var(--pg-bt-radius, 8px);\n  box-shadow: 0 0 0 1px var(--pg-bt-border, #212529);\n  background-color: var(--pg-bt-bg, #fff);\n  color: var(--pg-bt-text, #212529);\n  font-weight: 600;\n  cursor: pointer;\n}\n.pg-bt-apple-pay-button {\n  display: block;\n  box-sizing: border-box;\n  width: 100%;\n  height: 44px;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n  -webkit-appearance: -apple-pay-button;\n  -apple-pay-button-type: plain;\n  -apple-pay-button-style: white;\n  appearance: -apple-pay-button;\n}\n.pg-bt-apple-pay-button.pg-bt-apple-pay-dark {\n  -apple-pay-button-style: black;\n}\n.pg-bt-wallets-grid .pg-bt-wallet-apple,\n.pg-bt-wallets-grid .pg-bt-wallet:only-child {\n  grid-column: 1 / -1;\n}\n.pg-bt-wallet-error {\n  margin: 0;\n  padding: 10px 12px;\n  border: 1px solid #f1c1c6;\n  border-radius: 8px;\n  background: #fff5f5;\n  color: #8a2430;\n  font-size: 0.8125rem;\n  line-height: 1.4;\n}\n#payment-element + #submit.pg-bt-pay-button,\n#payment-element + #submit.pg-bt-pay-button:hover,\n#payment-element + #submit.pg-bt-pay-button:focus {\n  display: block;\n  width: 100%;\n  height: 44px;\n  margin: 1rem 0 0.25rem !important;\n  border: 0;\n  border-radius: var(--pg-bt-radius, 8px);\n  background-color: var(--pg-bt-primary, #0570de) !important;\n  color: var(--pg-bt-on-primary, #fff) !important;\n  font-weight: 600;\n}\n.pg-bt-hosted-field.form-control.pg-bt-loading {\n  background: linear-gradient(\n    90deg,\n    var(--pg-bt-bg, #fff) 0%,\n    var(--pg-bt-line, #e4e7ec) 50%,\n    var(--pg-bt-bg, #fff) 100%\n  );\n  background-size: 200% 100%;\n  animation: pg-bt-shimmer 1.2s ease-in-out infinite;\n}\n.pg-bt-wallets.pg-bt-wallets-loading {\n  position: relative;\n  min-height: 8.5rem;\n}\n.pg-bt-wallet-skeletons {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n.pg-bt-wallets.pg-bt-wallets-loading .pg-bt-wallet-skeletons {\n  position: absolute;\n  z-index: 2;\n  inset: 0;\n  justify-content: center;\n  background: var(--pg-bt-bg, #fff);\n}\n.pg-bt-wallet-skeleton {\n  height: 44px;\n  border-radius: var(--pg-bt-radius, 8px);\n  background: linear-gradient(\n    90deg,\n    var(--pg-bt-line, #e4e7ec) 0%,\n    var(--pg-bt-bg, #fff) 50%,\n    var(--pg-bt-line, #e4e7ec) 100%\n  );\n  background-size: 200% 100%;\n  animation: pg-bt-shimmer 1.2s ease-in-out infinite;\n}\n@keyframes pg-bt-shimmer {\n  from {\n    background-position: 100% 0;\n  }\n  to {\n    background-position: -100% 0;\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .pg-bt-hosted-field.form-control.pg-bt-loading,\n  .pg-bt-wallet-skeleton {\n    animation: none;\n    background: var(--pg-bt-line, #e4e7ec);\n  }\n}\n";
  document.head.appendChild(style);
}
function hostedFieldSlot(id, fieldClass, labelText) {
  var _context3;
  var wrap = document.createElement("div");
  wrap.className = "mb-3";
  var label = document.createElement("label");
  label.className = "form-label";
  label.htmlFor = id;
  label.textContent = labelText;
  var field = document.createElement("div");
  field.id = id;
  field.className = _concatInstanceProperty(_context3 = "form-control form-control-sm ".concat(BRAINTREE_HOSTED_FIELD_CLASS, " ")).call(_context3, fieldClass, " pg-bt-loading");
  wrap.append(label, field);
  return wrap;
}
function clearHostedFieldLoading(root) {
  var _context4;
  root.removeAttribute("aria-busy");
  _forEachInstanceProperty(_context4 = root.querySelectorAll(".pg-bt-loading")).call(_context4, function (node) {
    node.classList.remove("pg-bt-loading");
  });
}
var PAYMENT_LOADER_STYLE_ID = "pg-payment-loader-style";
var PAYMENT_LOADER_CLASS = "pg-payment-loader";
function ensurePaymentFormLoaderStyles() {
  if (typeof document === "undefined" || document.getElementById(PAYMENT_LOADER_STYLE_ID)) {
    return;
  }
  var style = document.createElement("style");
  style.id = PAYMENT_LOADER_STYLE_ID;
  style.textContent = "\n.pg-payment-loading {\n  position: relative;\n  min-height: 180px;\n}\n.pg-payment-loader {\n  position: absolute;\n  inset: 0;\n  z-index: 3;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0.85rem;\n  padding: 0.25rem;\n  color: inherit;\n  background: var(--card-bg, var(--pg-bt-bg, #fff));\n}\n.pg-payment-skeleton {\n  border-radius: var(--pg-bt-radius, 8px);\n  background: linear-gradient(\n    90deg,\n    var(--pg-bt-line, #e4e7ec) 0%,\n    var(--pg-bt-bg, #fff) 50%,\n    var(--pg-bt-line, #e4e7ec) 100%\n  );\n  background-size: 200% 100%;\n  animation: pg-payment-shimmer 1.2s ease-in-out infinite;\n}\n.pg-payment-skeleton-label {\n  height: 12px;\n  width: 40%;\n}\n.pg-payment-skeleton-field {\n  height: 42px;\n  width: 100%;\n}\n.pg-payment-skeleton-row {\n  display: flex;\n  gap: 0.75rem;\n}\n.pg-payment-skeleton-row .pg-payment-skeleton-field {\n  flex: 1;\n}\n.pg-payment-skeleton-button {\n  height: 44px;\n  width: 100%;\n  margin-top: 0.35rem;\n}\n@keyframes pg-payment-shimmer {\n  from {\n    background-position: 100% 0;\n  }\n  to {\n    background-position: -100% 0;\n  }\n}\n@media (prefers-reduced-motion: reduce) {\n  .pg-payment-skeleton {\n    animation: none;\n    background: var(--pg-bt-line, #e4e7ec);\n  }\n}\n";
  document.head.appendChild(style);
}
function showPaymentFormLoader(container) {
  if (!(container instanceof HTMLElement)) {
    return;
  }
  ensurePaymentFormLoaderStyles();
  container.classList.add("pg-payment-loading");
  container.setAttribute("aria-busy", "true");
  if (container.querySelector(":scope > .".concat(PAYMENT_LOADER_CLASS))) {
    return;
  }
  var loader = document.createElement("div");
  loader.className = PAYMENT_LOADER_CLASS;
  loader.setAttribute("role", "status");
  loader.setAttribute("aria-label", "Loading payment");
  var skeleton = function skeleton(extraClass) {
    var node = document.createElement("div");
    node.className = "pg-payment-skeleton ".concat(extraClass);
    return node;
  };
  var row = document.createElement("div");
  row.className = "pg-payment-skeleton-row";
  row.append(skeleton("pg-payment-skeleton-field"), skeleton("pg-payment-skeleton-field"));
  loader.append(skeleton("pg-payment-skeleton-label"), skeleton("pg-payment-skeleton-field"), row, skeleton("pg-payment-skeleton-button"));
  container.appendChild(loader);
}
function hidePaymentFormLoader(container) {
  var _context5;
  if (!(container instanceof HTMLElement)) {
    return;
  }
  container.classList.remove("pg-payment-loading");
  container.removeAttribute("aria-busy");
  _forEachInstanceProperty(_context5 = container.querySelectorAll(":scope > .".concat(PAYMENT_LOADER_CLASS))).call(_context5, function (node) {
    return node.remove();
  });
}
// Delay used when switching to a secondary provider after a primary failure.
// Kept short so the "Switching Provider" screen does not add noticeable latency.
var PROVIDER_SWITCH_DELAY_MS = 800;
// Static hosts contacted while mounting Braintree card fields and wallet buttons.
// Preconnecting warms DNS/TLS in parallel with the payment-intent round-trip.
var BRAINTREE_PRECONNECT_HOSTS = ["https://api.braintreegateway.com", "https://assets.braintreegateway.com", "https://client-analytics.braintreegateway.com", "https://pay.google.com", "https://www.paypal.com", "https://www.paypalobjects.com"];
function canInjectPreconnect() {
  return typeof document !== "undefined" && typeof document.createElement === "function" && !!document.head;
}
function injectPreconnect(href) {
  for (var _i = 0, _arr = ["preconnect", "dns-prefetch"]; _i < _arr.length; _i++) {
    var _context6;
    var rel = _arr[_i];
    if (document.querySelector(_concatInstanceProperty(_context6 = "link[rel=\"".concat(rel, "\"][href=\"")).call(_context6, href, "\"]"))) {
      continue;
    }
    var link = document.createElement("link");
    link.rel = rel;
    link.href = href;
    if (rel === "preconnect") {
      link.crossOrigin = "anonymous";
    }
    document.head.appendChild(link);
  }
}
var braintreePreconnectInjected = false;
function ensureBraintreePreconnect() {
  if (braintreePreconnectInjected || !canInjectPreconnect()) {
    return;
  }
  braintreePreconnectInjected = true;
  for (var _i2 = 0, _BRAINTREE_PRECONNECT = BRAINTREE_PRECONNECT_HOSTS; _i2 < _BRAINTREE_PRECONNECT.length; _i2++) {
    var host = _BRAINTREE_PRECONNECT[_i2];
    injectPreconnect(host);
  }
}
// Warm an arbitrary origin (e.g. the PG API or the IPQS script host) without
// changing any request logic. This only speeds up DNS/TLS for later fetches.
function preconnectOrigin(url) {
  if (!url || !canInjectPreconnect()) {
    return;
  }
  var origin;
  try {
    var _window$location;
    var base = typeof window !== "undefined" ? (_window$location = window.location) === null || _window$location === void 0 ? void 0 : _window$location.href : undefined;
    origin = new _URL(url, base).origin;
  } catch (_unused) {
    return;
  }
  if (!origin || origin === "null") {
    return;
  }
  injectPreconnect(origin);
}
function isStripeClient(client) {
  return _typeof(client) === "object" && client !== null && "confirmPayment" in client && typeof client.confirmPayment === "function";
}
var PaymentSwitchSDK = /*#__PURE__*/function () {
  // TODO: remove baseURL
  function PaymentSwitchSDK(apiBaseURL, apiKey) {
    var _this = this;
    var ipqsScriptURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    _classCallCheck(this, PaymentSwitchSDK);
    _defineProperty(this, "initContainerId", void 0);
    _defineProperty(this, "intentRequestBody", void 0);
    _defineProperty(this, "saveCradRequestBody", void 0);
    _defineProperty(this, "apiBaseURL", void 0);
    _defineProperty(this, "apiKey", void 0);
    _defineProperty(this, "apiSecret", void 0);
    _defineProperty(this, "sdkVersion", packageJson.version);
    _defineProperty(this, "paymentIntentResponse", void 0);
    _defineProperty(this, "buttonElement", void 0);
    _defineProperty(this, "paymentInProgress", false);
    // Set while a Braintree wallet (PayPal/Pay Later/Google Pay/Apple Pay/Venmo) authorization
    // is being routed back through the host's existing Pay button handler (handlePayClick).
    _defineProperty(this, "walletFlowActive", false);
    // Holds the authorized wallet result so handlePayClick can read it synchronously,
    // regardless of whether the host's button handler awaits before calling handlePayClick.
    _defineProperty(this, "pendingWalletResult", void 0);
    _defineProperty(this, "saveCardInProgress", false);
    _defineProperty(this, "saveCardButtonElement", void 0);
    _defineProperty(this, "saveCardResponse", void 0);
    _defineProperty(this, "elements", void 0);
    _defineProperty(this, "hostedFieldsInstance", null);
    _defineProperty(this, "saveCardHostedFieldsInstance", null);
    _defineProperty(this, "hostedFieldsMountToken", 0);
    _defineProperty(this, "paymentLoaderToken", 0);
    _defineProperty(this, "braintreeWalletTeardown", null);
    _defineProperty(this, "saveCardWalletTeardown", null);
    _defineProperty(this, "stripeInstance", void 0);
    _defineProperty(this, "stripePaymentMethodType", void 0);
    _defineProperty(this, "stripeSavePaymentMethodType", void 0);
    _defineProperty(this, "paymentValidationMessages", []);
    _defineProperty(this, "saveCardValidationMessages", []);
    _defineProperty(this, "messageClearTimers", new _WeakMap());
    _defineProperty(this, "customer", void 0);
    _defineProperty(this, "_cards", void 0);
    _defineProperty(this, "savePaymentIntentBody", void 0);
    _defineProperty(this, "cPresponse", void 0);
    _defineProperty(this, "paymentGateway", {});
    _defineProperty(this, "ccType", "");
    _defineProperty(this, "errorElement", void 0);
    _defineProperty(this, "isCreditCard", false);
    _defineProperty(this, "selectedCard", void 0);
    _defineProperty(this, "chargeData", void 0);
    _defineProperty(this, "saveCardContainerId", void 0);
    _defineProperty(this, "ipqsResult", void 0);
    _defineProperty(this, "stripeAppearance", void 0);
    _defineProperty(this, "stripeFonts", void 0);
    _defineProperty(this, "stripeAppearanceFollowsBrowser", true);
    _defineProperty(this, "browserThemeListenerAttached", false);
    _defineProperty(this, "creditCardHTML", " <div class=\"\">\n        <form name=\"cc_form\" id=\"cc_form\">\n            <div class=\"pg-card-row\">\n                <div class=\"col-half\">\n                    <label>First Name</label>\n                    <div class=\"input-group input-group-icon\">\n                        <input type=\"text\" placeholder=\"First Name\" name=\"cardholder_first_name\"\n                            id=\"cardholder_first_name\" required maxLength=\"64\" />\n                        <div class=\"error\" id=\"cardholder_first_name_error\"></div>\n                    </div>\n                </div>\n                <div class=\"col-half\">\n                    <label>Last Name</label>\n                    <div class=\"input-group input-group-icon\">\n                        <input type=\"text\" placeholder=\"Last Name\" name=\"cardholder_last_name\" id=\"cardholder_last_name\"\n                            required maxLength=\"64\" />\n                        <div class=\"error\" id=\"cardholder_last_name_error\"></div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"pg-card-row\">\n                <div class=\"col-half\">\n                    <div class=\"pg-card-row\">\n                        <div class=\"col-half\">\n                            <label>Street</label>\n                            <div class=\"input-group input-group-icon\">\n                                <input type=\"text\" name=\"cust_street\" placeholder=\"Street\" id=\"cust_street\" required\n                                    maxLength=\"64\" />\n                                <div class=\"error\" id=\"cust_street_error\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-half\">\n                            <label>City</label>\n                            <div class=\"input-group input-group-icon\">\n                                <input type=\"text\" name=\"cust_city\" placeholder=\"City\" id=\"cust_city\" required\n                                    maxLength=\"64\" />\n                                <div class=\"error\" id=\"cust_city_error\"></div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"col-half\">\n                    <div class=\"pg-card-row\">\n                        <div class=\"\">\n                            <label>Country</label>\n                            <div class=\"input-group input-group-icon\">\n                                <select name=\"cust_country_code\" id=\"cust_country_code\" required></select>\n                                <div class=\"error\" id=\"cust_country_code_error\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-half\" id=\"cust_state_code_div\" style=\"display:none\">\n                            <label>State Code</label>\n                            <div class=\"input-group input-group-icon\">\n                                <select name=\"cust_state_code\" id=\"cust_state_code\" required></select>\n                                <div class=\"error\" id=\"cust_state_code_error\"></div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n            <div class=\"pg-card-row\">\n                <div class=\"col-half\">\n                    <label>Card Number</label>\n                    <div class=\"input-group input-group-icon\">\n                        <input type=\"text\" placeholder=\"Card Number\" name=\"cc_number\" id=\"cc_number\" maxLength=\"50\"\n                            required />\n                        <div id=\"bank\"></div>\n                        <div class=\"error\" id=\"cc_number_error\"></div>\n                    </div>\n                </div>\n                <div class=\"col-half\">\n                    <div class=\"pg-card-row\">\n                        <div class=\"col-half\"  style=\"width:33%\">\n                            <label>Expiry</label>\n                            <div class=\"input-group\">\n                                <input type=\"text\" placeholder=\"Expiry\" name=\"cc_expiry\" id=\"cc_expiry\" required\n                                    maxLength=\"10\" minLength=\"10\" />\n                                <div class=\"error\" id=\"cc_expiry_error\"></div>\n                            </div>\n                        </div>\n                        <div class=\"col-half\"  style=\"width:67%\">\n                          <div class=\"pg-card-row\">\n                            <div class=\"col-half\"  style=\"width:42%\">\n                              <label>CVV</label>\n                              <div class=\"input-group input-group-icon\">\n                                  <input type=\"text\" placeholder=\"CVV\" name=\"cc_code\" id=\"cc_code\" minLength=\"3\"\n                                      maxLength=\"30\" />\n                                  <div class=\"error\" id=\"cc_code_error\"></div>\n                              </div>\n                            </div>\n                            <div class=\"col-half\"  style=\"width:58%\">\n                              <label>Zip Code</label>\n                              <div class=\"input-group input-group-icon\">\n                                  <input type=\"text\" name=\"cust_post_code\" placeholder=\"Zip code\" id=\"cust_post_code\"\n                                      required />\n                                  <div class=\"error\" id=\"cust_post_code_error\"></div>\n                              </div>\n                            </div>\n                          <div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </form>\n        <div class=\"error\" id=\"cc_form_error\">\n        </div>\n        <div class=\"credit-card-success\" id=\"cc_form_error\">\n        </div>\n    </div>");
    _defineProperty(this, "locationData", {});
    _defineProperty(this, "creditCardCSS", "<style>\n        /* 64ac15 */\n        *,\n        *:before,\n        *:after {\n            box-sizing: border-box;\n        }\n\n        h4 {\n            color: #0b5ed7;\n        }\n\n        .error {\n            padding-top: 5px;\n            font-size: 14px;\n            color: #dc3545;\n            white-space: normal;\n        }\n\n        .credit-card-success{\n          padding-top: 5px;\n          font-size: 14px;\n          color: #198754;\n        }\n        input,\n        input[type=\"radio\"]+label,\n        input[type=\"checkbox\"]+label:before,\n        select option,\n        select {\n            margin-top: 5px;\n            width: 100%;\n            padding: 1em;\n            line-height: 1.4;\n            border: 1px solid #e5e5e5;\n            border-radius: 3px;\n            -webkit-transition: 0.35s ease-in-out;\n            -moz-transition: 0.35s ease-in-out;\n            -o-transition: 0.35s ease-in-out;\n            transition: 0.35s ease-in-out;\n            transition: all 0.35s ease-in-out;\n            min-height: calc(1.5em + .5rem + 2px);\n            padding: .25rem .5rem;\n            font-size: .875rem;\n            border-radius: .25rem;\n        }\n\n        input:focus {\n            outline: 0;\n            border-color: #86b7fe;\n        }\n\n        input[type=\"radio\"] {\n            display: none;\n        }\n\n        input[type=\"radio\"]+label,\n        select {\n            display: inline-block;\n            width: 100%;\n            float: left;\n            border-radius: 0;\n        }\n\n        input[type=\"radio\"]+label:first-of-type {\n            border-top-left-radius: 3px;\n            border-bottom-left-radius: 3px;\n        }\n\n        input[type=\"radio\"]+label:last-of-type {\n            border-top-right-radius: 3px;\n            border-bottom-right-radius: 3px;\n        }\n\n        input[type=\"radio\"]+label i {\n            padding-right: 0.4em;\n        }\n\n        input[type=\"radio\"]:checked+label,\n        input:checked+label:before,\n        select:focus,\n        select:active {\n            border-color: #86b7fe;\n        }\n\n        input[type=\"checkbox\"] {\n            display: none;\n        }\n\n        input[type=\"checkbox\"]+label {\n            position: relative;\n            display: block;\n            padding-left: 1.6em;\n        }\n\n        input[type=\"checkbox\"]+label:before {\n            position: absolute;\n            top: 0.2em;\n            left: 0;\n            display: block;\n            width: 1em;\n            height: 1em;\n            padding: 0;\n            content: \"\";\n        }\n\n        input[type=\"checkbox\"]+label:after {\n            position: absolute;\n            top: 0.45em;\n            left: 0.2em;\n            font-size: 0.8em;\n            color: #fff;\n            opacity: 0;\n            font-family: FontAwesome;\n            content: \"\f00c\";\n        }\n\n        input:checked+label:after {\n            opacity: 1;\n        }\n\n        select:first-of-type {\n            border-top-left-radius: 3px;\n            border-bottom-left-radius: 3px;\n        }\n\n        select:last-of-type {\n            border-top-right-radius: 3px;\n            border-bottom-right-radius: 3px;\n        }\n\n        select:focus,\n        select:active {\n            outline: 0;\n        }\n\n        select option {\n            color: #000;\n        }\n\n        .input-group {\n            margin-bottom: 1em;\n            zoom: 1;\n        }\n\n        .input-group:before,\n        .input-group:after {\n            content: \"\";\n            display: table;\n        }\n\n        .input-group:after {\n            clear: both;\n        }\n\n        .input-group-icon {\n            position: relative;\n        }\n\n        .pg-card-container {\n            max-width: 38em;\n            padding: 1em 3em 2em 3em;\n            margin: 0em auto;\n            background-color: #fff;\n            border-radius: 4.2px;\n            box-shadow: 0px 3px 10px -2px rgba(0, 0, 0, 0.2);\n        }\n\n        .pg-card-row {\n            zoom: 1;\n        }\n\n        .pg-card-row:before,\n        .pg-card-row:after {\n            content: \"\";\n            display: table;\n        }\n\n        .pg-card-row:after {\n            clear: both;\n        }\n\n        .col-half {\n            padding-right: 10px;\n            float: left;\n            width: 50%;\n        }\n\n        .col-half:last-of-type {\n            padding-right: 0;\n        }\n\n        .col-third {\n            padding-right: 10px;\n            float: left;\n            width: 33.33333333%;\n        }\n\n        .col-third:last-of-type {\n            padding-right: 0;\n        }\n\n        @media only screen and (max-width: 540px) {\n            .col-half {\n                width: 100%;\n                padding-right: 0;\n            }\n        }\n\n        #bank {\n            display: inline-block;\n            position: absolute;\n            top: 7px;\n            right: 8px;\n        }\n    </style>");
    _defineProperty(this, "nmiThreeDSecureUI", void 0);
    _defineProperty(this, "ipqsScriptURL", void 0);
    _defineProperty(this, "events", {});
    _defineProperty(this, "paymentId", null);
    _defineProperty(this, "_cvvModalWaitState", void 0);
    _defineProperty(this, "braintreeThemeKey", "");
    // loadNmi = async (data: Record<string, any>) => {
    //   var scriptTag = document.createElement('script');
    //   scriptTag.src = 'https://secure.networkmerchants.com/token/Collect.js';
    //   scriptTag.setAttribute('data-tokenization-key', data.tokenizationKey);
    //   document.head.appendChild(scriptTag);
    //   // Wrap the loading logic in a Promise
    //   const loadScriptPromise = new Promise((resolve, reject) => {
    //     scriptTag.onload = resolve;
    //     scriptTag.onerror = reject;
    //   });
    //   // Append the script to the document
    //   document.head.appendChild(scriptTag);
    //   // Wait for the script to load
    //   await loadScriptPromise;
    //   // Now that the script has loaded, you can access its methods safely
    //   (window as any).CollectJS.configure({
    //     callback: async function (response: any) {
    //       alert('resToken ' + response.token);
    //       // FIX me preProceesStep
    //       const prepPayment = await this.processNMIPayment({
    //         amount: data.amount,
    //         type: 'sale',
    //         nonce: response.token,
    //       });
    //     },
    //     variant: 'inline',
    //     googleFont: 'Abel',
    //     invalidCss: {
    //       color: '#B40E3E',
    //     },
    //     validCss: {
    //       color: '#14855F',
    //     },
    //     customCss: {
    //       'border-color': '#FFFFFF',
    //       'border-style': 'solid',
    //     },
    //     focusCss: {
    //       'border-color': '#1CC48B',
    //       'border-style': 'solid',
    //       'border-width': '3px',
    //     },
    //     fields: {
    //       cvv: {
    //         placeholder: 'CVV',
    //       },
    //       ccnumber: {
    //         placeholder: 'Credit Card',
    //       },
    //       ccexp: {
    //         placeholder: 'MM / YY',
    //       },
    //     },
    //   });
    // };
    _defineProperty(this, "handlePayClick", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        var _document$getElementB, _context7, _this$paymentIntentRe, _this$paymentIntentRe2, _this$paymentIntentRe4, _this$paymentIntentRe6, _this$paymentIntentRe1;
        var type,
          response,
          input,
          paymentGateway,
          _this$paymentIntentRe3,
          _this$elements,
          nonCard,
          submitResult,
          cardMessage,
          messages,
          _e$preventDefault,
          _this$paymentIntentRe5,
          res,
          _this$paymentIntentRe7,
          _this$paymentIntentRe8,
          _response,
          _response2,
          _this$paymentIntentRe9,
          _this$paymentIntentRe0,
          data,
          _this$paymentIntentRe10,
          r,
          _args = arguments,
          _t;
        return _regeneratorRuntime.wrap(function (_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              type = _args.length > 1 && _args[1] !== undefined ? _args[1] : "payment";
              response = {};
              if (!_this.paymentInProgress) {
                _this.beginCardEntry(paymentMessageClass);
              }
              input = (_document$getElementB = document.getElementById("ip_pg_card_holder")) === null || _document$getElementB === void 0 ? void 0 : _trimInstanceProperty(_context7 = _document$getElementB.value).call(_context7);
              paymentGateway = _this.gatewayFor((_this$paymentIntentRe = _this.paymentIntentResponse) === null || _this$paymentIntentRe === void 0 ? void 0 : _this$paymentIntentRe.provider_name);
              if (!(((_this$paymentIntentRe2 = _this.paymentIntentResponse) === null || _this$paymentIntentRe2 === void 0 ? void 0 : _this$paymentIntentRe2.provider_name) == "stripe")) {
                _context8.next = 6;
                break;
              }
              if (input) {
                _context8.next = 4;
                break;
              }
              nonCard = !!_this.stripePaymentMethodType && _this.stripePaymentMethodType !== "card";
              if (!nonCard) {
                _context8.next = 1;
                break;
              }
              _t = undefined;
              _context8.next = 3;
              break;
            case 1:
              _context8.next = 2;
              return (_this$elements = _this.elements) === null || _this$elements === void 0 ? void 0 : _this$elements.submit();
            case 2:
              _t = _context8.sent;
            case 3:
              submitResult = _t;
              cardMessage = submitResult !== null && submitResult !== void 0 && submitResult.error ? messageForStripeError(submitResult.error, {
                paymentMethodType: _this.stripePaymentMethodType
              }) || (typeof submitResult.error.message === "string" ? submitResult.error.message : undefined) || "Please enter card details first!" : undefined;
              messages = messagesForCardEntry(cardMessage ? [cardMessage] : [], nonCard || !cardMessage ? messageForLanguage(_this.intentLanguageCode(), "cardHolderNameRequired") : undefined);
              _this.showCardFieldErrors(paymentMessageClass, messages);
              return _context8.abrupt("return", {
                status: false,
                message: messages[0]
              });
            case 4:
              _context8.next = 5;
              return _this.handleSubmit(e, (_this$paymentIntentRe3 = _this.paymentIntentResponse) === null || _this$paymentIntentRe3 === void 0 ? void 0 : _this$paymentIntentRe3.provider_name, _this.elements, input);
            case 5:
              response = _context8.sent;
              _context8.next = 22;
              break;
            case 6:
              if (!(((_this$paymentIntentRe4 = _this.paymentIntentResponse) === null || _this$paymentIntentRe4 === void 0 ? void 0 : _this$paymentIntentRe4.provider_name) == "braintree")) {
                _context8.next = 13;
                break;
              }
              if (!_this.walletFlowActive) {
                _context8.next = 10;
                break;
              }
              // A wallet button (PayPal/Pay Later/Google Pay/Apple Pay/Venmo) already authorized
              // and triggered this Pay button programmatically. Wait for its result on the wallet
              // emitter (same pattern as NMI/Flywire) so the host's existing handlePayClick handler
              // receives it and can finalize/redirect — no separate wallet callback required.
              // Cancel the click's default action synchronously (before awaiting) so that, if #submit
              // is a form submit button, it does not submit/reload the page after funds are authorized
              // and before the host finalizes the order. The card path does this inside handleSubmit.
              e === null || e === void 0 || (_e$preventDefault = e.preventDefault) === null || _e$preventDefault === void 0 || _e$preventDefault.call(e);
              // The wallet result is stored synchronously before the programmatic click, so read it
              // directly to avoid any emit/await race (the host's handler may await before calling
              // handlePayClick, which would otherwise miss the emitted event). Fall back to the
              // emitter only if the stored result is not yet available.
              if (!(_this.pendingWalletResult !== undefined)) {
                _context8.next = 7;
                break;
              }
              response = _this.pendingWalletResult;
              _this.pendingWalletResult = undefined;
              _context8.next = 9;
              break;
            case 7:
              _context8.next = 8;
              return new _Promise(function (resolve, reject) {
                walletEventEmitter.once("payment-response", resolve);
                walletEventEmitter.once("error", reject);
              });
            case 8:
              response = _context8.sent;
            case 9:
              _this.walletFlowActive = false;
              _context8.next = 12;
              break;
            case 10:
              _context8.next = 11;
              return _this.handleSubmit(e, (_this$paymentIntentRe5 = _this.paymentIntentResponse) === null || _this$paymentIntentRe5 === void 0 ? void 0 : _this$paymentIntentRe5.provider_name, null, input);
            case 11:
              response = _context8.sent;
            case 12:
              _context8.next = 22;
              break;
            case 13:
              if (!(((_this$paymentIntentRe6 = _this.paymentIntentResponse) === null || _this$paymentIntentRe6 === void 0 ? void 0 : _this$paymentIntentRe6.provider_name) === "nmi")) {
                _context8.next = 19;
                break;
              }
              if (paymentGateway && paymentGateway.showLoader) {
                paymentGateway.showLoader();
              }
              _context8.next = 14;
              return new _Promise(function (resolve, reject) {
                nmiEventEmitter.once("payment-response", resolve);
                nmiEventEmitter.once("error", reject);
              });
            case 14:
              res = _context8.sent;
              if (!res.status) {
                _context8.next = 17;
                break;
              }
              void _this.updateLog({
                payment_id: (_this$paymentIntentRe7 = _this.paymentIntentResponse) === null || _this$paymentIntentRe7 === void 0 ? void 0 : _this$paymentIntentRe7.payment_id,
                type: "info",
                provider: (_this$paymentIntentRe8 = _this.paymentIntentResponse) === null || _this$paymentIntentRe8 === void 0 ? void 0 : _this$paymentIntentRe8.provider_name,
                message: res === null || res === void 0 ? void 0 : res.message,
                event_name: "authorization_success"
              });
              _context8.next = 15;
              return _this.processNMIPayment({
                type: "auth",
                nonce: res.data.token
              });
            case 15:
              response = _context8.sent;
              if (((_response = response) === null || _response === void 0 ? void 0 : _response.status) == "requires_capture") {
                response = {
                  status: true,
                  return_url: response.return_url
                };
              }
              if (!(((_response2 = response) === null || _response2 === void 0 ? void 0 : _response2.code) == "400")) {
                _context8.next = 16;
                break;
              }
              return _context8.abrupt("return", {
                status: false,
                message: response.message
              });
            case 16:
              _context8.next = 18;
              break;
            case 17:
              if (paymentGateway && paymentGateway.hideLoader) {
                paymentGateway.hideLoader();
              }
              void _this.updateLog({
                payment_id: (_this$paymentIntentRe9 = _this.paymentIntentResponse) === null || _this$paymentIntentRe9 === void 0 ? void 0 : _this$paymentIntentRe9.payment_id,
                type: "error",
                provider: (_this$paymentIntentRe0 = _this.paymentIntentResponse) === null || _this$paymentIntentRe0 === void 0 ? void 0 : _this$paymentIntentRe0.provider_name,
                message: res === null || res === void 0 ? void 0 : res.message,
                event_name: "authorization_error"
              });
              return _context8.abrupt("return", {
                status: false,
                message: res.message
              });
            case 18:
              _context8.next = 22;
              break;
            case 19:
              if (!(((_this$paymentIntentRe1 = _this.paymentIntentResponse) === null || _this$paymentIntentRe1 === void 0 ? void 0 : _this$paymentIntentRe1.provider_name) === "flywire")) {
                _context8.next = 22;
                break;
              }
              _context8.next = 20;
              return new _Promise(function (resolve, reject) {
                flywireEventEmitter.once("payment-response", resolve);
                flywireEventEmitter.once("error", reject);
              });
            case 20:
              data = _context8.sent;
              _context8.next = 21;
              return _this.preProcessPayment(data);
            case 21:
              response = _context8.sent;
            case 22:
              if (!(!response || response.status === undefined)) {
                _context8.next = 23;
                break;
              }
              return _context8.abrupt("return", {
                status: false,
                message: "Please enter card details first!"
              });
            case 23:
              if (!(response.status == true && type == "invoice")) {
                _context8.next = 25;
                break;
              }
              _context8.next = 24;
              return _this.capturePayment({
                payment_id: (_this$paymentIntentRe10 = _this.paymentIntentResponse) === null || _this$paymentIntentRe10 === void 0 ? void 0 : _this$paymentIntentRe10.payment_id
              });
            case 24:
              r = _context8.sent;
              console.log(r);
            case 25:
              return _context8.abrupt("return", response);
            case 26:
            case "end":
              return _context8.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    _defineProperty(this, "handleCCSubmit", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(payment_id, metadata) {
        var formElement, _formData$get, formData, ccNumberValue, expiry, formProps, response, pIntent, _t2;
        return _regeneratorRuntime.wrap(function (_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              formElement = document.getElementById("cc_form");
              if (!formElement) {
                _context9.next = 6;
                break;
              }
              formData = new FormData(formElement);
              ccNumberValue = formData.get("cc_number");
              formData.append("cc_number", (ccNumberValue === null || ccNumberValue === void 0 ? void 0 : ccNumberValue.toString().replace(/ /g, "")) || "");
              formData.append("payment_id", payment_id);
              expiry = (_formData$get = formData.get("cc_expiry")) === null || _formData$get === void 0 ? void 0 : _formData$get.toString().split("/");
              if ((expiry === null || expiry === void 0 ? void 0 : expiry.length) == 2) {
                formData.append("cc_mo", expiry[0]);
                formData.append("cc_yr", expiry[1]);
              }
              formProps = _Object$fromEntries(formData);
              console.log("Form Props", formProps);
              if (!_this.checkCreditCardFormValidation(formProps)) {
                _context9.next = 5;
                break;
              }
              delete formProps["cc_expiry"];
              _context9.prev = 1;
              _context9.next = 2;
              return _this.fetch("".concat(_this.apiBaseURL, "/v1/credit"), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": _this.apiKey
                },
                body: _JSON$stringify(_objectSpread(_objectSpread({}, formProps), {}, {
                  cc_type: CCTypeCodes[_this.ccType] || _this.ccType,
                  metadata: metadata
                }))
              });
            case 2:
              response = _context9.sent;
              _context9.next = 3;
              return response.json();
            case 3:
              pIntent = _context9.sent;
              return _context9.abrupt("return", pIntent);
            case 4:
              _context9.prev = 4;
              _t2 = _context9["catch"](1);
              throw new Error("Error: " + _t2, {
                cause: _t2
              });
            case 5:
              _context9.next = 7;
              break;
            case 6:
              console.log("CC Form not found");
            case 7:
            case "end":
              return _context9.stop();
          }
        }, _callee2, null, [[1, 4]]);
      }));
      return function (_x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }());
    this.apiBaseURL = apiBaseURL;
    this.apiKey = apiKey;
    // this.apiSecret = apiSecret;
    this.apiSecret = "";
    this.ipqsScriptURL = ipqsScriptURL;
    this.paymentGateway["stripe"] = new StripeGateway();
    this.paymentGateway["braintree"] = new BraintreeGateway();
    this.paymentGateway["braintree_save_card"] = new BraintreeGateway();
    this.paymentGateway["nmi"] = new NMIGateway();
    this.paymentGateway["flywire"] = new FlywireGateway();
    // this.paymentGateway['authorize_net'] = new AuthorizeNetGateway();
    this.events = {};
    this.paymentId = null;
  }
  return _createClass(PaymentSwitchSDK, [{
    key: "required",
    value: function required(value, reading) {
      if (value === undefined) {
        throw new TypeError("Cannot read properties of undefined (reading '".concat(reading, "')"));
      }
      return value;
    }
  }, {
    key: "hasCustomerEmail",
    value: function hasCustomerEmail(value) {
      if (_typeof(value) !== "object" || value === null) {
        return false;
      }
      if (axios.isAxiosError(value) || value instanceof Error) {
        return false;
      }
      var email = value.email;
      return typeof email === "string" && email.length > 0;
    }
  }, {
    key: "intentLanguageCode",
    value: function intentLanguageCode() {
      var _this$intentRequestBo;
      var metadata = (_this$intentRequestBo = this.intentRequestBody) === null || _this$intentRequestBo === void 0 ? void 0 : _this$intentRequestBo.metadata;
      if (metadata == null) {
        throw new TypeError("Cannot read properties of ".concat(metadata, " (reading 'language_code')"));
      }
      if (_typeof(metadata) !== "object" || !("language_code" in metadata)) {
        return undefined;
      }
      return metadata.language_code;
    }
  }, {
    key: "getGateway",
    value: function getGateway(provider) {
      return this.paymentGateway[provider];
    }
  }, {
    key: "storeStripeClient",
    value: function storeStripeClient(client) {
      this.stripeInstance = isStripeClient(client) ? client : undefined;
    }
  }, {
    key: "gatewayFor",
    value: function gatewayFor(provider) {
      return this.getGateway(provider === undefined ? "undefined" : provider);
    }
  }, {
    key: "braintreeSaveCardGateway",
    value: function braintreeSaveCardGateway() {
      var gateway = this.getGateway("braintree_save_card");
      if (!(gateway instanceof BraintreeGateway)) {
        throw new Error("Braintree save card gateway is not configured.");
      }
      return gateway;
    }
  }, {
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(url, config) {
        var request, data, _err$response, _t3, _t4;
        return _regeneratorRuntime.wrap(function (_context0) {
          while (1) switch (_context0.prev = _context0.next) {
            case 0:
              config.headers = _objectSpread(_objectSpread({}, config.headers), {}, {
                "x-sdk-version": this.sdkVersion
              });
              _t3 = config.method.toLowerCase();
              _context0.next = _t3 === "get" ? 1 : _t3 === "post" ? 2 : _t3 === "put" ? 3 : _t3 === "delete" ? 4 : 5;
              break;
            case 1:
              request = axios.get(url, {
                headers: config.headers
              });
              return _context0.abrupt("continue", 5);
            case 2:
              request = axios.post(url, JSON.parse(String(config.body)), {
                headers: config.headers
              });
              return _context0.abrupt("continue", 5);
            case 3:
              request = axios.put(url, JSON.parse(String(config.body)), {
                headers: config.headers
              });
              return _context0.abrupt("continue", 5);
            case 4:
              request = axios.delete(url, {
                headers: config.headers,
                data: JSON.parse(String(config.body))
              });
              return _context0.abrupt("continue", 5);
            case 5:
              _context0.prev = 5;
              _context0.next = 6;
              return request;
            case 6:
              data = _context0.sent;
              return _context0.abrupt("return", {
                status: data.status,
                json: function json() {
                  return data.data;
                }
              });
            case 7:
              _context0.prev = 7;
              _t4 = _context0["catch"](5);
              if (!axios.isAxiosError(_t4)) {
                _context0.next = 8;
                break;
              }
              return _context0.abrupt("return", {
                status: ((_err$response = _t4.response) === null || _err$response === void 0 ? void 0 : _err$response.status) || _t4.code,
                json: function json() {
                  var _err$response2;
                  return ((_err$response2 = _t4.response) === null || _err$response2 === void 0 ? void 0 : _err$response2.data) || _t4;
                }
              });
            case 8:
              return _context0.abrupt("return", {
                status: undefined,
                json: function json() {
                  return _t4;
                }
              });
            case 9:
            case "end":
              return _context0.stop();
          }
        }, _callee3, this, [[5, 7]]);
      }));
      function fetch(_x4, _x5) {
        return _fetch.apply(this, arguments);
      }
      return fetch;
    }()
  }, {
    key: "checkCardNumber",
    value: function checkCardNumber(numb) {
      var cardElement = document.getElementById("cc_number");
      var cardErrorElement = document.getElementById("cc_number_error");
      var bankElement = document.getElementById("bank");
      if (cardElement) {
        cardElement.innerHTML = "";
      }
      var cardResult = cardValidator.number(numb);
      if (cardResult.isValid) {
        if (cardErrorElement) {
          cardErrorElement.innerHTML = "";
        }
      } else {
        if (cardErrorElement) {
          cardErrorElement.innerHTML = "Invalid Card!";
        }
        return false;
      }
      if (cardResult.card) {
        this.ccType = cardResult.card.niceType;
        if (cardImages[cardResult.card.niceType]) {
          if (bankElement) {
            bankElement.innerHTML = "<img src=\"".concat(cardImages[cardResult.card.niceType], "\" style=\"width:40px\" />");
          }
        } else {
          if (bankElement) {
            bankElement.innerHTML = cardResult.card.niceType;
          }
        }
        return true;
      }
      return false;
      // // let numb = document.display.cc_number.value;
      // let numbWithoutSeparators = "";
      // for (let i = 0; i < numb.length; i++) {
      //   const digit = numb.charAt(i);
      //   if (digit == " " || digit == "-") { // ignore spaces or dashes
      //     continue;
      //   } else if (digit < " ") { // ignore non-printable characters
      //     continue;
      //   } else if (digit < "0" || digit > "9") { // remove any other non-digits
      //     cardErrorElement ? cardErrorElement.innerHTML =
      //       "invalid character in number: " + digit : null;
      //     bankElement ? bankElement.innerHTML = "" : null;
      //     //            document.display.valid.value = "invalid character in number: " + digit;
      //     //            document.display.bank.value = "";
      //     return;
      //   } else {
      //     numbWithoutSeparators += digit;
      //   }
      // }
      // const bank = this.GetBank(numbWithoutSeparators);
      // if (bank === '' || bank === undetermined) {
      //   bankElement ? bankElement.innerHTML = '' : null;
      //   cardErrorElement ? cardErrorElement.innerHTML = 'Invalid card number' : null;
      //   return;
      // }
      // const validationResult = this.Validate(numbWithoutSeparators, bank);
      // if (['', undefined, null].indexOf(validationResult) > -1) {
      //   return true;
      // } else {
      //   return false;
      // }
    }
    /**
     * Host-page Stripe Appearance API config. Used only when the resolved provider is Stripe.
     * Pass theme "auto" (or omit appearance) to follow the browser light/dark preference.
     * Safe to call before or after Elements mount; after mount it updates the existing iframe
     * and the custom Card Holder Name field.
     */
  }, {
    key: "setAppearance",
    value: function setAppearance(appearance) {
      var _this$elements2;
      this.stripeAppearance = appearance;
      this.stripeAppearanceFollowsBrowser = !(appearance !== null && appearance !== void 0 && appearance.theme) || appearance.theme === "auto";
      this.ensureBrowserThemeListener();
      var resolved = this.resolveStripeAppearance();
      (_this$elements2 = this.elements) === null || _this$elements2 === void 0 || _this$elements2.update({
        appearance: resolved
      });
      this.styleCardHolderNameField();
      void this.refreshBraintreeFieldsForTheme();
    }
  }, {
    key: "applyStripeAppearanceFromBody",
    value: function applyStripeAppearanceFromBody(body) {
      var appearance = body.appearance,
        fonts = body.fonts,
        intentBody = _objectWithoutProperties(body, _excluded);
      if (appearance !== undefined) {
        this.stripeAppearance = appearance;
        this.stripeAppearanceFollowsBrowser = !(appearance !== null && appearance !== void 0 && appearance.theme) || appearance.theme === "auto";
      }
      if (fonts !== undefined) {
        this.stripeFonts = fonts;
      }
      this.ensureBrowserThemeListener();
      return intentBody;
    }
  }, {
    key: "resolveStripeAppearance",
    value: function resolveStripeAppearance() {
      var host = this.stripeAppearance;
      var themeName = !(host !== null && host !== void 0 && host.theme) || host.theme === "auto" ? getBrowserStripeTheme() : host.theme;
      var rest = _objectSpread({}, host || {});
      delete rest.theme;
      return _objectSpread(_objectSpread({}, rest), {}, {
        theme: themeName
      });
    }
  }, {
    key: "braintreeCheckoutTokens",
    value: function braintreeCheckoutTokens() {
      var appearance = this.resolveStripeAppearance();
      var vars = appearance.variables || {};
      var dark = appearance.theme === "night";
      var primary = vars.colorPrimary || (dark ? "#635bff" : "#0570de");
      return {
        background: vars.colorBackground || (dark ? "#30313d" : "#ffffff"),
        text: vars.colorText || (dark ? "#ffffff" : "#30313d"),
        border: dark ? primary : vars.inputColorBorder || "#e6e6e6",
        primary: primary,
        onPrimary: vars.accessibleColorOnColorPrimary || "#ffffff",
        placeholder: vars.colorTextPlaceholder || (dark ? "#abb2bf" : "#6d6e78"),
        radius: vars.borderRadius || "8px",
        label: vars.colorTextSecondary || vars.colorText || (dark ? "#ffffff" : "#30313d"),
        line: dark ? "rgba(255,255,255,0.24)" : "#e4e7ec"
      };
    }
  }, {
    key: "braintreeHostedFieldStyles",
    value: function braintreeHostedFieldStyles() {
      var tokens = this.braintreeCheckoutTokens();
      // Browser suggestions paint an opaque autofill background and dark text over the iframe.
      // background-color is not a Braintree hosted-field style, so cover it with an inset shadow.
      var autofill = {
        color: tokens.text,
        "-webkit-text-fill-color": tokens.text,
        "box-shadow": "0 0 0 1000px ".concat(tokens.background, " inset"),
        "-webkit-box-shadow": "0 0 0 1000px ".concat(tokens.background, " inset")
      };
      return {
        input: {
          "font-size": "14px",
          color: tokens.text
        },
        "::placeholder": {
          color: tokens.placeholder
        },
        "input:-webkit-autofill": autofill,
        "input:-webkit-autofill:hover": autofill,
        "input:-webkit-autofill:focus": autofill,
        "input:-webkit-autofill:active": autofill
      };
    }
  }, {
    key: "writeBraintreeTokens",
    value: function writeBraintreeTokens(element) {
      var tokens = this.braintreeCheckoutTokens();
      element.style.setProperty("--pg-bt-bg", tokens.background);
      element.style.setProperty("--pg-bt-text", tokens.text);
      element.style.setProperty("--pg-bt-border", tokens.border);
      element.style.setProperty("--pg-bt-primary", tokens.primary);
      element.style.setProperty("--pg-bt-on-primary", tokens.onPrimary);
      element.style.setProperty("--pg-bt-placeholder", tokens.placeholder);
      element.style.setProperty("--pg-bt-radius", tokens.radius);
      element.style.setProperty("--pg-bt-label", tokens.label);
      element.style.setProperty("--pg-bt-line", tokens.line);
    }
  }, {
    key: "applyBraintreeCheckoutTheme",
    value: function applyBraintreeCheckoutTheme(target) {
      var container = target !== null && target !== void 0 ? target : this.initContainerId;
      if (!(container instanceof HTMLElement)) {
        return;
      }
      this.writeBraintreeTokens(container);
      if (container.parentElement) {
        this.writeBraintreeTokens(container.parentElement);
      }
    }
  }, {
    key: "refreshBraintreeFieldsForTheme",
    value: function () {
      var _refreshBraintreeFieldsForTheme = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var key, languageCode;
        return _regeneratorRuntime.wrap(function (_context1) {
          while (1) switch (_context1.prev = _context1.next) {
            case 0:
              this.applyBraintreeCheckoutTheme();
              if (!(!this.hostedFieldsInstance || !(this.initContainerId instanceof HTMLElement))) {
                _context1.next = 1;
                break;
              }
              return _context1.abrupt("return");
            case 1:
              key = _JSON$stringify(this.braintreeCheckoutTokens());
              if (!(key === this.braintreeThemeKey)) {
                _context1.next = 2;
                break;
              }
              return _context1.abrupt("return");
            case 2:
              languageCode = this.intentRequestBody ? languageCodeOf(this.intentRequestBody) : undefined;
              _context1.next = 3;
              return this.mountBraintreeHostedFields(this.initContainerId, languageCode);
            case 3:
            case "end":
              return _context1.stop();
          }
        }, _callee4, this);
      }));
      function refreshBraintreeFieldsForTheme() {
        return _refreshBraintreeFieldsForTheme.apply(this, arguments);
      }
      return refreshBraintreeFieldsForTheme;
    }()
  }, {
    key: "getStripeElementsOptions",
    value: function getStripeElementsOptions(clientSecret) {
      var options = {
        clientSecret: clientSecret,
        appearance: this.resolveStripeAppearance()
      };
      if (this.stripeFonts) {
        options.fonts = this.stripeFonts;
      }
      // paymentMethodCreation is used at runtime; this stripe-js version omits it from the type.
      return _objectSpread(_objectSpread({}, options), {}, {
        paymentMethodCreation: "manual"
      });
    }
  }, {
    key: "ensureBrowserThemeListener",
    value: function ensureBrowserThemeListener() {
      var _this2 = this;
      if (this.browserThemeListenerAttached || typeof window === "undefined" || !window.matchMedia) {
        return;
      }
      var media = window.matchMedia("(prefers-color-scheme: dark)");
      var handler = function handler() {
        var _this2$elements;
        if (!_this2.stripeAppearanceFollowsBrowser) {
          return;
        }
        (_this2$elements = _this2.elements) === null || _this2$elements === void 0 || _this2$elements.update({
          appearance: _this2.resolveStripeAppearance()
        });
        _this2.styleCardHolderNameField();
        void _this2.refreshBraintreeFieldsForTheme();
      };
      if (typeof media.addEventListener === "function") {
        media.addEventListener("change", handler);
      } else if (typeof media.addListener === "function") {
        media.addListener(handler);
      }
      this.browserThemeListenerAttached = true;
    }
  }, {
    key: "styleCardHolderNameField",
    value: function styleCardHolderNameField() {
      if (typeof document === "undefined") {
        return;
      }
      var input = document.getElementById(CARD_HOLDER_INPUT_ID);
      if (!input) {
        return;
      }
      ensureCardHolderNameStyles();
      var appearance = this.resolveStripeAppearance();
      var vars = appearance.variables || {};
      var isDark = appearance.theme === "night";
      var tokens = {
        background: vars.colorBackground || (isDark ? "#30313d" : "#ffffff"),
        text: vars.colorText || (isDark ? "#e6e6e6" : "#30313d"),
        border: vars.inputColorBorder || (isDark ? "#424352" : "#e6e6e6"),
        label: vars.colorTextSecondary || vars.colorText || (isDark ? "#a3a3a3" : "#30313d"),
        primary: vars.colorPrimary || (isDark ? "#635bff" : "#0570de"),
        placeholder: vars.colorTextPlaceholder || (isDark ? "#8b8d97" : "#6d6e78"),
        radius: vars.borderRadius || "6px"
      };
      input.classList.add("pg-stripe-name-input");
      input.style.setProperty("--pg-name-bg", tokens.background);
      input.style.setProperty("--pg-name-text", tokens.text);
      input.style.setProperty("--pg-name-border", tokens.border);
      input.style.setProperty("--pg-name-primary", tokens.primary);
      input.style.setProperty("--pg-name-placeholder", tokens.placeholder);
      input.style.setProperty("--pg-name-radius", tokens.radius);
      var label = input.previousElementSibling;
      if (label && label.tagName === "LABEL") {
        label.classList.add("pg-stripe-name-label");
        label.style.setProperty("--pg-name-label", tokens.label);
      }
    }
  }, {
    key: "checkccYear",
    value: function checkccYear() {
      var ccYearElement = document.getElementById("cc_expiry");
      var ccYearErrorElement = document.getElementById("cc_expiry_error");
      var result = false;
      var dValue = ccYearElement.value.split("/");
      var pattern = /^\d{2}$/;
      if (_parseInt(dValue[0]) < 1 || _parseInt(dValue[0]) > 12) result = true;
      if (!pattern.test(dValue[0]) || !pattern.test(dValue[1])) result = true;
      if (dValue[2]) result = true;
      if (_parseInt(dValue[1]) === _parseInt(new Date().getFullYear().toString().substr(-2)) && _parseInt(dValue[0]) < new Date().getMonth() + 1) result = true;
      if (result) {
        if (ccYearErrorElement) {
          ccYearErrorElement.innerHTML = "Invalid Value.";
        }
      } else {
        if (ccYearErrorElement) {
          ccYearErrorElement.innerHTML = "";
        }
      }
      // const ccYearElement: HTMLInputElement | null = <HTMLInputElement>document.getElementById("cc_yr");
      // const ccMonthElement: HTMLInputElement | null = <HTMLInputElement>document.getElementById("cc_mo");
      // const ccYearErrorElement: HTMLElement | null = document.getElementById('cc_yr_error');
      // const ccMonthErrorElement: HTMLElement | null = document.getElementById('cc_mo_error');
      // let result = false;
      // const dValue: Array<string> = ['', ''];
      // dValue[0] = ccMonthElement.value;
      // dValue[1] = ccYearElement.value;
      // const pattern = /^\d{2}$/;
      // if ((parseInt(dValue[0]) < 1 || parseInt(dValue[0]) > 12))
      //   result = true;
      // if (!pattern.test(dValue[0]) || !pattern.test(dValue[1]))
      //   result = true;
      // // if (dValue[1])
      // //   result = true;
      // if (result) {
      //   ccYearErrorElement ? ccYearErrorElement.innerHTML = 'Invalid Value.' : null;
      // } else {
      //   ccYearErrorElement ? ccYearErrorElement.innerHTML = '' : null;
      // }
      // if (parseInt(dValue[1]) === parseInt(new Date().getFullYear().toString().substr(-2)) && parseInt(dValue[0]) < new Date().getMonth() + 1) {
      //   ccMonthErrorElement ? ccMonthErrorElement.innerHTML = 'Invalid Month.' : null;
      // } else {
      //   ccMonthErrorElement ? ccMonthErrorElement.innerHTML = '' : null;
      // }
      // if (parseInt(ccYearElement.value) == new Date().getFullYear()) {
      //   if (parseInt(ccMonthElement.value) <= new Date().getMonth()) {
      //     ccYearErrorElement ? ccYearErrorElement.innerHTML = 'Invalid Expiry Year.' : null;
      //   }
      // } else if (parseInt(ccYearElement.value) < new Date().getFullYear()) {
      //   ccYearErrorElement ? ccYearErrorElement.innerHTML = 'Invalid Expiry Year.' : null;
      // } else {
      //   ccYearErrorElement ? ccYearErrorElement.innerHTML = '' : null;
      // }
    }
  }, {
    key: "checkCardKey",
    value: function checkCardKey(e) {
      var checkCard = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (e.keyCode == 86 && e.ctrlKey && checkCard) {
        this.checkCardNumber(e.target.value);
      } else if (e.ctrlKey) ; else {
        var a = [8, 9, 37, 39];
        var k = e.which;
        for (var i = 48; i < 58; i++) a.push(i);
        if (!(_indexOfInstanceProperty(a).call(a, k) >= 0)) e.preventDefault();
      }
    }
  }, {
    key: "checkCreditCardFormValidation",
    value: function checkCreditCardFormValidation(values) {
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var emptyArray = ["", null, undefined];
      var isValid = true;
      if (key == "" || key == "cardholder_first_name") {
        if (_indexOfInstanceProperty(emptyArray).call(emptyArray, values.cardholder_first_name) > -1) {
          var ele = document.getElementById("cardholder_first_name_error");
          if (ele) {
            ele.innerHTML = "This field is required.";
          }
          isValid = false;
        } else {
          var _ele = document.getElementById("cardholder_first_name_error");
          if (_ele) {
            _ele.innerHTML = "";
          }
        }
      }
      if (key == "" || key == "cardholder_last_name") {
        if (_indexOfInstanceProperty(emptyArray).call(emptyArray, values.cardholder_last_name) > -1) {
          var _ele2 = document.getElementById("cardholder_last_name_error");
          if (_ele2) {
            _ele2.innerHTML = "This field is required.";
          }
          isValid = false;
        } else {
          var _ele3 = document.getElementById("cardholder_last_name_error");
          if (_ele3) {
            _ele3.innerHTML = "";
          }
        }
      }
      if (key == "" || key == "cc_code") {
        if (_indexOfInstanceProperty(emptyArray).call(emptyArray, values.cc_code) > -1) {
          var _ele4 = document.getElementById("cc_code_error");
          if (_ele4) {
            _ele4.innerHTML = "This field is required.";
          }
          isValid = false;
        } else if (values.cc_code != null && values.cc_code.toString().length < 3) {
          var _ele5 = document.getElementById("cc_code_error");
          if (_ele5) {
            _ele5.innerHTML = "Invalid Code.";
          }
          isValid = false;
        } else {
          var _ele6 = document.getElementById("cc_code_error");
          if (_ele6) {
            _ele6.innerHTML = "";
          }
        }
      }
      // if (key == '' || key == 'cc_mo') {
      //   if (emptyArray.indexOf(values.cc_mo) > -1) {
      //     const ele = document.getElementById('cc_mo_error');
      //     ele ? ele.innerHTML = 'This field is required.' : null;
      //     isValid = false
      //   } else {
      //     this.checkccYear()
      //     // const ele = document.getElementById('cc_mo_error');
      //     // ele ? ele.innerHTML = '' : null;
      //   }
      // }
      if (key == "" || key == "cc_number") {
        if (_indexOfInstanceProperty(emptyArray).call(emptyArray, values.cc_number) > -1) {
          var _ele7 = document.getElementById("cc_number_error");
          if (_ele7) {
            _ele7.innerHTML = "This field is required.";
          }
          isValid = false;
        } else if (values.cc_number != null) {
          var _ele8 = document.getElementById("cc_number_error");
          if (!this.checkCardNumber(values.cc_number)) {
            isValid = false;
          } else {
            if (_ele8) {
              _ele8.innerHTML = "";
            }
          }
        }
      }
      if (key == "" || key == "cc_expiry") {
        if (_indexOfInstanceProperty(emptyArray).call(emptyArray, values.cc_expiry) > -1) {
          var _ele9 = document.getElementById("cc_expiry_error");
          if (_ele9) {
            _ele9.innerHTML = "This field is required.";
          }
          isValid = false;
        } else {
          this.checkccYear();
          // const ele = document.getElementById('cc_expiry_error');
          // ele ? ele.innerHTML = '' : null;
        }
      }
      if (key == "" || key == "cust_country_code") {
        if (_indexOfInstanceProperty(emptyArray).call(emptyArray, values.cust_country_code) > -1) {
          var _ele0 = document.getElementById("cust_country_code_error");
          if (_ele0) {
            _ele0.innerHTML = "This field is required.";
          }
          isValid = false;
        } else {
          var _ele1 = document.getElementById("cust_country_code_error");
          if (_ele1) {
            _ele1.innerHTML = "";
          }
        }
      }
      if (key == "" || key == "cust_city") {
        if (_indexOfInstanceProperty(emptyArray).call(emptyArray, values.cust_city) > -1) {
          var _ele10 = document.getElementById("cust_city_error");
          if (_ele10) {
            _ele10.innerHTML = "This field is required.";
          }
          isValid = false;
        } else {
          var _ele11 = document.getElementById("cust_city_error");
          if (_ele11) {
            _ele11.innerHTML = "";
          }
        }
      }
      if (key == "" || key == "cust_post_code") {
        if (_indexOfInstanceProperty(emptyArray).call(emptyArray, values.cust_post_code) > -1) {
          var _ele12 = document.getElementById("cust_post_code_error");
          if (_ele12) {
            _ele12.innerHTML = "This field is required.";
          }
          isValid = false;
          // } else if (values.cust_post_code.toString().length < 5) {
          //   const ele = document.getElementById('cust_post_code_error');
          //   ele ? ele.innerHTML = 'Invalid post code!' : null;
          //   isValid = false
        } else {
          var _ele13 = document.getElementById("cust_post_code_error");
          if (_ele13) {
            _ele13.innerHTML = "";
          }
        }
      }
      if (key == "" || key == "cust_state_code") {
        if (values.cust_country_code === "US" || values.cust_country_code === "CA") {
          if (_indexOfInstanceProperty(emptyArray).call(emptyArray, values.cust_state_code) > -1) {
            var _ele14 = document.getElementById("cust_state_code_error");
            if (_ele14) {
              _ele14.innerHTML = "This field is required.";
            }
            isValid = false;
          } else {
            var _ele15 = document.getElementById("cust_state_code_error");
            if (_ele15) {
              _ele15.innerHTML = "";
            }
          }
        }
      }
      if (key == "" || key == "cust_street") {
        if (_indexOfInstanceProperty(emptyArray).call(emptyArray, values.cust_street) > -1) {
          var _ele16 = document.getElementById("cust_street_error");
          if (_ele16) {
            _ele16.innerHTML = "This field is required.";
          }
          isValid = false;
        } else {
          var _ele17 = document.getElementById("cust_street_error");
          if (_ele17) {
            _ele17.innerHTML = "";
          }
        }
      }
      if (key == "" || key == "payment_id") {
        if (_indexOfInstanceProperty(emptyArray).call(emptyArray, values.payment_id) > -1) {
          var _ele18 = document.getElementById("cc_form_error");
          if (_ele18) {
            _ele18.innerHTML = "Payment id is required.";
          }
          isValid = false;
        } else {
          var _ele19 = document.getElementById("cc_from_error");
          if (_ele19) {
            _ele19.innerHTML = "";
          }
        }
      }
      return isValid;
    }
  }, {
    key: "Callback",
    value: function Callback(result) {
      var cardElement = document.getElementById("cc_number");
      if (cardElement) {
        cardElement.innerHTML = result;
      }
    }
    /**
     * Credit card functions end
     */
  }, {
    key: "init",
    value: (function () {
      var _init = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(containerId, buttonElement, paymentIntentBody) {
        var loadSecondary,
          primary_supplier,
          _args5 = arguments;
        return _regeneratorRuntime.wrap(function (_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              loadSecondary = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : false;
              primary_supplier = _args5.length > 4 && _args5[4] !== undefined ? _args5[4] : "";
              return _context10.abrupt("return", this.initPayment(containerId, buttonElement, paymentIntentBody, loadSecondary, primary_supplier));
            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee5, this);
      }));
      function init(_x6, _x7, _x8) {
        return _init.apply(this, arguments);
      }
      return init;
    }())
  }, {
    key: "initPayment",
    value: function () {
      var _initPayment = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(containerId, buttonElement, paymentIntentBody) {
        var _this3 = this;
        var loadSecondary,
          primary_supplier,
          loaderToken,
          _this$paymentIntentRe11,
          _this$customer,
          ct,
          suppliedIntent,
          intentBody,
          paymentGateway,
          button,
          _context11,
          providerCredential,
          _paymentGateway$getPr,
          clientSecret,
          paymentElement,
          hostedFieldsMounted,
          _this$paymentIntentRe12,
          _this$paymentIntentRe13,
          _this$paymentIntentRe14,
          _this$paymentIntentRe15,
          _this$paymentIntentRe16,
          _this$paymentIntentRe17,
          _args8 = arguments,
          _t6;
        return _regeneratorRuntime.wrap(function (_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              loadSecondary = _args8.length > 3 && _args8[3] !== undefined ? _args8[3] : false;
              primary_supplier = _args8.length > 4 && _args8[4] !== undefined ? _args8[4] : "";
              // Tag this init so a superseded/older call never hides an overlay that a
              // newer init is still using (mirrors hostedFieldsMountToken for mounts).
              loaderToken = ++this.paymentLoaderToken;
              if (containerId instanceof HTMLElement && loadSecondary === false) {
                showPaymentFormLoader(containerId);
              }
              _context14.prev = 1;
              // Warm DNS/TLS for the provider CDNs, the PG API, and the IPQS host so
              // these connections overlap the IPQS + payment-intent round-trips below.
              ensureBraintreePreconnect();
              preconnectOrigin(this.apiBaseURL);
              preconnectOrigin(this.ipqsScriptURL);
              _context14.prev = 2;
              if (!((_this$customer = this.customer) !== null && _this$customer !== void 0 && _this$customer.email)) {
                _context14.next = 4;
                break;
              }
              _context14.next = 3;
              return this.loadIPQSScript();
            case 3:
              this.ipqsResult = _context14.sent;
            case 4:
              _context14.next = 6;
              break;
            case 5:
              _context14.prev = 5;
              _context14["catch"](2);
            case 6:
              this.initContainerId = containerId;
              this.beginCardEntry(paymentMessageClass);
              if (!(containerId == null)) {
                _context14.next = 7;
                break;
              }
              throw new TypeError("Cannot read properties of ".concat(containerId, " (reading 'id')"));
            case 7:
              this.hostedFieldsMountToken += 1;
              _context14.next = 8;
              return this.teardownHostedFields();
            case 8:
              ct = document.querySelector("#" + containerId.id);
              if (!(containerId && ct && this.isCreditCard === false)) {
                _context14.next = 10;
                break;
              }
              if (!loadSecondary) {
                _context14.next = 9;
                break;
              }
              ct.innerHTML += "<style>\n/* Center container */\n.switch-loader {\n  font-family: Arial, sans-serif;\n  background: #f4f6fb;\n  z-index: 10;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n/* Card */\n.switch-loader .card {\n  background: #fff;\n  width: 280px;\n  padding: 30px;\n  border-radius: 12px;\n  text-align: center;\n  box-shadow: 0 10px 25px rgba(0,0,0,0.1);\n}\n\n/* Spinner */\n.switch-loader .spinner {\n  width: 48px;\n  height: 48px;\n  border: 4px solid #e5e7eb;\n  border-top: 4px solid #4f46e5;\n  border-radius: 50%;\n  margin: 0 auto 16px;\n  animation: spin 1s linear infinite;\n}\n\n/* Text */\n.switch-loader .title {\n  font-weight: bold;\n  margin-bottom: 6px;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n</style>\n<div class=\"switch-loader\">\n  <div class=\"card\">\n    <div class=\"spinner\"></div>\n    <p class=\"title\">Switching Provider</p>\n  </div>\n</div>";
              _context14.next = 9;
              return new _Promise(function (resolve) {
                _setTimeout(function () {
                  resolve({});
                }, PROVIDER_SWITCH_DELAY_MS);
              });
            case 9:
              ct.innerHTML = "";
              ct.style.position = "relative";
              if (ct instanceof HTMLElement) {
                showPaymentFormLoader(ct);
              }
            case 10:
              if (!(paymentIntentBody === undefined)) {
                _context14.next = 11;
                break;
              }
              throw new TypeError("Cannot destructure property 'appearance' of 'undefined' as it is undefined.");
            case 11:
              suppliedIntent = paymentIntentBody;
              intentBody = this.applyStripeAppearanceFromBody(suppliedIntent);
              this.intentRequestBody = intentBody;
              _context14.next = 12;
              return this.createPaymentIntent(_objectSpread(_objectSpread({}, intentBody), {}, {
                type: undefined,
                load_secondary: loadSecondary,
                primary_supplier: primary_supplier
              }));
            case 12:
              this.paymentIntentResponse = _context14.sent;
              if (!((_this$paymentIntentRe11 = this.paymentIntentResponse) !== null && _this$paymentIntentRe11 !== void 0 && (_this$paymentIntentRe11 = _this$paymentIntentRe11.provider_credential) !== null && _this$paymentIntentRe11 !== void 0 && _this$paymentIntentRe11.publishable_key)) {
                debug("Unable to get Provider publishable_key");
              }
              paymentGateway = this.gatewayFor(this.required(this.paymentIntentResponse, "provider_name").provider_name);
              button = buttonElement;
              this.buttonElement = buttonElement;
              if (!(paymentGateway && Number(suppliedIntent.amount) > 0)) {
                _context14.next = 23;
                break;
              }
              providerCredential = this.required(this.required(this.paymentIntentResponse, "provider_credential").provider_credential, "publishable_key");
              _context14.next = 13;
              return paymentGateway.init(this.paymentIntentResponse.provider_name === "braintree" ? providerCredential.client_token || providerCredential.tokenization_key || providerCredential.publishable_key : providerCredential.publishable_key || providerCredential.client_token || providerCredential.tokenization_key, containerId, _objectSpread(_objectSpread({}, intentBody), {}, {
                is_prod_env: this.paymentIntentResponse.is_prod_env,
                webhook_url: this.paymentIntentResponse.webhook_url,
                first_name: this.required(this.customer, "first_name").first_name,
                last_name: this.required(this.customer, "last_name").last_name,
                phone: this.required(this.customer, "phone").phone,
                email: this.required(this.customer, "email").email,
                payment_id: this.paymentIntentResponse.payment_id,
                processFlywirePayment: _bindInstanceProperty(_context11 = this.processFlywirePayment).call(_context11, this),
                button_id: buttonElement.id
              }));
            case 13:
              if (!(this.paymentIntentResponse.provider_name == "stripe")) {
                _context14.next = 14;
                break;
              }
              clientSecret = this.required(this.required(this.paymentIntentResponse, "provider_credential").provider_credential, "client_token").client_token;
              this.elements = (_paymentGateway$getPr = paymentGateway.getProviderClient()) === null || _paymentGateway$getPr === void 0 ? void 0 : _paymentGateway$getPr.elements(this.getStripeElementsOptions(clientSecret));
              if (paymentGateway.setElements) {
                paymentGateway.setElements(this.elements);
              }
              paymentElement = this.elements.create("payment", {
                fields: {
                  billingDetails: {
                    name: "never",
                    // We collect name separately with translation
                    address: {
                      country: "auto",
                      postalCode: "auto"
                    }
                  }
                }
              });
              paymentElement.mount(containerId);
              paymentElement.on("change", function (event) {
                _this3.stripePaymentMethodType = event.value.type;
              });
              paymentElement.on("ready", function () {
                var languageCode = languageCodeOf(suppliedIntent);
                var input = document.createElement("input");
                input.type = "text";
                //input.placeholder = "Enter Car
                input.placeholder = messageForLanguage(languageCode, "enterCardHolderName");
                input.classList.add("form-control");
                input.classList.add("form-control-sm");
                input.classList.add("mb-3");
                input.id = CARD_HOLDER_INPUT_ID;
                var label = document.createElement("label");
                label.innerHTML = messageForLanguage(languageCode, "cardHolderName");
                label.classList.add("form-label");
                label.classList.add("pg-stripe-name-label");
                label.setAttribute("for", CARD_HOLDER_INPUT_ID);
                containerId.style.textAlign = "left";
                containerId.insertBefore(input, containerId.firstChild);
                containerId.insertBefore(label, containerId.firstChild);
                _this3.styleCardHolderNameField();
              });
              this.storeStripeClient(paymentGateway.getProviderClient());
              _context14.next = 23;
              break;
            case 14:
              if (!(this.paymentIntentResponse.provider_name == "braintree")) {
                _context14.next = 18;
                break;
              }
              _context14.next = 15;
              return this.mountBraintreeHostedFields(containerId, languageCodeOf(suppliedIntent));
            case 15:
              hostedFieldsMounted = _context14.sent;
              console.log("init result", hostedFieldsMounted);
              // Drop-in used to retry with the secondary supplier when every payment option failed to load.
              // A Hosted Fields mount failure has to do the same, or the checkout stays empty.
              if (!(hostedFieldsMounted === "failed" && loadSecondary === false)) {
                _context14.next = 17;
                break;
              }
              _context14.next = 16;
              return this.init(containerId, buttonElement, suppliedIntent, true, (_this$paymentIntentRe12 = (_this$paymentIntentRe13 = this.paymentIntentResponse) === null || _this$paymentIntentRe13 === void 0 ? void 0 : _this$paymentIntentRe13.provider_name) !== null && _this$paymentIntentRe12 !== void 0 ? _this$paymentIntentRe12 : primary_supplier);
            case 16:
              return _context14.abrupt("return", _context14.sent);
            case 17:
              _context14.next = 23;
              break;
            case 18:
              if (!(this.paymentIntentResponse.provider_name == "nmi")) {
                _context14.next = 22;
                break;
              }
              if (!paymentGateway.getNMIPayment) {
                _context14.next = 20;
                break;
              }
              _context14.next = 19;
              return paymentGateway.getNMIPayment(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(response) {
                  var _document$querySelect, gateway, threeDsService, postalCodeEle, postalCode;
                  return _regeneratorRuntime.wrap(function (_context13) {
                    while (1) switch (_context13.prev = _context13.next) {
                      case 0:
                        if (paymentGateway && paymentGateway.showLoader) {
                          paymentGateway.showLoader();
                        }
                        if (paymentGateway.getNMIGateway) {
                          gateway = paymentGateway.getNMIGateway();
                          threeDsService = gateway.get3DSecure();
                          if (_this3.nmiThreeDSecureUI) {
                            _this3.nmiThreeDSecureUI.unmount();
                          }
                          postalCodeEle = (_document$querySelect = document.querySelector("#" + containerId.id)) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.querySelector("[name='zip']");
                          postalCode = postalCodeEle.value;
                          _this3.nmiThreeDSecureUI = threeDsService.createUI({
                            paymentToken: response.token,
                            currency: suppliedIntent.currency,
                            amount: suppliedIntent.amount,
                            firstName: _this3.required(_this3.customer, "first_name").first_name,
                            lastName: _this3.required(_this3.customer, "last_name").last_name,
                            postalCode: postalCode
                          });
                          window.location.href = "#nmi3ds-modal";
                          _this3.nmiThreeDSecureUI.start("#nmi3ds_modal_content");
                          _this3.nmiThreeDSecureUI.on("error", function (e) {
                            nmiEventEmitter.emit("payment-response", {
                              status: false,
                              message: e.message
                            });
                            var closeEle = document.getElementById("nmi3ds_modal_close");
                            if (closeEle) {
                              closeEle.click();
                            }
                            if (button) button.style.visibility = "visible";
                            _this3.setMessage(document.querySelector("." + paymentMessageClass), e === null || e === void 0 ? void 0 : e.message, "error");
                          });
                          _this3.nmiThreeDSecureUI.on("failure", function (e) {
                            nmiEventEmitter.emit("payment-response", {
                              status: false,
                              message: e.message
                            });
                            var closeEle = document.getElementById("nmi3ds_modal_close");
                            if (closeEle) {
                              closeEle.click();
                            }
                            if (button) button.style.visibility = "visible";
                            _this3.setMessage(document.querySelector("." + paymentMessageClass), e === null || e === void 0 ? void 0 : e.message, "error");
                          });
                          _this3.nmiThreeDSecureUI.on("complete", /*#__PURE__*/function () {
                            var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e) {
                              var closeEle;
                              return _regeneratorRuntime.wrap(function (_context12) {
                                while (1) switch (_context12.prev = _context12.next) {
                                  case 0:
                                    if (e.cardHolderAuth === "verified" || e.cardHolderAuth === null) {
                                      nmiEventEmitter.emit("payment-response", {
                                        status: true,
                                        data: response
                                      });
                                    }
                                    closeEle = document.getElementById("nmi3ds_modal_close");
                                    if (closeEle) {
                                      closeEle.click();
                                    }
                                    if (button) {
                                      button.style.visibility = "visible";
                                    }
                                    if (paymentGateway && paymentGateway.showLoader) {
                                      paymentGateway.showLoader();
                                    }
                                  case 1:
                                  case "end":
                                    return _context12.stop();
                                }
                              }, _callee6);
                            }));
                            return function (_x11) {
                              return _ref4.apply(this, arguments);
                            };
                          }());
                        }
                        if (paymentGateway && paymentGateway.hideLoader) {
                          paymentGateway.hideLoader();
                        }
                      case 1:
                      case "end":
                        return _context13.stop();
                    }
                  }, _callee7);
                }));
                return function (_x10) {
                  return _ref3.apply(this, arguments);
                };
              }());
            case 19:
              _context14.next = 21;
              break;
            case 20:
              console.log("no nmi method found");
            case 21:
              _context14.next = 23;
              break;
            case 22:
              if (this.paymentIntentResponse.provider_name == "flywire") ;
            case 23:
              if (suppliedIntent.onInitilizePayment && typeof suppliedIntent.onInitilizePayment === "function") {
                suppliedIntent.onInitilizePayment({
                  paymentId: this.paymentIntentResponse.payment_id
                });
              }
              if (loadSecondary == false) {
                this.emit("payment_init_response", this.paymentIntentResponse);
              } else {
                this.emit("payment_changed", this.paymentIntentResponse);
              }
              return _context14.abrupt("return", this.paymentIntentResponse);
            case 24:
              _context14.prev = 24;
              _t6 = _context14["catch"](1);
              void this.updateLog({
                payment_id: (_this$paymentIntentRe14 = this.paymentIntentResponse) === null || _this$paymentIntentRe14 === void 0 ? void 0 : _this$paymentIntentRe14.payment_id,
                type: "error",
                provider: (_this$paymentIntentRe15 = this.paymentIntentResponse) === null || _this$paymentIntentRe15 === void 0 ? void 0 : _this$paymentIntentRe15.provider_name,
                message: messageFromCaught(_t6),
                event_name: "initilize_error"
              });
              console.log("error in initailization ", _t6);
            case 25:
              _context14.prev = 25;
              if (containerId && loaderToken === this.paymentLoaderToken) {
                hidePaymentFormLoader(containerId);
              }
              try {
                if (containerId) {
                  this.ensureMessageNode(containerId, paymentMessageClass);
                }
              } catch (error) {
                void this.updateLog({
                  payment_id: (_this$paymentIntentRe16 = this.paymentIntentResponse) === null || _this$paymentIntentRe16 === void 0 ? void 0 : _this$paymentIntentRe16.payment_id,
                  type: "error",
                  provider: (_this$paymentIntentRe17 = this.paymentIntentResponse) === null || _this$paymentIntentRe17 === void 0 ? void 0 : _this$paymentIntentRe17.provider_name,
                  message: messageFromCaught(error),
                  event_name: "initilize_error"
                });
              }
              return _context14.finish(25);
            case 26:
            case "end":
              return _context14.stop();
          }
        }, _callee8, this, [[1, 24, 25, 26], [2, 5]]);
      }));
      function initPayment(_x9, _x0, _x1) {
        return _initPayment.apply(this, arguments);
      }
      return initPayment;
    }()
  }, {
    key: "initSaveCard",
    value: function () {
      var _initSaveCard = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee1(containerId, buttonElement, paymentIntentBody) {
        var _this4 = this;
        var _this$saveCardRespons, _context15, ct, intentBody, paymentGateway, button, providerCredential, _paymentGateway$getPr2, clientSecret, paymentElement, _this$paymentIntentRe18, _this$paymentIntentRe19, _t7;
        return _regeneratorRuntime.wrap(function (_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.prev = 0;
              _context18.next = 1;
              return this.teardownSaveCardHostedFields();
            case 1:
              this.beginCardEntry(saveCardMessageClass);
              ct = document.querySelector("#" + containerId.id);
              if (containerId && ct && this.isCreditCard === false) {
                ct.innerHTML = "";
              }
              this.saveCardContainerId = containerId;
              if (this.customer) {
                _context18.next = 2;
                break;
              }
              return _context18.abrupt("return", {
                status: false,
                message: "Customer is not set. please set customer first."
              });
            case 2:
              intentBody = this.applyStripeAppearanceFromBody(paymentIntentBody);
              _context18.next = 3;
              return this.initialSaveCard(_objectSpread(_objectSpread({}, intentBody), {}, {
                type: undefined
              }));
            case 3:
              this.saveCardResponse = _context18.sent;
              this.savePaymentIntentBody = intentBody;
              if (!((_this$saveCardRespons = this.saveCardResponse) !== null && _this$saveCardRespons !== void 0 && (_this$saveCardRespons = _this$saveCardRespons.provider_credential) !== null && _this$saveCardRespons !== void 0 && _this$saveCardRespons.publishable_key)) {
                debug("Unable to get Provider publishable_key");
              }
              paymentGateway = this.saveCardResponse.provider_name === "braintree" ? this.braintreeSaveCardGateway() : this.gatewayFor(this.required(this.saveCardResponse, "provider_name").provider_name);
              if (!buttonElement.id) {
                buttonElement === null || buttonElement === void 0 || buttonElement.setAttribute("id", "payButton");
              }
              button = buttonElement;
              this.saveCardButtonElement = buttonElement;
              providerCredential = this.required(this.required(this.saveCardResponse, "provider_credential").provider_credential, "publishable_key");
              _context18.next = 4;
              return paymentGateway.init(this.saveCardResponse.provider_name === "braintree" ? providerCredential.client_token || providerCredential.tokenization_key || providerCredential.publishable_key : providerCredential.publishable_key || providerCredential.client_token || providerCredential.tokenization_key, containerId, _objectSpread(_objectSpread({}, intentBody), {}, {
                is_prod_env: this.saveCardResponse.is_prod_env,
                account_id: this.saveCardResponse.account_id,
                amount: 0,
                webhook_url: this.saveCardResponse.webhook_url,
                first_name: this.required(this.customer, "first_name").first_name,
                last_name: this.required(this.customer, "last_name").last_name,
                phone: this.required(this.customer, "phone").phone,
                email: this.required(this.customer, "email").email,
                payment_id: this.saveCardResponse.payment_id,
                processFlywirePayment: _bindInstanceProperty(_context15 = this.flywireSaveCard).call(_context15, this),
                recurringType: "tokenization",
                button_id: buttonElement.id
              }));
            case 4:
              if (!(this.saveCardResponse.provider_name == "stripe")) {
                _context18.next = 5;
                break;
              }
              clientSecret = this.required(this.required(this.saveCardResponse, "provider_credential").provider_credential, "client_token").client_token;
              this.elements = (_paymentGateway$getPr2 = paymentGateway.getProviderClient()) === null || _paymentGateway$getPr2 === void 0 ? void 0 : _paymentGateway$getPr2.elements(this.getStripeElementsOptions(clientSecret));
              paymentGateway === null || paymentGateway === void 0 || paymentGateway.setToken(clientSecret);
              if (paymentGateway.setElements) {
                paymentGateway.setElements(this.elements);
              }
              paymentElement = this.elements.create("payment", {
                // hidePostalCode: true,
              });
              if (paymentGateway.setCardElement) {
                paymentGateway.setCardElement(paymentElement);
              }
              paymentElement.mount(containerId);
              paymentElement.on("change", function (event) {
                _this4.stripeSavePaymentMethodType = event.value.type;
              });
              this.storeStripeClient(paymentGateway.getProviderClient());
              // paymentElement.on('change', function (event) {
              //   if (event.error || !event.complete) {
              //     button.disabled = true;
              //   } else {
              //     button.disabled = false;
              //   }
              // });
              // if (button) {
              //   button.addEventListener('click', async (e) => {
              //     e.preventDefault();
              //     await this.saveCard({
              //       email: this.customer?.email,
              //       account_id: this.saveCardResponse?.account_id,
              //       provider_name: this.saveCardResponse?.provider_name,
              //     });
              //     alert('Saved');
              //   });
              // } else {
              //   alert("Empty Button")
              // }
              _context18.next = 11;
              break;
            case 5:
              if (!(this.saveCardResponse.provider_name == "braintree")) {
                _context18.next = 8;
                break;
              }
              if (paymentGateway instanceof BraintreeGateway) {
                _context18.next = 6;
                break;
              }
              this.setMessage(document.querySelector("." + saveCardMessageClass), "An unexpected error occurred.", "error");
              _context18.next = 7;
              break;
            case 6:
              _context18.next = 7;
              return this.mountSaveCardBraintreeForm(containerId, paymentGateway);
            case 7:
              _context18.next = 11;
              break;
            case 8:
              if (!(this.saveCardResponse.provider_name == "nmi")) {
                _context18.next = 11;
                break;
              }
              if (!paymentGateway.getNMIPayment) {
                _context18.next = 10;
                break;
              }
              _context18.next = 9;
              return paymentGateway.getNMIPayment(/*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee0(response) {
                  var _document$querySelect2, gateway, threeDsService, postalCodeEle, postalCode;
                  return _regeneratorRuntime.wrap(function (_context17) {
                    while (1) switch (_context17.prev = _context17.next) {
                      case 0:
                        if (paymentGateway && paymentGateway.showLoader) {
                          paymentGateway.showLoader();
                        }
                        if (response.token && paymentGateway.getNMIGateway) {
                          gateway = paymentGateway.getNMIGateway();
                          threeDsService = gateway.get3DSecure();
                          if (_this4.nmiThreeDSecureUI) {
                            _this4.nmiThreeDSecureUI.unmount();
                          }
                          postalCodeEle = (_document$querySelect2 = document.querySelector("#" + containerId.id)) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.querySelector("[name='zip']");
                          postalCode = postalCodeEle.value;
                          _this4.nmiThreeDSecureUI = threeDsService.createUI({
                            paymentToken: response.token,
                            currency: paymentIntentBody.currency,
                            amount: 1,
                            //paymentIntentBody.amount,
                            firstName: _this4.required(_this4.customer, "first_name").first_name,
                            lastName: _this4.required(_this4.customer, "last_name").last_name,
                            postalCode: postalCode
                          });
                          _this4.nmiThreeDSecureUI.start("#nmi3ds_modal_content");
                          _this4.nmiThreeDSecureUI.on("error", function (e) {
                            nmiEventEmitter.emit("save-card-response", {
                              status: false,
                              data: e
                            });
                            var closeEle = document.getElementById("nmi3ds_modal_close");
                            if (closeEle) {
                              closeEle.click();
                            }
                            if (button) {
                              button.style.visibility = "visible";
                            }
                            _this4.setMessage(document.querySelector("." + saveCardMessageClass), e === null || e === void 0 ? void 0 : e.message, "error");
                          });
                          _this4.nmiThreeDSecureUI.on("failure", function (e) {
                            if (paymentGateway && paymentGateway.hideLoader) {
                              paymentGateway.hideLoader();
                            }
                            nmiEventEmitter.emit("save-card-response", {
                              status: false,
                              data: e
                            });
                            var closeEle = document.getElementById("nmi3ds_modal_close");
                            if (closeEle) {
                              closeEle.click();
                            }
                            if (button) {
                              button.style.visibility = "visible";
                            }
                            _this4.setMessage(document.querySelector("." + saveCardMessageClass), e === null || e === void 0 ? void 0 : e.message, "error");
                          });
                          _this4.nmiThreeDSecureUI.on("challenge", function (e) {
                            window.location.href = "#nmi3ds-modal";
                            _this4.setMessage(document.querySelector("." + saveCardMessageClass), e === null || e === void 0 ? void 0 : e.message, "error");
                          });
                          _this4.nmiThreeDSecureUI.on("complete", /*#__PURE__*/function () {
                            var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(e) {
                              var closeEle;
                              return _regeneratorRuntime.wrap(function (_context16) {
                                while (1) switch (_context16.prev = _context16.next) {
                                  case 0:
                                    if (e.cardHolderAuth === "verified" || e.cardHolderAuth === null) {
                                      nmiEventEmitter.emit("save-card-response", {
                                        status: true,
                                        data: response
                                      });
                                    }
                                    closeEle = document.getElementById("nmi3ds_modal_close");
                                    if (closeEle) {
                                      closeEle.click();
                                    }
                                    if (button) {
                                      button.style.visibility = "visible";
                                    }
                                  case 1:
                                  case "end":
                                    return _context16.stop();
                                }
                              }, _callee9);
                            }));
                            return function (_x16) {
                              return _ref6.apply(this, arguments);
                            };
                          }());
                          // await this.saveCard({
                          //   email: this.customer?.email,
                          //   account_id: this.saveCardResponse?.account_id,
                          //   provider_name: this.saveCardResponse?.provider_name,
                          //   token: response.token,
                          //   card: response.card,
                          // });
                        }
                        if (paymentGateway && paymentGateway.hideLoader) ;
                      case 1:
                      case "end":
                        return _context17.stop();
                    }
                  }, _callee0);
                }));
                return function (_x15) {
                  return _ref5.apply(this, arguments);
                };
              }());
            case 9:
              _context18.next = 11;
              break;
            case 10:
              console.log("no nmi method found");
            case 11:
              _context18.next = 13;
              break;
            case 12:
              _context18.prev = 12;
              _t7 = _context18["catch"](0);
              console.log("error in initailization ", _t7);
              this.setMessage(document.querySelector("." + saveCardMessageClass), messageFromCaught(_t7), "error");
            case 13:
              _context18.prev = 13;
              try {
                if (containerId) {
                  this.ensureMessageNode(containerId, saveCardMessageClass);
                }
              } catch (error) {
                void this.updateLog({
                  payment_id: (_this$paymentIntentRe18 = this.paymentIntentResponse) === null || _this$paymentIntentRe18 === void 0 ? void 0 : _this$paymentIntentRe18.payment_id,
                  type: "error",
                  provider: (_this$paymentIntentRe19 = this.paymentIntentResponse) === null || _this$paymentIntentRe19 === void 0 ? void 0 : _this$paymentIntentRe19.provider_name,
                  message: messageFromCaught(error),
                  event_name: "initilize_error"
                });
              }
              return _context18.finish(13);
            case 14:
            case "end":
              return _context18.stop();
          }
        }, _callee1, this, [[0, 12, 13, 14]]);
      }));
      function initSaveCard(_x12, _x13, _x14) {
        return _initSaveCard.apply(this, arguments);
      }
      return initSaveCard;
    }()
  }, {
    key: "handleSaveCard",
    value: function () {
      var _handleSaveCard = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(e) {
        var _this$saveCardRespons2, _this$customer2, _this$saveCardRespons3, _this$saveCardRespons4, _this$saveCardRespons5, _this$saveCardRespons6, _this$saveCardRespons7, _this$saveCardRespons8, _this$saveCardRespons13, _this$saveCardRespons16, _this$saveCardRespons19, saveCardRequest, paymentGateway, saveCardFields, message, _message, saveCardFieldMessages, _payload$details, _verified$threeDSecur, payload, _message2, expiryMessage, amount, email, verified, _this$saveCardRespons9, _this$saveCardRespons0, _context19, _this$saveCardRespons1, _this$saveCardRespons10, _this$paymentIntentRe20, _message3, code, _message4, fieldMessages, _this$saveCardRespons11, _this$saveCardRespons12, res, exp, card, cardValidate, res1, _this$saveCardRespons14, _this$saveCardRespons15, _res, _this$saveCardRespons17, _this$saveCardRespons18, result, _t8;
        return _regeneratorRuntime.wrap(function (_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              if (!this.saveCardInProgress) {
                _context20.next = 1;
                break;
              }
              e.preventDefault();
              return _context20.abrupt("return");
            case 1:
              this.beginCardEntry(saveCardMessageClass);
              this.saveCardInProgress = true;
              if (this.saveCardButtonElement) {
                this.saveCardButtonElement.disabled = true;
              }
              _context20.prev = 2;
              if (((_this$saveCardRespons2 = this.saveCardResponse) === null || _this$saveCardRespons2 === void 0 ? void 0 : _this$saveCardRespons2.provider_name) !== "nmi") {
                e.preventDefault();
              }
              saveCardRequest = {
                email: (_this$customer2 = this.customer) === null || _this$customer2 === void 0 ? void 0 : _this$customer2.email,
                account_id: (_this$saveCardRespons3 = this.saveCardResponse) === null || _this$saveCardRespons3 === void 0 ? void 0 : _this$saveCardRespons3.account_id,
                provider_name: (_this$saveCardRespons4 = this.saveCardResponse) === null || _this$saveCardRespons4 === void 0 ? void 0 : _this$saveCardRespons4.provider_name
              };
              paymentGateway = ((_this$saveCardRespons5 = this.saveCardResponse) === null || _this$saveCardRespons5 === void 0 ? void 0 : _this$saveCardRespons5.provider_name) === "braintree" ? this.braintreeSaveCardGateway() : this.gatewayFor((_this$saveCardRespons6 = this.saveCardResponse) === null || _this$saveCardRespons6 === void 0 ? void 0 : _this$saveCardRespons6.provider_name);
              if (!(((_this$saveCardRespons7 = this.saveCardResponse) === null || _this$saveCardRespons7 === void 0 ? void 0 : _this$saveCardRespons7.provider_name) == "stripe")) {
                _context20.next = 3;
                break;
              }
              _context20.next = 27;
              break;
            case 3:
              if (!(((_this$saveCardRespons8 = this.saveCardResponse) === null || _this$saveCardRespons8 === void 0 ? void 0 : _this$saveCardRespons8.provider_name) == "braintree")) {
                _context20.next = 17;
                break;
              }
              saveCardFields = this.saveCardHostedFieldsInstance;
              if (saveCardFields) {
                _context20.next = 4;
                break;
              }
              message = "Please enter card details first!";
              this.showCardFieldErrors(saveCardMessageClass, [message]);
              return _context20.abrupt("return", {
                status: false,
                message: message
              });
            case 4:
              if (paymentGateway instanceof BraintreeGateway) {
                _context20.next = 5;
                break;
              }
              _message = "An unexpected error occurred.";
              this.setMessage(document.querySelector("." + saveCardMessageClass), _message, "error");
              return _context20.abrupt("return", {
                status: false,
                message: _message
              });
            case 5:
              saveCardFieldMessages = messagesForCardEntry(messagesForBraintreeCardFields(saveCardFields.getState().fields), !saveCardFields.getState().fields.cardholderName || saveCardFields.getState().fields.cardholderName.isEmpty ? messageForLanguage(this.savePaymentIntentBody ? languageCodeOf(this.savePaymentIntentBody) : undefined, "cardHolderNameRequired") : undefined);
              if (!(saveCardFieldMessages.length > 0)) {
                _context20.next = 6;
                break;
              }
              this.showCardFieldErrors(saveCardMessageClass, saveCardFieldMessages);
              return _context20.abrupt("return", {
                status: false,
                message: saveCardFieldMessages[0]
              });
            case 6:
              _context20.prev = 6;
              _context20.next = 7;
              return saveCardFields.tokenize();
            case 7:
              payload = _context20.sent;
              if (!(!payload.nonce || !((_payload$details = payload.details) !== null && _payload$details !== void 0 && _payload$details.bin))) {
                _context20.next = 8;
                break;
              }
              _message2 = messageForBraintreeCardFields(saveCardFields.getState().fields) || "Please enter card details first!";
              this.showCardFieldErrors(saveCardMessageClass, [_message2]);
              return _context20.abrupt("return", {
                status: false,
                message: _message2
              });
            case 8:
              expiryMessage = messageForCardExpiry(payload.details.expirationMonth, payload.details.expirationYear);
              if (!expiryMessage) {
                _context20.next = 9;
                break;
              }
              this.showCardFieldErrors(saveCardMessageClass, [expiryMessage]);
              return _context20.abrupt("return", {
                status: false,
                message: expiryMessage
              });
            case 9:
              amount = String(this.required(this.savePaymentIntentBody, "amount").amount);
              email = this.required(this.customer, "email").email;
              _context20.next = 10;
              return paymentGateway.verify3dSecure(_objectSpread(_objectSpread({
                amount: amount,
                token: payload.nonce,
                bin: payload.details.bin
              }, typeof email === "string" ? {
                email: email
              } : {}), {}, {
                collectDeviceData: true
              }));
            case 10:
              verified = _context20.sent;
              if (!(this.saveCardResponse && this.shouldProceedAfter3DS((_verified$threeDSecur = verified.threeDSecureInfo) === null || _verified$threeDSecur === void 0 ? void 0 : _verified$threeDSecur.status))) {
                _context20.next = 12;
                break;
              }
              saveCardRequest["token"] = verified.nonce;
              _context20.next = 11;
              return this.braintreeDeviceData(paymentGateway);
            case 11:
              saveCardRequest["device_data"] = _context20.sent;
              void this.updateLog({
                payment_id: (_this$saveCardRespons9 = this.saveCardResponse) === null || _this$saveCardRespons9 === void 0 ? void 0 : _this$saveCardRespons9.payment_id,
                type: "info",
                provider: (_this$saveCardRespons0 = this.saveCardResponse) === null || _this$saveCardRespons0 === void 0 ? void 0 : _this$saveCardRespons0.provider_name,
                message: "Authorization success!",
                event_name: "save_card_authorizatoin_success"
              });
              _context20.next = 14;
              break;
            case 12:
              _message3 = "Authorization canceled!";
              if (verified.threeDSecureInfo && _indexOfInstanceProperty(_context19 = ["authenticate_frictionless_failed", "unsupported_card", "authenticate_unable_to_authenticate", "challenge_required", "authentication_unavailable", "lookup_failed_acs_error", "authenticate_error", "authenticate_rejected"]).call(_context19, verified.threeDSecureInfo.status) > -1) {
                _message3 = "Authorization failed! (Reason: " + verified.threeDSecureInfo.status + ")";
              }
              this.setMessage(document.querySelector("." + saveCardMessageClass), _message3, "error");
              void this.updateLog({
                payment_id: (_this$saveCardRespons1 = this.saveCardResponse) === null || _this$saveCardRespons1 === void 0 ? void 0 : _this$saveCardRespons1.payment_id,
                type: "error",
                provider: (_this$saveCardRespons10 = this.saveCardResponse) === null || _this$saveCardRespons10 === void 0 ? void 0 : _this$saveCardRespons10.provider_name,
                message: _message3,
                event_name: "save_card_authorizatoin_error"
              });
              _context20.next = 13;
              return this.initPayment(this.initContainerId, this.buttonElement, this.intentRequestBody, true, (_this$paymentIntentRe20 = this.paymentIntentResponse) === null || _this$paymentIntentRe20 === void 0 ? void 0 : _this$paymentIntentRe20.provider_name);
            case 13:
              return _context20.abrupt("return", {
                status: false,
                message: "Authorization canceled."
              });
            case 14:
              _context20.next = 16;
              break;
            case 15:
              _context20.prev = 15;
              _t8 = _context20["catch"](6);
              code = hostedFieldsErrorCode(_t8);
              _message4 = code === "HOSTED_FIELDS_FIELDS_EMPTY" || code === "HOSTED_FIELDS_FIELDS_INVALID" ? hostedFieldsFailureMessage(_t8, saveCardFields.getState().fields) : messageFromCaught(_t8) === "No payment method is available." ? "Please enter card details first!" : messageFromCaught(_t8) || "Something went wrong during 3D Secure authentication. Please try again.";
              fieldMessages = messagesForBraintreeCardFields(saveCardFields.getState().fields);
              this.showCardFieldErrors(saveCardMessageClass, code === "HOSTED_FIELDS_FIELDS_EMPTY" || code === "HOSTED_FIELDS_FIELDS_INVALID" ? fieldMessages.length > 0 ? fieldMessages : [_message4] : [_message4]);
              if (code !== "HOSTED_FIELDS_FIELDS_EMPTY" && code !== "HOSTED_FIELDS_FIELDS_INVALID" && _message4 !== "Please enter card details first!") {
                void this.updateLog({
                  payment_id: (_this$saveCardRespons11 = this.saveCardResponse) === null || _this$saveCardRespons11 === void 0 ? void 0 : _this$saveCardRespons11.payment_id,
                  type: "error",
                  provider: (_this$saveCardRespons12 = this.saveCardResponse) === null || _this$saveCardRespons12 === void 0 ? void 0 : _this$saveCardRespons12.provider_name,
                  message: _message4,
                  event_name: "save_card_authorizatoin_error"
                });
              }
              console.log("Braintree Dropin Submit:", _t8);
              return _context20.abrupt("return", {
                status: false,
                message: _message4
              });
            case 16:
              _context20.next = 27;
              break;
            case 17:
              if (!(((_this$saveCardRespons13 = this.saveCardResponse) === null || _this$saveCardRespons13 === void 0 ? void 0 : _this$saveCardRespons13.provider_name) == "nmi")) {
                _context20.next = 24;
                break;
              }
              if (paymentGateway.showLoader) {
                paymentGateway.showLoader();
              }
              _context20.next = 18;
              return new _Promise(function (resolve, reject) {
                nmiEventEmitter.once("save-card-response", resolve);
                nmiEventEmitter.once("error", reject);
              });
            case 18:
              res = _context20.sent;
              if (!(res.status === true)) {
                _context20.next = 22;
                break;
              }
              console.log("NMI Card Data", res);
              exp = res["data"]["card"].exp.match(/.{1,2}/g);
              card = {
                type: res["data"]["card"].type
              };
              card.exp_month = exp[0];
              card.exp_year = exp[1];
              card.last4 = res["data"]["card"].number.substr(res["data"]["card"].number.length - 4);
              saveCardRequest["token"] = res["data"]["token"];
              saveCardRequest["card"] = res["data"]["card"];
              if (paymentGateway && paymentGateway.showLoader) {
                paymentGateway.showLoader();
              }
              cardValidate = new CardValidation();
              cardValidate.loadDiv(this.required(this.saveCardContainerId, "innerHTML"), card, nmiEventEmitter);
              _context20.next = 19;
              return new _Promise(function (resolve, reject) {
                nmiEventEmitter.once("cvv-validation-response", resolve);
                nmiEventEmitter.once("error", reject);
              });
            case 19:
              res1 = _context20.sent;
              if (paymentGateway && paymentGateway.showLoader) {
                paymentGateway.showLoader();
              }
              console.log("NMI CVV Response: ", res1);
              if (!(res1.status === true)) {
                _context20.next = 20;
                break;
              }
              saveCardRequest.cvv = res1["cvv"];
              _context20.next = 21;
              break;
            case 20:
              return _context20.abrupt("return", {
                status: false
              });
            case 21:
              _context20.next = 23;
              break;
            case 22:
              this.setMessage(document.querySelector("." + saveCardMessageClass), res === null || res === void 0 ? void 0 : res.message, "error");
              void this.updateLog({
                payment_id: (_this$saveCardRespons14 = this.saveCardResponse) === null || _this$saveCardRespons14 === void 0 ? void 0 : _this$saveCardRespons14.payment_id,
                type: "error",
                provider: (_this$saveCardRespons15 = this.saveCardResponse) === null || _this$saveCardRespons15 === void 0 ? void 0 : _this$saveCardRespons15.provider_name,
                message: res === null || res === void 0 ? void 0 : res.message,
                event_name: "save_card_error"
              });
              return _context20.abrupt("return", res);
            case 23:
              _context20.next = 27;
              break;
            case 24:
              if (!(((_this$saveCardRespons16 = this.saveCardResponse) === null || _this$saveCardRespons16 === void 0 ? void 0 : _this$saveCardRespons16.provider_name) == "flywire")) {
                _context20.next = 27;
                break;
              }
              _context20.next = 25;
              return new _Promise(function (resolve, reject) {
                flywireEventEmitter.once("save-card-response", resolve);
                flywireEventEmitter.once("error", reject);
              });
            case 25:
              _res = _context20.sent;
              if (!(_res.status === "success")) {
                _context20.next = 26;
                break;
              }
              saveCardRequest["token"] = _res["token"];
              saveCardRequest["card"] = _res["card"];
              _context20.next = 27;
              break;
            case 26:
              void this.updateLog({
                payment_id: (_this$saveCardRespons17 = this.saveCardResponse) === null || _this$saveCardRespons17 === void 0 ? void 0 : _this$saveCardRespons17.payment_id,
                type: "error",
                provider: (_this$saveCardRespons18 = this.saveCardResponse) === null || _this$saveCardRespons18 === void 0 ? void 0 : _this$saveCardRespons18.provider_name,
                message: _res === null || _res === void 0 ? void 0 : _res.message,
                event_name: "save_card_error"
              });
              return _context20.abrupt("return", _res);
            case 27:
              _context20.next = 28;
              return this.saveCard(saveCardRequest);
            case 28:
              result = _context20.sent;
              if (((_this$saveCardRespons19 = this.saveCardResponse) === null || _this$saveCardRespons19 === void 0 ? void 0 : _this$saveCardRespons19.provider_name) !== "braintree" && paymentGateway && paymentGateway.showLoader) {
                paymentGateway.showLoader();
              }
              return _context20.abrupt("return", result);
            case 29:
              _context20.prev = 29;
              this.finishSaveCardAttempt();
              return _context20.finish(29);
            case 30:
            case "end":
              return _context20.stop();
          }
        }, _callee10, this, [[2,, 29, 30], [6, 15]]);
      }));
      function handleSaveCard(_x17) {
        return _handleSaveCard.apply(this, arguments);
      }
      return handleSaveCard;
    }()
  }, {
    key: "confirmPayment",
    value: function () {
      var _confirmPayment = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(paymentGatewayInstance, elements, reqBody) {
        var confirmPaymentResponse;
        return _regeneratorRuntime.wrap(function (_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 1;
              return paymentGatewayInstance === null || paymentGatewayInstance === void 0 ? void 0 : paymentGatewayInstance.confirmPayment({
                elements: elements,
                confirmParams: reqBody,
                redirect: "if_required"
              });
            case 1:
              confirmPaymentResponse = _context21.sent;
              return _context21.abrupt("return", confirmPaymentResponse);
            case 2:
            case "end":
              return _context21.stop();
          }
        }, _callee11);
      }));
      function confirmPayment(_x18, _x19, _x20) {
        return _confirmPayment.apply(this, arguments);
      }
      return confirmPayment;
    }()
  }, {
    key: "fetchProvider",
    value: function () {
      var _fetchProvider = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(data) {
        var response, providerResponse;
        return _regeneratorRuntime.wrap(function (_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 1;
              return this.fetch("".concat(this.apiBaseURL, "/v1/fetch_provider"), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": this.apiKey
                },
                body: _JSON$stringify(data)
              });
            case 1:
              response = _context22.sent;
              _context22.next = 2;
              return response.json();
            case 2:
              providerResponse = _context22.sent;
              return _context22.abrupt("return", providerResponse);
            case 3:
            case "end":
              return _context22.stop();
          }
        }, _callee12, this);
      }));
      function fetchProvider(_x21) {
        return _fetchProvider.apply(this, arguments);
      }
      return fetchProvider;
    }()
  }, {
    key: "config",
    value: function () {
      var _config = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13(data) {
        var _context23;
        var response, config;
        return _regeneratorRuntime.wrap(function (_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _context24.next = 1;
              return this.fetch("".concat(this.apiBaseURL, "/v1/payment/config"), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Basic ".concat(btoa(_concatInstanceProperty(_context23 = "".concat(this.apiKey, ":")).call(_context23, this.apiSecret)), " ")
                },
                body: _JSON$stringify({
                  clientCountry: data.metadata.clientCountry
                })
              });
            case 1:
              response = _context24.sent;
              _context24.next = 2;
              return response.json();
            case 2:
              config = _context24.sent;
              return _context24.abrupt("return", config);
            case 3:
            case "end":
              return _context24.stop();
          }
        }, _callee13, this);
      }));
      function config(_x22) {
        return _config.apply(this, arguments);
      }
      return config;
    }()
  }, {
    key: "createSetupIntent",
    value: function () {
      var _createSetupIntent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee14(data) {
        var _context25, response, sIntent, _t9;
        return _regeneratorRuntime.wrap(function (_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              _context26.prev = 0;
              _context26.next = 1;
              return this.fetch("".concat(this.apiBaseURL, "/v1/payment/setup_intent"), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Basic ".concat(btoa(_concatInstanceProperty(_context25 = "".concat(this.apiKey, ":")).call(_context25, this.apiSecret)), " ")
                },
                body: _JSON$stringify({
                  clientCountry: data.metadata.clientCountry,
                  setupIntent: _objectSpread({}, data)
                })
              });
            case 1:
              response = _context26.sent;
              _context26.next = 2;
              return response.json();
            case 2:
              sIntent = _context26.sent;
              return _context26.abrupt("return", sIntent);
            case 3:
              _context26.prev = 3;
              _t9 = _context26["catch"](0);
              throw new Error("Error: " + _t9, {
                cause: _t9
              });
            case 4:
            case "end":
              return _context26.stop();
          }
        }, _callee14, this, [[0, 3]]);
      }));
      function createSetupIntent(_x23) {
        return _createSetupIntent.apply(this, arguments);
      }
      return createSetupIntent;
    }()
  }, {
    key: "finishSetup",
    value: function () {
      var _finishSetup = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee15(data) {
        var _context27, response, sIntent, _t0;
        return _regeneratorRuntime.wrap(function (_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              _context28.prev = 0;
              _context28.next = 1;
              return this.fetch("".concat(this.apiBaseURL, "/v1/payment/finish_setup"), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Basic ".concat(btoa(_concatInstanceProperty(_context27 = "".concat(this.apiKey, ":")).call(_context27, this.apiSecret)), " ")
                },
                body: _JSON$stringify({
                  clientCountry: data.metadata.clientCountry,
                  setupIntent: _objectSpread({}, data)
                })
              });
            case 1:
              response = _context28.sent;
              _context28.next = 2;
              return response.json();
            case 2:
              sIntent = _context28.sent;
              return _context28.abrupt("return", sIntent);
            case 3:
              _context28.prev = 3;
              _t0 = _context28["catch"](0);
              throw new Error("Error: " + _t0, {
                cause: _t0
              });
            case 4:
            case "end":
              return _context28.stop();
          }
        }, _callee15, this, [[0, 3]]);
      }));
      function finishSetup(_x24) {
        return _finishSetup.apply(this, arguments);
      }
      return finishSetup;
    }()
  }, {
    key: "createPaymentIntent",
    value: function () {
      var _createPaymentIntent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee16(data) {
        var response, pIntent, _t1;
        return _regeneratorRuntime.wrap(function (_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              _context29.prev = 0;
              _context29.next = 1;
              return this.fetch("".concat(this.apiBaseURL, "/v1/payment"), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": this.apiKey
                },
                body: _JSON$stringify(_objectSpread(_objectSpread({}, data), this.ipqsResult ? {
                  ipqs_device_fingerprint: this.ipqsResult
                } : {}))
              });
            case 1:
              response = _context29.sent;
              _context29.next = 2;
              return response.json();
            case 2:
              pIntent = _context29.sent;
              return _context29.abrupt("return", pIntent);
            case 3:
              _context29.prev = 3;
              _t1 = _context29["catch"](0);
              throw new Error("Error: " + _t1, {
                cause: _t1
              });
            case 4:
            case "end":
              return _context29.stop();
          }
        }, _callee16, this, [[0, 3]]);
      }));
      function createPaymentIntent(_x25) {
        return _createPaymentIntent.apply(this, arguments);
      }
      return createPaymentIntent;
    }()
  }, {
    key: "createSavedCardIntent",
    value: function () {
      var _createSavedCardIntent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee17(data) {
        var response, paymentMethodResult, _t10;
        return _regeneratorRuntime.wrap(function (_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              _context30.prev = 0;
              _context30.next = 1;
              return this.fetch("".concat(this.apiBaseURL, "/v1/payment/saved_card_intent"), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": this.apiKey
                },
                body: _JSON$stringify(data)
              });
            case 1:
              response = _context30.sent;
              _context30.next = 2;
              return response.json();
            case 2:
              paymentMethodResult = _context30.sent;
              return _context30.abrupt("return", paymentMethodResult);
            case 3:
              _context30.prev = 3;
              _t10 = _context30["catch"](0);
              throw new Error("Error creating payment method with CVV: " + _t10, {
                cause: _t10
              });
            case 4:
            case "end":
              return _context30.stop();
          }
        }, _callee17, this, [[0, 3]]);
      }));
      function createSavedCardIntent(_x26) {
        return _createSavedCardIntent.apply(this, arguments);
      }
      return createSavedCardIntent;
    }()
  }, {
    key: "updatePayment",
    value: function () {
      var _updatePayment = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee18(data) {
        var _context31, payment_id, response, pIntent, _t11;
        return _regeneratorRuntime.wrap(function (_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              _context32.prev = 0;
              payment_id = data.payment_id;
              delete data.payment_id;
              _context32.next = 1;
              return this.fetch(_concatInstanceProperty(_context31 = "".concat(this.apiBaseURL, "/v1/payment/")).call(_context31, payment_id), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": this.apiKey
                },
                body: _JSON$stringify(data)
              });
            case 1:
              response = _context32.sent;
              _context32.next = 2;
              return response.json();
            case 2:
              pIntent = _context32.sent;
              return _context32.abrupt("return", pIntent);
            case 3:
              _context32.prev = 3;
              _t11 = _context32["catch"](0);
              throw new Error("Error: " + _t11, {
                cause: _t11
              });
            case 4:
            case "end":
              return _context32.stop();
          }
        }, _callee18, this, [[0, 3]]);
      }));
      function updatePayment(_x27) {
        return _updatePayment.apply(this, arguments);
      }
      return updatePayment;
    }()
  }, {
    key: "initialSaveCard",
    value: function () {
      var _initialSaveCard = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee19(data) {
        var response, pIntent, _t12;
        return _regeneratorRuntime.wrap(function (_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              _context33.prev = 0;
              _context33.next = 1;
              return this.fetch("".concat(this.apiBaseURL, "/v1/payment/initiate_save_card"), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": this.apiKey
                },
                body: _JSON$stringify(data)
              });
            case 1:
              response = _context33.sent;
              _context33.next = 2;
              return response.json();
            case 2:
              pIntent = _context33.sent;
              return _context33.abrupt("return", pIntent);
            case 3:
              _context33.prev = 3;
              _t12 = _context33["catch"](0);
              throw new Error("Error: " + _t12, {
                cause: _t12
              });
            case 4:
            case "end":
              return _context33.stop();
          }
        }, _callee19, this, [[0, 3]]);
      }));
      function initialSaveCard(_x28) {
        return _initialSaveCard.apply(this, arguments);
      }
      return initialSaveCard;
    }()
  }, {
    key: "initCreditCard",
    value: function () {
      var _initCreditCard = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee22(containerId, buttonElement) {
        var _this5 = this;
        var loadStates, loadCountries, loadDivs, button;
        return _regeneratorRuntime.wrap(function (_context38) {
          while (1) switch (_context38.prev = _context38.next) {
            case 0:
              this.isCreditCard = true;
              loadStates = /*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee20(countryCode) {
                  var _context34;
                  var statesSelect, response, states;
                  return _regeneratorRuntime.wrap(function (_context35) {
                    while (1) switch (_context35.prev = _context35.next) {
                      case 0:
                        statesSelect = document.getElementById("cust_state_code");
                        statesSelect.innerHTML = "";
                        _context35.next = 1;
                        return _this5.fetch(_concatInstanceProperty(_context34 = "".concat(_this5.apiBaseURL, "/v1/master/common/states/")).call(_context34, countryCode), {
                          method: "GET",
                          headers: {
                            "Content-Type": "application/json",
                            "api-key": _this5.apiKey
                          }
                        });
                      case 1:
                        response = _context35.sent;
                        if (statesSelect) {
                          states = response.json();
                          _forEachInstanceProperty(states).call(states, function (cc) {
                            statesSelect.add(new Option(cc.label, cc.value));
                          });
                        } else {
                          console.log("states not found");
                        }
                      case 2:
                      case "end":
                        return _context35.stop();
                    }
                  }, _callee20);
                }));
                return function loadStates(_x31) {
                  return _ref7.apply(this, arguments);
                };
              }(); // NOTE: reconstructed — the source we were asked to refactor only contained the tail end
              // of this country-loading routine (the assignment to `this.locationData` and the
              // `countrySelect` default-value logic below). The country-list endpoint and the
              // geolocation lookup used here are a best-effort reconstruction; please verify them
              // against your actual backend/API before shipping.
              loadCountries = /*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
                  var countrySelect, placeholderOption, response, countries, locationResponse, event;
                  return _regeneratorRuntime.wrap(function (_context36) {
                    while (1) switch (_context36.prev = _context36.next) {
                      case 0:
                        countrySelect = document.getElementById("cust_country_code");
                        if (!countrySelect) {
                          _context36.next = 3;
                          break;
                        }
                        countrySelect.innerHTML = "";
                        placeholderOption = new Option("Select country", "");
                        placeholderOption.disabled = true;
                        placeholderOption.selected = true;
                        countrySelect.add(placeholderOption);
                        _context36.next = 1;
                        return _this5.fetch("".concat(_this5.apiBaseURL, "/v1/master/common/countries"), {
                          method: "GET",
                          headers: {
                            "Content-Type": "application/json",
                            "api-key": _this5.apiKey
                          }
                        });
                      case 1:
                        response = _context36.sent;
                        countries = response.json();
                        if (_Array$isArray(countries)) {
                          _forEachInstanceProperty(countries).call(countries, function (cc) {
                            countrySelect.add(new Option(cc.countryName, cc.countryCode));
                          });
                        }
                        _context36.next = 2;
                        return _this5.fetch("https://www.geoplugin.net/json.gp", {
                          method: "GET",
                          headers: {}
                        });
                      case 2:
                        locationResponse = _context36.sent;
                        _this5.locationData = locationResponse.json();
                        if (locationResponse.status == 200) {
                          countrySelect.value = _this5.locationData.geoplugin_countryCode;
                          event = new Event("change");
                          countrySelect.dispatchEvent(event);
                        }
                        _context36.next = 4;
                        break;
                      case 3:
                        console.log("Country select not found");
                      case 4:
                      case "end":
                        return _context36.stop();
                    }
                  }, _callee21);
                }));
                return function loadCountries() {
                  return _ref8.apply(this, arguments);
                };
              }();
              loadDivs = function loadDivs() {
                var sheet = document.createElement("style");
                sheet.innerHTML = "".concat(_this5.creditCardCSS);
                var paymentFieldsHTML = "".concat(_this5.creditCardHTML);
                containerId.innerHTML = paymentFieldsHTML;
                containerId.appendChild(sheet);
                var fields = ["cc_number", "cardholder_first_name", "cardholder_last_name", "cc_type", "cc_expiry", "cc_code", "cust_street", "cust_city", "cust_country_code", "cust_state_code", "cust_post_code"];
                _forEachInstanceProperty(fields).call(fields, function (element) {
                  var ele = document.getElementById(element);
                  if (ele) {
                    if (element == "cc_number") {
                      var cardNumberPattern = {
                        mask: [{
                          mask: "0000 0000 0000 0000",
                          regex: /^4\d{0,15}/,
                          cardtype: "visa"
                        }, {
                          mask: "0000 0000 0000 0000",
                          regex: /^(^5[1-5]\d{0,2}|^22[2-9]\d|^2[3-7]\d{0,2})\d{0,12}/,
                          cardtype: "mastercard"
                        }, {
                          mask: "0000 0000 0000 0000",
                          regex: /^3[47]\\d{0,13}/,
                          cardtype: "american-express"
                        }, {
                          mask: "0000 0000 0000 0000",
                          regex: /^606282|^3841(?:[0|4|6]{1})0/,
                          cardtype: "hipercard"
                        }, {
                          mask: "0000 0000 0000 0000",
                          regex: /^6\d{0,15}/,
                          cardtype: "elo"
                        }, {
                          mask: "0000 0000 0000 0000",
                          cardtype: "default"
                        }],
                        dispatch: function dispatch(appended, dynamicMasked) {
                          var _context37;
                          var number = (dynamicMasked.value + appended).replace(/\D/g, "");
                          var foundMask = _findInstanceProperty(_context37 = dynamicMasked.compiledMasks).call(_context37, function (item) {
                            if ("regex" in item && item.regex instanceof RegExp) {
                              return number.match(item.regex);
                            }
                            return null;
                          });
                          return foundMask;
                        }
                      };
                      var cardNumberMasked = IMask(ele, cardNumberPattern);
                      cardNumberMasked.on("accept", function () {
                        //
                      });
                      ele.onblur = function (event) {
                        var target = event.target;
                        if (target instanceof HTMLInputElement) {
                          _this5.checkCardNumber(target.value || 0);
                        }
                      };
                    }
                    if (element == "cc_expiry") {
                      var ccYearElement = document.getElementById("cc_expiry");
                      if (ccYearElement) {
                        var expirationdate_mask = IMask(ccYearElement, {
                          mask: "MM{/}YY",
                          lazy: false,
                          blocks: {
                            YY: {
                              mask: IMask.MaskedRange,
                              from: _parseInt(new Date().getFullYear().toString().substr(-2)),
                              to: 99
                            },
                            MM: {
                              mask: IMask.MaskedRange,
                              from: 1,
                              to: 12
                            }
                          }
                        });
                        expirationdate_mask.on("accept", function () {
                          //
                        });
                      }
                      ele.onblur = function () {
                        _this5.checkccYear();
                      };
                    }
                    if (element == "cc_code") {
                      var _ccYearElement = document.getElementById("cc_code");
                      if (_ccYearElement) {
                        IMask(_ccYearElement, {
                          mask: IMask.MaskedRange,
                          from: 0,
                          to: 9999,
                          minLength: 3,
                          maxLength: 4
                        });
                      }
                    }
                    ele.onchange = function () {
                      if (element == "cust_country_code") {
                        var stateCodeele = document.getElementById("cust_state_code_div");
                        if (ele.value === "US" || ele.value === "CA") {
                          if (stateCodeele) {
                            stateCodeele.style.display = "block";
                          }
                          loadStates(ele.value);
                          if (ele) {
                            var _ele$parentElement;
                            (_ele$parentElement = ele.parentElement) === null || _ele$parentElement === void 0 || (_ele$parentElement = _ele$parentElement.parentElement) === null || _ele$parentElement === void 0 || (_ele$parentElement = _ele$parentElement.classList) === null || _ele$parentElement === void 0 || _ele$parentElement.add("col-half");
                          }
                        } else {
                          if (stateCodeele) {
                            stateCodeele.style.display = "none";
                          }
                          if (ele) {
                            var _ele$parentElement2;
                            (_ele$parentElement2 = ele.parentElement) === null || _ele$parentElement2 === void 0 || (_ele$parentElement2 = _ele$parentElement2.parentElement) === null || _ele$parentElement2 === void 0 || (_ele$parentElement2 = _ele$parentElement2.classList) === null || _ele$parentElement2 === void 0 || _ele$parentElement2.remove("col-half");
                          }
                        }
                      }
                      _this5.checkCreditCardFormValidation(_defineProperty({}, element, ele.value), element);
                    };
                  } else {
                    console.log("not found onchange event on", element);
                  }
                });
              };
              loadDivs();
              loadCountries();
              button = buttonElement;
              button.disabled = false;
            case 1:
            case "end":
              return _context38.stop();
          }
        }, _callee22, this);
      }));
      function initCreditCard(_x29, _x30) {
        return _initCreditCard.apply(this, arguments);
      }
      return initCreditCard;
    }()
  }, {
    key: "processPayment",
    value: function () {
      var _processPayment = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee23(data) {
        var response, pIntent, isFraudSuspected, _this$paymentIntentRe21, _this$paymentIntentRe22, _this$paymentIntentRe23, _this$paymentIntentRe24, _this$paymentIntentRe25, providerName, paymentId, statusResult, retryResult, _this$paymentIntentRe26, _this$paymentIntentRe27, msgEl, message, _t13;
        return _regeneratorRuntime.wrap(function (_context39) {
          while (1) switch (_context39.prev = _context39.next) {
            case 0:
              _context39.prev = 0;
              _context39.next = 1;
              return this.fetch("".concat(this.apiBaseURL, "/v1/payment/process_payment"), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": this.apiKey
                },
                body: _JSON$stringify(_objectSpread(_objectSpread({}, data), this.ipqsResult ? {
                  ipqs_device_fingerprint: this.ipqsResult
                } : {}))
              });
            case 1:
              response = _context39.sent;
              _context39.next = 2;
              return response.json();
            case 2:
              pIntent = _context39.sent;
              isFraudSuspected = !!pIntent.fraud_suspected;
              if (!(pIntent.code && pIntent.code > 399)) {
                _context39.next = 4;
                break;
              }
              this.setMessage(document.querySelector("." + paymentMessageClass), friendlyCardFailureMessage(pIntent === null || pIntent === void 0 ? void 0 : pIntent.message) || (pIntent === null || pIntent === void 0 ? void 0 : pIntent.message), "error");
              _context39.next = 3;
              return this.initPayment(this.initContainerId, this.buttonElement, this.intentRequestBody, true, (_this$paymentIntentRe21 = this.paymentIntentResponse) === null || _this$paymentIntentRe21 === void 0 ? void 0 : _this$paymentIntentRe21.provider_name);
            case 3:
              _context39.next = 11;
              break;
            case 4:
              providerName = (_this$paymentIntentRe22 = this.paymentIntentResponse) === null || _this$paymentIntentRe22 === void 0 ? void 0 : _this$paymentIntentRe22.provider_name;
              paymentId = ((_this$paymentIntentRe23 = this.paymentIntentResponse) === null || _this$paymentIntentRe23 === void 0 || (_this$paymentIntentRe23 = _this$paymentIntentRe23.payment_id) === null || _this$paymentIntentRe23 === void 0 || (_this$paymentIntentRe24 = _this$paymentIntentRe23.toString) === null || _this$paymentIntentRe24 === void 0 ? void 0 : _this$paymentIntentRe24.call(_this$paymentIntentRe23)) || ((_this$paymentIntentRe25 = this.paymentIntentResponse) === null || _this$paymentIntentRe25 === void 0 ? void 0 : _this$paymentIntentRe25.payment_id); // Braintree status polling: post-auth rules can set fraud asynchronously. If process_payment
              // returned fraud_suspected=false, we still poll the status API (1s + optional 2.5s retry)
              // to pick up fraud set by post-auth or webhooks before showing the success message.
              if (!(providerName === "braintree" && paymentId && !isFraudSuspected)) {
                _context39.next = 10;
                break;
              }
              _context39.next = 5;
              return new _Promise(function (r) {
                return _setTimeout(r, 1000);
              });
            case 5:
              _context39.next = 6;
              return this.getPaymentStatus(String(paymentId), "braintree");
            case 6:
              statusResult = _context39.sent;
              if (statusResult.fraud_suspected) {
                _context39.next = 9;
                break;
              }
              _context39.next = 7;
              return new _Promise(function (r) {
                return _setTimeout(r, 2500);
              });
            case 7:
              _context39.next = 8;
              return this.getPaymentStatus(String(paymentId), "braintree");
            case 8:
              retryResult = _context39.sent;
              if (retryResult.fraud_suspected) statusResult = retryResult;
            case 9:
              if (statusResult.fraud_suspected) isFraudSuspected = true;
            case 10:
              if (isFraudSuspected) {
                void this.updateLog({
                  payment_id: (_this$paymentIntentRe26 = this.paymentIntentResponse) === null || _this$paymentIntentRe26 === void 0 ? void 0 : _this$paymentIntentRe26.payment_id,
                  type: "info",
                  provider: (_this$paymentIntentRe27 = this.paymentIntentResponse) === null || _this$paymentIntentRe27 === void 0 ? void 0 : _this$paymentIntentRe27.provider_name,
                  message: FRAUD_SUSPECTED_MESSAGE,
                  event_name: AUTHORIZATION_FRAUD_SUSPECTED_EVENT
                });
                msgEl = document.querySelector("." + paymentMessageClass);
                this.setMessage(msgEl, FRAUD_SUSPECTED_MESSAGE, "error");
                this.applyFraudDeclineUI(msgEl);
              } else {
                this.setMessage(document.querySelector("." + paymentMessageClass), "Payment authorized success", "success");
              }
            case 11:
              return _context39.abrupt("return", _objectSpread(_objectSpread({
                status: true
              }, pIntent), {}, {
                fraud_suspected: isFraudSuspected
              }));
            case 12:
              _context39.prev = 12;
              _t13 = _context39["catch"](0);
              message = messageFromCaught(_t13);
              this.setMessage(document.querySelector("." + paymentMessageClass), message, "error");
              console.log(_t13);
              return _context39.abrupt("return", {
                status: false,
                message: message
              });
            case 13:
            case "end":
              return _context39.stop();
          }
        }, _callee23, this, [[0, 12]]);
      }));
      function processPayment(_x32) {
        return _processPayment.apply(this, arguments);
      }
      return processPayment;
    }()
  }, {
    key: "preProcessPayment",
    value: function () {
      var _preProcessPayment = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee24(data) {
        var response, pIntent, _this$paymentIntentRe28, _this$paymentIntentRe29, _this$paymentIntentRe30, _this$paymentIntentRe31, isFraudSuspected, _this$paymentIntentRe32, _this$paymentIntentRe33, fraudMsgEl, msgDiv, _t14;
        return _regeneratorRuntime.wrap(function (_context40) {
          while (1) switch (_context40.prev = _context40.next) {
            case 0:
              _context40.prev = 0;
              _context40.next = 1;
              return this.fetch("".concat(this.apiBaseURL, "/v1/payment/pre_process_payment"), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": this.apiKey
                },
                body: _JSON$stringify(data)
              });
            case 1:
              response = _context40.sent;
              _context40.next = 2;
              return response.json();
            case 2:
              pIntent = _context40.sent;
              if (pIntent.code && pIntent.code > 399) {
                this.setMessage(document.querySelector("." + paymentMessageClass), friendlyCardFailureMessage(pIntent === null || pIntent === void 0 ? void 0 : pIntent.message) || (pIntent === null || pIntent === void 0 ? void 0 : pIntent.message), "error");
                void this.updateLog({
                  payment_id: (_this$paymentIntentRe28 = this.paymentIntentResponse) === null || _this$paymentIntentRe28 === void 0 ? void 0 : _this$paymentIntentRe28.payment_id,
                  type: "error",
                  provider: (_this$paymentIntentRe29 = this.paymentIntentResponse) === null || _this$paymentIntentRe29 === void 0 ? void 0 : _this$paymentIntentRe29.provider_name,
                  message: pIntent === null || pIntent === void 0 ? void 0 : pIntent.message,
                  event_name: "authorization_error"
                });
              } else {
                isFraudSuspected = !!pIntent.fraud_suspected;
                void this.updateLog({
                  payment_id: (_this$paymentIntentRe30 = this.paymentIntentResponse) === null || _this$paymentIntentRe30 === void 0 ? void 0 : _this$paymentIntentRe30.payment_id,
                  type: "info",
                  provider: (_this$paymentIntentRe31 = this.paymentIntentResponse) === null || _this$paymentIntentRe31 === void 0 ? void 0 : _this$paymentIntentRe31.provider_name,
                  message: isFraudSuspected ? FRAUD_SUSPECTED_MESSAGE : "Payment authorized success!",
                  event_name: isFraudSuspected ? AUTHORIZATION_FRAUD_SUSPECTED_EVENT : "authorization_success"
                });
                if (isFraudSuspected) {
                  fraudMsgEl = null;
                  if (((_this$paymentIntentRe32 = this.paymentIntentResponse) === null || _this$paymentIntentRe32 === void 0 ? void 0 : _this$paymentIntentRe32.provider_name) === "braintree") {
                    fraudMsgEl = document.querySelector("." + paymentMessageClass);
                    this.setMessage(fraudMsgEl, FRAUD_SUSPECTED_MESSAGE, "error");
                  } else if (((_this$paymentIntentRe33 = this.paymentIntentResponse) === null || _this$paymentIntentRe33 === void 0 ? void 0 : _this$paymentIntentRe33.provider_name) === "stripe" && this.initContainerId) {
                    this.initContainerId.innerHTML = "";
                    msgDiv = document.createElement("div");
                    msgDiv.className = paymentMessageClass;
                    this.initContainerId.appendChild(msgDiv);
                    this.setMessage(msgDiv, FRAUD_SUSPECTED_MESSAGE, "error");
                    fraudMsgEl = msgDiv;
                  } else {
                    fraudMsgEl = document.querySelector("." + paymentMessageClass);
                    this.setMessage(fraudMsgEl, FRAUD_SUSPECTED_MESSAGE, "error");
                  }
                  this.applyFraudDeclineUI(fraudMsgEl);
                } else {
                  this.setMessage(document.querySelector("." + paymentMessageClass), "Payment authorized success", "success");
                }
              }
              return _context40.abrupt("return", pIntent);
            case 3:
              _context40.prev = 3;
              _t14 = _context40["catch"](0);
              throw new Error("Error: " + _t14, {
                cause: _t14
              });
            case 4:
            case "end":
              return _context40.stop();
          }
        }, _callee24, this, [[0, 3]]);
      }));
      function preProcessPayment(_x33) {
        return _preProcessPayment.apply(this, arguments);
      }
      return preProcessPayment;
    }()
  }, {
    key: "capturePayment",
    value: function () {
      var _capturePayment = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee25(data) {
        var _context41, response, pCapture, _t15;
        return _regeneratorRuntime.wrap(function (_context42) {
          while (1) switch (_context42.prev = _context42.next) {
            case 0:
              _context42.prev = 0;
              _context42.next = 1;
              return this.fetch(_concatInstanceProperty(_context41 = "".concat(this.apiBaseURL, "/v1/payment/")).call(_context41, data.payment_id, "/capture"), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": this.apiKey
                },
                body: _JSON$stringify(_objectSpread(_objectSpread({}, data), {}, {
                  payment_id: undefined
                }))
              });
            case 1:
              response = _context42.sent;
              _context42.next = 2;
              return response.json();
            case 2:
              pCapture = _context42.sent;
              return _context42.abrupt("return", pCapture);
            case 3:
              _context42.prev = 3;
              _t15 = _context42["catch"](0);
              throw new Error("Error: " + _t15, {
                cause: _t15
              });
            case 4:
            case "end":
              return _context42.stop();
          }
        }, _callee25, this, [[0, 3]]);
      }));
      function capturePayment(_x34) {
        return _capturePayment.apply(this, arguments);
      }
      return capturePayment;
    }()
  }, {
    key: "saveCard",
    value: function () {
      var _saveCard = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee26(data) {
        var paymentGateway, result, message, _this$saveCardRespons20, _this$saveCardRespons21, savedMethodLabel, cardValidate, _this$saveCardRespons22, _this$saveCardRespons23, nonCardStripe, _cardValidate;
        return _regeneratorRuntime.wrap(function (_context43) {
          while (1) switch (_context43.prev = _context43.next) {
            case 0:
              paymentGateway = this.gatewayFor(data.provider_name);
              if (!paymentGateway) {
                _context43.next = 5;
                break;
              }
              _context43.next = 1;
              return paymentGateway.saveCard(_objectSpread({
                apiKey: this.apiKey,
                apiBaseURL: this.apiBaseURL
              }, data));
            case 1:
              result = _context43.sent;
              message = result.message;
              if (!(result.success === true)) {
                _context43.next = 3;
                break;
              }
              savedMethodLabel = "Card";
              if (data.payment_method === "paypal") {
                savedMethodLabel = "PayPal";
              } else if (data.payment_method === "googlePay") {
                savedMethodLabel = "Google Pay";
              } else if (data.payment_method === "applePay") {
                savedMethodLabel = "Apple Pay";
              } else if (data.payment_method === "venmo") {
                savedMethodLabel = "Venmo";
              }
              void this.updateLog({
                payment_id: (_this$saveCardRespons20 = this.saveCardResponse) === null || _this$saveCardRespons20 === void 0 ? void 0 : _this$saveCardRespons20.payment_id,
                type: "info",
                provider: (_this$saveCardRespons21 = this.saveCardResponse) === null || _this$saveCardRespons21 === void 0 ? void 0 : _this$saveCardRespons21.provider_name,
                message: "".concat(savedMethodLabel, " Saved!"),
                event_name: "save_card"
              });
              if (!(data.provider_name === "braintree")) {
                _context43.next = 2;
                break;
              }
              _context43.next = 2;
              return this.refreshSaveCardFields();
            case 2:
              this.setMessage(document.querySelector("." + saveCardMessageClass), "".concat(savedMethodLabel, " saved!"), "success");
              if (data.provider_name === "nmi") {
                cardValidate = new CardValidation();
                cardValidate.success(this.required(this.saveCardContainerId, "innerHTML"));
              }
              _context43.next = 4;
              break;
            case 3:
              nonCardStripe = data.provider_name === "stripe" && !!this.stripeSavePaymentMethodType && this.stripeSavePaymentMethodType !== "card";
              message = nonCardStripe ? result.message || messageFromCaught(result.error) : messageForStripeError(result.error, {
                paymentMethodType: data.provider_name === "stripe" ? this.stripeSavePaymentMethodType : undefined
              }) || friendlyCardFailureMessage(result.message) || friendlyCardFailureMessage(result.error) || result.message || messageFromCaught(result.error);
              this.showCardFieldErrors(saveCardMessageClass, [message]);
              void this.updateLog({
                payment_id: (_this$saveCardRespons22 = this.saveCardResponse) === null || _this$saveCardRespons22 === void 0 ? void 0 : _this$saveCardRespons22.payment_id,
                type: "error",
                provider: (_this$saveCardRespons23 = this.saveCardResponse) === null || _this$saveCardRespons23 === void 0 ? void 0 : _this$saveCardRespons23.provider_name,
                message: message,
                event_name: "save_card_error"
              });
              if (data.provider_name === "nmi") {
                _cardValidate = new CardValidation();
                _cardValidate.failed(this.required(this.saveCardContainerId, "innerHTML"), message || "Card validation failed");
              }
            case 4:
              return _context43.abrupt("return", _objectSpread(_objectSpread({}, result), {}, {
                message: message
              }));
            case 5:
              return _context43.abrupt("return", {});
            case 6:
            case "end":
              return _context43.stop();
          }
        }, _callee26, this);
      }));
      function saveCard(_x35) {
        return _saveCard.apply(this, arguments);
      }
      return saveCard;
    }()
  }, {
    key: "teardownSaveCardHostedFields",
    value: function () {
      var _teardownSaveCardHostedFields = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
        var walletTeardown, instance, _t16, _t17;
        return _regeneratorRuntime.wrap(function (_context44) {
          while (1) switch (_context44.prev = _context44.next) {
            case 0:
              walletTeardown = this.saveCardWalletTeardown;
              this.saveCardWalletTeardown = null;
              if (!walletTeardown) {
                _context44.next = 4;
                break;
              }
              _context44.prev = 1;
              _context44.next = 2;
              return walletTeardown();
            case 2:
              _context44.next = 4;
              break;
            case 3:
              _context44.prev = 3;
              _t16 = _context44["catch"](1);
              console.log("Braintree save card PayPal teardown", _t16);
            case 4:
              instance = this.saveCardHostedFieldsInstance;
              this.saveCardHostedFieldsInstance = null;
              _context44.next = 5;
              return this.braintreeSaveCardGateway().teardownDataCollector();
            case 5:
              if (instance) {
                _context44.next = 6;
                break;
              }
              return _context44.abrupt("return");
            case 6:
              _context44.prev = 6;
              _context44.next = 7;
              return instance.teardown();
            case 7:
              _context44.next = 9;
              break;
            case 8:
              _context44.prev = 8;
              _t17 = _context44["catch"](6);
              console.log("Braintree save card hosted fields teardown", _t17);
            case 9:
            case "end":
              return _context44.stop();
          }
        }, _callee27, this, [[1, 3], [6, 8]]);
      }));
      function teardownSaveCardHostedFields() {
        return _teardownSaveCardHostedFields.apply(this, arguments);
      }
      return teardownSaveCardHostedFields;
    }() /** Venmo vaulting for Add New Card — tokenizes with multi_use and calls /card (save). */
  }, {
    key: "mountSaveCardVenmo",
    value: (function () {
      var _mountSaveCardVenmo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee29(container, paymentGateway) {
        var _this6 = this;
        var client, mounted;
        return _regeneratorRuntime.wrap(function (_context46) {
          while (1) switch (_context46.prev = _context46.next) {
            case 0:
              if (this.walletMethodEnabled("venmo")) {
                _context46.next = 1;
                break;
              }
              return _context46.abrupt("return", undefined);
            case 1:
              client = paymentGateway.getClientInstance();
              if (client) {
                _context46.next = 2;
                break;
              }
              return _context46.abrupt("return", undefined);
            case 2:
              _context46.next = 3;
              return mountVenmoVaultButton({
                client: client,
                container: container,
                options: {
                  paymentMethodUsage: "multi_use",
                  allowDesktop: true,
                  allowDesktopWebLogin: false
                },
                onNonce: function () {
                  var _onNonce = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee28(nonce) {
                    return _regeneratorRuntime.wrap(function (_context45) {
                      while (1) switch (_context45.prev = _context45.next) {
                        case 0:
                          return _context45.abrupt("return", _this6.saveVaultNonce(nonce, "venmo", paymentGateway));
                        case 1:
                        case "end":
                          return _context45.stop();
                      }
                    }, _callee28);
                  }));
                  function onNonce(_x38) {
                    return _onNonce.apply(this, arguments);
                  }
                  return onNonce;
                }(),
                onError: function onError(message) {
                  _this6.setMessage(document.querySelector("." + saveCardMessageClass), message, "error");
                }
              });
            case 3:
              mounted = _context46.sent;
              return _context46.abrupt("return", mounted.teardown);
            case 4:
            case "end":
              return _context46.stop();
          }
        }, _callee29, this);
      }));
      function mountSaveCardVenmo(_x36, _x37) {
        return _mountSaveCardVenmo.apply(this, arguments);
      }
      return mountSaveCardVenmo;
    }())
  }, {
    key: "mountSaveCardHostedFields",
    value: function () {
      var _mountSaveCardHostedFields = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee30(container, paymentGateway, languageCode) {
        var _context47;
        var mountWallets,
          fieldIds,
          fieldsRoot,
          cardLabel,
          expirationCvvAndPostal,
          wallets,
          payButton,
          walletTask,
          hostedFieldsInstance,
          _args30 = arguments,
          _t18,
          _t19;
        return _regeneratorRuntime.wrap(function (_context48) {
          while (1) switch (_context48.prev = _context48.next) {
            case 0:
              mountWallets = _args30.length > 3 && _args30[3] !== undefined ? _args30[3] : true;
              fieldIds = {
                number: "".concat(container.id, "-bt-number"),
                expirationDate: "".concat(container.id, "-bt-expiration-date"),
                cvv: "".concat(container.id, "-bt-cvv"),
                cardholderName: "".concat(container.id, "-bt-cardholder-name"),
                postalCode: "".concat(container.id, "-bt-postal-code")
              };
              fieldsRoot = document.createElement("div");
              fieldsRoot.className = "pg-bt-hosted-fields";
              fieldsRoot.setAttribute("aria-busy", "true");
              cardLabel = document.createElement("p");
              cardLabel.className = "pg-bt-section-label";
              cardLabel.textContent = "Card";
              fieldsRoot.appendChild(cardLabel);
              expirationCvvAndPostal = document.createElement("div");
              expirationCvvAndPostal.className = "pg-bt-hosted-fields-row";
              expirationCvvAndPostal.append(hostedFieldSlot(fieldIds.expirationDate, "pg-bt-hosted-field-expiration-date", "Expiry"), hostedFieldSlot(fieldIds.cvv, "pg-bt-hosted-field-cvv", "CVV"), hostedFieldSlot(fieldIds.postalCode, "pg-bt-hosted-field-postal-code", "Postal Code"));
              fieldsRoot.append(hostedFieldSlot(fieldIds.cardholderName, "pg-bt-hosted-field-cardholder-name", messageForLanguage(languageCode, "cardHolderName")), hostedFieldSlot(fieldIds.number, "pg-bt-hosted-field-number", "Card Number"), expirationCvvAndPostal);
              _forEachInstanceProperty(_context47 = container.querySelectorAll(".pg-bt-hosted-fields")).call(_context47, function (node) {
                return node.remove();
              });
              wallets = container.querySelector(":scope > .pg-bt-wallets");
              if (wallets) {
                container.insertBefore(fieldsRoot, wallets);
              } else {
                container.appendChild(fieldsRoot);
              }
              payButton = container.nextElementSibling;
              if (payButton instanceof HTMLButtonElement && payButton.id === "submit") {
                payButton.classList.add("pg-bt-pay-button");
              }
              ensureBraintreeHostedFieldStyles();
              if (container instanceof HTMLElement) {
                this.applyBraintreeCheckoutTheme(container);
              }
              this.startBraintreeDataCollector(paymentGateway);
              walletTask = mountWallets ? this.mountSaveCardWallets(container, paymentGateway) : _Promise.resolve();
              _context48.prev = 1;
              _context48.next = 2;
              return paymentGateway.getHostedFieldsInstance({
                fields: fieldIds,
                placeholders: {
                  number: "Card Number",
                  expirationDate: "MM/YY",
                  cvv: "CVV",
                  postalCode: "Postal Code",
                  cardholderName: messageForLanguage(languageCode, "enterCardHolderName")
                },
                styles: this.braintreeHostedFieldStyles()
              });
            case 2:
              hostedFieldsInstance = _context48.sent;
              clearHostedFieldLoading(fieldsRoot);
              this.saveCardHostedFieldsInstance = hostedFieldsInstance;
              _context48.next = 3;
              return walletTask;
            case 3:
              _context48.next = 10;
              break;
            case 4:
              _context48.prev = 4;
              _t18 = _context48["catch"](1);
              fieldsRoot.remove();
              if (!mountWallets) {
                _context48.next = 9;
                break;
              }
              _context48.prev = 5;
              _context48.next = 6;
              return walletTask;
            case 6:
              _context48.next = 8;
              break;
            case 7:
              _context48.prev = 7;
              _t19 = _context48["catch"](5);
              console.log("Braintree save card wallets", _t19);
            case 8:
              _context48.next = 9;
              return this.teardownSaveCardHostedFields();
            case 9:
              throw _t18;
            case 10:
            case "end":
              return _context48.stop();
          }
        }, _callee30, this, [[1, 4], [5, 7]]);
      }));
      function mountSaveCardHostedFields(_x39, _x40, _x41) {
        return _mountSaveCardHostedFields.apply(this, arguments);
      }
      return mountSaveCardHostedFields;
    }()
  }, {
    key: "walletMethodEnabled",
    value: function walletMethodEnabled(name) {
      var _this$saveCardRespons24;
      var types = (_this$saveCardRespons24 = this.saveCardResponse) === null || _this$saveCardRespons24 === void 0 ? void 0 : _this$saveCardRespons24.payment_method_types;
      if (!_Array$isArray(types)) {
        return false;
      }
      var normalized = name.toLowerCase().replace("_", "");
      return _someInstanceProperty(types).call(types, function (type) {
        return typeof type === "string" && type.toLowerCase().replace("_", "") === normalized;
      });
    }
  }, {
    key: "mountSaveCardWallets",
    value: function () {
      var _mountSaveCardWallets = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee33(container, paymentGateway) {
        var endLoading, teardowns, remember;
        return _regeneratorRuntime.wrap(function (_context53) {
          while (1) switch (_context53.prev = _context53.next) {
            case 0:
              endLoading = openWalletLoading(container);
              teardowns = [];
              remember = /*#__PURE__*/function () {
                var _ref9 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee31(task, label) {
                  var teardown, _t20;
                  return _regeneratorRuntime.wrap(function (_context49) {
                    while (1) switch (_context49.prev = _context49.next) {
                      case 0:
                        _context49.prev = 0;
                        _context49.next = 1;
                        return task;
                      case 1:
                        teardown = _context49.sent;
                        if (teardown) {
                          teardowns.push(teardown);
                        }
                        _context49.next = 3;
                        break;
                      case 2:
                        _context49.prev = 2;
                        _t20 = _context49["catch"](0);
                        console.log(label, _t20);
                      case 3:
                      case "end":
                        return _context49.stop();
                    }
                  }, _callee31, null, [[0, 2]]);
                }));
                return function remember(_x44, _x45) {
                  return _ref9.apply(this, arguments);
                };
              }();
              _context53.prev = 1;
              _context53.next = 2;
              return _Promise.allSettled([remember(this.mountSaveCardPayPalVault(container, paymentGateway), "Braintree save card PayPal"), remember(this.mountSaveCardGooglePay(container, paymentGateway), "Braintree save card Google Pay"), remember(this.mountSaveCardApplePay(container, paymentGateway), "Braintree save card Apple Pay"), remember(this.mountSaveCardVenmo(container, paymentGateway), "Braintree save card Venmo")]);
            case 2:
              _context53.prev = 2;
              endLoading();
              this.saveCardWalletTeardown = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee32() {
                var _context50, _context51;
                var _iterator, _step, teardown, _t21, _t22;
                return _regeneratorRuntime.wrap(function (_context52) {
                  while (1) switch (_context52.prev = _context52.next) {
                    case 0:
                      _iterator = _createForOfIteratorHelper(_reverseInstanceProperty(_context50 = _concatInstanceProperty(_context51 = []).call(_context51, teardowns)).call(_context50));
                      _context52.prev = 1;
                      _iterator.s();
                    case 2:
                      if ((_step = _iterator.n()).done) {
                        _context52.next = 7;
                        break;
                      }
                      teardown = _step.value;
                      _context52.prev = 3;
                      _context52.next = 4;
                      return teardown();
                    case 4:
                      _context52.next = 6;
                      break;
                    case 5:
                      _context52.prev = 5;
                      _t21 = _context52["catch"](3);
                      console.log("Braintree save card wallet teardown", _t21);
                    case 6:
                      _context52.next = 2;
                      break;
                    case 7:
                      _context52.next = 9;
                      break;
                    case 8:
                      _context52.prev = 8;
                      _t22 = _context52["catch"](1);
                      _iterator.e(_t22);
                    case 9:
                      _context52.prev = 9;
                      _iterator.f();
                      return _context52.finish(9);
                    case 10:
                    case "end":
                      return _context52.stop();
                  }
                }, _callee32, null, [[1, 8, 9, 10], [3, 5]]);
              }));
              return _context53.finish(2);
            case 3:
            case "end":
              return _context53.stop();
          }
        }, _callee33, this, [[1,, 2, 3]]);
      }));
      function mountSaveCardWallets(_x42, _x43) {
        return _mountSaveCardWallets.apply(this, arguments);
      }
      return mountSaveCardWallets;
    }()
  }, {
    key: "mountSaveCardPayPalVault",
    value: function () {
      var _mountSaveCardPayPalVault = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee35(container, paymentGateway) {
        var _this$savePaymentInte,
          _this$saveCardRespons25,
          _this7 = this;
        var client, currencyValue, currency, methodOptions, paypalOptions, vaultOptions, mounted;
        return _regeneratorRuntime.wrap(function (_context55) {
          while (1) switch (_context55.prev = _context55.next) {
            case 0:
              if (this.walletMethodEnabled("paypal")) {
                _context55.next = 1;
                break;
              }
              return _context55.abrupt("return", undefined);
            case 1:
              client = paymentGateway.getClientInstance();
              if (client) {
                _context55.next = 2;
                break;
              }
              return _context55.abrupt("return");
            case 2:
              currencyValue = (_this$savePaymentInte = this.savePaymentIntentBody) === null || _this$savePaymentInte === void 0 ? void 0 : _this$savePaymentInte.currency;
              currency = typeof currencyValue === "string" && currencyValue ? currencyValue.toUpperCase() : "USD";
              methodOptions = (_this$saveCardRespons25 = this.saveCardResponse) === null || _this$saveCardRespons25 === void 0 ? void 0 : _this$saveCardRespons25.payment_method_options;
              paypalOptions = methodOptions === null || methodOptions === void 0 ? void 0 : methodOptions["paypal"];
              vaultOptions = paypalOptions !== null && _typeof(paypalOptions) === "object" && !_Array$isArray(paypalOptions) ? _objectSpread({}, paypalOptions) : {};
              _context55.next = 3;
              return mountPayPalVaultButton({
                client: client,
                container: container,
                currency: currency,
                options: vaultOptions,
                onNonce: function () {
                  var _onNonce2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee34(nonce) {
                    return _regeneratorRuntime.wrap(function (_context54) {
                      while (1) switch (_context54.prev = _context54.next) {
                        case 0:
                          _context54.next = 1;
                          return _this7.saveVaultNonce(nonce, "paypal", paymentGateway);
                        case 1:
                        case "end":
                          return _context54.stop();
                      }
                    }, _callee34);
                  }));
                  function onNonce(_x48) {
                    return _onNonce2.apply(this, arguments);
                  }
                  return onNonce;
                }(),
                onError: function onError(message) {
                  _this7.setMessage(document.querySelector("." + saveCardMessageClass), message, "error");
                }
              });
            case 3:
              mounted = _context55.sent;
              return _context55.abrupt("return", mounted.teardown);
            case 4:
            case "end":
              return _context55.stop();
          }
        }, _callee35, this);
      }));
      function mountSaveCardPayPalVault(_x46, _x47) {
        return _mountSaveCardPayPalVault.apply(this, arguments);
      }
      return mountSaveCardPayPalVault;
    }()
  }, {
    key: "mountSaveCardGooglePay",
    value: function () {
      var _mountSaveCardGooglePay = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee37(container, paymentGateway) {
        var _this$savePaymentInte2,
          _this$saveCardRespons26,
          _this$saveCardRespons27,
          _this8 = this;
        var client, currencyValue, currency, methodOptions, googleOptions, vaultOptions, mounted;
        return _regeneratorRuntime.wrap(function (_context57) {
          while (1) switch (_context57.prev = _context57.next) {
            case 0:
              if (this.walletMethodEnabled("googlePay")) {
                _context57.next = 1;
                break;
              }
              return _context57.abrupt("return", undefined);
            case 1:
              client = paymentGateway.getClientInstance();
              if (client) {
                _context57.next = 2;
                break;
              }
              return _context57.abrupt("return", undefined);
            case 2:
              currencyValue = (_this$savePaymentInte2 = this.savePaymentIntentBody) === null || _this$savePaymentInte2 === void 0 ? void 0 : _this$savePaymentInte2.currency;
              currency = typeof currencyValue === "string" && currencyValue ? currencyValue.toUpperCase() : "USD";
              methodOptions = (_this$saveCardRespons26 = this.saveCardResponse) === null || _this$saveCardRespons26 === void 0 ? void 0 : _this$saveCardRespons26.payment_method_options;
              googleOptions = methodOptions === null || methodOptions === void 0 ? void 0 : methodOptions["googlePay"];
              vaultOptions = googleOptions !== null && _typeof(googleOptions) === "object" && !_Array$isArray(googleOptions) ? _objectSpread({}, googleOptions) : {};
              _context57.next = 3;
              return mountGooglePayVaultButton({
                client: client,
                container: container,
                currency: currency,
                isProduction: ((_this$saveCardRespons27 = this.saveCardResponse) === null || _this$saveCardRespons27 === void 0 ? void 0 : _this$saveCardRespons27.is_prod_env) === true,
                options: vaultOptions,
                onNonce: function () {
                  var _onNonce3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee36(nonce) {
                    return _regeneratorRuntime.wrap(function (_context56) {
                      while (1) switch (_context56.prev = _context56.next) {
                        case 0:
                          _context56.next = 1;
                          return _this8.saveVaultNonce(nonce, "googlePay", paymentGateway);
                        case 1:
                        case "end":
                          return _context56.stop();
                      }
                    }, _callee36);
                  }));
                  function onNonce(_x51) {
                    return _onNonce3.apply(this, arguments);
                  }
                  return onNonce;
                }(),
                onError: function onError(message) {
                  _this8.setMessage(document.querySelector("." + saveCardMessageClass), message, "error");
                }
              });
            case 3:
              mounted = _context57.sent;
              return _context57.abrupt("return", mounted.teardown);
            case 4:
            case "end":
              return _context57.stop();
          }
        }, _callee37, this);
      }));
      function mountSaveCardGooglePay(_x49, _x50) {
        return _mountSaveCardGooglePay.apply(this, arguments);
      }
      return mountSaveCardGooglePay;
    }()
  }, {
    key: "mountSaveCardApplePay",
    value: function () {
      var _mountSaveCardApplePay = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee39(container, paymentGateway) {
        var _this$saveCardRespons28,
          _this9 = this;
        var client, methodOptions, appleOptions, vaultOptions, mounted;
        return _regeneratorRuntime.wrap(function (_context59) {
          while (1) switch (_context59.prev = _context59.next) {
            case 0:
              if (this.walletMethodEnabled("applePay")) {
                _context59.next = 1;
                break;
              }
              return _context59.abrupt("return", undefined);
            case 1:
              client = paymentGateway.getClientInstance();
              if (client) {
                _context59.next = 2;
                break;
              }
              return _context59.abrupt("return", undefined);
            case 2:
              methodOptions = (_this$saveCardRespons28 = this.saveCardResponse) === null || _this$saveCardRespons28 === void 0 ? void 0 : _this$saveCardRespons28.payment_method_options;
              appleOptions = methodOptions === null || methodOptions === void 0 ? void 0 : methodOptions["applePay"];
              vaultOptions = appleOptions !== null && _typeof(appleOptions) === "object" && !_Array$isArray(appleOptions) ? _objectSpread({}, appleOptions) : {};
              _context59.next = 3;
              return mountApplePayVaultButton({
                client: client,
                container: container,
                options: vaultOptions,
                onNonce: function () {
                  var _onNonce4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee38(nonce) {
                    return _regeneratorRuntime.wrap(function (_context58) {
                      while (1) switch (_context58.prev = _context58.next) {
                        case 0:
                          return _context58.abrupt("return", _this9.saveVaultNonce(nonce, "applePay", paymentGateway));
                        case 1:
                        case "end":
                          return _context58.stop();
                      }
                    }, _callee38);
                  }));
                  function onNonce(_x54) {
                    return _onNonce4.apply(this, arguments);
                  }
                  return onNonce;
                }(),
                onError: function onError(message) {
                  _this9.setMessage(document.querySelector("." + saveCardMessageClass), message, "error");
                }
              });
            case 3:
              mounted = _context59.sent;
              return _context59.abrupt("return", mounted.teardown);
            case 4:
            case "end":
              return _context59.stop();
          }
        }, _callee39, this);
      }));
      function mountSaveCardApplePay(_x52, _x53) {
        return _mountSaveCardApplePay.apply(this, arguments);
      }
      return mountSaveCardApplePay;
    }()
  }, {
    key: "saveVaultNonce",
    value: function () {
      var _saveVaultNonce = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee40(nonce, paymentMethod, paymentGateway) {
        var _this$customer3, _this$saveCardRespons29, _this$saveCardRespons30, _t23, _t24, _t25, _t26, _t27, _t28, _t29;
        return _regeneratorRuntime.wrap(function (_context60) {
          while (1) switch (_context60.prev = _context60.next) {
            case 0:
              if (!this.saveCardInProgress) {
                _context60.next = 1;
                break;
              }
              return _context60.abrupt("return", {
                success: false
              });
            case 1:
              this.saveCardInProgress = true;
              if (this.saveCardButtonElement) {
                this.saveCardButtonElement.disabled = true;
              }
              _context60.prev = 2;
              _t23 = this;
              _t24 = (_this$customer3 = this.customer) === null || _this$customer3 === void 0 ? void 0 : _this$customer3.email;
              _t25 = (_this$saveCardRespons29 = this.saveCardResponse) === null || _this$saveCardRespons29 === void 0 ? void 0 : _this$saveCardRespons29.account_id;
              _t26 = (_this$saveCardRespons30 = this.saveCardResponse) === null || _this$saveCardRespons30 === void 0 ? void 0 : _this$saveCardRespons30.provider_name;
              _t27 = nonce;
              _context60.next = 3;
              return this.braintreeDeviceData(paymentGateway);
            case 3:
              _t28 = _context60.sent;
              _t29 = paymentMethod;
              _context60.next = 4;
              return _t23.saveCard.call(_t23, {
                email: _t24,
                account_id: _t25,
                provider_name: _t26,
                token: _t27,
                device_data: _t28,
                payment_method: _t29
              });
            case 4:
              return _context60.abrupt("return", _context60.sent);
            case 5:
              _context60.prev = 5;
              this.finishSaveCardAttempt();
              return _context60.finish(5);
            case 6:
            case "end":
              return _context60.stop();
          }
        }, _callee40, this, [[2,, 5, 6]]);
      }));
      function saveVaultNonce(_x55, _x56, _x57) {
        return _saveVaultNonce.apply(this, arguments);
      }
      return saveVaultNonce;
    }()
  }, {
    key: "finishSaveCardAttempt",
    value: function finishSaveCardAttempt() {
      this.saveCardInProgress = false;
      if (this.saveCardButtonElement) {
        this.saveCardButtonElement.disabled = false;
      }
    }
    /** Clear the card entry after a save. Wallet buttons stay mounted. */
  }, {
    key: "refreshSaveCardFields",
    value: (function () {
      var _refreshSaveCardFields = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee41() {
        var container, instance, languageCode, _t30, _t31;
        return _regeneratorRuntime.wrap(function (_context61) {
          while (1) switch (_context61.prev = _context61.next) {
            case 0:
              container = this.saveCardContainerId;
              if (container) {
                _context61.next = 1;
                break;
              }
              return _context61.abrupt("return");
            case 1:
              instance = this.saveCardHostedFieldsInstance;
              this.saveCardHostedFieldsInstance = null;
              if (!instance) {
                _context61.next = 5;
                break;
              }
              _context61.prev = 2;
              _context61.next = 3;
              return instance.teardown();
            case 3:
              _context61.next = 5;
              break;
            case 4:
              _context61.prev = 4;
              _t30 = _context61["catch"](2);
              console.log("Braintree save card hosted fields teardown", _t30);
            case 5:
              languageCode = this.savePaymentIntentBody ? languageCodeOf(this.savePaymentIntentBody) : undefined;
              _context61.prev = 6;
              _context61.next = 7;
              return this.mountSaveCardHostedFields(container, this.braintreeSaveCardGateway(), languageCode, false);
            case 7:
              _context61.next = 9;
              break;
            case 8:
              _context61.prev = 8;
              _t31 = _context61["catch"](6);
              console.log("Braintree save card field refresh", _t31);
            case 9:
            case "end":
              return _context61.stop();
          }
        }, _callee41, this, [[2, 4], [6, 8]]);
      }));
      function refreshSaveCardFields() {
        return _refreshSaveCardFields.apply(this, arguments);
      }
      return refreshSaveCardFields;
    }())
  }, {
    key: "mountSaveCardBraintreeForm",
    value: function () {
      var _mountSaveCardBraintreeForm = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee42(container, paymentGateway) {
        var languageCode;
        return _regeneratorRuntime.wrap(function (_context62) {
          while (1) switch (_context62.prev = _context62.next) {
            case 0:
              languageCode = this.savePaymentIntentBody ? languageCodeOf(this.savePaymentIntentBody) : undefined;
              _context62.next = 1;
              return this.mountSaveCardHostedFields(container, paymentGateway, languageCode);
            case 1:
            case "end":
              return _context62.stop();
          }
        }, _callee42, this);
      }));
      function mountSaveCardBraintreeForm(_x58, _x59) {
        return _mountSaveCardBraintreeForm.apply(this, arguments);
      }
      return mountSaveCardBraintreeForm;
    }()
  }, {
    key: "teardownBraintreeWallets",
    value: function () {
      var _teardownBraintreeWallets = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee43() {
        var teardown;
        return _regeneratorRuntime.wrap(function (_context63) {
          while (1) switch (_context63.prev = _context63.next) {
            case 0:
              teardown = this.braintreeWalletTeardown;
              this.braintreeWalletTeardown = null;
              if (teardown) {
                _context63.next = 1;
                break;
              }
              return _context63.abrupt("return");
            case 1:
              _context63.next = 2;
              return teardown();
            case 2:
            case "end":
              return _context63.stop();
          }
        }, _callee43, this);
      }));
      function teardownBraintreeWallets() {
        return _teardownBraintreeWallets.apply(this, arguments);
      }
      return teardownBraintreeWallets;
    }()
  }, {
    key: "teardownHostedFields",
    value: function () {
      var _teardownHostedFields = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee44() {
        var _this$initContainerId, _context64;
        var instance, paymentGateway, _t32;
        return _regeneratorRuntime.wrap(function (_context65) {
          while (1) switch (_context65.prev = _context65.next) {
            case 0:
              _context65.next = 1;
              return this.teardownBraintreeWallets();
            case 1:
              instance = this.hostedFieldsInstance;
              this.hostedFieldsInstance = null;
              paymentGateway = this.gatewayFor("braintree");
              if (!(paymentGateway instanceof BraintreeGateway)) {
                _context65.next = 2;
                break;
              }
              _context65.next = 2;
              return paymentGateway.teardownDataCollector();
            case 2:
              if (!instance) {
                _context65.next = 6;
                break;
              }
              _context65.prev = 3;
              _context65.next = 4;
              return instance.teardown();
            case 4:
              _context65.next = 6;
              break;
            case 5:
              _context65.prev = 5;
              _t32 = _context65["catch"](3);
              console.log("Braintree hosted fields teardown", _t32);
            case 6:
              (_this$initContainerId = this.initContainerId) === null || _this$initContainerId === void 0 || _forEachInstanceProperty(_context64 = _this$initContainerId.querySelectorAll(".pg-bt-hosted-fields")).call(_context64, function (node) {
                return node.remove();
              });
            case 7:
            case "end":
              return _context65.stop();
          }
        }, _callee44, this, [[3, 5]]);
      }));
      function teardownHostedFields() {
        return _teardownHostedFields.apply(this, arguments);
      }
      return teardownHostedFields;
    }()
  }, {
    key: "mountBraintreeHostedFields",
    value: function () {
      var _mountBraintreeHostedFields = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee45(container, languageCode) {
        var _context66;
        var token, paymentGateway, fieldIds, fieldsRoot, cardLabel, expirationCvvAndPostal, payButton, walletTask, hostedFieldsInstance, _this$paymentIntentRe34, _t33, _t34;
        return _regeneratorRuntime.wrap(function (_context67) {
          while (1) switch (_context67.prev = _context67.next) {
            case 0:
              token = ++this.hostedFieldsMountToken;
              _context67.next = 1;
              return this.teardownHostedFields();
            case 1:
              if (!(token !== this.hostedFieldsMountToken)) {
                _context67.next = 2;
                break;
              }
              return _context67.abrupt("return", "superseded");
            case 2:
              paymentGateway = this.gatewayFor("braintree");
              if (paymentGateway instanceof BraintreeGateway) {
                _context67.next = 3;
                break;
              }
              return _context67.abrupt("return", "failed");
            case 3:
              fieldIds = {
                number: "".concat(container.id, "-bt-number"),
                expirationDate: "".concat(container.id, "-bt-expiration-date"),
                cvv: "".concat(container.id, "-bt-cvv"),
                cardholderName: "".concat(container.id, "-bt-cardholder-name"),
                postalCode: "".concat(container.id, "-bt-postal-code")
              };
              fieldsRoot = document.createElement("div");
              fieldsRoot.className = "pg-bt-hosted-fields";
              fieldsRoot.setAttribute("aria-busy", "true");
              cardLabel = document.createElement("p");
              cardLabel.className = "pg-bt-section-label";
              cardLabel.textContent = "Card";
              fieldsRoot.appendChild(cardLabel);
              expirationCvvAndPostal = document.createElement("div");
              expirationCvvAndPostal.className = "pg-bt-hosted-fields-row";
              expirationCvvAndPostal.append(hostedFieldSlot(fieldIds.expirationDate, "pg-bt-hosted-field-expiration-date", "Expiry"), hostedFieldSlot(fieldIds.cvv, "pg-bt-hosted-field-cvv", "CVV"), hostedFieldSlot(fieldIds.postalCode, "pg-bt-hosted-field-postal-code", "Postal Code"));
              fieldsRoot.append(hostedFieldSlot(fieldIds.cardholderName, "pg-bt-hosted-field-cardholder-name", messageForLanguage(languageCode, "cardHolderName")), hostedFieldSlot(fieldIds.number, "pg-bt-hosted-field-number", "Card Number"), expirationCvvAndPostal);
              _forEachInstanceProperty(_context66 = container.querySelectorAll(".pg-bt-hosted-fields")).call(_context66, function (node) {
                return node.remove();
              });
              container.appendChild(fieldsRoot);
              payButton = container.nextElementSibling;
              if (payButton instanceof HTMLButtonElement && payButton.id === "submit") {
                payButton.classList.add("pg-bt-pay-button");
              }
              ensureBraintreeHostedFieldStyles();
              this.applyBraintreeCheckoutTheme();
              this.braintreeThemeKey = _JSON$stringify(this.braintreeCheckoutTokens());
              this.startBraintreeDataCollector(paymentGateway);
              walletTask = this.mountBraintreeWalletButtons(container).catch(function (error) {
                console.log("Braintree wallet buttons", error);
              });
              _context67.prev = 4;
              _context67.next = 5;
              return paymentGateway.getHostedFieldsInstance({
                fields: fieldIds,
                placeholders: {
                  number: "Card Number",
                  expirationDate: "MM/YY",
                  cvv: "CVV",
                  postalCode: "Postal Code",
                  cardholderName: messageForLanguage(languageCode, "enterCardHolderName")
                },
                styles: this.braintreeHostedFieldStyles()
              });
            case 5:
              hostedFieldsInstance = _context67.sent;
              if (!(token !== this.hostedFieldsMountToken)) {
                _context67.next = 11;
                break;
              }
              _context67.prev = 6;
              _context67.next = 7;
              return hostedFieldsInstance.teardown();
            case 7:
              _context67.next = 9;
              break;
            case 8:
              _context67.prev = 8;
              _t33 = _context67["catch"](6);
              console.log("Braintree hosted fields teardown", _t33);
            case 9:
              fieldsRoot.remove();
              _context67.next = 10;
              return walletTask;
            case 10:
              return _context67.abrupt("return", "superseded");
            case 11:
              clearHostedFieldLoading(fieldsRoot);
              this.hostedFieldsInstance = hostedFieldsInstance;
              _context67.next = 12;
              return walletTask;
            case 12:
              if (!(token !== this.hostedFieldsMountToken)) {
                _context67.next = 13;
                break;
              }
              return _context67.abrupt("return", "superseded");
            case 13:
              return _context67.abrupt("return", "mounted");
            case 14:
              _context67.prev = 14;
              _t34 = _context67["catch"](4);
              console.log("Braintree hosted fields mount failed", _t34);
              fieldsRoot.remove();
              _context67.next = 15;
              return walletTask;
            case 15:
              if (!(token !== this.hostedFieldsMountToken)) {
                _context67.next = 16;
                break;
              }
              return _context67.abrupt("return", "superseded");
            case 16:
              void this.updateLog({
                payment_id: (_this$paymentIntentRe34 = this.paymentIntentResponse) === null || _this$paymentIntentRe34 === void 0 ? void 0 : _this$paymentIntentRe34.payment_id,
                type: "error",
                provider: "braintree",
                message: caughtMessage(_t34),
                event_name: "initilize_error"
              });
              _context67.next = 17;
              return this.teardownHostedFields();
            case 17:
              return _context67.abrupt("return", "failed");
            case 18:
            case "end":
              return _context67.stop();
          }
        }, _callee45, this, [[4, 14], [6, 8]]);
      }));
      function mountBraintreeHostedFields(_x60, _x61) {
        return _mountBraintreeHostedFields.apply(this, arguments);
      }
      return mountBraintreeHostedFields;
    }()
  }, {
    key: "startBraintreeDataCollector",
    value: function startBraintreeDataCollector(paymentGateway) {
      void paymentGateway.ensureDataCollector().catch(function (error) {
        console.log("Braintree data collector", error);
      });
    }
  }, {
    key: "braintreeDeviceData",
    value: function () {
      var _braintreeDeviceData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee46(paymentGateway) {
        var _t35;
        return _regeneratorRuntime.wrap(function (_context68) {
          while (1) switch (_context68.prev = _context68.next) {
            case 0:
              _context68.prev = 0;
              _context68.next = 1;
              return paymentGateway.ensureDataCollector();
            case 1:
              _context68.next = 3;
              break;
            case 2:
              _context68.prev = 2;
              _t35 = _context68["catch"](0);
              console.log("Braintree data collector", _t35);
            case 3:
              return _context68.abrupt("return", paymentGateway.getDeviceData());
            case 4:
            case "end":
              return _context68.stop();
          }
        }, _callee46, null, [[0, 2]]);
      }));
      function braintreeDeviceData(_x62) {
        return _braintreeDeviceData.apply(this, arguments);
      }
      return braintreeDeviceData;
    }()
  }, {
    key: "shouldProceedAfter3DS",
    value: function shouldProceedAfter3DS(status) {
      return status === "authenticate_successful" || status === "authenticate_attempt_successful" || status === "lookup_not_enrolled" || status === "lookup_error";
    }
  }, {
    key: "tokenizeMountedHostedFields",
    value: function () {
      var _tokenizeMountedHostedFields = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee47() {
        var hostedFields, message, cardholderName, cardFieldMessages, _payload$details2, _verified$threeDSecur2, payload, _message5, expiryMessage, paymentGateway, _message6, amountValue, amount, email, verified, _this$paymentIntentRe35, _this$paymentIntentRe36, _message7, deviceData, code, isHostedFieldsError, fieldMessages, _message8, _this$paymentIntentRe37, _this$paymentIntentRe38, _t36;
        return _regeneratorRuntime.wrap(function (_context69) {
          while (1) switch (_context69.prev = _context69.next) {
            case 0:
              hostedFields = this.hostedFieldsInstance;
              if (hostedFields) {
                _context69.next = 1;
                break;
              }
              message = "Please enter card details first!";
              this.showCardFieldErrors(paymentMessageClass, [message]);
              return _context69.abrupt("return", {
                error: message
              });
            case 1:
              cardholderName = hostedFields.getState().fields.cardholderName;
              cardFieldMessages = messagesForCardEntry(messagesForBraintreeCardFields(hostedFields.getState().fields), !cardholderName || cardholderName.isEmpty ? messageForLanguage(this.intentRequestBody ? languageCodeOf(this.intentRequestBody) : undefined, "cardHolderNameRequired") : undefined);
              if (!(cardFieldMessages.length > 0)) {
                _context69.next = 2;
                break;
              }
              this.setLoading(false);
              this.showCardFieldErrors(paymentMessageClass, cardFieldMessages);
              return _context69.abrupt("return", {
                error: cardFieldMessages[0]
              });
            case 2:
              _context69.prev = 2;
              _context69.next = 3;
              return hostedFields.tokenize();
            case 3:
              payload = _context69.sent;
              if (!(!payload.nonce || !((_payload$details2 = payload.details) !== null && _payload$details2 !== void 0 && _payload$details2.bin))) {
                _context69.next = 4;
                break;
              }
              _message5 = messageForBraintreeCardFields(hostedFields.getState().fields) || "Please enter card details first!";
              this.setLoading(false);
              this.showCardFieldErrors(paymentMessageClass, [_message5]);
              return _context69.abrupt("return", {
                error: _message5
              });
            case 4:
              expiryMessage = messageForCardExpiry(payload.details.expirationMonth, payload.details.expirationYear);
              if (!expiryMessage) {
                _context69.next = 5;
                break;
              }
              this.setLoading(false);
              this.showCardFieldErrors(paymentMessageClass, [expiryMessage]);
              return _context69.abrupt("return", {
                error: expiryMessage
              });
            case 5:
              paymentGateway = this.gatewayFor("braintree");
              if (paymentGateway instanceof BraintreeGateway) {
                _context69.next = 6;
                break;
              }
              _message6 = "An unexpected error occurred.";
              this.setLoading(false);
              this.setMessage(document.querySelector("." + paymentMessageClass), _message6, "error");
              return _context69.abrupt("return", {
                error: _message6
              });
            case 6:
              amountValue = this.required(this.intentRequestBody, "amount").amount;
              amount = typeof amountValue === "number" || typeof amountValue === "string" ? String(amountValue) : "";
              if (amount) {
                _context69.next = 7;
                break;
              }
              throw new TypeError("Cannot read properties of undefined (reading 'amount')");
            case 7:
              email = this.required(this.customer, "email").email;
              _context69.next = 8;
              return paymentGateway.verify3dSecure(_objectSpread(_objectSpread({
                amount: amount,
                token: payload.nonce,
                bin: payload.details.bin
              }, typeof email === "string" ? {
                email: email
              } : {}), {}, {
                collectDeviceData: true
              }));
            case 8:
              verified = _context69.sent;
              if (!(!this.shouldProceedAfter3DS((_verified$threeDSecur2 = verified.threeDSecureInfo) === null || _verified$threeDSecur2 === void 0 ? void 0 : _verified$threeDSecur2.status) || !verified.nonce)) {
                _context69.next = 9;
                break;
              }
              _message7 = "Something went wrong during 3D Secure authentication. Please try again.";
              this.setLoading(false);
              this.setMessage(document.querySelector("." + paymentMessageClass), _message7, "error");
              void this.updateLog({
                payment_id: (_this$paymentIntentRe35 = this.paymentIntentResponse) === null || _this$paymentIntentRe35 === void 0 ? void 0 : _this$paymentIntentRe35.payment_id,
                type: "error",
                provider: (_this$paymentIntentRe36 = this.paymentIntentResponse) === null || _this$paymentIntentRe36 === void 0 ? void 0 : _this$paymentIntentRe36.provider_name,
                message: _message7,
                event_name: "authorization_error"
              });
              return _context69.abrupt("return", {
                error: _message7
              });
            case 9:
              _context69.next = 10;
              return this.braintreeDeviceData(paymentGateway);
            case 10:
              deviceData = _context69.sent;
              return _context69.abrupt("return", _objectSpread({
                nonce: verified.nonce
              }, typeof deviceData === "string" ? {
                deviceData: deviceData
              } : {}));
            case 11:
              _context69.prev = 11;
              _t36 = _context69["catch"](2);
              code = hostedFieldsErrorCode(_t36);
              isHostedFieldsError = (code === null || code === void 0 ? void 0 : _startsWithInstanceProperty(code).call(code, "HOSTED_FIELDS_")) === true;
              fieldMessages = messagesForBraintreeCardFields(hostedFields.getState().fields);
              _message8 = isHostedFieldsError ? fieldMessages[0] || hostedFieldsFailureMessage(_t36, hostedFields.getState().fields) : messageFromCaught(_t36) || "Something went wrong during 3D Secure authentication. Please try again.";
              this.setLoading(false);
              this.showCardFieldErrors(paymentMessageClass, isHostedFieldsError && fieldMessages.length > 0 ? fieldMessages : [_message8]);
              if (code !== "HOSTED_FIELDS_FIELDS_EMPTY" && code !== "HOSTED_FIELDS_FIELDS_INVALID") {
                void this.updateLog({
                  payment_id: (_this$paymentIntentRe37 = this.paymentIntentResponse) === null || _this$paymentIntentRe37 === void 0 ? void 0 : _this$paymentIntentRe37.payment_id,
                  type: "error",
                  provider: (_this$paymentIntentRe38 = this.paymentIntentResponse) === null || _this$paymentIntentRe38 === void 0 ? void 0 : _this$paymentIntentRe38.provider_name,
                  message: _message8,
                  event_name: "authorization_error"
                });
              }
              console.log("Braintree hosted fields tokenize:", _t36);
              return _context69.abrupt("return", {
                error: _message8
              });
            case 12:
            case "end":
              return _context69.stop();
          }
        }, _callee47, this, [[2, 11]]);
      }));
      function tokenizeMountedHostedFields() {
        return _tokenizeMountedHostedFields.apply(this, arguments);
      }
      return tokenizeMountedHostedFields;
    }()
  }, {
    key: "collectBraintreePaymentMethod",
    value: function () {
      var _collectBraintreePaymentMethod = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee48() {
        return _regeneratorRuntime.wrap(function (_context70) {
          while (1) switch (_context70.prev = _context70.next) {
            case 0:
              return _context70.abrupt("return", this.tokenizeMountedHostedFields());
            case 1:
            case "end":
              return _context70.stop();
          }
        }, _callee48, this);
      }));
      function collectBraintreePaymentMethod() {
        return _collectBraintreePaymentMethod.apply(this, arguments);
      }
      return collectBraintreePaymentMethod;
    }()
  }, {
    key: "mountBraintreeWalletButtons",
    value: function () {
      var _mountBraintreeWalletButtons2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee50(container) {
        var _this$paymentIntentRe39,
          _this$intentRequestBo2,
          _this$intentRequestBo3,
          _this$paymentIntentRe40,
          _this$paymentIntentRe41,
          _this$paymentIntentRe42,
          _this0 = this;
        var paymentGateway, client, configuredTypes, paymentMethodTypes, amountValue, amount, currencyValue, currency, basePaymentMethodOptions, existingVenmoOptions, paymentMethodOptions, token, mounted;
        return _regeneratorRuntime.wrap(function (_context72) {
          while (1) switch (_context72.prev = _context72.next) {
            case 0:
              paymentGateway = this.gatewayFor("braintree");
              if (paymentGateway instanceof BraintreeGateway) {
                _context72.next = 1;
                break;
              }
              return _context72.abrupt("return");
            case 1:
              client = paymentGateway.getClientInstance();
              if (client) {
                _context72.next = 2;
                break;
              }
              return _context72.abrupt("return");
            case 2:
              configuredTypes = (_this$paymentIntentRe39 = this.paymentIntentResponse) === null || _this$paymentIntentRe39 === void 0 ? void 0 : _this$paymentIntentRe39.payment_method_types;
              paymentMethodTypes = _Array$isArray(configuredTypes) ? _filterInstanceProperty(configuredTypes).call(configuredTypes, function (type) {
                return typeof type === "string";
              }) : [];
              amountValue = (_this$intentRequestBo2 = this.intentRequestBody) === null || _this$intentRequestBo2 === void 0 ? void 0 : _this$intentRequestBo2.amount;
              amount = typeof amountValue === "number" || typeof amountValue === "string" ? Number(amountValue).toFixed(2) : "0.00";
              currencyValue = (_this$intentRequestBo3 = this.intentRequestBody) === null || _this$intentRequestBo3 === void 0 ? void 0 : _this$intentRequestBo3.currency;
              currency = typeof currencyValue === "string" && currencyValue ? currencyValue.toUpperCase() : "USD";
              basePaymentMethodOptions = (_this$paymentIntentRe40 = (_this$paymentIntentRe41 = this.paymentIntentResponse) === null || _this$paymentIntentRe41 === void 0 ? void 0 : _this$paymentIntentRe41.payment_method_options) !== null && _this$paymentIntentRe40 !== void 0 ? _this$paymentIntentRe40 : {};
              existingVenmoOptions = _typeof(basePaymentMethodOptions.venmo) === "object" && basePaymentMethodOptions.venmo !== null && !_Array$isArray(basePaymentMethodOptions.venmo) ? basePaymentMethodOptions.venmo : {}; // Payment tab: one-time Venmo only. Vaulting is done from Add New Card.
              paymentMethodOptions = _objectSpread(_objectSpread({}, basePaymentMethodOptions), {}, {
                venmo: _objectSpread(_objectSpread({}, existingVenmoOptions), {}, {
                  paymentMethodUsage: "single_use",
                  allowDesktop: true,
                  allowDesktopWebLogin: false
                })
              });
              token = this.hostedFieldsMountToken; // mountBraintreeWalletButtons renders its own skeleton loader (pg-bt-wallets-loading)
              // while the wallet buttons mount, so no extra loader is wrapped here.
              _context72.next = 3;
              return mountBraintreeWalletButtons({
                client: client,
                container: container,
                paymentMethodTypes: paymentMethodTypes,
                paymentMethodOptions: paymentMethodOptions,
                amount: amount,
                currency: currency,
                isProduction: ((_this$paymentIntentRe42 = this.paymentIntentResponse) === null || _this$paymentIntentRe42 === void 0 ? void 0 : _this$paymentIntentRe42.is_prod_env) === true,
                onNonce: function () {
                  var _onNonce5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee49(nonce, paymentMethod) {
                    var authorizationCompleted, result, _t37, _t38;
                    return _regeneratorRuntime.wrap(function (_context71) {
                      while (1) switch (_context71.prev = _context71.next) {
                        case 0:
                          if (!_this0.paymentInProgress) {
                            _context71.next = 1;
                            break;
                          }
                          return _context71.abrupt("return", {
                            status: false
                          });
                        case 1:
                          _this0.paymentInProgress = true;
                          if (_this0.buttonElement) {
                            _this0.buttonElement.disabled = true;
                          }
                          authorizationCompleted = false;
                          _context71.prev = 2;
                          _t37 = _this0;
                          _t38 = nonce;
                          _context71.next = 3;
                          return _this0.braintreeDeviceData(paymentGateway);
                        case 3:
                          _context71.next = 4;
                          return _t37.submitBraintreeNonce.call(_t37, _t38, _context71.sent, paymentMethod);
                        case 4:
                          result = _context71.sent;
                          authorizationCompleted = _this0.paymentAuthorizationCompleted(result);
                          if (!authorizationCompleted) {
                            _this0.setLoading(false);
                          } else {
                            _this0.completeWalletPayment(result);
                          }
                          return _context71.abrupt("return", result);
                        case 5:
                          _context71.prev = 5;
                          if (!authorizationCompleted) {
                            _this0.paymentInProgress = false;
                            if (_this0.buttonElement) {
                              _this0.buttonElement.disabled = false;
                            }
                          }
                          return _context71.finish(5);
                        case 6:
                        case "end":
                          return _context71.stop();
                      }
                    }, _callee49, null, [[2,, 5, 6]]);
                  }));
                  function onNonce(_x64, _x65) {
                    return _onNonce5.apply(this, arguments);
                  }
                  return onNonce;
                }(),
                onError: function onError(message) {
                  _this0.setMessage(document.querySelector("." + paymentMessageClass), message, "error");
                }
              });
            case 3:
              mounted = _context72.sent;
              if (!(token !== this.hostedFieldsMountToken)) {
                _context72.next = 5;
                break;
              }
              _context72.next = 4;
              return mounted.teardown();
            case 4:
              return _context72.abrupt("return");
            case 5:
              this.braintreeWalletTeardown = mounted.teardown;
            case 6:
            case "end":
              return _context72.stop();
          }
        }, _callee50, this);
      }));
      function mountBraintreeWalletButtons$1(_x63) {
        return _mountBraintreeWalletButtons2.apply(this, arguments);
      }
      return mountBraintreeWalletButtons$1;
    }()
  }, {
    key: "submitBraintreeNonce",
    value: function () {
      var _submitBraintreeNonce = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee51(nonce, deviceData, paymentMethod) {
        var result, _result, _this$paymentIntentRe43, _this$paymentIntentRe44, _this$paymentIntentRe45, message, isFraudSuspected, _this$paymentIntentRe46, _this$paymentIntentRe47, _this$paymentIntentRe48, _message9, _t39;
        return _regeneratorRuntime.wrap(function (_context73) {
          while (1) switch (_context73.prev = _context73.next) {
            case 0:
              console.log("Device Data", deviceData);
              this.setLoading(true);
              console.log("Payload: ", {
                nonce: nonce,
                deviceData: deviceData,
                paymentMethod: paymentMethod
              }, this.paymentIntentResponse);
              _context73.prev = 1;
              if (!this.paymentIntentResponse) {
                _context73.next = 3;
                break;
              }
              _context73.next = 2;
              return this.processPayment(_objectSpread(_objectSpread({
                nonce: nonce,
                payment_id: this.paymentIntentResponse.payment_id,
                account_id: this.paymentIntentResponse.account_id,
                amount: this.required(this.intentRequestBody, "amount").amount
              }, deviceData !== undefined ? {
                device_data: deviceData
              } : {}), paymentMethod ? {
                payment_method: paymentMethod
              } : {}));
            case 2:
              result = _context73.sent;
            case 3:
              if (!(result && result.success === false)) {
                _context73.next = 6;
                break;
              }
              message = friendlyCardFailureMessage(result.message) || result.message || "Authorization failed!";
              _context73.next = 4;
              return this.updateLog({
                payment_id: (_this$paymentIntentRe43 = this.paymentIntentResponse) === null || _this$paymentIntentRe43 === void 0 ? void 0 : _this$paymentIntentRe43.payment_id,
                type: "error",
                provider: (_this$paymentIntentRe44 = this.paymentIntentResponse) === null || _this$paymentIntentRe44 === void 0 ? void 0 : _this$paymentIntentRe44.provider_name,
                message: message,
                event_name: "authorization_error"
              });
            case 4:
              _context73.next = 5;
              return this.initPayment(this.initContainerId, this.buttonElement, this.intentRequestBody, true, (_this$paymentIntentRe45 = this.paymentIntentResponse) === null || _this$paymentIntentRe45 === void 0 ? void 0 : _this$paymentIntentRe45.provider_name);
            case 5:
              this.setMessage(document.querySelector("." + paymentMessageClass), message, "error");
              return _context73.abrupt("return", {
                status: false,
                message: message
              });
            case 6:
              isFraudSuspected = !!((_result = result) !== null && _result !== void 0 && _result.fraud_suspected); // Only log success here; fraud is already logged in processPayment to avoid duplicate.
              if (!isFraudSuspected) {
                void this.updateLog({
                  payment_id: (_this$paymentIntentRe46 = this.paymentIntentResponse) === null || _this$paymentIntentRe46 === void 0 ? void 0 : _this$paymentIntentRe46.payment_id,
                  type: "info",
                  provider: (_this$paymentIntentRe47 = this.paymentIntentResponse) === null || _this$paymentIntentRe47 === void 0 ? void 0 : _this$paymentIntentRe47.provider_name,
                  message: "Payment authorized success!",
                  event_name: "authorization_success"
                });
              }
              return _context73.abrupt("return", result);
            case 7:
              _context73.prev = 7;
              _t39 = _context73["catch"](1);
              _message9 = messageFromCaught(_t39) || "Please enter card details first!";
              if (!(_message9 === "No payment method is available.")) {
                _context73.next = 8;
                break;
              }
              this.setMessage(document.querySelector("." + paymentMessageClass), "Please enter card details first!", "error");
              return _context73.abrupt("return", {
                status: false,
                message: _message9
              });
            case 8:
              console.log(_t39);
              _context73.next = 9;
              return this.initPayment(this.initContainerId, this.buttonElement, this.intentRequestBody, true, (_this$paymentIntentRe48 = this.paymentIntentResponse) === null || _this$paymentIntentRe48 === void 0 ? void 0 : _this$paymentIntentRe48.provider_name);
            case 9:
              return _context73.abrupt("return", {
                status: false,
                message: _message9
              });
            case 10:
            case "end":
              return _context73.stop();
          }
        }, _callee51, this, [[1, 7]]);
      }));
      function submitBraintreeNonce(_x66, _x67, _x68) {
        return _submitBraintreeNonce.apply(this, arguments);
      }
      return submitBraintreeNonce;
    }()
  }, {
    key: "processDropinPayment",
    value: function () {
      var _processDropinPayment = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee52() {
        var paymentMethod, message, _t40;
        return _regeneratorRuntime.wrap(function (_context74) {
          while (1) switch (_context74.prev = _context74.next) {
            case 0:
              _context74.prev = 0;
              _context74.next = 1;
              return this.collectBraintreePaymentMethod();
            case 1:
              paymentMethod = _context74.sent;
              if (!isBraintreePaymentError(paymentMethod)) {
                _context74.next = 2;
                break;
              }
              return _context74.abrupt("return", {
                status: false,
                message: paymentMethod.error || "Please enter card details first!"
              });
            case 2:
              _context74.next = 3;
              return this.submitBraintreeNonce(paymentMethod.nonce, paymentMethod.deviceData);
            case 3:
              return _context74.abrupt("return", _context74.sent);
            case 4:
              _context74.prev = 4;
              _t40 = _context74["catch"](0);
              message = messageFromCaught(_t40) || "Please enter card details first!";
              console.log(_t40);
              return _context74.abrupt("return", {
                status: false,
                message: message
              });
            case 5:
            case "end":
              return _context74.stop();
          }
        }, _callee52, this, [[0, 4]]);
      }));
      function processDropinPayment() {
        return _processDropinPayment.apply(this, arguments);
      }
      return processDropinPayment;
    }()
  }, {
    key: "processNMIPayment",
    value: function () {
      var _processNMIPayment = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee53(data) {
        var _this$paymentIntentRe49;
        var result, paymentGateway;
        return _regeneratorRuntime.wrap(function (_context75) {
          while (1) switch (_context75.prev = _context75.next) {
            case 0:
              paymentGateway = this.gatewayFor((_this$paymentIntentRe49 = this.paymentIntentResponse) === null || _this$paymentIntentRe49 === void 0 ? void 0 : _this$paymentIntentRe49.provider_name);
              if (!this.paymentIntentResponse) {
                _context75.next = 2;
                break;
              }
              _context75.next = 1;
              return this.preProcessPayment({
                nonce: data.nonce,
                card: data.card,
                payment_id: this.paymentIntentResponse.payment_id,
                account_id: this.paymentIntentResponse.account_id,
                amount: this.required(this.intentRequestBody, "amount").amount,
                type: data.type
              });
            case 1:
              result = _context75.sent;
            case 2:
              if (paymentGateway && paymentGateway.hideLoader) {
                paymentGateway.hideLoader();
              }
              return _context75.abrupt("return", result);
            case 3:
            case "end":
              return _context75.stop();
          }
        }, _callee53, this);
      }));
      function processNMIPayment(_x69) {
        return _processNMIPayment.apply(this, arguments);
      }
      return processNMIPayment;
    }()
  }, {
    key: "processFlywirePayment",
    value: function () {
      var _processFlywirePayment = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee54(data) {
        return _regeneratorRuntime.wrap(function (_context76) {
          while (1) switch (_context76.prev = _context76.next) {
            case 0:
              if (data.status === "success" && this.paymentIntentResponse) {
                if (this.buttonElement) {
                  this.buttonElement.click();
                }
                flywireEventEmitter.emit("payment-response", {
                  nonce: data.reference,
                  payment_id: this.paymentIntentResponse.payment_id,
                  account_id: this.paymentIntentResponse.account_id,
                  amount: this.required(this.intentRequestBody, "amount").amount,
                  type: data.paymentMethod
                });
              } else {
                console.log("Payment intent flywire:", this.paymentIntentResponse);
              }
            case 1:
            case "end":
              return _context76.stop();
          }
        }, _callee54, this);
      }));
      function processFlywirePayment(_x70) {
        return _processFlywirePayment.apply(this, arguments);
      }
      return processFlywirePayment;
    }()
  }, {
    key: "flywireSaveCard",
    value: function () {
      var _flywireSaveCard = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee55(data) {
        return _regeneratorRuntime.wrap(function (_context77) {
          while (1) switch (_context77.prev = _context77.next) {
            case 0:
              if (data.status === "success" && this.saveCardResponse) {
                if (this.saveCardButtonElement) {
                  this.saveCardButtonElement.click();
                }
                flywireEventEmitter.emit("save-card-response", data);
              } else {
                console.log("Save card intent flywire:", this.saveCardResponse);
              }
            case 1:
            case "end":
              return _context77.stop();
          }
        }, _callee55, this);
      }));
      function flywireSaveCard(_x71) {
        return _flywireSaveCard.apply(this, arguments);
      }
      return flywireSaveCard;
    }()
  }, {
    key: "setLoading",
    value: function setLoading(isLoading) {
      var spinner = document.querySelector("#spinner");
      var buttonText = document.querySelector("#button-text");
      if (isLoading) {
        var _spinner$classList, _buttonText$classList;
        spinner === null || spinner === void 0 || (_spinner$classList = spinner.classList) === null || _spinner$classList === void 0 || _spinner$classList.remove("hidden");
        buttonText === null || buttonText === void 0 || (_buttonText$classList = buttonText.classList) === null || _buttonText$classList === void 0 || _buttonText$classList.add("hidden");
      } else {
        var _spinner$classList2, _buttonText$classList2;
        spinner === null || spinner === void 0 || (_spinner$classList2 = spinner.classList) === null || _spinner$classList2 === void 0 || _spinner$classList2.add("hidden");
        buttonText === null || buttonText === void 0 || (_buttonText$classList2 = buttonText.classList) === null || _buttonText$classList2 === void 0 || _buttonText$classList2.remove("hidden");
      }
    }
  }, {
    key: "showMessage",
    value: function showMessage(messageText) {
      var messageContainer = document.querySelector("#payment-message");
      if (messageContainer && (messageText !== null || messageText !== "")) {
        var _messageContainer$cla;
        messageContainer === null || messageContainer === void 0 || (_messageContainer$cla = messageContainer.classList) === null || _messageContainer$cla === void 0 || _messageContainer$cla.remove("hidden");
        messageContainer.textContent = messageText;
        messageContainer.style.color = "red";
        _setTimeout(function () {
          var _messageContainer$cla2;
          messageContainer === null || messageContainer === void 0 || (_messageContainer$cla2 = messageContainer.classList) === null || _messageContainer$cla2 === void 0 || _messageContainer$cla2.add("hidden");
          messageContainer.textContent = "";
        }, 20000);
      }
    }
  }, {
    key: "completeWalletPayment",
    value: function completeWalletPayment(result) {
      var _this$intentRequestBo4,
        _this1 = this;
      if (!result || result.fraud_suspected === true) {
        return;
      }
      // Optional explicit override: if the host supplied an onPaymentComplete callback,
      // hand the authorized result to it directly.
      var onPaymentComplete = (_this$intentRequestBo4 = this.intentRequestBody) === null || _this$intentRequestBo4 === void 0 ? void 0 : _this$intentRequestBo4.onPaymentComplete;
      if (typeof onPaymentComplete === "function") {
        var callback = onPaymentComplete;
        // Run inside a Promise chain so both synchronous throws and rejected async callbacks
        // (e.g. a failed finalizeOrder or redirect) are caught here — not surfaced as an
        // unhandled rejection.
        void _Promise.resolve().then(function () {
          return callback(result);
        }).catch(function (error) {
          var _this1$paymentIntentR, _this1$paymentIntentR2;
          void _this1.updateLog({
            payment_id: (_this1$paymentIntentR = _this1.paymentIntentResponse) === null || _this1$paymentIntentR === void 0 ? void 0 : _this1$paymentIntentR.payment_id,
            type: "error",
            provider: (_this1$paymentIntentR2 = _this1.paymentIntentResponse) === null || _this1$paymentIntentR2 === void 0 ? void 0 : _this1$paymentIntentR2.provider_name,
            message: messageFromCaught(error),
            event_name: "wallet_on_payment_complete_error"
          });
          // The host callback failed, so the expected redirect did not happen. Release the
          // lock and re-enable the button so the shopper can retry instead of being stuck.
          _this1.setLoading(false);
          _this1.paymentInProgress = false;
          if (_this1.buttonElement) {
            _this1.buttonElement.disabled = false;
          }
        });
        return;
      }
      // Default: route the authorized wallet result through the host's existing Pay button
      // handler, mirroring the NMI/Flywire flow. We programmatically click the Pay button so
      // the host's handlePayClick listener runs, then hand it the stored result. This lets the
      // host reuse its card completion/redirect logic for wallets with no new function to wire.
      // (onNonce disabled the button, so re-enable it before clicking.)
      //
      // Store the result BEFORE the click so handlePayClick can read it synchronously. This is
      // race-proof: even if the host's handler awaits before calling handlePayClick (which would
      // miss an emitted event), the stored value is still available whenever handlePayClick runs.
      this.pendingWalletResult = result;
      this.walletFlowActive = true;
      if (this.buttonElement) {
        // The button must be enabled for click() to dispatch. We re-disable immediately after so
        // the button stays disabled during host finalization and a manual second click can't fall
        // through to the card path (which would return a failure with no payment_id while
        // paymentInProgress is still true).
        this.buttonElement.disabled = false;
        this.buttonElement.click();
        this.buttonElement.disabled = true;
      }
      // Emit as a fallback for any host that attached the listener before the stored result was
      // set; harmless when handlePayClick already consumed pendingWalletResult (no listeners).
      walletEventEmitter.emit("payment-response", result);
    }
  }, {
    key: "paymentAuthorizationCompleted",
    value: function paymentAuthorizationCompleted(result) {
      if (!result || result.status === false || result.success === false) {
        return false;
      }
      return typeof result.code !== "number" || result.code <= 399;
    }
  }, {
    key: "handleSubmit",
    value: function () {
      var _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee56(e, providerName, elements, name) {
        var authorizationCompleted, _this$paymentIntentRe52, _this$cPresponse, _this$cPresponse$erro, stripeClient, _this$paymentIntentRe50, _this$paymentIntentRe51, _this$paymentIntentRe53, _this$paymentIntentRe54, _this$paymentIntentRe55, _this$paymentIntentRe60, _this$paymentIntentRe61, paymentId, statusResult, retryResult, _this$paymentIntentRe56, _this$paymentIntentRe57, fraudMsgEl, msgDiv, _this$paymentIntentRe58, _this$paymentIntentRe59, _this$cPresponse2, _this$cPresponse3, _this$paymentIntentRe62, _this$paymentIntentRe63, message, _this$paymentIntentRe64, _this$paymentIntentRe65, _this$cPresponse4, _this$cPresponse5, result, _t41;
        return _regeneratorRuntime.wrap(function (_context78) {
          while (1) switch (_context78.prev = _context78.next) {
            case 0:
              if (!this.paymentInProgress) {
                _context78.next = 1;
                break;
              }
              return _context78.abrupt("return", {
                status: false,
                message: "Please enter card details first!"
              });
            case 1:
              this.beginCardEntry(paymentMessageClass);
              this.paymentInProgress = true;
              if (this.buttonElement) {
                this.buttonElement.disabled = true;
              }
              authorizationCompleted = false;
              _context78.prev = 2;
              e === null || e === void 0 || e.preventDefault();
              this.setLoading(true);
              if (!(providerName == "stripe")) {
                _context78.next = 15;
                break;
              }
              stripeClient = this.stripeInstance;
              if (stripeClient) {
                _context78.next = 3;
                break;
              }
              this.setMessage(document.querySelector("." + paymentMessageClass), "An unexpected error occurred.", "error");
              void this.updateLog({
                payment_id: (_this$paymentIntentRe50 = this.paymentIntentResponse) === null || _this$paymentIntentRe50 === void 0 ? void 0 : _this$paymentIntentRe50.payment_id,
                type: "error",
                provider: (_this$paymentIntentRe51 = this.paymentIntentResponse) === null || _this$paymentIntentRe51 === void 0 ? void 0 : _this$paymentIntentRe51.provider_name,
                message: "An unexpected error occurred",
                event_name: "authorization_error"
              });
              return _context78.abrupt("return", {
                status: false,
                message: "An unexpected error occurred."
              });
            case 3:
              _context78.next = 4;
              return this.confirmPayment(stripeClient, elements, {
                payment_method_data: {
                  billing_details: {
                    name: name
                  }
                },
                return_url: (_this$paymentIntentRe52 = this.paymentIntentResponse) === null || _this$paymentIntentRe52 === void 0 ? void 0 : _this$paymentIntentRe52.return_url
              });
            case 4:
              this.cPresponse = _context78.sent;
              if ((_this$cPresponse = this.cPresponse) !== null && _this$cPresponse !== void 0 && _this$cPresponse.error) {
                _context78.next = 12;
                break;
              }
              paymentId = ((_this$paymentIntentRe53 = this.paymentIntentResponse) === null || _this$paymentIntentRe53 === void 0 || (_this$paymentIntentRe53 = _this$paymentIntentRe53.payment_id) === null || _this$paymentIntentRe53 === void 0 || (_this$paymentIntentRe54 = _this$paymentIntentRe53.toString) === null || _this$paymentIntentRe54 === void 0 ? void 0 : _this$paymentIntentRe54.call(_this$paymentIntentRe53)) || ((_this$paymentIntentRe55 = this.paymentIntentResponse) === null || _this$paymentIntentRe55 === void 0 ? void 0 : _this$paymentIntentRe55.payment_id); // Wait 1s for post-auth rules / Stripe Radar to complete before checking fraud.
              _context78.next = 5;
              return new _Promise(function (r) {
                return _setTimeout(r, 1000);
              });
            case 5:
              if (!paymentId) {
                _context78.next = 7;
                break;
              }
              _context78.next = 6;
              return this.getPaymentStatus(String(paymentId), "stripe");
            case 6:
              _t41 = _context78.sent;
              _context78.next = 8;
              break;
            case 7:
              _t41 = {
                status: "unknown",
                fraud_suspected: false
              };
            case 8:
              statusResult = _t41;
              if (!(!statusResult.fraud_suspected && statusResult.status === "requires_capture" && paymentId)) {
                _context78.next = 11;
                break;
              }
              _context78.next = 9;
              return new _Promise(function (r) {
                return _setTimeout(r, 2500);
              });
            case 9:
              _context78.next = 10;
              return this.getPaymentStatus(String(paymentId), "stripe");
            case 10:
              retryResult = _context78.sent;
              if (retryResult.fraud_suspected) statusResult = retryResult;
            case 11:
              if (statusResult.fraud_suspected) {
                if (this.initContainerId) {
                  this.initContainerId.innerHTML = "";
                  msgDiv = document.createElement("div");
                  msgDiv.className = paymentMessageClass;
                  this.initContainerId.appendChild(msgDiv);
                  this.setMessage(msgDiv, FRAUD_SUSPECTED_MESSAGE, "error");
                  fraudMsgEl = msgDiv;
                } else {
                  fraudMsgEl = document.querySelector("." + paymentMessageClass);
                  this.setMessage(fraudMsgEl, FRAUD_SUSPECTED_MESSAGE, "error");
                }
                this.applyFraudDeclineUI(fraudMsgEl);
                void this.updateLog({
                  payment_id: (_this$paymentIntentRe56 = this.paymentIntentResponse) === null || _this$paymentIntentRe56 === void 0 ? void 0 : _this$paymentIntentRe56.payment_id,
                  type: "info",
                  provider: (_this$paymentIntentRe57 = this.paymentIntentResponse) === null || _this$paymentIntentRe57 === void 0 ? void 0 : _this$paymentIntentRe57.provider_name,
                  message: FRAUD_SUSPECTED_MESSAGE,
                  event_name: AUTHORIZATION_FRAUD_SUSPECTED_EVENT
                });
              } else {
                this.setMessage(document.querySelector("." + paymentMessageClass), "Payment authorized success!", "success");
                void this.updateLog({
                  payment_id: (_this$paymentIntentRe58 = this.paymentIntentResponse) === null || _this$paymentIntentRe58 === void 0 ? void 0 : _this$paymentIntentRe58.payment_id,
                  type: "info",
                  provider: (_this$paymentIntentRe59 = this.paymentIntentResponse) === null || _this$paymentIntentRe59 === void 0 ? void 0 : _this$paymentIntentRe59.provider_name,
                  message: "Payment authorized success!",
                  event_name: "authorization_success"
                });
              }
              authorizationCompleted = true;
              return _context78.abrupt("return", {
                status: true,
                return_url: ((_this$paymentIntentRe60 = this.paymentIntentResponse) === null || _this$paymentIntentRe60 === void 0 ? void 0 : _this$paymentIntentRe60.return_url) + "?payment_id=" + ((_this$paymentIntentRe61 = this.paymentIntentResponse) === null || _this$paymentIntentRe61 === void 0 ? void 0 : _this$paymentIntentRe61.payment_id) + "&payment_status=requires_capture"
              });
            case 12:
              if (!(this.cPresponse && this.cPresponse.error && ((_this$cPresponse$erro = this.cPresponse.error) === null || _this$cPresponse$erro === void 0 ? void 0 : _this$cPresponse$erro.type) === "card_error" || this.cPresponse.error && this.cPresponse.error.type === "validation_error")) {
                _context78.next = 13;
                break;
              }
              message = messageForStripeError((_this$cPresponse2 = this.cPresponse) === null || _this$cPresponse2 === void 0 ? void 0 : _this$cPresponse2.error, {
                paymentMethodType: this.stripePaymentMethodType
              }) || ((_this$cPresponse3 = this.cPresponse) === null || _this$cPresponse3 === void 0 || (_this$cPresponse3 = _this$cPresponse3.error) === null || _this$cPresponse3 === void 0 ? void 0 : _this$cPresponse3.message) || "Please enter card details first!";
              this.showCardFieldErrors(paymentMessageClass, [message]);
              void this.updateLog({
                payment_id: (_this$paymentIntentRe62 = this.paymentIntentResponse) === null || _this$paymentIntentRe62 === void 0 ? void 0 : _this$paymentIntentRe62.payment_id,
                type: "error",
                provider: (_this$paymentIntentRe63 = this.paymentIntentResponse) === null || _this$paymentIntentRe63 === void 0 ? void 0 : _this$paymentIntentRe63.provider_name,
                message: message,
                event_name: "authorization_error"
              });
              return _context78.abrupt("return", {
                status: false,
                message: message
              });
            case 13:
              this.setMessage(document.querySelector("." + paymentMessageClass), "An unexpected error occurred.", "error");
              void this.updateLog({
                payment_id: (_this$paymentIntentRe64 = this.paymentIntentResponse) === null || _this$paymentIntentRe64 === void 0 ? void 0 : _this$paymentIntentRe64.payment_id,
                type: "error",
                provider: (_this$paymentIntentRe65 = this.paymentIntentResponse) === null || _this$paymentIntentRe65 === void 0 ? void 0 : _this$paymentIntentRe65.provider_name,
                message: "An unexpected error occurred " + ((_this$cPresponse4 = this.cPresponse) === null || _this$cPresponse4 === void 0 || (_this$cPresponse4 = _this$cPresponse4.error) === null || _this$cPresponse4 === void 0 ? void 0 : _this$cPresponse4.message),
                event_name: "authorization_error"
              });
              return _context78.abrupt("return", {
                status: false,
                message: ((_this$cPresponse5 = this.cPresponse) === null || _this$cPresponse5 === void 0 || (_this$cPresponse5 = _this$cPresponse5.error) === null || _this$cPresponse5 === void 0 ? void 0 : _this$cPresponse5.message) || "Please enter card details first!"
              });
            case 14:
              _context78.next = 18;
              break;
            case 15:
              if (!(providerName == "braintree")) {
                _context78.next = 18;
                break;
              }
              _context78.next = 16;
              return this.processDropinPayment();
            case 16:
              result = _context78.sent;
              authorizationCompleted = this.paymentAuthorizationCompleted(result);
              if (!result) {
                _context78.next = 17;
                break;
              }
              return _context78.abrupt("return", result);
            case 17:
              return _context78.abrupt("return", {
                status: false,
                message: "Please enter card details first!"
              });
            case 18:
              this.setLoading(false);
              return _context78.abrupt("return", {
                status: false,
                message: "Please enter card details first!"
              });
            case 19:
              _context78.prev = 19;
              if (!authorizationCompleted) {
                this.paymentInProgress = false;
                if (this.buttonElement) {
                  this.buttonElement.disabled = false;
                }
              }
              return _context78.finish(19);
            case 20:
            case "end":
              return _context78.stop();
          }
        }, _callee56, this, [[2,, 19, 20]]);
      }));
      function handleSubmit(_x72, _x73, _x74, _x75) {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }()
  }, {
    key: "createCustomer",
    value: function () {
      var _createCustomer = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee57(data) {
        var response, pIntent, _t42;
        return _regeneratorRuntime.wrap(function (_context79) {
          while (1) switch (_context79.prev = _context79.next) {
            case 0:
              _context79.prev = 0;
              _context79.next = 1;
              return this.fetch("".concat(this.apiBaseURL, "/v1/payment/customer"), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": this.apiKey
                },
                body: _JSON$stringify(data)
              });
            case 1:
              response = _context79.sent;
              _context79.next = 2;
              return response.json();
            case 2:
              pIntent = _context79.sent;
              console.log("customer", pIntent);
              if (this.hasCustomerEmail(pIntent)) {
                this.customer = pIntent;
              } else {
                this.customer = undefined;
              }
              return _context79.abrupt("return", pIntent);
            case 3:
              _context79.prev = 3;
              _t42 = _context79["catch"](0);
              throw new Error("Error: " + _t42, {
                cause: _t42
              });
            case 4:
            case "end":
              return _context79.stop();
          }
        }, _callee57, this, [[0, 3]]);
      }));
      function createCustomer(_x76) {
        return _createCustomer.apply(this, arguments);
      }
      return createCustomer;
    }()
  }, {
    key: "fetchPaymentIntent",
    value: function () {
      var _fetchPaymentIntent = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee58(id, provider) {
        var _context80, _context81, _context82, response, pIntent, _t43;
        return _regeneratorRuntime.wrap(function (_context83) {
          while (1) switch (_context83.prev = _context83.next) {
            case 0:
              _context83.prev = 0;
              _context83.next = 1;
              return this.fetch(_concatInstanceProperty(_context80 = _concatInstanceProperty(_context81 = "".concat(this.apiBaseURL, "/v1/payment/payment_intent?id=")).call(_context81, id, "&provider=")).call(_context80, provider), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: "Basic ".concat(btoa(_concatInstanceProperty(_context82 = "".concat(this.apiKey, ":")).call(_context82, this.apiSecret)))
                }
              });
            case 1:
              response = _context83.sent;
              _context83.next = 2;
              return response.json();
            case 2:
              pIntent = _context83.sent;
              return _context83.abrupt("return", pIntent);
            case 3:
              _context83.prev = 3;
              _t43 = _context83["catch"](0);
              throw new Error("Error: " + _t43, {
                cause: _t43
              });
            case 4:
            case "end":
              return _context83.stop();
          }
        }, _callee58, this, [[0, 3]]);
      }));
      function fetchPaymentIntent(_x77, _x78) {
        return _fetchPaymentIntent.apply(this, arguments);
      }
      return fetchPaymentIntent;
    }()
    /**
     * Fetches payment status including fraud_suspected from GET /v1/payment/status.
     * Used by Stripe (after confirm) and Braintree (after process_payment) to decide whether to show
     * FRAUD_SUSPECTED_MESSAGE or "Payment authorized success". Backend checks payment.isFraud,
     * payment_outcome timeline (blocked/post_auth_rule_declined), and for Stripe also the charge outcome.
     */
  }, {
    key: "getPaymentStatus",
    value: (function () {
      var _getPaymentStatus = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee59(paymentId, provider) {
        var _context84, _context85, response, data, _t44;
        return _regeneratorRuntime.wrap(function (_context86) {
          while (1) switch (_context86.prev = _context86.next) {
            case 0:
              _context86.prev = 0;
              _context86.next = 1;
              return this.fetch(_concatInstanceProperty(_context84 = _concatInstanceProperty(_context85 = "".concat(this.apiBaseURL, "/v1/payment/status?payment_id=")).call(_context85, encodeURIComponent(paymentId), "&provider=")).call(_context84, encodeURIComponent(provider)), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": this.apiKey
                }
              });
            case 1:
              response = _context86.sent;
              _context86.next = 2;
              return response.json();
            case 2:
              data = _context86.sent;
              if (!(data.code && data.code > 399)) {
                _context86.next = 3;
                break;
              }
              console.warn("[pg-switch-js] getPaymentStatus error:", data.message || data);
              return _context86.abrupt("return", {
                status: data.status || "unknown",
                fraud_suspected: false
              });
            case 3:
              return _context86.abrupt("return", {
                status: data.status || "unknown",
                fraud_suspected: !!data.fraud_suspected
              });
            case 4:
              _context86.prev = 4;
              _t44 = _context86["catch"](0);
              console.warn("[pg-switch-js] getPaymentStatus failed:", _t44);
              return _context86.abrupt("return", {
                status: "unknown",
                fraud_suspected: false
              });
            case 5:
            case "end":
              return _context86.stop();
          }
        }, _callee59, this, [[0, 4]]);
      }));
      function getPaymentStatus(_x79, _x80) {
        return _getPaymentStatus.apply(this, arguments);
      }
      return getPaymentStatus;
    }())
  }, {
    key: "cards",
    value: function () {
      var _cards = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee60(data) {
        var _context87, _this$customer4, query, email, response, pIntent, _t45;
        return _regeneratorRuntime.wrap(function (_context88) {
          while (1) switch (_context88.prev = _context88.next) {
            case 0:
              _context88.prev = 0;
              query = new _URLSearchParams(_mapInstanceProperty(_context87 = _Object$entries(data)).call(_context87, function (_ref1) {
                var _ref10 = _slicedToArray(_ref1, 2),
                  key = _ref10[0],
                  value = _ref10[1];
                return [key, "".concat(value)];
              }));
              email = (_this$customer4 = this.customer) === null || _this$customer4 === void 0 ? void 0 : _this$customer4.email;
              if (!(typeof email !== "string" || email.length === 0)) {
                _context88.next = 1;
                break;
              }
              return _context88.abrupt("return", []);
            case 1:
              _context88.next = 2;
              return this.fetch("".concat(this.apiBaseURL, "/v1/card/list/") + email + "?" + query.toString(), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": this.apiKey
                }
              });
            case 2:
              response = _context88.sent;
              _context88.next = 3;
              return response.json();
            case 3:
              pIntent = _context88.sent;
              return _context88.abrupt("return", pIntent);
            case 4:
              _context88.prev = 4;
              _t45 = _context88["catch"](0);
              throw new Error("Error: " + _t45, {
                cause: _t45
              });
            case 5:
            case "end":
              return _context88.stop();
          }
        }, _callee60, this, [[0, 4]]);
      }));
      function cards(_x81) {
        return _cards.apply(this, arguments);
      }
      return cards;
    }()
  }, {
    key: "deleteCard",
    value: function () {
      var _deleteCard = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee61(data) {
        var response, pIntent, _t46;
        return _regeneratorRuntime.wrap(function (_context89) {
          while (1) switch (_context89.prev = _context89.next) {
            case 0:
              _context89.prev = 0;
              _context89.next = 1;
              return this.fetch("".concat(this.apiBaseURL, "/v1/card/delete/") + data.email, {
                method: "DELETE",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": this.apiKey
                },
                body: _JSON$stringify({
                  card_id: data.card_id
                })
              });
            case 1:
              response = _context89.sent;
              if (!(response.status != 204)) {
                _context89.next = 3;
                break;
              }
              _context89.next = 2;
              return response.json();
            case 2:
              pIntent = _context89.sent;
              return _context89.abrupt("return", pIntent);
            case 3:
              return _context89.abrupt("return", {
                status: "Deleted"
              });
            case 4:
              _context89.next = 6;
              break;
            case 5:
              _context89.prev = 5;
              _t46 = _context89["catch"](0);
              throw new Error("Error: " + _t46, {
                cause: _t46
              });
            case 6:
            case "end":
              return _context89.stop();
          }
        }, _callee61, this, [[0, 5]]);
      }));
      function deleteCard(_x82) {
        return _deleteCard.apply(this, arguments);
      }
      return deleteCard;
    }()
  }, {
    key: "charge",
    value: function () {
      var _charge = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee62(data) {
        var _this$customer5, response, pIntent, _pIntent$provider_nex, _t48;
        return _regeneratorRuntime.wrap(function (_context90) {
          while (1) switch (_context90.prev = _context90.next) {
            case 0:
              _context90.prev = 0;
              _context90.prev = 1;
              if (!((_this$customer5 = this.customer) !== null && _this$customer5 !== void 0 && _this$customer5.email)) {
                _context90.next = 3;
                break;
              }
              _context90.next = 2;
              return this.loadIPQSScript();
            case 2:
              this.ipqsResult = _context90.sent;
            case 3:
              _context90.next = 5;
              break;
            case 4:
              _context90.prev = 4;
              _context90["catch"](1);
            case 5:
              delete data.bin;
              _context90.next = 6;
              return this.fetch("".concat(this.apiBaseURL, "/v1/payment/charge"), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": this.apiKey
                },
                body: _JSON$stringify(_objectSpread(_objectSpread({}, data), this.ipqsResult ? {
                  ipqs_device_fingerprint: this.ipqsResult
                } : {}))
              });
            case 6:
              response = _context90.sent;
              _context90.next = 7;
              return response.json();
            case 7:
              pIntent = _context90.sent;
              if (!(pIntent.provider_name === "stripe")) {
                _context90.next = 9;
                break;
              }
              if (!((pIntent === null || pIntent === void 0 || (_pIntent$provider_nex = pIntent.provider_next_action) === null || _pIntent$provider_nex === void 0 ? void 0 : _pIntent$provider_nex.type) == "redirect_to_url")) {
                _context90.next = 8;
                break;
              }
              window.location = pIntent.provider_next_action.redirect_to_url.url;
              _context90.next = 9;
              break;
            case 8:
              return _context90.abrupt("return", pIntent);
            case 9:
              return _context90.abrupt("return", pIntent);
            case 10:
              _context90.prev = 10;
              _t48 = _context90["catch"](0);
              throw new Error("Error: " + _t48, {
                cause: _t48
              });
            case 11:
            case "end":
              return _context90.stop();
          }
        }, _callee62, this, [[0, 10], [1, 4]]);
      }));
      function charge(_x83) {
        return _charge.apply(this, arguments);
      }
      return charge;
    }()
  }, {
    key: "card_charge_authorize",
    value: function () {
      var _card_charge_authorize = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee63(data) {
        var _this$customer6, response, pIntent, _pIntent$provider_nex2, _t50;
        return _regeneratorRuntime.wrap(function (_context91) {
          while (1) switch (_context91.prev = _context91.next) {
            case 0:
              _context91.prev = 0;
              _context91.prev = 1;
              if (!((_this$customer6 = this.customer) !== null && _this$customer6 !== void 0 && _this$customer6.email)) {
                _context91.next = 3;
                break;
              }
              _context91.next = 2;
              return this.loadIPQSScript();
            case 2:
              this.ipqsResult = _context91.sent;
            case 3:
              _context91.next = 5;
              break;
            case 4:
              _context91.prev = 4;
              _context91["catch"](1);
            case 5:
              delete data.bin;
              _context91.next = 6;
              return this.fetch("".concat(this.apiBaseURL, "/v1/payment/card_charge_authorized"), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": this.apiKey
                },
                body: _JSON$stringify(_objectSpread(_objectSpread({}, data), this.ipqsResult ? {
                  ipqs_device_fingerprint: this.ipqsResult
                } : {}))
              });
            case 6:
              response = _context91.sent;
              _context91.next = 7;
              return response.json();
            case 7:
              pIntent = _context91.sent;
              if (!(pIntent.provider_name === "stripe")) {
                _context91.next = 9;
                break;
              }
              if (!((pIntent === null || pIntent === void 0 || (_pIntent$provider_nex2 = pIntent.provider_next_action) === null || _pIntent$provider_nex2 === void 0 ? void 0 : _pIntent$provider_nex2.type) == "redirect_to_url")) {
                _context91.next = 8;
                break;
              }
              window.location = pIntent.provider_next_action.redirect_to_url.url;
              _context91.next = 9;
              break;
            case 8:
              return _context91.abrupt("return", pIntent);
            case 9:
              return _context91.abrupt("return", pIntent);
            case 10:
              _context91.prev = 10;
              _t50 = _context91["catch"](0);
              throw new Error("Error: " + _t50, {
                cause: _t50
              });
            case 11:
            case "end":
              return _context91.stop();
          }
        }, _callee63, this, [[0, 10], [1, 4]]);
      }));
      function card_charge_authorize(_x84) {
        return _card_charge_authorize.apply(this, arguments);
      }
      return card_charge_authorize;
    }()
  }, {
    key: "card_charge_authorize_with_cvv",
    value: function () {
      var _card_charge_authorize_with_cvv = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee64(data) {
        var _this10 = this;
        var _this$customer7, cvvModal, cvvModalWaitState, result;
        return _regeneratorRuntime.wrap(function (_context97) {
          while (1) switch (_context97.prev = _context97.next) {
            case 0:
              _context97.prev = 0;
              if (!((_this$customer7 = this.customer) !== null && _this$customer7 !== void 0 && _this$customer7.email)) {
                _context97.next = 2;
                break;
              }
              _context97.next = 1;
              return this.loadIPQSScript();
            case 1:
              this.ipqsResult = _context97.sent;
            case 2:
              _context97.next = 4;
              break;
            case 3:
              _context97.prev = 3;
              _context97["catch"](0);
            case 4:
              cvvModal = new CVVModal(); // Attach a property to keep track of ongoing CVV modal waits
              if (!this._cvvModalWaitState) {
                this._cvvModalWaitState = {};
              }
              cvvModalWaitState = this._cvvModalWaitState; // If there is a previous promise waiting, cancel it
              if (cvvModalWaitState.waitReject) {
                cvvModalWaitState.waitReject({
                  cancelled: true
                });
              }
              // Show the modal and wait for its result via a Promise+event
              _context97.next = 5;
              return new _Promise(function (resolve, reject) {
                var _context92, _context93, _context94, _context95, _context96;
                var finished = false;
                // Track reject to discard older waiters
                cvvModalWaitState.waitReject = function (reason) {
                  if (!finished) {
                    finished = true;
                    reject(reason);
                  }
                };
                cvvModal.show({
                  data: _objectSpread(_objectSpread({}, data), _this10.ipqsResult ? {
                    ipqs_device_fingerprint: _this10.ipqsResult
                  } : {}),
                  createSavedCardIntent: _bindInstanceProperty(_context92 = _this10.createSavedCardIntent).call(_context92, _this10),
                  getGateway: _bindInstanceProperty(_context93 = _this10.getGateway).call(_context93, _this10),
                  chargeCardAuthorize: _bindInstanceProperty(_context94 = _this10.card_charge_authorize).call(_context94, _this10),
                  processPayment: _bindInstanceProperty(_context95 = _this10.processPayment).call(_context95, _this10),
                  updateLog: _bindInstanceProperty(_context96 = _this10.updateLog).call(_context96, _this10),
                  onResult: function onResult(res) {
                    if (!finished) {
                      finished = true;
                      resolve(res);
                    }
                    cvvModalWaitState.waitReject = null;
                  }
                });
              });
            case 5:
              result = _context97.sent;
              return _context97.abrupt("return", result);
            case 6:
            case "end":
              return _context97.stop();
          }
        }, _callee64, this, [[0, 3]]);
      }));
      function card_charge_authorize_with_cvv(_x85) {
        return _card_charge_authorize_with_cvv.apply(this, arguments);
      }
      return card_charge_authorize_with_cvv;
    }()
  }, {
    key: "addError",
    value: function addError(element, message) {
      if (this.errorElement) {
        this.errorElement.innerHTML = message;
      } else {
        var sp1 = document.createElement("span");
        sp1.innerHTML = message;
        sp1.style.color = "#B40E3E";
        sp1.classList.add("pg-error-message");
        this.errorElement = sp1;
        if (element && element.parentNode) {
          element.parentNode.insertBefore(sp1, element);
        }
      }
    }
  }, {
    key: "removeError",
    value: function removeError() {
      var els = document.getElementsByClassName("pg-error-message");
      while (els.length > 0) {
        els[0].remove();
      }
    }
  }, {
    key: "messageNodes",
    value: function messageNodes(className) {
      if (typeof document === "undefined" || typeof document.querySelectorAll !== "function") {
        return [];
      }
      return _Array$from(document.querySelectorAll("." + className));
    }
  }, {
    key: "messageParent",
    value: function messageParent(className) {
      return className === saveCardMessageClass ? this.saveCardContainerId : this.initContainerId;
    }
    /** Keep the message that belongs to the active payment or save-card container. */
  }, {
    key: "preferredMessageNode",
    value: function preferredMessageNode(className, fallback) {
      var _nodes$;
      var nodes = this.messageNodes(className);
      var parent = this.messageParent(className);
      if (parent) {
        var inside = _filterInstanceProperty(nodes).call(nodes, function (node) {
          return elementContains(parent, node);
        });
        if (inside[0]) {
          return inside[0];
        }
        if (fallback && elementContains(parent, fallback)) {
          return fallback;
        }
        return null;
      }
      if (fallback && _indexOfInstanceProperty(nodes).call(nodes, fallback) >= 0) {
        return fallback;
      }
      return (_nodes$ = nodes[0]) !== null && _nodes$ !== void 0 ? _nodes$ : fallback;
    }
  }, {
    key: "removeOtherMessageNodes",
    value: function removeOtherMessageNodes(className, keeper) {
      if (!className) {
        return;
      }
      var parent = this.messageParent(className) || (keeper === null || keeper === void 0 ? void 0 : keeper.parentElement) || null;
      if (!parent) {
        return;
      }
      var _iterator2 = _createForOfIteratorHelper(this.messageNodes(className)),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var node = _step2.value;
          if (node !== keeper && elementContains(parent, node)) {
            node.remove();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "scheduleMessageClear",
    value: function scheduleMessageClear(keeper) {
      var _this11 = this;
      var pending = this.messageClearTimers.get(keeper);
      if (pending !== undefined) {
        clearTimeout(pending);
      }
      var timer = _setTimeout(function () {
        if (_this11.messageClearTimers.get(keeper) !== timer) {
          return;
        }
        _this11.messageClearTimers.delete(keeper);
        keeper.innerHTML = "";
      }, 5000);
      this.messageClearTimers.set(keeper, timer);
    }
  }, {
    key: "beginCardEntry",
    value: function beginCardEntry(className) {
      if (className === saveCardMessageClass) {
        this.saveCardValidationMessages = [];
      } else {
        this.paymentValidationMessages = [];
      }
      var keeper = this.preferredMessageNode(className, null);
      this.removeOtherMessageNodes(className, keeper);
      if (keeper) {
        keeper.innerHTML = "";
      }
    }
  }, {
    key: "ensureMessageNode",
    value: function ensureMessageNode(parent, className) {
      var _context98;
      if (typeof parent.querySelectorAll !== "function" || typeof document === "undefined" || typeof document.createElement !== "function") {
        return;
      }
      var nodes = _filterInstanceProperty(_context98 = _Array$from(parent.querySelectorAll("." + className))).call(_context98, function (node) {
        return elementContains(parent, node);
      });
      for (var index = 1; index < nodes.length; index += 1) {
        nodes[index].remove();
      }
      if (nodes[0]) {
        return;
      }
      var created = document.createElement("div");
      created.className = className;
      parent.appendChild(created);
    }
  }, {
    key: "showCardFieldErrors",
    value: function showCardFieldErrors(className, messages) {
      var _context99;
      var current = className === saveCardMessageClass ? this.saveCardValidationMessages : this.paymentValidationMessages;
      var next = dedupeValidationMessages(_concatInstanceProperty(_context99 = []).call(_context99, _toConsumableArray(current), _toConsumableArray(messages)));
      if (className === saveCardMessageClass) {
        this.saveCardValidationMessages = next;
      } else {
        this.paymentValidationMessages = next;
      }
      var parent = this.messageParent(className);
      if (parent) {
        this.ensureMessageNode(parent, className);
      }
      this.setMessage(this.preferredMessageNode(className, null), next.join("<br>"), next.length > 0 ? "error" : undefined);
    }
  }, {
    key: "setMessage",
    value: function setMessage(container, message, type) {
      if (container) {
        var className = messageClassName(container);
        var parent = className ? this.messageParent(className) : undefined;
        var keeper = className ? this.preferredMessageNode(className, container) : container;
        if (className && parent && (!keeper || !elementContains(parent, keeper))) {
          this.ensureMessageNode(parent, className);
          keeper = this.preferredMessageNode(className, null);
        } else if (!keeper) {
          keeper = container;
        }
        if (!keeper || className && parent && !elementContains(parent, keeper)) {
          return;
        }
        this.removeOtherMessageNodes(className, keeper);
        keeper.style.position = "relative";
        keeper.style.zIndex = "11";
        switch (type) {
          case "success":
            keeper.style.color = "#28a745";
            keeper.innerHTML = message ? message : "";
            break;
          case "warning":
            keeper.style.color = "#ffc107";
            keeper.innerHTML = message ? message : "";
            break;
          case "error":
            keeper.style.color = "#dc3545";
            keeper.innerHTML = message ? message : "";
            break;
          default:
            keeper.innerHTML = "";
        }
        this.scheduleMessageClear(keeper);
      }
    }
    /** Disable Pay now button and center the message container when showing fraud/decline message. */
  }, {
    key: "applyFraudDeclineUI",
    value: function applyFraudDeclineUI(messageContainer) {
      if (this.buttonElement) this.buttonElement.disabled = true;
      if (this.initContainerId) {
        var container = this.initContainerId;
        container.style.display = "flex";
        container.style.justifyContent = "center";
        container.style.alignItems = "center";
        container.style.minHeight = "80px";
      }
      if (messageContainer) {
        messageContainer.style.textAlign = "center";
      }
    }
  }, {
    key: "updateLog",
    value: function () {
      var _updateLog = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee65(data) {
        var response, pIntent, _t52;
        return _regeneratorRuntime.wrap(function (_context100) {
          while (1) switch (_context100.prev = _context100.next) {
            case 0:
              _context100.prev = 0;
              _context100.next = 1;
              return this.fetch("".concat(this.apiBaseURL, "/v1/log/sdk"), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": this.apiKey
                },
                body: _JSON$stringify(data)
              });
            case 1:
              response = _context100.sent;
              _context100.next = 2;
              return response.json();
            case 2:
              pIntent = _context100.sent;
              return _context100.abrupt("return", pIntent);
            case 3:
              _context100.prev = 3;
              _t52 = _context100["catch"](0);
              throw new Error("Error: " + _t52, {
                cause: _t52
              });
            case 4:
            case "end":
              return _context100.stop();
          }
        }, _callee65, this, [[0, 3]]);
      }));
      function updateLog(_x86) {
        return _updateLog.apply(this, arguments);
      }
      return updateLog;
    }()
  }, {
    key: "updateLogIPQS",
    value: function () {
      var _updateLogIPQS = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee66(data) {
        var response, pIntent, _t53;
        return _regeneratorRuntime.wrap(function (_context101) {
          while (1) switch (_context101.prev = _context101.next) {
            case 0:
              _context101.prev = 0;
              _context101.next = 1;
              return this.fetch("".concat(this.apiBaseURL, "/v1/log/winston_log_sdk"), {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": this.apiKey
                },
                body: _JSON$stringify(data)
              });
            case 1:
              response = _context101.sent;
              _context101.next = 2;
              return response.json();
            case 2:
              pIntent = _context101.sent;
              return _context101.abrupt("return", pIntent);
            case 3:
              _context101.prev = 3;
              _t53 = _context101["catch"](0);
              throw new Error("Error: " + _t53, {
                cause: _t53
              });
            case 4:
            case "end":
              return _context101.stop();
          }
        }, _callee66, this, [[0, 3]]);
      }));
      function updateLogIPQS(_x87) {
        return _updateLogIPQS.apply(this, arguments);
      }
      return updateLogIPQS;
    }()
  }, {
    key: "getInvoiceDetails",
    value: function () {
      var _getInvoiceDetails = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee67(id, containerId, buttonElement, latitude, longitude) {
        var _context102, _context103, _context104, response, invoiceData, _this$paymentIntentRe66, _this$paymentIntentRe67, _t54;
        return _regeneratorRuntime.wrap(function (_context105) {
          while (1) switch (_context105.prev = _context105.next) {
            case 0:
              _context105.prev = 0;
              _context105.next = 1;
              return this.fetch(_concatInstanceProperty(_context102 = _concatInstanceProperty(_context103 = _concatInstanceProperty(_context104 = "".concat(this.apiBaseURL, "/v1/invoice/paymenlink/")).call(_context104, id, "?latitude=")).call(_context103, latitude, "&longitude=")).call(_context102, longitude), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": this.apiKey
                }
              });
            case 1:
              response = _context105.sent;
              _context105.next = 2;
              return response.json();
            case 2:
              invoiceData = _context105.sent;
              if (invoiceData.invoiceDetails) {
                this.paymentIntentResponse = invoiceData.invoiceDetails.response_payment;
                this.intentRequestBody = {
                  amount: invoiceData.invoiceDetails.total_amount || 100
                };
                this.customer = invoiceData.invoiceDetails.customer;
                console.log("Customer: ", this.customer);
              }
              return _context105.abrupt("return", invoiceData);
            case 3:
              _context105.prev = 3;
              _t54 = _context105["catch"](0);
              throw new Error("Error: " + _t54, {
                cause: _t54
              });
            case 4:
              _context105.prev = 4;
              try {
                if (containerId) {
                  this.ensureMessageNode(containerId, paymentMessageClass);
                }
              } catch (error) {
                void this.updateLog({
                  payment_id: (_this$paymentIntentRe66 = this.paymentIntentResponse) === null || _this$paymentIntentRe66 === void 0 ? void 0 : _this$paymentIntentRe66.payment_id,
                  type: "error",
                  provider: (_this$paymentIntentRe67 = this.paymentIntentResponse) === null || _this$paymentIntentRe67 === void 0 ? void 0 : _this$paymentIntentRe67.provider_name,
                  message: messageFromCaught(error),
                  event_name: "initilize_error"
                });
              }
              return _context105.finish(4);
            case 5:
            case "end":
              return _context105.stop();
          }
        }, _callee67, this, [[0, 3, 4, 5]]);
      }));
      function getInvoiceDetails(_x88, _x89, _x90, _x91, _x92) {
        return _getInvoiceDetails.apply(this, arguments);
      }
      return getInvoiceDetails;
    }()
  }, {
    key: "fetchDistance",
    value: function () {
      var _fetchDistance = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee68(latitude, longitude) {
        var _context106, _context107, response, distanceData, _t55;
        return _regeneratorRuntime.wrap(function (_context108) {
          while (1) switch (_context108.prev = _context108.next) {
            case 0:
              _context108.prev = 0;
              _context108.next = 1;
              return this.fetch(_concatInstanceProperty(_context106 = _concatInstanceProperty(_context107 = "".concat(this.apiBaseURL, "/v1/location/get_distance?latitude=")).call(_context107, latitude, "&longitude=")).call(_context106, longitude), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": this.apiKey
                }
              });
            case 1:
              response = _context108.sent;
              _context108.next = 2;
              return response.json();
            case 2:
              distanceData = _context108.sent;
              return _context108.abrupt("return", distanceData);
            case 3:
              _context108.prev = 3;
              _t55 = _context108["catch"](0);
              throw new Error("Error: " + _t55, {
                cause: _t55
              });
            case 4:
            case "end":
              return _context108.stop();
          }
        }, _callee68, this, [[0, 3]]);
      }));
      function fetchDistance(_x93, _x94) {
        return _fetchDistance.apply(this, arguments);
      }
      return fetchDistance;
    }()
  }, {
    key: "fetchLatLongCountry",
    value: function () {
      var _fetchLatLongCountry = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee69(latitude, longitude) {
        var _context109, _context110, response, distanceData, _t56;
        return _regeneratorRuntime.wrap(function (_context111) {
          while (1) switch (_context111.prev = _context111.next) {
            case 0:
              _context111.prev = 0;
              _context111.next = 1;
              return this.fetch(_concatInstanceProperty(_context109 = _concatInstanceProperty(_context110 = "".concat(this.apiBaseURL, "/v1/master/common/lat_long_country?latitude=")).call(_context110, latitude, "&longitude=")).call(_context109, longitude), {
                method: "GET",
                headers: {
                  "Content-Type": "application/json",
                  "api-key": this.apiKey
                }
              });
            case 1:
              response = _context111.sent;
              _context111.next = 2;
              return response.json();
            case 2:
              distanceData = _context111.sent;
              return _context111.abrupt("return", distanceData);
            case 3:
              _context111.prev = 3;
              _t56 = _context111["catch"](0);
              throw new Error("Error: " + _t56, {
                cause: _t56
              });
            case 4:
            case "end":
              return _context111.stop();
          }
        }, _callee69, this, [[0, 3]]);
      }));
      function fetchLatLongCountry(_x95, _x96) {
        return _fetchLatLongCountry.apply(this, arguments);
      }
      return fetchLatLongCountry;
    }()
  }, {
    key: "loadIPQSScript",
    value: function loadIPQSScript() {
      var _this12 = this;
      return new _Promise(function (resolve, reject) {
        var existingScript = document.querySelector("script[src=\"".concat(_this12.ipqsScriptURL, "\"]"));
        if (existingScript) {
          console.log("IPQS script already loaded.");
          resolve(_this12.ipqsResult);
          return;
        }
        if (!_this12.ipqsScriptURL) {
          console.log("ipqsScriptURL is not found!");
          // Instead of reject, resolve with null to not block flow
          resolve(null);
          return;
        }
        // Make a HEAD request to check content type before inserting script
        fetch(_this12.ipqsScriptURL, {
          method: "HEAD"
        }).then(function (response) {
          var _context112;
          var contentType = response.headers.get("content-type");
          if (!contentType || !_includesInstanceProperty(_context112 = contentType.toLowerCase()).call(_context112, "javascript")) {
            throw new Error("IPQS script has invalid content type: ".concat(contentType));
          }
          window.IPQ = {
            Callback: function Callback() {
              try {
                var Startup = window.Startup;
                Startup.Store("userID", _this12.required(_this12.customer, "email").email);
                Startup.Store("transactionID", "");
                Startup.AfterResult(/*#__PURE__*/function () {
                  var _ref11 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee70(result) {
                    var _t57;
                    return _regeneratorRuntime.wrap(function (_context113) {
                      while (1) switch (_context113.prev = _context113.next) {
                        case 0:
                          _context113.prev = 0;
                          console.log("IPQS Device Fingerprint Result:", result);
                          _context113.next = 1;
                          return _this12.updateLogIPQS({
                            type: result.success ? "info" : "error",
                            message: "IPQS Device Fingerprint Verification",
                            event_name: "initiate_payment",
                            result: result,
                            user_email: _this12.required(_this12.customer, "email").email
                          });
                        case 1:
                          resolve(result);
                          _context113.next = 3;
                          break;
                        case 2:
                          _context113.prev = 2;
                          _t57 = _context113["catch"](0);
                          console.log("Error on IPQS AfterResult:", _t57);
                          resolve(null);
                        case 3:
                        case "end":
                          return _context113.stop();
                      }
                    }, _callee70, null, [[0, 2]]);
                  }));
                  return function (_x97) {
                    return _ref11.apply(this, arguments);
                  };
                }());
                Startup.Init();
              } catch (e) {
                console.log("Error inside IPQ Callback:", e);
                resolve(null);
              }
            }
          };
          var script = document.createElement("script");
          script.src = _this12.ipqsScriptURL;
          script.crossOrigin = "anonymous";
          script.async = true;
          script.onload = function () {
            return console.log("IPQS script loaded.");
          };
          script.onerror = function () {
            console.log("Failed to load IPQS script");
            resolve(null);
          };
          document.body.appendChild(script);
        }).catch(function (err) {
          reject(new Error("Failed to load IPQS script: " + (err instanceof Error ? err.message : String(err))));
        });
      });
    }
  }, {
    key: "on",
    value: function on(event, callback) {
      if (!this.events[event]) {
        this.events[event] = [];
      }
      this.events[event].push(callback);
    }
  }, {
    key: "off",
    value: function off(event, callback) {
      var _context114;
      if (!this.events[event]) return;
      this.events[event] = _filterInstanceProperty(_context114 = this.events[event]).call(_context114, function (cb) {
        return cb !== callback;
      });
    }
  }, {
    key: "emit",
    value: function emit(event, data) {
      var _context115;
      if (!this.events[event]) return;
      _forEachInstanceProperty(_context115 = this.events[event]).call(_context115, function (cb) {
        return cb(data);
      });
    }
  }]);
}(); // Export the SDK for use in client applications

export { PaymentSwitchSDK as default };
